const franceData = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 90,
        name: "Territoire de Belfort",
        REG: 27,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6.939764744501587, 47.43011652225874],
            [6.9301334938177055, 47.459883477741265],
            [6.9098008534850655, 47.49001344487601],
            [6.9301334938177055, 47.52014341201075],
            [6.900169602801182, 47.54991036749328],
            [6.879836962468542, 47.5600746937556],
            [6.860039391618339, 47.54991036749328],
            [6.819909180435498, 47.54991036749328],
            [6.809742860269176, 47.5600746937556],
            [6.779778969252654, 47.61997161637287],
            [6.8001116095852945, 47.63993725724529],
            [6.779778969252654, 47.65990289811772],
            [6.779778969252654, 47.69983417986256],
            [6.759981398402451, 47.72016283238722],
            [6.759981398402451, 47.74992978786973],
            [6.770147718568771, 47.76989542874216],
            [6.7899452894189745, 47.78005975500449],
            [6.819909180435498, 47.809826710487],
            [6.849873071452019, 47.81999103674933],
            [6.860039391618339, 47.78005975500449],
            [6.9098008534850655, 47.78005975500449],
            [6.939764744501587, 47.76989542874216],
            [6.970263705000547, 47.74992978786973],
            [7.00022759601707, 47.74992978786973],
            [7.020025166867273, 47.72996414699731],
            [7.039822737717475, 47.69003286525247],
            [7.039822737717475, 47.65010158350762],
            [7.020025166867273, 47.65010158350762],
            [7.009858846700953, 47.6301359426352],
            [7.009858846700953, 47.60000597550045],
            [7.079952948900318, 47.60000597550045],
            [7.090119269066638, 47.5698760083657],
            [7.109916839916841, 47.5698760083657],
            [7.1398807309333625, 47.529944726620855],
            [7.130249480249481, 47.50017777113833],
            [7.099750519750521, 47.50017777113833],
            [7.079952948900318, 47.49001344487601],
            [7.039822737717475, 47.50017777113833],
            [6.99006127585075, 47.49001344487601],
            [7.00022759601707, 47.450082163131164],
            [6.970263705000547, 47.450082163131164],
            [6.960097384834227, 47.43011652225874],
            [6.939764744501587, 47.43011652225874],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 21, name: "Côte-d'Or", REG: 27, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [4.170245103402999, 47.12010457125784],
              [4.1499124630703585, 47.10994024499552],
              [4.119948572053835, 47.12010457125784],
              [4.109782251887515, 47.14007021213027],
              [4.1397461429040385, 47.14007021213027],
              [4.17987635408688, 47.14987152674037],
              [4.190042674253202, 47.14987152674037],
              [4.190042674253202, 47.12990588586794],
              [4.170245103402999, 47.12010457125784],
            ],
          ],
          [
            [
              [5.100195863880075, 46.949852106363906],
              [5.070231972863552, 46.96001643262623],
              [5.060065652697232, 46.979982073498654],
              [5.030101761680709, 46.979982073498654],
              [5.0001378706641875, 46.96001643262623],
              [4.949841339315024, 46.96001643262623],
              [4.91024619761462, 46.97018075888856],
              [4.8701159864317765, 46.949852106363906],
              [4.819819455082613, 46.94005079175381],
              [4.780224313382209, 46.92008515088139],
              [4.719761461866725, 46.92008515088139],
              [4.689797570850202, 46.90011951000896],
              [4.670000000000001, 46.909920824619064],
              [4.680166320166321, 46.929886465491485],
              [4.650202429149798, 46.94005079175381],
              [4.620238538133276, 46.94005079175381],
              [4.599905897800634, 46.949852106363906],
              [4.589739577634314, 46.97018075888856],
              [4.569942006784113, 46.97018075888856],
              [4.559775686617793, 47.0101120406334],
              [4.510014224751067, 47.0101120406334],
              [4.499847904584747, 47.03007768150583],
              [4.469884013568225, 47.03007768150583],
              [4.460252762884342, 47.039878996115924],
              [4.429753802385382, 47.039878996115924],
              [4.399789911368859, 47.05984463698835],
              [4.420122551701499, 47.080173289513],
              [4.369826020352337, 47.080173289513],
              [4.360194769668454, 47.05984463698835],
              [4.339862129335814, 47.07000896325067],
              [4.350028449502134, 47.10013893038542],
              [4.309898238319291, 47.10013893038542],
              [4.30026698763541, 47.10994024499552],
              [4.260136776452566, 47.10994024499552],
              [4.209840245103403, 47.16003585300269],
              [4.209840245103403, 47.18000149387511],
              [4.230172885436043, 47.19996713474754],
              [4.220006565269723, 47.21993277561996],
              [4.17987635408688, 47.25006274275471],
              [4.1397461429040385, 47.23989841649238],
              [4.109782251887515, 47.289994024499556],
              [4.130114892220155, 47.320123991634304],
              [4.109782251887515, 47.340089632506725],
              [4.100151001203634, 47.36985658798925],
              [4.079818360870992, 47.380020914251574],
              [4.070187110187111, 47.399986555123995],
              [4.079818360870992, 47.43991783686884],
              [4.119948572053835, 47.43991783686884],
              [4.130114892220155, 47.470047804003585],
              [4.119948572053835, 47.479849118613686],
              [4.119948572053835, 47.509979085748434],
              [4.190042674253202, 47.5698760083657],
              [4.200208994419522, 47.60000597550045],
              [4.220006565269723, 47.60000597550045],
              [4.220006565269723, 47.6301359426352],
              [4.249970456286246, 47.65990289811772],
              [4.230172885436043, 47.67986853899014],
              [4.269768027136448, 47.69983417986256],
              [4.239804136119926, 47.72016283238722],
              [4.27993434730277, 47.74012847325964],
              [4.29010066746909, 47.72996414699731],
              [4.339862129335814, 47.76989542874216],
              [4.320064558485611, 47.809826710487],
              [4.320064558485611, 47.85012100388408],
              [4.29010066746909, 47.85012100388408],
              [4.260136776452566, 47.83995667762175],
              [4.260136776452566, 47.8700866447565],
              [4.249970456286246, 47.8798879593666],
              [4.269768027136448, 47.89985360023902],
              [4.309898238319291, 47.89985360023902],
              [4.309898238319291, 47.91981924111145],
              [4.29010066746909, 47.92998356737377],
              [4.309898238319291, 47.960113534508515],
              [4.350028449502134, 47.960113534508515],
              [4.420122551701499, 47.96991484911862],
              [4.450086442718022, 47.960113534508515],
              [4.499847904584747, 47.96991484911862],
              [4.559775686617793, 47.96991484911862],
              [4.53997811576759, 47.98988048999104],
              [4.55014443593391, 48.009846130863465],
              [4.580108326950433, 48.03017478338811],
              [4.620238538133276, 48.020010457125785],
              [4.699963891016522, 48.020010457125785],
              [4.7502604223656855, 48.000044816253364],
              [4.78985556406609, 48.009846130863465],
              [4.810188204398732, 47.98988048999104],
              [4.78985556406609, 47.96991484911862],
              [4.800021884232412, 47.960113534508515],
              [4.849783346099136, 47.960113534508515],
              [4.8701159864317765, 47.940147893636095],
              [4.829985775248933, 47.91001792650135],
              [4.859949666265456, 47.89985360023902],
              [4.8701159864317765, 47.91981924111145],
              [4.91024619761462, 47.91981924111145],
              [4.930043768464821, 47.8700866447565],
              [4.949841339315024, 47.8700866447565],
              [4.960007659481344, 47.83995667762175],
              [4.979805230331547, 47.830155363011656],
              [4.9899715504978674, 47.80002539587691],
              [4.940210088631141, 47.78986106961458],
              [4.919877448298501, 47.76989542874216],
              [4.960007659481344, 47.76009411413206],
              [4.970173979647664, 47.74012847325964],
              [4.960007659481344, 47.70999850612489],
              [4.970173979647664, 47.69003286525247],
              [5.030101761680709, 47.70999850612489],
              [5.030101761680709, 47.69003286525247],
              [5.079863223547435, 47.65990289811772],
              [5.130159754896597, 47.65010158350762],
              [5.179921216763323, 47.67986853899014],
              [5.169754896597003, 47.65010158350762],
              [5.190087536929643, 47.65010158350762],
              [5.230217748112486, 47.6301359426352],
              [5.239848998796368, 47.60000597550045],
              [5.260181639129008, 47.58004033462802],
              [5.309943100995732, 47.61017030176277],
              [5.3399069920122555, 47.61017030176277],
              [5.369870883028779, 47.60000597550045],
              [5.3998347740453, 47.60000597550045],
              [5.429798665061823, 47.6301359426352],
              [5.4800951964109865, 47.61017030176277],
              [5.4902615165773065, 47.58004033462802],
              [5.4800951964109865, 47.5698760083657],
              [5.49989276726119, 47.54991036749328],
              [5.4902615165773065, 47.529944726620855],
              [5.4699288762446665, 47.529944726620855],
              [5.450131305394463, 47.50017777113833],
              [5.3998347740453, 47.50017777113833],
              [5.380037203195099, 47.470047804003585],
              [5.380037203195099, 47.450082163131164],
              [5.410001094211622, 47.459883477741265],
              [5.429798665061823, 47.43991783686884],
              [5.429798665061823, 47.419952195996416],
              [5.450131305394463, 47.380020914251574],
              [5.4800951964109865, 47.38982222886167],
              [5.49989276726119, 47.340089632506725],
              [5.4699288762446665, 47.320123991634304],
              [5.52022540759383, 47.300158350761876],
              [5.51005908742751, 47.27982969823723],
              [5.4800951964109865, 47.25986405736481],
              [5.4800951964109865, 47.21993277561996],
              [5.450131305394463, 47.19996713474754],
              [5.4597625560783465, 47.18000149387511],
              [5.450131305394463, 47.16003585300269],
              [5.410001094211622, 47.12990588586794],
              [5.390203523361419, 47.080173289513],
              [5.3297406718459355, 47.080173289513],
              [5.309943100995732, 47.05984463698835],
              [5.279979209979211, 47.05004332237825],
              [5.279979209979211, 47.03007768150583],
              [5.320109421162054, 47.0199133552435],
              [5.279979209979211, 46.99994771437108],
              [5.260181639129008, 46.979982073498654],
              [5.2200514279461645, 46.99014639976098],
              [5.190087536929643, 46.97018075888856],
              [5.16012364591312, 46.96001643262623],
              [5.109827114563957, 46.96001643262623],
              [5.100195863880075, 46.949852106363906],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 14, name: "Calvados", REG: 28, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.8401455301455298, 48.75002688975202],
            [-0.8497767808294121, 48.759828204362115],
            [-0.8797406718459353, 48.759828204362115],
            [-0.8899069920122553, 48.76999253062444],
            [-0.9198708830287776, 48.76999253062444],
            [-0.9498347740452999, 48.78995817149686],
            [-0.9701674143779409, 48.78995817149686],
            [-1.0199288762446654, 48.76999253062444],
            [-1.0402615165773064, 48.78015685688677],
            [-1.0600590874275087, 48.76999253062444],
            [-1.100189298610351, 48.78995817149686],
            [-1.090022978444031, 48.80012249775919],
            [-1.1098205492942332, 48.82008813863161],
            [-1.1601170806433965, 48.82988945324171],
            [-1.100189298610351, 48.86982073498656],
            [-1.0702254075938287, 48.86982073498656],
            [-1.0097625560783454, 48.91991634299373],
            [-0.9899649852281431, 48.95004631012848],
            [-0.9402035233614177, 48.9700119510009],
            [-0.870109421162053, 49.040073199880496],
            [-0.870109421162053, 49.08000448162534],
            [-0.8797406718459353, 49.090168807887665],
            [-0.8797406718459353, 49.11993576337019],
            [-0.9000733121785753, 49.13990140424261],
            [-0.9402035233614177, 49.150065730504934],
            [-0.9300372031950976, 49.15986704511503],
            [-0.9000733121785753, 49.2001613385121],
            [-0.9198708830287776, 49.220126979384524],
            [-0.9402035233614177, 49.220126979384524],
            [-0.9701674143779409, 49.189997012249776],
            [-0.9899649852281431, 49.2001613385121],
            [-1.0199288762446654, 49.2001613385121],
            [-1.0300951964109855, 49.220126979384524],
            [-1.0702254075938287, 49.229928293994625],
            [-1.090022978444031, 49.249893934867046],
            [-1.1301531896268737, 49.269859575739474],
            [-1.139784440310756, 49.31015386913654],
            [-1.1098205492942332, 49.33011951000897],
            [-1.1199868694605537, 49.359886465491485],
            [-1.079856658277711, 49.39001643262623],
            [-1.0199288762446654, 49.39001643262623],
            [-0.9899649852281431, 49.40018075888856],
            [-0.9600010942116208, 49.40018075888856],
            [-0.8797406718459353, 49.37005079175381],
            [-0.8599431009957321, 49.37005079175381],
            [-0.7898489987963675, 49.35008515088139],
            [-0.6501958638800742, 49.35008515088139],
            [-0.6298632235474342, 49.339920824619064],
            [-0.5699354415143887, 49.339920824619064],
            [-0.5501378706641864, 49.35008515088139],
            [-0.5100076594813441, 49.339920824619064],
            [-0.40994966626545537, 49.339920824619064],
            [-0.29009410219936527, 49.289825216611895],
            [-0.24996389101652294, 49.289825216611895],
            [-0.23016632016631977, 49.280023902001794],
            [-0.20983367983367973, 49.289825216611895],
            [-0.13973957763431422, 49.289825216611895],
            [-0.08997811576758963, 49.299989542874215],
            [-0.07018054491738734, 49.31015386913654],
            [-0.04021665390086415, 49.31015386913654],
            [-0.010252762884341848, 49.31995518374664],
            [0.0502100886311414, 49.35008515088139],
            [0.1101378706641869, 49.39001643262623],
            [0.14973301236459147, 49.40998207349866],
            [0.21982711456395698, 49.42994771437108],
            [0.3000875369296425, 49.42994771437108],
            [0.31025385709596254, 49.39001643262623],
            [0.3000875369296425, 49.37005079175381],
            [0.3198851077798448, 49.339920824619064],
            [0.31025385709596254, 49.31995518374664],
            [0.3198851077798448, 49.31015386913654],
            [0.3198851077798448, 49.280023902001794],
            [0.3498489987963671, 49.299989542874215],
            [0.3798128898128903, 49.289825216611895],
            [0.3798128898128903, 49.26005826112937],
            [0.34021774811248484, 49.249893934867046],
            [0.34021774811248484, 49.229928293994625],
            [0.3899792099792103, 49.220126979384524],
            [0.3899792099792103, 49.150065730504934],
            [0.43010942116205264, 49.150065730504934],
            [0.4097767808294126, 49.11993576337019],
            [0.4097767808294126, 49.08000448162534],
            [0.3798128898128903, 49.06984015536301],
            [0.3798128898128903, 49.040073199880496],
            [0.4499069920122549, 49.02010755900807],
            [0.43010942116205264, 49.00014191813565],
            [0.43010942116205264, 48.9700119510009],
            [0.4097767808294126, 48.95004631012848],
            [0.3798128898128903, 48.9700119510009],
            [0.3600153189626871, 48.95004631012848],
            [0.3300514279461648, 48.93988198386615],
            [0.31025385709596254, 48.95004631012848],
            [0.2797548965970016, 48.95004631012848],
            [0.24015975489659702, 48.95984762473857],
            [0.1898632235474338, 48.93988198386615],
            [0.18023197286355153, 48.93008066925605],
            [0.14973301236459147, 48.93008066925605],
            [0.12993544151438918, 48.95004631012848],
            [0.0801739796476637, 48.93988198386615],
            [0.0502100886311414, 48.8999507021213],
            [0.0202461976146191, 48.8999507021213],
            [-0.010252762884341848, 48.87998506124888],
            [-0.060014224751066436, 48.84985509411413],
            [-0.060014224751066436, 48.84005377950403],
            [-0.10977568661779191, 48.84005377950403],
            [-0.11994200678411193, 48.84985509411413],
            [-0.14990589780063424, 48.82008813863161],
            [-0.17986978881715743, 48.84005377950403],
            [-0.23016632016631977, 48.84005377950403],
            [-0.23979757085020204, 48.84985509411413],
            [-0.3002604223656853, 48.84985509411413],
            [-0.3302243133822085, 48.86001942037646],
            [-0.3302243133822085, 48.84005377950403],
            [-0.35002188423241076, 48.82008813863161],
            [-0.37998577524893307, 48.84985509411413],
            [-0.40994966626545537, 48.86982073498656],
            [-0.46987744829850087, 48.86982073498656],
            [-0.49984133931502317, 48.84985509411413],
            [-0.5501378706641864, 48.84985509411413],
            [-0.5998993325309119, 48.82988945324171],
            [-0.6501958638800742, 48.82988945324171],
            [-0.6801597548965974, 48.84005377950403],
            [-0.7101236459131197, 48.80012249775919],
            [-0.7802177481124852, 48.78995817149686],
            [-0.8101816391290075, 48.759828204362115],
            [-0.8401455301455298, 48.75002688975202],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 976, name: "Mayotte", REG: "06", CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [1.4799157457052194, 41.93992829399462],
              [1.4601181748550172, 41.9101613385121],
              [1.4301542838384949, 41.93992829399462],
              [1.4601181748550172, 41.97005826112937],
              [1.4799157457052194, 41.95989393486704],
              [1.4799157457052194, 41.93992829399462],
            ],
          ],
          [
            [
              [1.340262610788927, 41.82013444876008],
              [1.3199299704562861, 41.79000448162533],
              [1.3001323996060838, 41.79000448162533],
              [1.2899660794397638, 41.77003884075291],
              [1.2600021884232415, 41.73990887361816],
              [1.2600021884232415, 41.71994323274574],
              [1.2402046175730392, 41.71014191813564],
              [1.2600021884232415, 41.69017627726322],
              [1.3001323996060838, 41.66984762473857],
              [1.2701685085895615, 41.66004631012847],
              [1.2300382974067183, 41.68001195100089],
              [1.200074406390196, 41.64008066925605],
              [1.1599441952073537, 41.649881983866145],
              [1.1497778750410328, 41.66984762473857],
              [1.1198139840245105, 41.66004631012847],
              [1.1299803041908305, 41.69017627726322],
              [1.1000164131743082, 41.69017627726322],
              [1.1000164131743082, 41.71014191813564],
              [1.1198139840245105, 41.73010755900806],
              [1.0898500930079882, 41.73990887361816],
              [1.059886201991465, 41.77984015536301],
              [1.1101827333406282, 41.77984015536301],
              [1.1198139840245105, 41.75007319988049],
              [1.1599441952073537, 41.73010755900806],
              [1.200074406390196, 41.73010755900806],
              [1.210240726556516, 41.75007319988049],
              [1.189908086223876, 41.79000448162533],
              [1.1701105153736737, 41.80016880788766],
              [1.1401466243571505, 41.82993576337018],
              [1.1101827333406282, 41.84010008963251],
              [1.1299803041908305, 41.89999701224978],
              [1.1101827333406282, 41.93012697938452],
              [1.1198139840245105, 41.950092620256946],
              [1.1101827333406282, 41.97005826112937],
              [1.070052522157786, 41.97005826112937],
              [1.0400886311412627, 41.99002390200179],
              [1.0197559908086227, 41.97985957573947],
              [1.0101247401247404, 41.99982521661189],
              [1.0400886311412627, 42.020153869136536],
              [1.0101247401247404, 42.02995518374664],
              [1.0299223109749427, 42.060085150881385],
              [1.0502549513075827, 42.060085150881385],
              [1.1000164131743082, 42.11018075888855],
              [1.1401466243571505, 42.080050791753806],
              [1.1401466243571505, 42.060085150881385],
              [1.1599441952073537, 42.04992082461906],
              [1.1701105153736737, 42.020153869136536],
              [1.189908086223876, 42.009989542874216],
              [1.2300382974067183, 42.009989542874216],
              [1.2402046175730392, 42.02995518374664],
              [1.2600021884232415, 42.020153869136536],
              [1.309763650289966, 42.020153869136536],
              [1.330096290622607, 41.99982521661189],
              [1.3498938614728093, 41.99982521661189],
              [1.3702265018054494, 41.97985957573947],
              [1.3702265018054494, 41.93992829399462],
              [1.340262610788927, 41.93012697938452],
              [1.309763650289966, 41.9101613385121],
              [1.309763650289966, 41.88983268598745],
              [1.2899660794397638, 41.88003137137735],
              [1.2899660794397638, 41.86006573050493],
              [1.3199299704562861, 41.82013444876008],
              [1.340262610788927, 41.82013444876008],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 85, name: "Vendée", REG: 52, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-2.3297789692526534, 46.68993576337019],
              [-2.359742860269176, 46.68993576337019],
              [-2.399873071452019, 46.72006573050493],
              [-2.3902418207681366, 46.72986704511503],
              [-2.350111609585294, 46.72986704511503],
              [-2.309981398402451, 46.70990140424261],
              [-2.3297789692526534, 46.68993576337019],
            ],
          ],
          [
            [
              [-2.1499956231535178, 46.889955183746636],
              [-2.1799595141700405, 46.929886465491485],
              [-2.2200897253528833, 46.96001643262623],
              [-2.2698511872196083, 46.96001643262623],
              [-2.2800175073859283, 46.979982073498654],
              [-2.299815078236131, 46.99014639976098],
              [-2.2800175073859283, 47.03007768150583],
              [-2.2200897253528833, 47.0199133552435],
              [-2.2200897253528833, 46.97018075888856],
              [-2.1601619433198382, 46.949852106363906],
              [-2.1499956231535178, 46.929886465491485],
              [-2.1499956231535178, 46.889955183746636],
            ],
          ],
          [
            [
              [-1.350066746908852, 46.33999253062444],
              [-1.3998282087755771, 46.33999253062444],
              [-1.4201608491082176, 46.35015685688676],
              [-1.4399584199584199, 46.33999253062444],
              [-1.4699223109749426, 46.33999253062444],
              [-1.4800886311412627, 46.37012249775919],
              [-1.5100525221577854, 46.39988945324171],
              [-1.5298500930079877, 46.41005377950403],
              [-1.6197417660575555, 46.41005377950403],
              [-1.650240726556516, 46.41985509411413],
              [-1.650240726556516, 46.43001942037646],
              [-1.7101685085895615, 46.44998506124888],
              [-1.7700962906226065, 46.48991634299372],
              [-1.8102265018054493, 46.48991634299372],
              [-1.8198577524893316, 46.52004631012847],
              [-1.8498216435058539, 46.57994323274574],
              [-1.8599879636721743, 46.61007319988049],
              [-1.900118174855017, 46.63984015536301],
              [-1.9199157457052194, 46.66997012249776],
              [-1.9498796367217421, 46.68993576337019],
              [-1.9798435277382644, 46.70010008963251],
              [-1.9798435277382644, 46.72006573050493],
              [-2.1398293029871978, 46.819893934867046],
              [-2.1499956231535178, 46.83985957573947],
              [-2.1499956231535178, 46.889955183746636],
              [-2.1200317321369955, 46.889955183746636],
              [-2.1200317321369955, 46.909920824619064],
              [-2.06010395010395, 46.949852106363906],
              [-2.03977130977131, 46.979982073498654],
              [-2.0301400590874277, 47.0101120406334],
              [-1.9798435277382644, 47.03007768150583],
              [-1.9402483860378599, 46.99014639976098],
              [-1.9199157457052194, 46.99014639976098],
              [-1.9097494255388994, 46.97018075888856],
              [-1.8701542838384944, 46.949852106363906],
              [-1.8300240726556516, 46.949852106363906],
              [-1.8300240726556516, 46.929886465491485],
              [-1.749763650289966, 46.929886465491485],
              [-1.7401323996060838, 46.90011951000896],
              [-1.7197997592734438, 46.88015386913654],
              [-1.689835868256921, 46.889955183746636],
              [-1.6101105153736732, 46.869989542874215],
              [-1.580146624357151, 46.869989542874215],
              [-1.5501827333406282, 46.859825216611895],
              [-1.4998862019914654, 46.88015386913654],
              [-1.4998862019914654, 46.889955183746636],
              [-1.5501827333406282, 46.929886465491485],
              [-1.5202188423241054, 46.94005079175381],
              [-1.5501827333406282, 46.979982073498654],
              [-1.5400164131743082, 46.99994771437108],
              [-1.5501827333406282, 47.0101120406334],
              [-1.4998862019914654, 47.039878996115924],
              [-1.4699223109749426, 47.03007768150583],
              [-1.4699223109749426, 46.99014639976098],
              [-1.4800886311412627, 46.979982073498654],
              [-1.4597559908086226, 46.96001643262623],
              [-1.4699223109749426, 46.929886465491485],
              [-1.3698643177590548, 46.949852106363906],
              [-1.3800306379253748, 46.99014639976098],
              [-1.3602330670751726, 46.99994771437108],
              [-1.3800306379253748, 47.03007768150583],
              [-1.3602330670751726, 47.039878996115924],
              [-1.2997702155596893, 47.03007768150583],
              [-1.290138964875807, 47.080173289513],
              [-1.2698063245431666, 47.080173289513],
              [-1.2002472918262392, 47.039878996115924],
              [-1.1499507604770765, 47.03007768150583],
              [-1.139784440310756, 47.0199133552435],
              [-1.090022978444031, 47.0199133552435],
              [-1.079856658277711, 47.0101120406334],
              [-1.0498927672611886, 47.0101120406334],
              [-1.0199288762446654, 46.99994771437108],
              [-0.9899649852281431, 47.0101120406334],
              [-0.9600010942116208, 46.99994771437108],
              [-0.9198708830287776, 46.99994771437108],
              [-0.8899069920122553, 46.979982073498654],
              [-0.870109421162053, 46.949852106363906],
              [-0.8299792099792098, 46.929886465491485],
              [-0.8101816391290075, 46.909920824619064],
              [-0.8198128898128898, 46.88015386913654],
              [-0.7898489987963675, 46.859825216611895],
              [-0.7802177481124852, 46.83985957573947],
              [-0.6999573257467997, 46.810092620256945],
              [-0.719754896597002, 46.799928293994626],
              [-0.729921216763322, 46.770161338512104],
              [-0.6897910055804797, 46.72986704511503],
              [-0.6699934347302765, 46.72006573050493],
              [-0.6598271145639565, 46.680134448760086],
              [-0.6100656526972319, 46.61987451449059],
              [-0.6202319728635519, 46.59990887361817],
              [-0.6202319728635519, 46.55997759187332],
              [-0.5998993325309119, 46.52984762473857],
              [-0.6298632235474342, 46.52984762473857],
              [-0.6400295437137542, 46.50988198386615],
              [-0.6202319728635519, 46.4699507021213],
              [-0.6202319728635519, 46.439820734986554],
              [-0.6400295437137542, 46.43001942037646],
              [-0.6400295437137542, 46.41005377950403],
              [-0.6100656526972319, 46.41005377950403],
              [-0.5699354415143887, 46.39008813863161],
              [-0.5399715504978664, 46.39008813863161],
              [-0.5597691213480687, 46.359958171496864],
              [-0.5998993325309119, 46.359958171496864],
              [-0.6400295437137542, 46.320026889752015],
              [-0.6699934347302765, 46.320026889752015],
              [-0.6999573257467997, 46.329828204362116],
              [-0.729921216763322, 46.300061248879594],
              [-0.750253857095962, 46.300061248879594],
              [-0.8000153189626875, 46.329828204362116],
              [-0.8000153189626875, 46.33999253062444],
              [-0.8401455301455298, 46.33999253062444],
              [-0.870109421162053, 46.320026889752015],
              [-0.8899069920122553, 46.329828204362116],
              [-0.9102396323448954, 46.309862563489695],
              [-0.9600010942116208, 46.320026889752015],
              [-0.9402035233614177, 46.33999253062444],
              [-0.9498347740452999, 46.359958171496864],
              [-0.9701674143779409, 46.35015685688676],
              [-1.0199288762446654, 46.35015685688676],
              [-1.0498927672611886, 46.33999253062444],
              [-1.100189298610351, 46.309862563489695],
              [-1.1301531896268737, 46.309862563489695],
              [-1.1499507604770765, 46.320026889752015],
              [-1.2002472918262392, 46.320026889752015],
              [-1.2098785425101215, 46.28009560800717],
              [-1.230211182842762, 46.28009560800717],
              [-1.3201028558923298, 46.329828204362116],
              [-1.350066746908852, 46.33999253062444],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 31,
        name: "Haute-Garonne",
        REG: 76,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.0101247401247404, 43.0100866447565],
            [0.9801608491082181, 42.97015536301165],
            [0.9298643177590549, 42.97015536301165],
            [0.9100667469088526, 42.95999103674933],
            [0.8699365357260094, 42.95999103674933],
            [0.8897341065762117, 42.9400253958769],
            [0.8801028558923294, 42.92986106961458],
            [0.8399726447094871, 42.92986106961458],
            [0.829806324543167, 42.92005975500448],
            [0.8399726447094871, 42.90009411413206],
            [0.8399726447094871, 42.86996414699731],
            [0.8597702155596894, 42.83003286525246],
            [0.7800448626764416, 42.839834179862564],
            [0.7399146514935993, 42.849998506124884],
            [0.7297483313272792, 42.86016283238721],
            [0.6799868694605538, 42.86016283238721],
            [0.6601892986103515, 42.839834179862564],
            [0.6601892986103515, 42.799902898117715],
            [0.6398566582777114, 42.779937257245294],
            [0.6601892986103515, 42.77013594263519],
            [0.6601892986103515, 42.75017030176277],
            [0.6799868694605538, 42.7098760083657],
            [0.6698205492942337, 42.689910367493276],
            [0.6200590874275083, 42.7000746937556],
            [0.5301674143779405, 42.7000746937556],
            [0.5200010942116204, 42.689910367493276],
            [0.49003720319509814, 42.689910367493276],
            [0.4798708830287781, 42.7000746937556],
            [0.4798708830287781, 42.7098760083657],
            [0.4499069920122549, 42.729841649238125],
            [0.46007331217857583, 42.740005975500445],
            [0.46007331217857583, 42.849998506124884],
            [0.4798708830287781, 42.88012847325963],
            [0.5002035233614182, 42.86996414699731],
            [0.5301674143779405, 42.86996414699731],
            [0.5601313053944637, 42.86016283238721],
            [0.5799288762446659, 42.86996414699731],
            [0.600261516577306, 42.92986106961458],
            [0.6302254075938292, 42.9400253958769],
            [0.6500229784440315, 42.95999103674933],
            [0.6200590874275083, 42.97015536301165],
            [0.6302254075938292, 42.99992231849417],
            [0.6098927672611882, 43.03005228562892],
            [0.590095196410986, 43.01988795936659],
            [0.5601313053944637, 43.01988795936659],
            [0.5499649852281436, 42.99992231849417],
            [0.5301674143779405, 42.99992231849417],
            [0.5397986650618227, 43.03985360023902],
            [0.5697625560783459, 43.03985360023902],
            [0.5601313053944637, 43.06998356737377],
            [0.5301674143779405, 43.08014789363609],
            [0.5002035233614182, 43.100113534508516],
            [0.49003720319509814, 43.12007917538094],
            [0.46007331217857583, 43.10991484911861],
            [0.4499069920122549, 43.12988048999104],
            [0.46007331217857583, 43.14984613086346],
            [0.5002035233614182, 43.170174783388106],
            [0.5200010942116204, 43.190140424260534],
            [0.5200010942116204, 43.210106065132955],
            [0.5499649852281436, 43.210106065132955],
            [0.5697625560783459, 43.21990737974305],
            [0.5499649852281436, 43.23987302061548],
            [0.6200590874275083, 43.280167314012544],
            [0.6398566582777114, 43.30013295488497],
            [0.6098927672611882, 43.309934269495066],
            [0.6398566582777114, 43.309934269495066],
            [0.6799868694605538, 43.329899910367494],
            [0.6901531896268738, 43.349865551239915],
            [0.720117080643397, 43.37999551837466],
            [0.7500809716599193, 43.39015984463699],
            [0.7698785425101216, 43.41992680011951],
            [0.8100087536929648, 43.399961159247084],
            [0.8201750738592848, 43.41992680011951],
            [0.8399726447094871, 43.41012548550941],
            [0.9202330670751726, 43.41012548550941],
            [0.9400306379253749, 43.37999551837466],
            [0.9598282087755772, 43.39015984463699],
            [0.9801608491082181, 43.36002987750224],
            [0.9999584199584204, 43.37999551837466],
            [0.9897920997921004, 43.41012548550941],
            [1.0197559908086227, 43.41012548550941],
            [1.0299223109749427, 43.41992680011951],
            [1.0197559908086227, 43.43989244099193],
            [1.0400886311412627, 43.459858081864354],
            [1.0197559908086227, 43.479823722736775],
            [1.059886201991465, 43.50015237526143],
            [1.0502549513075827, 43.52011801613385],
            [1.059886201991465, 43.54008365700627],
            [1.080218842324106, 43.54988497161637],
            [1.1000164131743082, 43.52991933074395],
            [1.1198139840245105, 43.54988497161637],
            [1.1599441952073537, 43.5600492978787],
            [1.1599441952073537, 43.56985061248879],
            [1.200074406390196, 43.56985061248879],
            [1.200074406390196, 43.59998057962354],
            [1.189908086223876, 43.61014490588587],
            [1.1599441952073537, 43.61014490588587],
            [1.1401466243571505, 43.61994622049597],
            [1.1497778750410328, 43.63991186136839],
            [1.1198139840245105, 43.63991186136839],
            [1.0898500930079882, 43.63991186136839],
            [1.1000164131743082, 43.65987750224081],
            [1.070052522157786, 43.65987750224081],
            [1.0502549513075827, 43.67984314311323],
            [1.059886201991465, 43.700171795637885],
            [1.0197559908086227, 43.70997311024798],
            [1.0101247401247404, 43.72993875112041],
            [0.9897920997921004, 43.74010307738273],
            [0.9598282087755772, 43.76987003286525],
            [0.9501969580916949, 43.78983567373768],
            [0.9801608491082181, 43.78983567373768],
            [0.9897920997921004, 43.8],
            [1.059886201991465, 43.8],
            [1.080218842324106, 43.819965640872425],
            [1.1198139840245105, 43.8],
            [1.1401466243571505, 43.819965640872425],
            [1.179741766057556, 43.8],
            [1.179741766057556, 43.78983567373768],
            [1.2198719772403983, 43.78983567373768],
            [1.210240726556516, 43.76987003286525],
            [1.2701685085895615, 43.78983567373768],
            [1.2701685085895615, 43.8],
            [1.309763650289966, 43.8],
            [1.3600601816391293, 43.819965640872425],
            [1.3498938614728093, 43.839931281744846],
            [1.309763650289966, 43.830129967134745],
            [1.3001323996060838, 43.850095608007166],
            [1.3199299704562861, 43.85989692261727],
            [1.340262610788927, 43.850095608007166],
            [1.3702265018054494, 43.890026889752015],
            [1.4199879636721748, 43.870061248879594],
            [1.4499518546886971, 43.870061248879594],
            [1.4799157457052194, 43.909992530624436],
            [1.5002483860378595, 43.890026889752015],
            [1.5302122770543827, 43.92015685688676],
            [1.560176168070905, 43.92015685688676],
            [1.550009847904585, 43.890026889752015],
            [1.5698074187547872, 43.850095608007166],
            [1.5901400590874273, 43.839931281744846],
            [1.5901400590874273, 43.819965640872425],
            [1.6500678411204728, 43.78983567373768],
            [1.6602341612867928, 43.76987003286525],
            [1.6500678411204728, 43.74990439199283],
            [1.680031732136995, 43.74010307738273],
            [1.7099956231535183, 43.720137436510306],
            [1.6602341612867928, 43.69000746937556],
            [1.7201619433198383, 43.69000746937556],
            [1.7201619433198383, 43.65987750224081],
            [1.6998293029871983, 43.65007618763072],
            [1.690198052303316, 43.63011054675829],
            [1.7201619433198383, 43.61994622049597],
            [1.7399595141700406, 43.59998057962354],
            [1.7699234051865629, 43.59998057962354],
            [1.7902560455192038, 43.58001493875112],
            [1.8400175073859284, 43.58001493875112],
            [1.8501838275522484, 43.54988497161637],
            [1.8699813984024516, 43.52991933074395],
            [1.9197428602691762, 43.50995368987152],
            [1.9502418207681371, 43.4899880489991],
            [1.9802057117846594, 43.4899880489991],
            [2.019800853485064, 43.47002240812668],
            [2.0101696028011817, 43.45005676725425],
            [2.029967173651384, 43.43989244099193],
            [2.040133493817705, 43.41992680011951],
            [2.0101696028011817, 43.41992680011951],
            [1.9898369624685417, 43.41012548550941],
            [1.9700393916183394, 43.41992680011951],
            [1.9197428602691762, 43.41992680011951],
            [1.899945289418974, 43.41012548550941],
            [1.8598150782361307, 43.43989244099193],
            [1.8202199365357261, 43.41012548550941],
            [1.8298511872196084, 43.39015984463699],
            [1.799887296203086, 43.39015984463699],
            [1.810053616369406, 43.36002987750224],
            [1.799887296203086, 43.340064236629814],
            [1.7297931940037206, 43.340064236629814],
            [1.7399595141700406, 43.32009859575739],
            [1.7099956231535183, 43.30013295488497],
            [1.690198052303316, 43.270002987750225],
            [1.669865411970675, 43.280167314012544],
            [1.6399015209541528, 43.2500373468778],
            [1.5997713097713095, 43.270002987750225],
            [1.5698074187547872, 43.270002987750225],
            [1.5200459568880627, 43.289968628622645],
            [1.5002483860378595, 43.289968628622645],
            [1.4900820658715395, 43.2598386614879],
            [1.5002483860378595, 43.2500373468778],
            [1.4697494255388994, 43.210106065132955],
            [1.4499518546886971, 43.210106065132955],
            [1.4199879636721748, 43.230071706005376],
            [1.4301542838384949, 43.2598386614879],
            [1.3798577524893316, 43.289968628622645],
            [1.3702265018054494, 43.309934269495066],
            [1.3498938614728093, 43.32009859575739],
            [1.3001323996060838, 43.289968628622645],
            [1.3001323996060838, 43.270002987750225],
            [1.330096290622607, 43.2598386614879],
            [1.3498938614728093, 43.23987302061548],
            [1.3702265018054494, 43.23987302061548],
            [1.3798577524893316, 43.21990737974305],
            [1.3001323996060838, 43.190140424260534],
            [1.2797997592734438, 43.19994173887063],
            [1.2300382974067183, 43.170174783388106],
            [1.2198719772403983, 43.14984613086346],
            [1.2701685085895615, 43.14984613086346],
            [1.3001323996060838, 43.12007917538094],
            [1.2600021884232415, 43.10991484911861],
            [1.2600021884232415, 43.08994920824619],
            [1.2198719772403983, 43.08994920824619],
            [1.200074406390196, 43.12988048999104],
            [1.1497778750410328, 43.14004481625336],
            [1.1198139840245105, 43.160010457125786],
            [1.1101827333406282, 43.14004481625336],
            [1.0898500930079882, 43.12988048999104],
            [1.059886201991465, 43.14004481625336],
            [1.0400886311412627, 43.100113534508516],
            [1.0101247401247404, 43.10991484911861],
            [0.9897920997921004, 43.08994920824619],
            [0.9897920997921004, 43.01988795936659],
            [1.0101247401247404, 43.0100866447565],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 63, name: "Puy-de-Dôme", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.100106138527191, 45.35005975500448],
            [3.0701422475106694, 45.33989542874216],
            [3.0701422475106694, 45.31992978786973],
            [3.019845716161506, 45.29016283238721],
            [3.000048145311303, 45.29016283238721],
            [2.9700842542947816, 45.31012847325964],
            [2.94975161396214, 45.31012847325964],
            [2.9299540431119384, 45.33009411413206],
            [2.9197877229456184, 45.37002539587691],
            [2.889823831929095, 45.379826710487],
            [2.859859940912573, 45.379826710487],
            [2.8202647992121683, 45.40015536301165],
            [2.7897658387132074, 45.38999103674933],
            [2.729838056680162, 45.38999103674933],
            [2.7100404858299596, 45.379826710487],
            [2.6998741656636396, 45.40015536301165],
            [2.6800765948134373, 45.40995667762175],
            [2.6902429149797573, 45.4400866447565],
            [2.6597439544807973, 45.42992231849418],
            [2.639946383630594, 45.4498879593666],
            [2.5800186015975495, 45.4498879593666],
            [2.5698522814312295, 45.46005228562892],
            [2.5398883904147063, 45.46005228562892],
            [2.5398883904147063, 45.48001792650135],
            [2.509924499398184, 45.48001792650135],
            [2.509924499398184, 45.51994920824619],
            [2.520090819564504, 45.55007917538094],
            [2.4601630375314585, 45.590010457125786],
            [2.4799606083816617, 45.60997609799821],
            [2.4799606083816617, 45.640106065132954],
            [2.520090819564504, 45.640106065132954],
            [2.530257139730824, 45.660071706005375],
            [2.509924499398184, 45.669873020615476],
            [2.530257139730824, 45.6898386614879],
            [2.520090819564504, 45.71016731401255],
            [2.4901269285479817, 45.73993426949507],
            [2.430199146514936, 45.77006423662982],
            [2.430199146514936, 45.79002987750224],
            [2.390068935332094, 45.82996115924709],
            [2.400235255498414, 45.84012548550941],
            [2.430199146514936, 45.82996115924709],
            [2.4398303971988184, 45.86989244099193],
            [2.4697942882153407, 45.86989244099193],
            [2.4901269285479817, 45.86009112638183],
            [2.509924499398184, 45.889858081864354],
            [2.5500547105810263, 45.90982372273678],
            [2.5398883904147063, 45.9199880489991],
            [2.5698522814312295, 45.95991933074395],
            [2.609982492614072, 45.97008365700628],
            [2.5901849217638695, 45.9998506124888],
            [2.5998161724477518, 46.02998057962354],
            [2.5698522814312295, 46.04994622049597],
            [2.5500547105810263, 46.080076187630716],
            [2.5500547105810263, 46.12000746937556],
            [2.5698522814312295, 46.139973110247986],
            [2.620148812780392, 46.12000746937556],
            [2.650112703796915, 46.130171795637885],
            [2.6800765948134373, 46.15993875112041],
            [2.6902429149797573, 46.17990439199283],
            [2.7202068059962796, 46.17990439199283],
            [2.729838056680162, 46.21983567373768],
            [2.750170697012803, 46.21983567373768],
            [2.7897658387132074, 46.199870032865256],
            [2.8202647992121683, 46.210034359127576],
            [2.8202647992121683, 46.240164326262324],
            [2.859859940912573, 46.260129967134745],
            [2.870026261078893, 46.249965640872425],
            [2.9299540431119384, 46.249965640872425],
            [2.9401203632782584, 46.240164326262324],
            [2.9101564722617352, 46.210034359127576],
            [2.9197877229456184, 46.170103077382734],
            [2.94975161396214, 46.170103077382734],
            [2.9599179341284616, 46.130171795637885],
            [3.0300120363278262, 46.10004182850314],
            [3.100106138527191, 46.10004182850314],
            [3.100106138527191, 46.080076187630716],
            [3.130070029543714, 46.06991186136839],
            [3.260091913776125, 46.06991186136839],
            [3.2798894846263265, 46.060110546758295],
            [3.3200196958091697, 46.060110546758295],
            [3.3301860159754897, 46.04014490588587],
            [3.3697811576758943, 46.04994622049597],
            [3.3997450486924174, 46.06991186136839],
            [3.4302440091913775, 46.060110546758295],
            [3.4602079002079007, 46.060110546758295],
            [3.469839150891782, 46.02998057962354],
            [3.4602079002079007, 46.01001493875112],
            [3.5201356822409453, 46.01001493875112],
            [3.5201356822409453, 46.02017926501345],
            [3.5902297844403117, 46.02017926501345],
            [3.6399912463070363, 45.97008365700628],
            [3.6801214574898795, 45.95991933074395],
            [3.689752708173761, 45.93015237526143],
            [3.740049239522924, 45.90982372273678],
            [3.750215559689244, 45.889858081864354],
            [3.720251668672721, 45.84992680011951],
            [3.729882919356604, 45.82996115924709],
            [3.699919028340081, 45.779865551239915],
            [3.729882919356604, 45.779865551239915],
            [3.729882919356604, 45.759899910367494],
            [3.7598468103731273, 45.75009859575739],
            [3.7801794507057673, 45.719968628622645],
            [3.7801794507057673, 45.6898386614879],
            [3.7898107013896487, 45.669873020615476],
            [3.819774592406172, 45.649907379743055],
            [3.819774592406172, 45.62994173887063],
            [3.859904803589015, 45.62014042426053],
            [3.880237443921655, 45.60017478338811],
            [3.9102013349381766, 45.60017478338811],
            [3.949796476638583, 45.55988048999104],
            [3.959962796804903, 45.49998356737377],
            [3.9899266878214243, 45.48981924111144],
            [3.970129116971223, 45.46985360023902],
            [3.970129116971223, 45.4498879593666],
            [3.9000350147718565, 45.40995667762175],
            [3.8898686946055365, 45.38999103674933],
            [3.9000350147718565, 45.35986106961458],
            [3.849738483422695, 45.35986106961458],
            [3.840107232738812, 45.379826710487],
            [3.8101433417222887, 45.38999103674933],
            [3.7898107013896487, 45.379826710487],
            [3.7801794507057673, 45.35005975500448],
            [3.740049239522924, 45.35005975500448],
            [3.729882919356604, 45.35986106961458],
            [3.699919028340081, 45.35986106961458],
            [3.6801214574898795, 45.379826710487],
            [3.6597888171572377, 45.35986106961458],
            [3.620193675456833, 45.33989542874216],
            [3.5902297844403117, 45.35986106961458],
            [3.5698971441076717, 45.40015536301165],
            [3.5201356822409453, 45.40015536301165],
            [3.4998030419083053, 45.42992231849418],
            [3.4602079002079007, 45.40995667762175],
            [3.4602079002079007, 45.40015536301165],
            [3.3799474778422143, 45.40015536301165],
            [3.360149906992013, 45.42012100388408],
            [3.3098533756428496, 45.42012100388408],
            [3.2900558047926465, 45.40015536301165],
            [3.239759273443485, 45.38999103674933],
            [3.1798314914104386, 45.35986106961458],
            [3.1798314914104386, 45.35005975500448],
            [3.100106138527191, 45.35005975500448],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: "03", name: "Allier", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.279844621949885, 46.41985509411413],
            [2.279844621949885, 46.44998506124888],
            [2.3301411532990484, 46.50008066925605],
            [2.369736294999453, 46.52004631012847],
            [2.409866506182296, 46.52004631012847],
            [2.430199146514936, 46.52984762473857],
            [2.4499967173651385, 46.52004631012847],
            [2.4697942882153407, 46.52984762473857],
            [2.530257139730824, 46.52984762473857],
            [2.5398883904147063, 46.52004631012847],
            [2.609982492614072, 46.55017627726322],
            [2.5998161724477518, 46.59990887361817],
            [2.5800186015975495, 46.61007319988049],
            [2.5800186015975495, 46.63003884075292],
            [2.5998161724477518, 46.63984015536301],
            [2.5698522814312295, 46.66016880788766],
            [2.609982492614072, 46.66997012249776],
            [2.620148812780392, 46.68993576337019],
            [2.650112703796915, 46.68993576337019],
            [2.6998741656636396, 46.72006573050493],
            [2.6998741656636396, 46.740031371377356],
            [2.729838056680162, 46.74983268598745],
            [2.740004376846483, 46.72986704511503],
            [2.759801947696685, 46.72006573050493],
            [2.8400623700623706, 46.740031371377356],
            [2.880192581245213, 46.75999701224978],
            [2.9299540431119384, 46.799928293994626],
            [3.019845716161506, 46.799928293994626],
            [3.0300120363278262, 46.790126979384524],
            [3.0498096071780294, 46.75999701224978],
            [3.100106138527191, 46.72986704511503],
            [3.130070029543714, 46.72986704511503],
            [3.1702002407265573, 46.68993576337019],
            [3.219961702593282, 46.680134448760086],
            [3.230128022759602, 46.70010008963251],
            [3.270258233942445, 46.72006573050493],
            [3.3002221249589683, 46.72006573050493],
            [3.3002221249589683, 46.70010008963251],
            [3.349983586825693, 46.680134448760086],
            [3.3697811576758943, 46.68993576337019],
            [3.3799474778422143, 46.70990140424261],
            [3.4302440091913775, 46.70990140424261],
            [3.4500415800415807, 46.68993576337019],
            [3.4500415800415807, 46.66016880788766],
            [3.4602079002079007, 46.65000448162534],
            [3.490171791224424, 46.66016880788766],
            [3.5201356822409453, 46.68993576337019],
            [3.5399332530911485, 46.680134448760086],
            [3.5602658934237885, 46.68993576337019],
            [3.5500995732574685, 46.72006573050493],
            [3.5800634642739917, 46.72006573050493],
            [3.599861035124193, 46.72986704511503],
            [3.5800634642739917, 46.74983268598745],
            [3.6298249261407163, 46.74983268598745],
            [3.620193675456833, 46.740031371377356],
            [3.6399912463070363, 46.70990140424261],
            [3.6699551373235595, 46.680134448760086],
            [3.699919028340081, 46.66016880788766],
            [3.720251668672721, 46.63003884075292],
            [3.720251668672721, 46.61007319988049],
            [3.740049239522924, 46.57994323274574],
            [3.740049239522924, 46.5400119510009],
            [3.7700131305394473, 46.5400119510009],
            [3.8101433417222887, 46.52004631012847],
            [3.840107232738812, 46.52984762473857],
            [3.859904803589015, 46.52004631012847],
            [3.859904803589015, 46.50008066925605],
            [3.8898686946055365, 46.48011502838363],
            [3.9198325856220597, 46.50008066925605],
            [3.9299989057883797, 46.48991634299372],
            [3.959962796804903, 46.48991634299372],
            [4.000093007987744, 46.46014938751121],
            [4.000093007987744, 46.43001942037646],
            [3.9797603676551043, 46.39008813863161],
            [3.9899266878214243, 46.37012249775919],
            [3.9899266878214243, 46.329828204362116],
            [3.9797603676551043, 46.320026889752015],
            [3.949796476638583, 46.320026889752015],
            [3.949796476638583, 46.300061248879594],
            [3.9000350147718565, 46.289896922617274],
            [3.9000350147718565, 46.28009560800717],
            [3.880237443921655, 46.28009560800717],
            [3.870071123755335, 46.260129967134745],
            [3.8101433417222887, 46.260129967134745],
            [3.7999770215559687, 46.240164326262324],
            [3.7700131305394473, 46.230000000000004],
            [3.7898107013896487, 46.210034359127576],
            [3.7898107013896487, 46.190068718255155],
            [3.8101433417222887, 46.15993875112041],
            [3.7898107013896487, 46.15993875112041],
            [3.7999770215559687, 46.10984314311324],
            [3.819774592406172, 46.08987750224081],
            [3.8101433417222887, 46.04014490588587],
            [3.829940912572492, 45.9998506124888],
            [3.8101433417222887, 45.97988497161637],
            [3.7801794507057673, 45.97008365700628],
            [3.699919028340081, 45.97008365700628],
            [3.689752708173761, 45.93015237526143],
            [3.6801214574898795, 45.95991933074395],
            [3.6399912463070363, 45.97008365700628],
            [3.5902297844403117, 46.02017926501345],
            [3.5201356822409453, 46.02017926501345],
            [3.5201356822409453, 46.01001493875112],
            [3.4602079002079007, 46.01001493875112],
            [3.469839150891782, 46.02998057962354],
            [3.4602079002079007, 46.060110546758295],
            [3.4302440091913775, 46.060110546758295],
            [3.3997450486924174, 46.06991186136839],
            [3.3697811576758943, 46.04994622049597],
            [3.3301860159754897, 46.04014490588587],
            [3.3200196958091697, 46.060110546758295],
            [3.2798894846263265, 46.060110546758295],
            [3.260091913776125, 46.06991186136839],
            [3.130070029543714, 46.06991186136839],
            [3.100106138527191, 46.080076187630716],
            [3.100106138527191, 46.10004182850314],
            [3.0300120363278262, 46.10004182850314],
            [2.9599179341284616, 46.130171795637885],
            [2.94975161396214, 46.170103077382734],
            [2.9197877229456184, 46.170103077382734],
            [2.9101564722617352, 46.210034359127576],
            [2.9401203632782584, 46.240164326262324],
            [2.9299540431119384, 46.249965640872425],
            [2.870026261078893, 46.249965640872425],
            [2.859859940912573, 46.260129967134745],
            [2.8202647992121683, 46.240164326262324],
            [2.8202647992121683, 46.210034359127576],
            [2.7897658387132074, 46.199870032865256],
            [2.750170697012803, 46.21983567373768],
            [2.729838056680162, 46.21983567373768],
            [2.7202068059962796, 46.17990439199283],
            [2.6902429149797573, 46.17990439199283],
            [2.6800765948134373, 46.15993875112041],
            [2.650112703796915, 46.130171795637885],
            [2.620148812780392, 46.12000746937556],
            [2.5698522814312295, 46.139973110247986],
            [2.560221030747347, 46.170103077382734],
            [2.520090819564504, 46.199870032865256],
            [2.520090819564504, 46.240164326262324],
            [2.4901269285479817, 46.249965640872425],
            [2.4697942882153407, 46.289896922617274],
            [2.420032826348616, 46.289896922617274],
            [2.420032826348616, 46.309862563489695],
            [2.390068935332094, 46.329828204362116],
            [2.3601050443155707, 46.320026889752015],
            [2.3098085129664083, 46.329828204362116],
            [2.3098085129664083, 46.359958171496864],
            [2.3301411532990484, 46.379923812369285],
            [2.290010942116205, 46.379923812369285],
            [2.279844621949885, 46.39008813863161],
            [2.279844621949885, 46.41985509411413],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 73, name: "Savoie", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.670044862676442, 45.55007917538094],
            [5.670044862676442, 45.55988048999104],
            [5.619748331327279, 45.60997609799821],
            [5.650247291826239, 45.62994173887063],
            [5.650247291826239, 45.640106065132954],
            [5.689842433526645, 45.640106065132954],
            [5.689842433526645, 45.669873020615476],
            [5.710175073859285, 45.6800373468778],
            [5.700008753692965, 45.71016731401255],
            [5.75993653572601, 45.71016731401255],
            [5.779734106576213, 45.73013295488497],
            [5.779734106576213, 45.799831192112336],
            [5.800066746908853, 45.82996115924709],
            [5.830030637925375, 45.90002240812668],
            [5.830030637925375, 45.93995368987153],
            [5.859994528941898, 45.93015237526143],
            [5.879792099792101, 45.86009112638183],
            [5.870160849108218, 45.84012548550941],
            [5.900124740124741, 45.82996115924709],
            [5.900124740124741, 45.80999551837466],
            [5.960052522157786, 45.80999551837466],
            [5.979850093007989, 45.799831192112336],
            [5.970218842324106, 45.77006423662982],
            [6.039777875041033, 45.73993426949507],
            [6.060110515373673, 45.75009859575739],
            [6.100240726556517, 45.73993426949507],
            [6.100240726556517, 45.759899910367494],
            [6.169799759273444, 45.759899910367494],
            [6.190132399606084, 45.700002987750224],
            [6.230262610788928, 45.700002987750224],
            [6.280024072655652, 45.6800373468778],
            [6.329785534522377, 45.6898386614879],
            [6.350118174855017, 45.719968628622645],
            [6.350118174855017, 45.73993426949507],
            [6.36991574570522, 45.75009859575739],
            [6.3597494255389, 45.77006423662982],
            [6.39024838603786, 45.779865551239915],
            [6.420212277054383, 45.799831192112336],
            [6.450176168070905, 45.84012548550941],
            [6.469973738921108, 45.88005676725426],
            [6.499937629937631, 45.889858081864354],
            [6.510103950103951, 45.90982372273678],
            [6.559865411970676, 45.889858081864354],
            [6.570031732136996, 45.86009112638183],
            [6.5400678411204725, 45.86009112638183],
            [6.550234161286794, 45.82996115924709],
            [6.580198052303316, 45.82015984463699],
            [6.580198052303316, 45.799831192112336],
            [6.6599234051865634, 45.799831192112336],
            [6.6599234051865634, 45.79002987750224],
            [6.689887296203087, 45.77006423662982],
            [6.689887296203087, 45.73013295488497],
            [6.710219936535727, 45.719968628622645],
            [6.759981398402451, 45.77006423662982],
            [6.8001116095852945, 45.779865551239915],
            [6.809742860269176, 45.73013295488497],
            [6.849873071452019, 45.6898386614879],
            [6.870205711784659, 45.6800373468778],
            [6.9098008534850655, 45.6800373468778],
            [6.9098008534850655, 45.649907379743055],
            [6.97989495568443, 45.649907379743055],
            [7.00022759601707, 45.640106065132954],
            [6.97989495568443, 45.590010457125786],
            [7.00022759601707, 45.53991484911862],
            [7.00022759601707, 45.49998356737377],
            [7.049989057883795, 45.49998356737377],
            [7.060155378050115, 45.48981924111144],
            [7.049989057883795, 45.46985360023902],
            [7.099750519750521, 45.46985360023902],
            [7.109916839916841, 45.42992231849418],
            [7.180010942116206, 45.40995667762175],
            [7.180010942116206, 45.38999103674933],
            [7.1398807309333625, 45.35005975500448],
            [7.130249480249481, 45.33009411413206],
            [7.109916839916841, 45.33009411413206],
            [7.120083160083161, 45.29996414699731],
            [7.1398807309333625, 45.27999850612489],
            [7.130249480249481, 45.24986853899014],
            [7.069786628733998, 45.20993725724529],
            [7.039822737717475, 45.22010158350762],
            [7.00022759601707, 45.22010158350762],
            [6.970263705000547, 45.20993725724529],
            [6.949931064667907, 45.18997161637287],
            [6.949931064667907, 45.170005975500445],
            [6.890003282634862, 45.170005975500445],
            [6.890003282634862, 45.139876008365704],
            [6.849873071452019, 45.1300746937556],
            [6.770147718568771, 45.159841649238125],
            [6.749815078236131, 45.139876008365704],
            [6.6802560455192035, 45.139876008365704],
            [6.6700897253528835, 45.119910367493276],
            [6.640125834336362, 45.119910367493276],
            [6.62995951417004, 45.11010905288318],
            [6.610161943319839, 45.119910367493276],
            [6.580198052303316, 45.119910367493276],
            [6.559865411970676, 45.099944726620855],
            [6.529901520954152, 45.099944726620855],
            [6.510103950103951, 45.11010905288318],
            [6.480140059087428, 45.090143412010754],
            [6.489771309771311, 45.060013444876006],
            [6.450176168070905, 45.049849118613686],
            [6.429843527738265, 45.060013444876006],
            [6.399879636721743, 45.060013444876006],
            [6.3597494255389, 45.07017777113833],
            [6.36991574570522, 45.099944726620855],
            [6.329785534522377, 45.119910367493276],
            [6.320154283838495, 45.11010905288318],
            [6.280024072655652, 45.11010905288318],
            [6.260226501805449, 45.1300746937556],
            [6.239893861472809, 45.150040334628024],
            [6.220096290622608, 45.139876008365704],
            [6.209929970456288, 45.159841649238125],
            [6.179966079439764, 45.159841649238125],
            [6.169799759273444, 45.150040334628024],
            [6.139835868256921, 45.150040334628024],
            [6.160168508589561, 45.18997161637287],
            [6.13020461757304, 45.229902898117714],
            [6.139835868256921, 45.26003286525246],
            [6.13020461757304, 45.27999850612489],
            [6.139835868256921, 45.29996414699731],
            [6.190132399606084, 45.33009411413206],
            [6.179966079439764, 45.35986106961458],
            [6.190132399606084, 45.37002539587691],
            [6.179966079439764, 45.38999103674933],
            [6.150002188423241, 45.40995667762175],
            [6.13020461757304, 45.4400866447565],
            [6.100240726556517, 45.42992231849418],
            [6.090074406390197, 45.4400866447565],
            [6.049944195207353, 45.4400866447565],
            [6.00981398402451, 45.4498879593666],
            [6.00981398402451, 45.46985360023902],
            [5.970218842324106, 45.48981924111144],
            [5.919922310974942, 45.48001792650135],
            [5.930088631141262, 45.46005228562892],
            [5.919922310974942, 45.4400866447565],
            [5.900124740124741, 45.42992231849418],
            [5.930088631141262, 45.40995667762175],
            [5.909755990808622, 45.38999103674933],
            [5.889958419958421, 45.38999103674933],
            [5.879792099792101, 45.40995667762175],
            [5.830030637925375, 45.42012100388408],
            [5.789900426742533, 45.4400866447565],
            [5.740138964875807, 45.4400866447565],
            [5.729972644709487, 45.4498879593666],
            [5.740138964875807, 45.46985360023902],
            [5.719806324543167, 45.48001792650135],
            [5.700008753692965, 45.51994920824619],
            [5.670044862676442, 45.55007917538094],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 34, name: "Hérault", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.5698522814312295, 43.41992680011951],
            [2.609982492614072, 43.43009112638183],
            [2.639946383630594, 43.459858081864354],
            [2.6597439544807973, 43.459858081864354],
            [2.6597439544807973, 43.52011801613385],
            [2.629780063464274, 43.54988497161637],
            [2.620148812780392, 43.56985061248879],
            [2.629780063464274, 43.58001493875112],
            [2.620148812780392, 43.59998057962354],
            [2.629780063464274, 43.63011054675829],
            [2.650112703796915, 43.65007618763072],
            [2.6902429149797573, 43.65007618763072],
            [2.7202068059962796, 43.63991186136839],
            [2.750170697012803, 43.61994622049597],
            [2.769968267863005, 43.61994622049597],
            [2.8100984790458474, 43.63991186136839],
            [2.8502286902286906, 43.63991186136839],
            [2.880192581245213, 43.65987750224081],
            [2.9101564722617352, 43.65007618763072],
            [2.9197877229456184, 43.65987750224081],
            [2.9197877229456184, 43.69000746937556],
            [2.9401203632782584, 43.69000746937556],
            [2.9802505744611016, 43.70997311024798],
            [3.000048145311303, 43.70997311024798],
            [3.0300120363278262, 43.69000746937556],
            [3.0701422475106694, 43.70997311024798],
            [3.0498096071780294, 43.74010307738273],
            [3.0701422475106694, 43.760068718255155],
            [3.0498096071780294, 43.8],
            [3.0599759273443494, 43.810164326262324],
            [3.0599759273443494, 43.839931281744846],
            [3.089939818360871, 43.839931281744846],
            [3.149867600393917, 43.810164326262324],
            [3.209795382426962, 43.810164326262324],
            [3.249925593609805, 43.839931281744846],
            [3.239759273443485, 43.870061248879594],
            [3.2900558047926465, 43.890026889752015],
            [3.339817266659373, 43.890026889752015],
            [3.360149906992013, 43.909992530624436],
            [3.4200776890250575, 43.909992530624436],
            [3.4398752598752607, 43.899828204362116],
            [3.4302440091913775, 43.870061248879594],
            [3.4602079002079007, 43.870061248879594],
            [3.480005471058104, 43.890026889752015],
            [3.5099693620746253, 43.899828204362116],
            [3.5201356822409453, 43.870061248879594],
            [3.5500995732574685, 43.850095608007166],
            [3.5800634642739917, 43.839931281744846],
            [3.5800634642739917, 43.879862563489695],
            [3.620193675456833, 43.92015685688676],
            [3.6399912463070363, 43.909992530624436],
            [3.6699551373235595, 43.909992530624436],
            [3.6801214574898795, 43.949923812369285],
            [3.729882919356604, 43.969889453241706],
            [3.7898107013896487, 43.969889453241706],
            [3.7999770215559687, 43.940122497759184],
            [3.829940912572492, 43.940122497759184],
            [3.7999770215559687, 43.890026889752015],
            [3.819774592406172, 43.870061248879594],
            [3.849738483422695, 43.870061248879594],
            [3.859904803589015, 43.879862563489695],
            [3.9000350147718565, 43.879862563489695],
            [3.9198325856220597, 43.85989692261727],
            [3.959962796804903, 43.850095608007166],
            [3.9797603676551043, 43.830129967134745],
            [3.959962796804903, 43.819965640872425],
            [3.970129116971223, 43.8],
            [4.000093007987744, 43.810164326262324],
            [4.049854469854471, 43.78983567373768],
            [4.049854469854471, 43.76987003286525],
            [4.079818360870992, 43.76987003286525],
            [4.109782251887515, 43.74010307738273],
            [4.1397461429040385, 43.74010307738273],
            [4.170245103402999, 43.700171795637885],
            [4.160078783236679, 43.69000746937556],
            [4.190042674253202, 43.65007618763072],
            [4.170245103402999, 43.61014490588587],
            [4.1499124630703585, 43.59017926501345],
            [4.079818360870992, 43.59017926501345],
            [4.109782251887515, 43.56985061248879],
            [4.100151001203634, 43.54988497161637],
            [4.070187110187111, 43.5600492978787],
            [4.040223219170588, 43.5600492978787],
            [4.000093007987744, 43.54988497161637],
            [3.9102013349381766, 43.52011801613385],
            [3.829940912572492, 43.47002240812668],
            [3.7898107013896487, 43.43989244099193],
            [3.720251668672721, 43.41992680011951],
            [3.729882919356604, 43.399961159247084],
            [3.689752708173761, 43.39015984463699],
            [3.6501575664733563, 43.39015984463699],
            [3.5698971441076717, 43.329899910367494],
            [3.5099693620746253, 43.270002987750225],
            [3.4398752598752607, 43.280167314012544],
            [3.4398752598752607, 43.289968628622645],
            [3.3997450486924174, 43.289968628622645],
            [3.360149906992013, 43.280167314012544],
            [3.239759273443485, 43.210106065132955],
            [3.209795382426962, 43.230071706005376],
            [3.2001641317430787, 43.2500373468778],
            [3.1600339205602372, 43.23987302061548],
            [3.140236349710034, 43.2598386614879],
            [3.079773498194551, 43.2598386614879],
            [3.0498096071780294, 43.280167314012544],
            [3.010214465477623, 43.280167314012544],
            [3.000048145311303, 43.32009859575739],
            [2.94975161396214, 43.309934269495066],
            [2.9197877229456184, 43.329899910367494],
            [2.889823831929095, 43.329899910367494],
            [2.889823831929095, 43.369831192112336],
            [2.870026261078893, 43.36002987750224],
            [2.870026261078893, 43.329899910367494],
            [2.8502286902286906, 43.329899910367494],
            [2.7897658387132074, 43.289968628622645],
            [2.7897658387132074, 43.270002987750225],
            [2.750170697012803, 43.2500373468778],
            [2.7100404858299596, 43.289968628622645],
            [2.6902429149797573, 43.32009859575739],
            [2.6597439544807973, 43.289968628622645],
            [2.620148812780392, 43.289968628622645],
            [2.5800186015975495, 43.329899910367494],
            [2.5398883904147063, 43.349865551239915],
            [2.560221030747347, 43.369831192112336],
            [2.5500547105810263, 43.37999551837466],
            [2.5698522814312295, 43.399961159247084],
            [2.5698522814312295, 43.41992680011951],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 40, name: "Landes", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.5202188423241054, 43.52991933074395],
            [-1.4902549513075831, 43.56985061248879],
            [-1.4501247401247404, 43.63991186136839],
            [-1.4297920997920999, 43.74010307738273],
            [-1.4099945289418976, 43.78983567373768],
            [-1.3998282087755771, 43.839931281744846],
            [-1.3800306379253748, 43.879862563489695],
            [-1.350066746908852, 44.000019420376454],
            [-1.3201028558923298, 44.12997759187332],
            [-1.290138964875807, 44.27010008963251],
            [-1.2698063245431666, 44.3401613385121],
            [-1.2500087536929643, 44.47011951000896],
            [-1.1098205492942332, 44.499886465491485],
            [-1.090022978444031, 44.53001643262623],
            [-1.0300951964109855, 44.51005079175381],
            [-0.9899649852281431, 44.51005079175381],
            [-0.9797986650618231, 44.479920824619064],
            [-0.9899649852281431, 44.45995518374664],
            [-1.0300951964109855, 44.420023902001795],
            [-0.9701674143779409, 44.42982521661189],
            [-0.9498347740452999, 44.439989542874216],
            [-0.9102396323448954, 44.439989542874216],
            [-0.8401455301455298, 44.420023902001795],
            [-0.8101816391290075, 44.420023902001795],
            [-0.7700514279461643, 44.439989542874216],
            [-0.729921216763322, 44.45015386913654],
            [-0.6897910055804797, 44.439989542874216],
            [-0.6699934347302765, 44.45995518374664],
            [-0.6298632235474342, 44.439989542874216],
            [-0.6298632235474342, 44.40985957573947],
            [-0.6400295437137542, 44.40005826112937],
            [-0.5699354415143887, 44.380092620256946],
            [-0.5298052303315464, 44.360126979384525],
            [-0.5201739796476641, 44.3401613385121],
            [-0.42974723711565854, 44.31983268598745],
            [-0.42974723711565854, 44.29986704511503],
            [-0.37998577524893307, 44.29006573050493],
            [-0.39978334609913535, 44.23997012249776],
            [-0.3901520954152531, 44.20984015536301],
            [-0.30989167304956755, 44.20003884075291],
            [-0.2697614618667252, 44.18987451449059],
            [-0.26013021118284296, 44.20003884075291],
            [-0.21999999999999975, 44.20984015536301],
            [-0.23016632016631977, 44.25993576337018],
            [-0.19003610898347745, 44.27010008963251],
            [-0.17023853813327516, 44.23997012249776],
            [-0.13973957763431422, 44.23016880788766],
            [-0.13010832695043195, 44.20003884075291],
            [-0.13010832695043195, 44.14994323274574],
            [-0.08997811576758963, 44.16010755900807],
            [-0.060014224751066436, 44.14994323274574],
            [-0.00008644271802182857, 44.14994323274574],
            [0.029877448298501363, 44.14014191813564],
            [0.029877448298501363, 44.12997759187332],
            [0.12993544151438918, 44.12017627726322],
            [0.1401017616807092, 44.11001195100089],
            [0.09997155049786599, 44.09004631012847],
            [0.0801739796476637, 44.0301493875112],
            [0.05984133931502367, 44.01998506124888],
            [0.05984133931502367, 44.000019420376454],
            [0.0801739796476637, 43.98005377950403],
            [0.05984133931502367, 43.96008813863161],
            [0.0801739796476637, 43.909992530624436],
            [0.05984133931502367, 43.899828204362116],
            [0.029877448298501363, 43.899828204362116],
            [-0.019884013568224113, 43.929958171496864],
            [0.010079877448298191, 43.949923812369285],
            [-0.04021665390086415, 43.98005377950403],
            [-0.04021665390086415, 43.96008813863161],
            [-0.060014224751066436, 43.96008813863161],
            [-0.10014443593390965, 43.929958171496864],
            [-0.13010832695043195, 43.940122497759184],
            [-0.17986978881715743, 43.940122497759184],
            [-0.20020242914979747, 43.909992530624436],
            [-0.23016632016631977, 43.909992530624436],
            [-0.23016632016631977, 43.890026889752015],
            [-0.20020242914979747, 43.890026889752015],
            [-0.19003610898347745, 43.879862563489695],
            [-0.20983367983367973, 43.85989692261727],
            [-0.19003610898347745, 43.839931281744846],
            [-0.20020242914979747, 43.830129967134745],
            [-0.19003610898347745, 43.810164326262324],
            [-0.23016632016631977, 43.810164326262324],
            [-0.20983367983367973, 43.780034359127576],
            [-0.21999999999999975, 43.76987003286525],
            [-0.19003610898347745, 43.74010307738273],
            [-0.21999999999999975, 43.720137436510306],
            [-0.24996389101652294, 43.70997311024798],
            [-0.23979757085020204, 43.69000746937556],
            [-0.24996389101652294, 43.67984314311323],
            [-0.23979757085020204, 43.65987750224081],
            [-0.26013021118284296, 43.63991186136839],
            [-0.27992778203304525, 43.63991186136839],
            [-0.27992778203304525, 43.61994622049597],
            [-0.24996389101652294, 43.61994622049597],
            [-0.23979757085020204, 43.58001493875112],
            [-0.26013021118284296, 43.59017926501345],
            [-0.29009410219936527, 43.56985061248879],
            [-0.33985556406609074, 43.54988497161637],
            [-0.35002188423241076, 43.5600492978787],
            [-0.40994966626545537, 43.56985061248879],
            [-0.43991355728197856, 43.54988497161637],
            [-0.4602461976146186, 43.5600492978787],
            [-0.42974723711565854, 43.58001493875112],
            [-0.4500798774482986, 43.59998057962354],
            [-0.5298052303315464, 43.5600492978787],
            [-0.5501378706641864, 43.54008365700627],
            [-0.5699354415143887, 43.5600492978787],
            [-0.5998993325309119, 43.54008365700627],
            [-0.6598271145639565, 43.5600492978787],
            [-0.729921216763322, 43.5600492978787],
            [-0.7700514279461643, 43.58001493875112],
            [-0.7898489987963675, 43.5600492978787],
            [-0.8198128898128898, 43.5600492978787],
            [-0.8599431009957321, 43.54008365700627],
            [-0.870109421162053, 43.54988497161637],
            [-0.9102396323448954, 43.54988497161637],
            [-0.9899649852281431, 43.52991933074395],
            [-0.9899649852281431, 43.50015237526143],
            [-1.0199288762446654, 43.50995368987152],
            [-1.1301531896268737, 43.50995368987152],
            [-1.1697483313272787, 43.54988497161637],
            [-1.2500087536929643, 43.52011801613385],
            [-1.290138964875807, 43.50015237526143],
            [-1.4201608491082176, 43.50015237526143],
            [-1.4597559908086226, 43.52011801613385],
            [-1.4800886311412627, 43.54008365700627],
            [-1.5202188423241054, 43.52991933074395],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 46, name: "Lot", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.059886201991465, 44.380092620256946],
            [1.059886201991465, 44.42982521661189],
            [1.0299223109749427, 44.42982521661189],
            [1.0197559908086227, 44.45015386913654],
            [1.0299223109749427, 44.47011951000896],
            [1.0101247401247404, 44.490085150881384],
            [1.0197559908086227, 44.499886465491485],
            [0.9801608491082181, 44.54018075888855],
            [0.9897920997921004, 44.549982073498654],
            [1.0299223109749427, 44.549982073498654],
            [1.080218842324106, 44.5801120406334],
            [1.1000164131743082, 44.5899133552435],
            [1.1299803041908305, 44.62004332237825],
            [1.1497778750410328, 44.629844636988345],
            [1.1497778750410328, 44.67013893038542],
            [1.1701105153736737, 44.67994024499552],
            [1.2198719772403983, 44.67994024499552],
            [1.2198719772403983, 44.69010457125784],
            [1.2701685085895615, 44.71987152674036],
            [1.2899660794397638, 44.71007021213027],
            [1.3001323996060838, 44.73983716761279],
            [1.3199299704562861, 44.73983716761279],
            [1.3199299704562861, 44.76016582013744],
            [1.3001323996060838, 44.78013146100986],
            [1.3001323996060838, 44.80009710188228],
            [1.330096290622607, 44.80989841649238],
            [1.3600601816391293, 44.80989841649238],
            [1.3600601816391293, 44.84002838362713],
            [1.4001903928219717, 44.84982969823723],
            [1.409821643505854, 44.870158350761876],
            [1.4397855345223771, 44.870158350761876],
            [1.4397855345223771, 44.8901239916343],
            [1.4199879636721748, 44.8999253062444],
            [1.4199879636721748, 44.91989094711682],
            [1.4397855345223771, 44.91989094711682],
            [1.4397855345223771, 44.93985658798924],
            [1.409821643505854, 44.969986555123995],
            [1.409821643505854, 45.00991783686884],
            [1.4499518546886971, 45.020082163131164],
            [1.5098796367217417, 45.040047804003585],
            [1.539843527738265, 45.040047804003585],
            [1.550009847904585, 45.02988347774126],
            [1.5799737389211073, 45.040047804003585],
            [1.6099376299376305, 45.02988347774126],
            [1.6500678411204728, 45.02988347774126],
            [1.669865411970675, 45.000116522258736],
            [1.6998293029871983, 44.989952195996416],
            [1.7099956231535183, 44.969986555123995],
            [1.7501258343363606, 44.95982222886167],
            [1.7501258343363606, 44.93985658798924],
            [1.7699234051865629, 44.930055273379146],
            [1.8298511872196084, 44.930055273379146],
            [1.8501838275522484, 44.95002091425157],
            [1.8897789692526539, 44.95982222886167],
            [1.910111609585294, 44.980150881386315],
            [1.9400755006018162, 44.969986555123995],
            [1.9400755006018162, 44.95002091425157],
            [2.0101696028011817, 44.980150881386315],
            [2.059931064667907, 44.980150881386315],
            [2.0802637050005472, 44.95002091425157],
            [2.0802637050005472, 44.930055273379146],
            [2.1102275960170696, 44.910089632506725],
            [2.0898949556844295, 44.8999253062444],
            [2.0898949556844295, 44.870158350761876],
            [2.119858846700952, 44.84982969823723],
            [2.1401914870335927, 44.82006274275471],
            [2.170155378050115, 44.80989841649238],
            [2.170155378050115, 44.78013146100986],
            [2.149822737717475, 44.76996713474753],
            [2.149822737717475, 44.69990588586794],
            [2.1797866287339973, 44.67013893038542],
            [2.170155378050115, 44.64000896325067],
            [2.2097505197505196, 44.62004332237825],
            [2.2001192690666374, 44.5899133552435],
            [2.170155378050115, 44.5899133552435],
            [2.149822737717475, 44.569947714371075],
            [2.0700973848342272, 44.569947714371075],
            [2.049764744501587, 44.5801120406334],
            [2.029967173651384, 44.56014639976098],
            [2.0000032826348617, 44.56014639976098],
            [1.9598730714520194, 44.519852106363906],
            [1.9400755006018162, 44.519852106363906],
            [1.910111609585294, 44.490085150881384],
            [1.8801477185687716, 44.479920824619064],
            [1.8598150782361307, 44.490085150881384],
            [1.8501838275522484, 44.47011951000896],
            [1.8501838275522484, 44.439989542874216],
            [1.8699813984024516, 44.420023902001795],
            [1.8699813984024516, 44.38989393486705],
            [1.910111609585294, 44.360126979384525],
            [1.8801477185687716, 44.3401613385121],
            [1.8501838275522484, 44.32999701224978],
            [1.8298511872196084, 44.3401613385121],
            [1.7902560455192038, 44.32999701224978],
            [1.7699234051865629, 44.31003137137735],
            [1.7399595141700406, 44.32999701224978],
            [1.6602341612867928, 44.29006573050493],
            [1.6399015209541528, 44.27010008963251],
            [1.6201039501039505, 44.27990140424261],
            [1.6201039501039505, 44.29986704511503],
            [1.5698074187547872, 44.29986704511503],
            [1.5698074187547872, 44.27990140424261],
            [1.5901400590874273, 44.250134448760086],
            [1.550009847904585, 44.23016880788766],
            [1.5200459568880627, 44.250134448760086],
            [1.5098796367217417, 44.27010008963251],
            [1.4697494255388994, 44.27990140424261],
            [1.4301542838384949, 44.23997012249776],
            [1.3900240726556516, 44.23016880788766],
            [1.3600601816391293, 44.20003884075291],
            [1.330096290622607, 44.23016880788766],
            [1.3001323996060838, 44.23016880788766],
            [1.2797997592734438, 44.250134448760086],
            [1.3001323996060838, 44.25993576337018],
            [1.3001323996060838, 44.29986704511503],
            [1.2498358682569215, 44.27010008963251],
            [1.2300382974067183, 44.27990140424261],
            [1.210240726556516, 44.27010008963251],
            [1.1401466243571505, 44.31983268598745],
            [1.1101827333406282, 44.31983268598745],
            [1.1101827333406282, 44.3401613385121],
            [1.0898500930079882, 44.36992829399462],
            [1.1299803041908305, 44.36992829399462],
            [1.1299803041908305, 44.38989393486705],
            [1.1000164131743082, 44.38989393486705],
            [1.059886201991465, 44.380092620256946],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 60, name: "Oise", REG: 32, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.019845716161506, 49.220126979384524],
            [3.000048145311303, 49.24009262025695],
            [2.9599179341284616, 49.229928293994625],
            [2.9700842542947816, 49.189997012249776],
            [3.000048145311303, 49.189997012249776],
            [3.000048145311303, 49.209962653122204],
            [3.019845716161506, 49.220126979384524],
            [3.0300120363278262, 49.209962653122204],
            [3.089939818360871, 49.189997012249776],
            [3.140236349710034, 49.150065730504934],
            [3.089939818360871, 49.11993576337019],
            [3.0701422475106694, 49.11993576337019],
            [3.0599759273443494, 49.099970122497766],
            [3.0701422475106694, 49.090168807887665],
            [2.9700842542947816, 49.090168807887665],
            [2.9401203632782584, 49.08000448162534],
            [2.889823831929095, 49.08000448162534],
            [2.859859940912573, 49.06984015536301],
            [2.8100984790458474, 49.099970122497766],
            [2.7897658387132074, 49.08000448162534],
            [2.759801947696685, 49.06003884075292],
            [2.740004376846483, 49.06003884075292],
            [2.7202068059962796, 49.08000448162534],
            [2.6998741656636396, 49.06003884075292],
            [2.6800765948134373, 49.090168807887665],
            [2.629780063464274, 49.110134448760085],
            [2.620148812780392, 49.090168807887665],
            [2.5901849217638695, 49.08000448162534],
            [2.560221030747347, 49.099970122497766],
            [2.530257139730824, 49.099970122497766],
            [2.4901269285479817, 49.110134448760085],
            [2.499758179231864, 49.11993576337019],
            [2.4398303971988184, 49.150065730504934],
            [2.3601050443155707, 49.150065730504934],
            [2.3199748331327283, 49.179832685987456],
            [2.300177262282526, 49.179832685987456],
            [2.290010942116205, 49.15986704511503],
            [2.260047051099683, 49.150065730504934],
            [2.2199168399168405, 49.150065730504934],
            [2.2300831600831605, 49.170031371377355],
            [2.159989057883795, 49.170031371377355],
            [2.1300251668672727, 49.189997012249776],
            [2.1000612758507495, 49.189997012249776],
            [2.0802637050005472, 49.209962653122204],
            [2.040133493817705, 49.189997012249776],
            [2.0000032826348617, 49.179832685987456],
            [1.9700393916183394, 49.179832685987456],
            [1.9598730714520194, 49.170031371377355],
            [1.9299091804354962, 49.170031371377355],
            [1.8801477185687716, 49.15986704511503],
            [1.8699813984024516, 49.170031371377355],
            [1.8400175073859284, 49.170031371377355],
            [1.799887296203086, 49.189997012249776],
            [1.7800897253528838, 49.189997012249776],
            [1.7597570850202429, 49.170031371377355],
            [1.7201619433198383, 49.2001613385121],
            [1.7399595141700406, 49.220126979384524],
            [1.7099956231535183, 49.24009262025695],
            [1.6998293029871983, 49.229928293994625],
            [1.6998293029871983, 49.249893934867046],
            [1.7297931940037206, 49.269859575739474],
            [1.7501258343363606, 49.269859575739474],
            [1.7902560455192038, 49.249893934867046],
            [1.799887296203086, 49.269859575739474],
            [1.7699234051865629, 49.289825216611895],
            [1.7699234051865629, 49.339920824619064],
            [1.7597570850202429, 49.359886465491485],
            [1.7201619433198383, 49.40018075888856],
            [1.7099956231535183, 49.40998207349866],
            [1.7501258343363606, 49.46007768150583],
            [1.7800897253528838, 49.46987899611592],
            [1.7902560455192038, 49.510173289513],
            [1.7597570850202429, 49.510173289513],
            [1.7399595141700406, 49.5199746041231],
            [1.7297931940037206, 49.55990588586795],
            [1.7099956231535183, 49.57987152674037],
            [1.7201619433198383, 49.59003585300269],
            [1.7201619433198383, 49.62996713474754],
            [1.6998293029871983, 49.640131461009865],
            [1.7201619433198383, 49.68006274275471],
            [1.690198052303316, 49.68986405736481],
            [1.7297931940037206, 49.73015835076188],
            [1.7501258343363606, 49.7599253062444],
            [1.7800897253528838, 49.7599253062444],
            [1.8202199365357261, 49.73995966537198],
            [1.8400175073859284, 49.73995966537198],
            [1.8400175073859284, 49.70982969823723],
            [1.8501838275522484, 49.70002838362713],
            [1.8897789692526539, 49.70002838362713],
            [1.9197428602691762, 49.70982969823723],
            [1.9502418207681371, 49.70002838362713],
            [1.9802057117846594, 49.70982969823723],
            [2.029967173651384, 49.70982969823723],
            [2.059931064667907, 49.68986405736481],
            [2.1401914870335927, 49.68986405736481],
            [2.149822737717475, 49.70002838362713],
            [2.260047051099683, 49.70002838362713],
            [2.290010942116205, 49.68006274275471],
            [2.3199748331327283, 49.68986405736481],
            [2.3499387241492506, 49.660097101882286],
            [2.409866506182296, 49.660097101882286],
            [2.4697942882153407, 49.640131461009865],
            [2.4799606083816617, 49.62016582013744],
            [2.509924499398184, 49.640131461009865],
            [2.5500547105810263, 49.62016582013744],
            [2.5901849217638695, 49.61000149387512],
            [2.620148812780392, 49.61000149387512],
            [2.629780063464274, 49.57987152674037],
            [2.650112703796915, 49.57007021213027],
            [2.6699102746471173, 49.57987152674037],
            [2.6699102746471173, 49.59983716761279],
            [2.6998741656636396, 49.62016582013744],
            [2.740004376846483, 49.62996713474754],
            [2.780134588029325, 49.61000149387512],
            [2.7999321588795274, 49.62996713474754],
            [2.7897658387132074, 49.660097101882286],
            [2.8502286902286906, 49.660097101882286],
            [2.859859940912573, 49.68006274275471],
            [2.880192581245213, 49.68006274275471],
            [2.9101564722617352, 49.70002838362713],
            [2.9299540431119384, 49.68006274275471],
            [2.94975161396214, 49.68006274275471],
            [2.94975161396214, 49.68986405736481],
            [2.989881825144983, 49.70982969823723],
            [3.0300120363278262, 49.68006274275471],
            [3.0599759273443494, 49.68986405736481],
            [3.0498096071780294, 49.70982969823723],
            [3.119903709377394, 49.70982969823723],
            [3.130070029543714, 49.70002838362713],
            [3.100106138527191, 49.62016582013744],
            [3.140236349710034, 49.57987152674037],
            [3.130070029543714, 49.57007021213027],
            [3.130070029543714, 49.53013893038542],
            [3.100106138527191, 49.510173289513],
            [3.119903709377394, 49.48984463698835],
            [3.109737389211074, 49.46987899611592],
            [3.1600339205602372, 49.4499133552435],
            [3.130070029543714, 49.42994771437108],
            [3.100106138527191, 49.44011204063341],
            [3.089939818360871, 49.37985210636391],
            [3.0701422475106694, 49.35008515088139],
            [3.0300120363278262, 49.33011951000897],
            [3.010214465477623, 49.339920824619064],
            [2.9599179341284616, 49.31995518374664],
            [2.9802505744611016, 49.31015386913654],
            [2.989881825144983, 49.289825216611895],
            [3.0300120363278262, 49.289825216611895],
            [3.0300120363278262, 49.24009262025695],
            [3.019845716161506, 49.220126979384524],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 76,
        name: "Seine-Maritime",
        REG: 28,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.34021774811248484, 49.44011204063341],
            [0.2899212167633225, 49.4499133552435],
            [0.21982711456395698, 49.4499133552435],
            [0.21019586388007472, 49.46007768150583],
            [0.1598993325309115, 49.46007768150583],
            [0.14973301236459147, 49.46987899611592],
            [0.1101378706641869, 49.46987899611592],
            [0.08980523033154597, 49.48004332237825],
            [0.08980523033154597, 49.50000896325068],
            [0.07000765948134369, 49.510173289513],
            [0.0801739796476637, 49.53994024499552],
            [0.1101378706641869, 49.59003585300269],
            [0.12993544151438918, 49.61000149387512],
            [0.1598993325309115, 49.66989841649239],
            [0.1598993325309115, 49.68986405736481],
            [0.2899212167633225, 49.73995966537198],
            [0.3198851077798448, 49.73995966537198],
            [0.43010942116205264, 49.79005527337915],
            [0.5098347740453004, 49.81982222886167],
            [0.5601313053944637, 49.849952195996416],
            [0.600261516577306, 49.849952195996416],
            [0.6098927672611882, 49.86011652225874],
            [0.6500229784440315, 49.86011652225874],
            [0.6601892986103515, 49.869917836868844],
            [0.7602472918262393, 49.869917836868844],
            [0.8399726447094871, 49.889883477741265],
            [0.8999004267425326, 49.90004780400359],
            [0.9598282087755772, 49.92001344487601],
            [1.0400886311412627, 49.92001344487601],
            [1.0898500930079882, 49.93997908574843],
            [1.1198139840245105, 49.93997908574843],
            [1.1497778750410328, 49.95014341201076],
            [1.2701685085895615, 50.01004033462803],
            [1.3798577524893316, 50.0699372572453],
            [1.409821643505854, 50.0601359426352],
            [1.4199879636721748, 50.0699372572453],
            [1.4601181748550172, 50.0601359426352],
            [1.4499518546886971, 50.04017030176278],
            [1.5302122770543827, 49.9998760083657],
            [1.5901400590874273, 49.95994472662086],
            [1.6201039501039505, 49.93017777113833],
            [1.6500678411204728, 49.93017777113833],
            [1.680031732136995, 49.92001344487601],
            [1.7297931940037206, 49.84015088138632],
            [1.7297931940037206, 49.810020914251574],
            [1.7800897253528838, 49.7599253062444],
            [1.7501258343363606, 49.7599253062444],
            [1.7297931940037206, 49.73015835076188],
            [1.690198052303316, 49.68986405736481],
            [1.7201619433198383, 49.68006274275471],
            [1.6998293029871983, 49.640131461009865],
            [1.7201619433198383, 49.62996713474754],
            [1.7201619433198383, 49.59003585300269],
            [1.7099956231535183, 49.57987152674037],
            [1.7297931940037206, 49.55990588586795],
            [1.7399595141700406, 49.5199746041231],
            [1.7597570850202429, 49.510173289513],
            [1.7902560455192038, 49.510173289513],
            [1.7800897253528838, 49.46987899611592],
            [1.7501258343363606, 49.46007768150583],
            [1.7099956231535183, 49.40998207349866],
            [1.690198052303316, 49.39001643262623],
            [1.669865411970675, 49.40998207349866],
            [1.6500678411204728, 49.40018075888856],
            [1.6099376299376305, 49.40998207349866],
            [1.5799737389211073, 49.44011204063341],
            [1.5002483860378595, 49.44011204063341],
            [1.4900820658715395, 49.4499133552435],
            [1.4499518546886971, 49.4499133552435],
            [1.4397855345223771, 49.46007768150583],
            [1.409821643505854, 49.46007768150583],
            [1.340262610788927, 49.44011204063341],
            [1.309763650289966, 49.42994771437108],
            [1.3199299704562861, 49.40998207349866],
            [1.2899660794397638, 49.39001643262623],
            [1.2899660794397638, 49.359886465491485],
            [1.2701685085895615, 49.35008515088139],
            [1.200074406390196, 49.35008515088139],
            [1.200074406390196, 49.339920824619064],
            [1.1497778750410328, 49.339920824619064],
            [1.1299803041908305, 49.31015386913654],
            [1.070052522157786, 49.31015386913654],
            [1.0502549513075827, 49.299989542874215],
            [1.070052522157786, 49.280023902001794],
            [1.0400886311412627, 49.26005826112937],
            [0.9999584199584204, 49.249893934867046],
            [0.9897920997921004, 49.26005826112937],
            [0.9501969580916949, 49.299989542874215],
            [0.8999004267425326, 49.31995518374664],
            [0.8597702155596894, 49.31995518374664],
            [0.8501389648758071, 49.33011951000897],
            [0.8897341065762117, 49.35008515088139],
            [0.9202330670751726, 49.339920824619064],
            [0.9202330670751726, 49.39001643262623],
            [0.8801028558923294, 49.37005079175381],
            [0.8597702155596894, 49.39001643262623],
            [0.829806324543167, 49.39001643262623],
            [0.8100087536929648, 49.40998207349866],
            [0.7800448626764416, 49.40998207349866],
            [0.7698785425101216, 49.42014639976098],
            [0.7399146514935993, 49.40998207349866],
            [0.6901531896268738, 49.40998207349866],
            [0.6601892986103515, 49.42014639976098],
            [0.6398566582777114, 49.44011204063341],
            [0.6098927672611882, 49.42994771437108],
            [0.5799288762446659, 49.42994771437108],
            [0.5200010942116204, 49.48004332237825],
            [0.47023963234489585, 49.48004332237825],
            [0.4397406718459349, 49.46007768150583],
            [0.3899792099792103, 49.4499133552435],
            [0.37018163912900803, 49.44011204063341],
            [0.34021774811248484, 49.44011204063341],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: "01", name: "Ain", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.830030637925375, 45.93995368987153],
            [5.830030637925375, 45.90002240812668],
            [5.800066746908853, 45.82996115924709],
            [5.779734106576213, 45.799831192112336],
            [5.779734106576213, 45.73013295488497],
            [5.75993653572601, 45.71016731401255],
            [5.700008753692965, 45.71016731401255],
            [5.710175073859285, 45.6800373468778],
            [5.689842433526645, 45.669873020615476],
            [5.689842433526645, 45.640106065132954],
            [5.650247291826239, 45.640106065132954],
            [5.650247291826239, 45.62994173887063],
            [5.619748331327279, 45.60997609799821],
            [5.5897844403107575, 45.669873020615476],
            [5.559820549294234, 45.669873020615476],
            [5.550189298610351, 45.6800373468778],
            [5.559820549294234, 45.700002987750224],
            [5.52022540759383, 45.73013295488497],
            [5.4800951964109865, 45.75009859575739],
            [5.4597625560783465, 45.779865551239915],
            [5.420167414377942, 45.80999551837466],
            [5.429798665061823, 45.82996115924709],
            [5.420167414377942, 45.84992680011951],
            [5.3500733121785755, 45.88005676725426],
            [5.3297406718459355, 45.86009112638183],
            [5.299776780829412, 45.84992680011951],
            [5.290145530145531, 45.80999551837466],
            [5.260181639129008, 45.779865551239915],
            [5.2200514279461645, 45.77006423662982],
            [5.190087536929643, 45.779865551239915],
            [5.169754896597003, 45.799831192112336],
            [5.13979100558048, 45.799831192112336],
            [5.100195863880075, 45.80999551837466],
            [4.940210088631141, 45.80999551837466],
            [4.879747237115658, 45.88005676725426],
            [4.879747237115658, 45.90002240812668],
            [4.849783346099136, 45.90982372273678],
            [4.810188204398732, 45.90002240812668],
            [4.810188204398732, 45.9199880489991],
            [4.78985556406609, 45.9199880489991],
            [4.780224313382209, 45.93995368987153],
            [4.759891673049569, 45.93015237526143],
            [4.729927782033045, 45.95011801613385],
            [4.7502604223656855, 45.95991933074395],
            [4.7502604223656855, 45.9998506124888],
            [4.7400941021993654, 46.02017926501345],
            [4.7502604223656855, 46.02998057962354],
            [4.7400941021993654, 46.04994622049597],
            [4.759891673049569, 46.060110546758295],
            [4.7502604223656855, 46.08987750224081],
            [4.770057993215889, 46.12000746937556],
            [4.800021884232412, 46.139973110247986],
            [4.800021884232412, 46.15993875112041],
            [4.780224313382209, 46.17990439199283],
            [4.810188204398732, 46.240164326262324],
            [4.829985775248933, 46.300061248879594],
            [4.849783346099136, 46.329828204362116],
            [4.859949666265456, 46.37012249775919],
            [4.88991355728198, 46.39988945324171],
            [4.88991355728198, 46.44998506124888],
            [4.91024619761462, 46.46014938751121],
            [4.91024619761462, 46.48011502838363],
            [4.930043768464821, 46.50988198386615],
            [4.970173979647664, 46.50988198386615],
            [4.979805230331547, 46.52004631012847],
            [5.009769121348069, 46.50988198386615],
            [5.009769121348069, 46.50008066925605],
            [5.049899332530912, 46.48011502838363],
            [5.100195863880075, 46.50008066925605],
            [5.109827114563957, 46.48991634299372],
            [5.13979100558048, 46.50988198386615],
            [5.16012364591312, 46.50008066925605],
            [5.200253857095963, 46.50988198386615],
            [5.2200514279461645, 46.4699507021213],
            [5.260181639129008, 46.44998506124888],
            [5.309943100995732, 46.44998506124888],
            [5.320109421162054, 46.43001942037646],
            [5.309943100995732, 46.41005377950403],
            [5.3500733121785755, 46.39988945324171],
            [5.380037203195099, 46.379923812369285],
            [5.380037203195099, 46.33999253062444],
            [5.420167414377942, 46.33999253062444],
            [5.439964985228143, 46.320026889752015],
            [5.4800951964109865, 46.320026889752015],
            [5.4597625560783465, 46.28009560800717],
            [5.4800951964109865, 46.260129967134745],
            [5.51005908742751, 46.260129967134745],
            [5.540022978444031, 46.269931281744846],
            [5.559820549294234, 46.289896922617274],
            [5.5897844403107575, 46.289896922617274],
            [5.6101170806433975, 46.309862563489695],
            [5.6101170806433975, 46.329828204362116],
            [5.650247291826239, 46.320026889752015],
            [5.680211182842762, 46.320026889752015],
            [5.710175073859285, 46.309862563489695],
            [5.729972644709487, 46.260129967134745],
            [5.77010285589233, 46.269931281744846],
            [5.8198643177590546, 46.260129967134745],
            [5.849828208775578, 46.260129967134745],
            [5.879792099792101, 46.269931281744846],
            [5.889958419958421, 46.289896922617274],
            [5.919922310974942, 46.289896922617274],
            [5.919922310974942, 46.309862563489695],
            [5.940254951307584, 46.309862563489695],
            [5.979850093007989, 46.35015685688676],
            [5.979850093007989, 46.359958171496864],
            [6.030146624357152, 46.39008813863161],
            [6.060110515373673, 46.41985509411413],
            [6.100240726556517, 46.41005377950403],
            [6.169799759273444, 46.37012249775919],
            [6.169799759273444, 46.359958171496864],
            [6.139835868256921, 46.329828204362116],
            [6.12003829740672, 46.320026889752015],
            [6.12003829740672, 46.300061248879594],
            [6.100240726556517, 46.28009560800717],
            [6.12003829740672, 46.269931281744846],
            [6.12003829740672, 46.249965640872425],
            [6.090074406390197, 46.249965640872425],
            [6.049944195207353, 46.230000000000004],
            [6.030146624357152, 46.240164326262324],
            [6.000182733340629, 46.21983567373768],
            [5.970218842324106, 46.210034359127576],
            [5.990016413174309, 46.17990439199283],
            [5.970218842324106, 46.15993875112041],
            [5.960052522157786, 46.130171795637885],
            [5.919922310974942, 46.130171795637885],
            [5.889958419958421, 46.12000746937556],
            [5.889958419958421, 46.08987750224081],
            [5.859994528941898, 46.08987750224081],
            [5.8198643177590546, 46.10004182850314],
            [5.810233067075173, 46.080076187630716],
            [5.810233067075173, 45.9900492978787],
            [5.830030637925375, 45.97008365700628],
            [5.830030637925375, 45.93995368987153],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 59, name: "Nord", REG: 32, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [3.100106138527191, 50.15996414699731],
              [3.0701422475106694, 50.15016283238722],
              [3.0701422475106694, 50.12983417986257],
              [3.0401783564941463, 50.12983417986257],
              [3.000048145311303, 50.12003286525247],
              [2.989881825144983, 50.13999850612489],
              [3.000048145311303, 50.15016283238722],
              [3.0401783564941463, 50.15016283238722],
              [3.0599759273443494, 50.17012847325964],
              [3.100106138527191, 50.15996414699731],
            ],
          ],
          [
            [
              [3.1702002407265573, 50.01004033462803],
              [3.149867600393917, 50.03000597550045],
              [3.119903709377394, 50.03000597550045],
              [3.089939818360871, 50.04997161637287],
              [3.089939818360871, 50.08010158350762],
              [3.109737389211074, 50.08990289811772],
              [3.100106138527191, 50.12003286525247],
              [3.140236349710034, 50.13999850612489],
              [3.100106138527191, 50.15996414699731],
              [3.149867600393917, 50.17992978786974],
              [3.130070029543714, 50.19989542874216],
              [3.140236349710034, 50.21986106961458],
              [3.1798314914104386, 50.21986106961458],
              [3.1798314914104386, 50.23982671048701],
              [3.149867600393917, 50.249991036749336],
              [3.140236349710034, 50.26995667762176],
              [3.0401783564941463, 50.26995667762176],
              [3.0498096071780294, 50.28992231849418],
              [3.079773498194551, 50.320052285628925],
              [3.0401783564941463, 50.340017926501346],
              [2.989881825144983, 50.379949208246195],
              [2.989881825144983, 50.399914849118616],
              [3.010214465477623, 50.399914849118616],
              [3.0401783564941463, 50.419880489991044],
              [3.0701422475106694, 50.430044816253364],
              [3.0701422475106694, 50.46017478338811],
              [3.0401783564941463, 50.439846130863465],
              [3.019845716161506, 50.439846130863465],
              [3.010214465477623, 50.46017478338811],
              [3.019845716161506, 50.46997609799821],
              [3.010214465477623, 50.489941738870634],
              [2.9599179341284616, 50.509907379743055],
              [2.9299540431119384, 50.509907379743055],
              [2.9101564722617352, 50.50010606513296],
              [2.880192581245213, 50.509907379743055],
              [2.889823831929095, 50.52987302061548],
              [2.7999321588795274, 50.52987302061548],
              [2.8202647992121683, 50.57016731401255],
              [2.7897658387132074, 50.59013295488498],
              [2.8400623700623706, 50.63006423662982],
              [2.870026261078893, 50.63006423662982],
              [2.8400623700623706, 50.65983119211234],
              [2.769968267863005, 50.65983119211234],
              [2.750170697012803, 50.6100985957574],
              [2.729838056680162, 50.6100985957574],
              [2.7202068059962796, 50.63006423662982],
              [2.6699102746471173, 50.63006423662982],
              [2.629780063464274, 50.619899910367494],
              [2.620148812780392, 50.63006423662982],
              [2.4901269285479817, 50.63006423662982],
              [2.409866506182296, 50.66999551837467],
              [2.390068935332094, 50.70012548550942],
              [2.369736294999453, 50.70992680011951],
              [2.3397724039829306, 50.74005676725426],
              [2.379902615165773, 50.74985808186436],
              [2.400235255498414, 50.76982372273678],
              [2.390068935332094, 50.77998804899911],
              [2.3199748331327283, 50.77998804899911],
              [2.290010942116205, 50.79015237526143],
              [2.270213371266003, 50.77998804899911],
              [2.2300831600831605, 50.810118016133856],
              [2.2097505197505196, 50.810118016133856],
              [2.2097505197505196, 50.83988497161638],
              [2.170155378050115, 50.90994622049597],
              [2.149822737717475, 50.929911861368396],
              [2.1401914870335927, 50.96004182850314],
              [2.1102275960170696, 50.99017179563789],
              [2.0700973848342272, 51.01013743651031],
              [2.119858846700952, 51.01013743651031],
              [2.1401914870335927, 51.01993875112041],
              [2.1797866287339973, 51.01993875112041],
              [2.1899529489003173, 51.039904391992835],
              [2.2097505197505196, 51.03010307738273],
              [2.3499387241492506, 51.059870032865255],
              [2.379902615165773, 51.05006871825516],
              [2.4697942882153407, 51.07003435912758],
              [2.4901269285479817, 51.07003435912758],
              [2.5500547105810263, 51.09],
              [2.5698522814312295, 51.05006871825516],
              [2.5800186015975495, 50.999973110247986],
              [2.609982492614072, 50.99017179563789],
              [2.629780063464274, 50.94987750224082],
              [2.5901849217638695, 50.920110546758295],
              [2.609982492614072, 50.900144905885874],
              [2.609982492614072, 50.8500492978787],
              [2.629780063464274, 50.810118016133856],
              [2.6597439544807973, 50.81991933074396],
              [2.6800765948134373, 50.810118016133856],
              [2.7202068059962796, 50.810118016133856],
              [2.740004376846483, 50.77998804899911],
              [2.780134588029325, 50.74985808186436],
              [2.7897658387132074, 50.72989244099194],
              [2.8100984790458474, 50.72009112638184],
              [2.8502286902286906, 50.72009112638184],
              [2.880192581245213, 50.70992680011951],
              [2.9101564722617352, 50.68996115924709],
              [2.9299540431119384, 50.70992680011951],
              [2.9401203632782584, 50.74985808186436],
              [2.9700842542947816, 50.74985808186436],
              [3.010214465477623, 50.76982372273678],
              [3.0401783564941463, 50.76982372273678],
              [3.0599759273443494, 50.77998804899911],
              [3.089939818360871, 50.76982372273678],
              [3.109737389211074, 50.79015237526143],
              [3.149867600393917, 50.79015237526143],
              [3.1600339205602372, 50.76982372273678],
              [3.2001641317430787, 50.72989244099194],
              [3.209795382426962, 50.70992680011951],
              [3.249925593609805, 50.70992680011951],
              [3.260091913776125, 50.68015984463699],
              [3.239759273443485, 50.66999551837467],
              [3.260091913776125, 50.619899910367494],
              [3.2798894846263265, 50.59013295488498],
              [3.2798894846263265, 50.5400373468778],
              [3.3301860159754897, 50.509907379743055],
              [3.3799474778422143, 50.489941738870634],
              [3.4500415800415807, 50.509907379743055],
              [3.469839150891782, 50.52987302061548],
              [3.5099693620746253, 50.52987302061548],
              [3.5201356822409453, 50.52007170600538],
              [3.4998030419083053, 50.50010606513296],
              [3.5201356822409453, 50.489941738870634],
              [3.5602658934237885, 50.50010606513296],
              [3.6298249261407163, 50.48014042426053],
              [3.6399912463070363, 50.46017478338811],
              [3.6597888171572377, 50.46017478338811],
              [3.6699551373235595, 50.439846130863465],
              [3.6699551373235595, 50.379949208246195],
              [3.6597888171572377, 50.370147893636094],
              [3.6801214574898795, 50.32985360023902],
              [3.710085348506401, 50.300086644756504],
              [3.729882919356604, 50.3098879593666],
              [3.740049239522924, 50.34981924111145],
              [3.859904803589015, 50.34981924111145],
              [3.8898686946055365, 50.32985360023902],
              [3.9198325856220597, 50.32985360023902],
              [3.970129116971223, 50.34981924111145],
              [4.010259328154066, 50.34981924111145],
              [4.030056899004268, 50.359983567373774],
              [4.049854469854471, 50.340017926501346],
              [4.130114892220155, 50.28992231849418],
              [4.119948572053835, 50.26995667762176],
              [4.1397461429040385, 50.260155363011656],
              [4.170245103402999, 50.26995667762176],
              [4.209840245103403, 50.26995667762176],
              [4.220006565269723, 50.249991036749336],
              [4.1499124630703585, 50.21005975500449],
              [4.160078783236679, 50.17012847325964],
              [4.1397461429040385, 50.15016283238722],
              [4.200208994419522, 50.12983417986257],
              [4.200208994419522, 50.10006722438004],
              [4.230172885436043, 50.08010158350762],
              [4.220006565269723, 50.0601359426352],
              [4.190042674253202, 50.04997161637287],
              [4.160078783236679, 50.04997161637287],
              [4.1397461429040385, 50.01984164923813],
              [4.160078783236679, 49.9900746937556],
              [4.1397461429040385, 49.97991036749328],
              [4.100151001203634, 49.97010905288318],
              [4.060020790020791, 49.9900746937556],
              [4.030056899004268, 49.97991036749328],
              [4.010259328154066, 49.9998760083657],
              [3.9797603676551043, 49.9998760083657],
              [4.000093007987744, 50.03000597550045],
              [3.9797603676551043, 50.04017030176278],
              [3.949796476638583, 50.03000597550045],
              [3.9198325856220597, 50.03000597550045],
              [3.8898686946055365, 50.01984164923813],
              [3.870071123755335, 50.04017030176278],
              [3.840107232738812, 50.04997161637287],
              [3.819774592406172, 50.04017030176278],
              [3.7999770215559687, 50.04997161637287],
              [3.750215559689244, 50.04997161637287],
              [3.720251668672721, 50.0699372572453],
              [3.6699551373235595, 50.0601359426352],
              [3.6501575664733563, 50.04017030176278],
              [3.610027355290513, 50.03000597550045],
              [3.5800634642739917, 50.04997161637287],
              [3.5399332530911485, 50.04997161637287],
              [3.490171791224424, 50.01984164923813],
              [3.4302440091913775, 50.01984164923813],
              [3.349983586825693, 50.04017030176278],
              [3.339817266659373, 50.01984164923813],
              [3.2798894846263265, 50.01984164923813],
              [3.270258233942445, 50.03000597550045],
              [3.230128022759602, 50.03000597550045],
              [3.1702002407265573, 50.01004033462803],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 88, name: "Vosges", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.879792099792101, 47.92998356737377],
            [5.859994528941898, 47.949949208246196],
            [5.830030637925375, 47.960113534508515],
            [5.789900426742533, 47.949949208246196],
            [5.779734106576213, 47.980079175380936],
            [5.789900426742533, 48.009846130863465],
            [5.779734106576213, 48.03017478338811],
            [5.75993653572601, 48.03017478338811],
            [5.740138964875807, 48.05014042426053],
            [5.719806324543167, 48.05014042426053],
            [5.700008753692965, 48.079907379743055],
            [5.629914651493599, 48.079907379743055],
            [5.659878542510122, 48.130002987750224],
            [5.689842433526645, 48.14996862862265],
            [5.680211182842762, 48.1800985957574],
            [5.700008753692965, 48.189899910367494],
            [5.729972644709487, 48.189899910367494],
            [5.710175073859285, 48.22002987750224],
            [5.640080971659919, 48.23999551837467],
            [5.650247291826239, 48.27012548550941],
            [5.6101170806433975, 48.29009112638184],
            [5.5897844403107575, 48.27992680011951],
            [5.52022540759383, 48.33982372273678],
            [5.529856658277711, 48.34998804899911],
            [5.4597625560783465, 48.34998804899911],
            [5.420167414377942, 48.33982372273678],
            [5.420167414377942, 48.36015237526143],
            [5.439964985228143, 48.380118016133856],
            [5.410001094211622, 48.38991933074395],
            [5.4699288762446665, 48.4200492978787],
            [5.49989276726119, 48.40988497161638],
            [5.52022540759383, 48.4298506124888],
            [5.559820549294234, 48.44001493875112],
            [5.619748331327279, 48.44001493875112],
            [5.650247291826239, 48.45998057962355],
            [5.689842433526645, 48.470144905885874],
            [5.719806324543167, 48.45998057962355],
            [5.740138964875807, 48.470144905885874],
            [5.74977021555969, 48.490110546758295],
            [5.77010285589233, 48.49991186136839],
            [5.789900426742533, 48.47994622049597],
            [5.810233067075173, 48.49991186136839],
            [5.840196958091696, 48.49991186136839],
            [5.859994528941898, 48.510076187630716],
            [5.900124740124741, 48.47994622049597],
            [5.879792099792101, 48.44001493875112],
            [5.859994528941898, 48.4200492978787],
            [5.879792099792101, 48.40008365700628],
            [5.900124740124741, 48.40988497161638],
            [5.909755990808622, 48.4298506124888],
            [5.909755990808622, 48.40988497161638],
            [5.930088631141262, 48.40008365700628],
            [5.940254951307584, 48.380118016133856],
            [5.960052522157786, 48.36995368987153],
            [5.960052522157786, 48.34998804899911],
            [5.990016413174309, 48.34998804899911],
            [6.00981398402451, 48.36015237526143],
            [6.100240726556517, 48.36015237526143],
            [6.12003829740672, 48.34998804899911],
            [6.150002188423241, 48.380118016133856],
            [6.150002188423241, 48.40988497161638],
            [6.179966079439764, 48.40008365700628],
            [6.230262610788928, 48.40008365700628],
            [6.299821643505855, 48.4298506124888],
            [6.309987963672175, 48.40988497161638],
            [6.339951854688697, 48.40008365700628],
            [6.3597494255389, 48.40988497161638],
            [6.39024838603786, 48.40988497161638],
            [6.38008206587154, 48.38991933074395],
            [6.410045956888063, 48.38991933074395],
            [6.420212277054383, 48.40988497161638],
            [6.499937629937631, 48.40988497161638],
            [6.570031732136996, 48.44001493875112],
            [6.580198052303316, 48.45998057962355],
            [6.599995623153519, 48.470144905885874],
            [6.640125834336362, 48.470144905885874],
            [6.640125834336362, 48.450179265013446],
            [6.700053616369407, 48.40988497161638],
            [6.710219936535727, 48.4200492978787],
            [6.74018382755225, 48.4200492978787],
            [6.770147718568771, 48.40008365700628],
            [6.819909180435498, 48.40008365700628],
            [6.830075500601818, 48.4200492978787],
            [6.890003282634862, 48.4200492978787],
            [6.9301334938177055, 48.44001493875112],
            [6.97989495568443, 48.47994622049597],
            [7.009858846700953, 48.47994622049597],
            [7.079952948900318, 48.510076187630716],
            [7.090119269066638, 48.510076187630716],
            [7.120083160083161, 48.510076187630716],
            [7.090119269066638, 48.510076187630716],
            [7.090119269066638, 48.490110546758295],
            [7.120083160083161, 48.47994622049597],
            [7.099750519750521, 48.450179265013446],
            [7.099750519750521, 48.38991933074395],
            [7.109916839916841, 48.380118016133856],
            [7.079952948900318, 48.34998804899911],
            [7.120083160083161, 48.33002240812668],
            [7.180010942116206, 48.33002240812668],
            [7.199808512966409, 48.31005676725426],
            [7.169844621949886, 48.29989244099193],
            [7.160213371266004, 48.27012548550941],
            [7.130249480249481, 48.23999551837467],
            [7.109916839916841, 48.189899910367494],
            [7.079952948900318, 48.1800985957574],
            [7.079952948900318, 48.16013295488497],
            [7.060155378050115, 48.14016731401255],
            [7.079952948900318, 48.130002987750224],
            [7.049989057883795, 48.079907379743055],
            [7.030191487033593, 48.079907379743055],
            [7.00022759601707, 48.020010457125785],
            [6.960097384834227, 48.000044816253364],
            [6.9199671736513855, 47.949949208246196],
            [6.9199671736513855, 47.89985360023902],
            [6.9098008534850655, 47.8798879593666],
            [6.9098008534850655, 47.85012100388408],
            [6.900169602801182, 47.830155363011656],
            [6.870205711784659, 47.830155363011656],
            [6.849873071452019, 47.81999103674933],
            [6.819909180435498, 47.809826710487],
            [6.7899452894189745, 47.830155363011656],
            [6.779778969252654, 47.85012100388408],
            [6.74018382755225, 47.85992231849418],
            [6.689887296203087, 47.890052285628926],
            [6.649757085020243, 47.89985360023902],
            [6.62995951417004, 47.92998356737377],
            [6.599995623153519, 47.940147893636095],
            [6.570031732136996, 47.92998356737377],
            [6.5400678411204725, 47.89985360023902],
            [6.499937629937631, 47.89985360023902],
            [6.480140059087428, 47.890052285628926],
            [6.429843527738265, 47.940147893636095],
            [6.410045956888063, 47.940147893636095],
            [6.39024838603786, 47.960113534508515],
            [6.3597494255389, 47.960113534508515],
            [6.320154283838495, 47.949949208246196],
            [6.290190392821972, 47.960113534508515],
            [6.260226501805449, 47.949949208246196],
            [6.239893861472809, 47.92998356737377],
            [6.209929970456288, 47.949949208246196],
            [6.169799759273444, 47.949949208246196],
            [6.160168508589561, 47.96991484911862],
            [6.160168508589561, 48.009846130863465],
            [6.13020461757304, 48.020010457125785],
            [6.109871977240398, 48.009846130863465],
            [6.0697417660575566, 48.020010457125785],
            [6.01998030419083, 47.98988048999104],
            [6.00981398402451, 47.960113534508515],
            [5.970218842324106, 47.960113534508515],
            [5.949886201991466, 47.980079175380936],
            [5.919922310974942, 47.96991484911862],
            [5.919922310974942, 47.949949208246196],
            [5.879792099792101, 47.92998356737377],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 32, name: "Gers", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.6098927672611882, 43.309934269495066],
            [0.5499649852281436, 43.329899910367494],
            [0.40014553014553034, 43.329899910367494],
            [0.40014553014553034, 43.349865551239915],
            [0.3798128898128903, 43.36002987750224],
            [0.34021774811248484, 43.340064236629814],
            [0.3300514279461648, 43.369831192112336],
            [0.3000875369296425, 43.369831192112336],
            [0.3000875369296425, 43.39015984463699],
            [0.24015975489659702, 43.369831192112336],
            [0.18023197286355153, 43.369831192112336],
            [0.1700656526972315, 43.399961159247084],
            [0.1401017616807092, 43.41992680011951],
            [0.1401017616807092, 43.43009112638183],
            [0.1700656526972315, 43.43989244099193],
            [0.14973301236459147, 43.47002240812668],
            [0.12993544151438918, 43.47002240812668],
            [0.12993544151438918, 43.50015237526143],
            [0.1101378706641869, 43.52011801613385],
            [0.0502100886311414, 43.52011801613385],
            [0.04004376846482138, 43.54008365700627],
            [0.0202461976146191, 43.54008365700627],
            [-0.019884013568224113, 43.61014490588587],
            [-0.07018054491738734, 43.61014490588587],
            [-0.07981179560126961, 43.59017926501345],
            [-0.10014443593390965, 43.58001493875112],
            [-0.11994200678411193, 43.59017926501345],
            [-0.14990589780063424, 43.59017926501345],
            [-0.17986978881715743, 43.59998057962354],
            [-0.23979757085020204, 43.58001493875112],
            [-0.24996389101652294, 43.61994622049597],
            [-0.27992778203304525, 43.61994622049597],
            [-0.27992778203304525, 43.63991186136839],
            [-0.26013021118284296, 43.63991186136839],
            [-0.23979757085020204, 43.65987750224081],
            [-0.24996389101652294, 43.67984314311323],
            [-0.23979757085020204, 43.69000746937556],
            [-0.24996389101652294, 43.70997311024798],
            [-0.21999999999999975, 43.720137436510306],
            [-0.19003610898347745, 43.74010307738273],
            [-0.21999999999999975, 43.76987003286525],
            [-0.20983367983367973, 43.780034359127576],
            [-0.23016632016631977, 43.810164326262324],
            [-0.19003610898347745, 43.810164326262324],
            [-0.20020242914979747, 43.830129967134745],
            [-0.19003610898347745, 43.839931281744846],
            [-0.20983367983367973, 43.85989692261727],
            [-0.19003610898347745, 43.879862563489695],
            [-0.20020242914979747, 43.890026889752015],
            [-0.23016632016631977, 43.890026889752015],
            [-0.23016632016631977, 43.909992530624436],
            [-0.20020242914979747, 43.909992530624436],
            [-0.17986978881715743, 43.940122497759184],
            [-0.13010832695043195, 43.940122497759184],
            [-0.10014443593390965, 43.929958171496864],
            [-0.060014224751066436, 43.96008813863161],
            [-0.04021665390086415, 43.96008813863161],
            [-0.04021665390086415, 43.98005377950403],
            [0.010079877448298191, 43.949923812369285],
            [-0.019884013568224113, 43.929958171496864],
            [0.029877448298501363, 43.899828204362116],
            [0.05984133931502367, 43.899828204362116],
            [0.0801739796476637, 43.909992530624436],
            [0.05984133931502367, 43.96008813863161],
            [0.0801739796476637, 43.98005377950403],
            [0.12993544151438918, 44.000019420376454],
            [0.14973301236459147, 43.969889453241706],
            [0.1898632235474338, 44.009820734986555],
            [0.21019586388007472, 44.01998506124888],
            [0.2497910055804793, 44.000019420376454],
            [0.2797548965970016, 44.000019420376454],
            [0.3000875369296425, 43.989855094114134],
            [0.3198851077798448, 44.009820734986555],
            [0.3600153189626871, 44.01998506124888],
            [0.3798128898128903, 44.009820734986555],
            [0.4397406718459349, 44.0301493875112],
            [0.46007331217857583, 44.05991634299372],
            [0.4798708830287781, 44.05011502838363],
            [0.5098347740453004, 44.05991634299372],
            [0.5397986650618227, 44.05011502838363],
            [0.600261516577306, 44.07008066925605],
            [0.6302254075938292, 44.05991634299372],
            [0.6601892986103515, 44.01998506124888],
            [0.6799868694605538, 44.0301493875112],
            [0.6901531896268738, 44.05011502838363],
            [0.7399146514935993, 44.07008066925605],
            [0.7602472918262393, 44.05011502838363],
            [0.7602472918262393, 44.0301493875112],
            [0.7998424335266439, 44.0399507021213],
            [0.8201750738592848, 44.05991634299372],
            [0.8399726447094871, 44.05011502838363],
            [0.8501389648758071, 44.0301493875112],
            [0.8201750738592848, 44.0301493875112],
            [0.8100087536929648, 44.01998506124888],
            [0.829806324543167, 44.000019420376454],
            [0.7902111828427616, 43.969889453241706],
            [0.7800448626764416, 43.949923812369285],
            [0.7602472918262393, 43.949923812369285],
            [0.7698785425101216, 43.92015685688676],
            [0.8100087536929648, 43.929958171496864],
            [0.8201750738592848, 43.92015685688676],
            [0.8597702155596894, 43.92015685688676],
            [0.8897341065762117, 43.909992530624436],
            [0.8897341065762117, 43.870061248879594],
            [0.9100667469088526, 43.850095608007166],
            [0.8999004267425326, 43.839931281744846],
            [0.9100667469088526, 43.819965640872425],
            [0.8999004267425326, 43.78983567373768],
            [0.9501969580916949, 43.78983567373768],
            [0.9598282087755772, 43.76987003286525],
            [0.9897920997921004, 43.74010307738273],
            [1.0101247401247404, 43.72993875112041],
            [1.0197559908086227, 43.70997311024798],
            [1.059886201991465, 43.700171795637885],
            [1.0502549513075827, 43.67984314311323],
            [1.070052522157786, 43.65987750224081],
            [1.1000164131743082, 43.65987750224081],
            [1.0898500930079882, 43.63991186136839],
            [1.1198139840245105, 43.63991186136839],
            [1.1497778750410328, 43.63991186136839],
            [1.1401466243571505, 43.61994622049597],
            [1.1599441952073537, 43.61014490588587],
            [1.189908086223876, 43.61014490588587],
            [1.200074406390196, 43.59998057962354],
            [1.200074406390196, 43.56985061248879],
            [1.1599441952073537, 43.56985061248879],
            [1.1599441952073537, 43.5600492978787],
            [1.1198139840245105, 43.54988497161637],
            [1.1000164131743082, 43.52991933074395],
            [1.080218842324106, 43.54988497161637],
            [1.059886201991465, 43.54008365700627],
            [1.0502549513075827, 43.52011801613385],
            [1.059886201991465, 43.50015237526143],
            [1.0197559908086227, 43.479823722736775],
            [1.0400886311412627, 43.459858081864354],
            [1.0197559908086227, 43.43989244099193],
            [1.0299223109749427, 43.41992680011951],
            [1.0197559908086227, 43.41012548550941],
            [0.9897920997921004, 43.41012548550941],
            [0.9999584199584204, 43.37999551837466],
            [0.9801608491082181, 43.36002987750224],
            [0.9598282087755772, 43.39015984463699],
            [0.9400306379253749, 43.37999551837466],
            [0.9202330670751726, 43.41012548550941],
            [0.8399726447094871, 43.41012548550941],
            [0.8201750738592848, 43.41992680011951],
            [0.8100087536929648, 43.399961159247084],
            [0.7698785425101216, 43.41992680011951],
            [0.7500809716599193, 43.39015984463699],
            [0.720117080643397, 43.37999551837466],
            [0.6901531896268738, 43.349865551239915],
            [0.6799868694605538, 43.329899910367494],
            [0.6398566582777114, 43.309934269495066],
            [0.6098927672611882, 43.309934269495066],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 87, name: "Haute-Vienne", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.6302254075938292, 45.71016731401255],
            [0.6500229784440315, 45.719968628622645],
            [0.6500229784440315, 45.73993426949507],
            [0.7099507604770761, 45.759899910367494],
            [0.7099507604770761, 45.799831192112336],
            [0.7602472918262393, 45.799831192112336],
            [0.7998424335266439, 45.82996115924709],
            [0.829806324543167, 45.88005676725426],
            [0.8100087536929648, 45.90002240812668],
            [0.8201750738592848, 45.9199880489991],
            [0.8801028558923294, 45.9199880489991],
            [0.9202330670751726, 45.95011801613385],
            [0.9298643177590549, 45.95011801613385],
            [0.9400306379253749, 45.95991933074395],
            [0.9100667469088526, 46.02017926501345],
            [0.8699365357260094, 46.02017926501345],
            [0.8501389648758071, 46.04014490588587],
            [0.8201750738592848, 46.04994622049597],
            [0.829806324543167, 46.06991186136839],
            [0.8201750738592848, 46.080076187630716],
            [0.829806324543167, 46.10004182850314],
            [0.8100087536929648, 46.12000746937556],
            [0.8201750738592848, 46.130171795637885],
            [0.8501389648758071, 46.139973110247986],
            [0.829806324543167, 46.15993875112041],
            [0.829806324543167, 46.17990439199283],
            [0.7902111828427616, 46.210034359127576],
            [0.8100087536929648, 46.230000000000004],
            [0.8501389648758071, 46.230000000000004],
            [0.8597702155596894, 46.260129967134745],
            [0.8897341065762117, 46.269931281744846],
            [0.8999004267425326, 46.289896922617274],
            [0.9298643177590549, 46.28009560800717],
            [0.9400306379253749, 46.289896922617274],
            [0.9699945289418972, 46.289896922617274],
            [0.9897920997921004, 46.28009560800717],
            [1.0299223109749427, 46.320026889752015],
            [1.0299223109749427, 46.33999253062444],
            [1.0502549513075827, 46.359958171496864],
            [1.1000164131743082, 46.359958171496864],
            [1.1101827333406282, 46.35015685688676],
            [1.1497778750410328, 46.37012249775919],
            [1.1599441952073537, 46.39008813863161],
            [1.179741766057556, 46.379923812369285],
            [1.210240726556516, 46.39008813863161],
            [1.210240726556516, 46.37012249775919],
            [1.2402046175730392, 46.37012249775919],
            [1.2498358682569215, 46.379923812369285],
            [1.2797997592734438, 46.379923812369285],
            [1.309763650289966, 46.37012249775919],
            [1.3199299704562861, 46.39008813863161],
            [1.3600601816391293, 46.39988945324171],
            [1.4199879636721748, 46.35015685688676],
            [1.4499518546886971, 46.329828204362116],
            [1.4397855345223771, 46.320026889752015],
            [1.4001903928219717, 46.240164326262324],
            [1.3798577524893316, 46.21983567373768],
            [1.409821643505854, 46.17990439199283],
            [1.4601181748550172, 46.17990439199283],
            [1.4697494255388994, 46.150137436510306],
            [1.5002483860378595, 46.139973110247986],
            [1.4900820658715395, 46.10984314311324],
            [1.5098796367217417, 46.08987750224081],
            [1.539843527738265, 46.080076187630716],
            [1.5302122770543827, 46.060110546758295],
            [1.550009847904585, 46.04014490588587],
            [1.5302122770543827, 46.01001493875112],
            [1.539843527738265, 45.9998506124888],
            [1.5698074187547872, 45.9998506124888],
            [1.5698074187547872, 45.95991933074395],
            [1.539843527738265, 45.95011801613385],
            [1.5302122770543827, 45.93015237526143],
            [1.550009847904585, 45.9199880489991],
            [1.5799737389211073, 45.93015237526143],
            [1.6297352007878327, 45.9199880489991],
            [1.6399015209541528, 45.889858081864354],
            [1.5997713097713095, 45.889858081864354],
            [1.6099376299376305, 45.86989244099193],
            [1.5997713097713095, 45.86009112638183],
            [1.669865411970675, 45.84012548550941],
            [1.7297931940037206, 45.84012548550941],
            [1.7699234051865629, 45.86989244099193],
            [1.7800897253528838, 45.82996115924709],
            [1.799887296203086, 45.82996115924709],
            [1.8202199365357261, 45.80999551837466],
            [1.8598150782361307, 45.80999551837466],
            [1.899945289418974, 45.759899910367494],
            [1.8801477185687716, 45.73013295488497],
            [1.899945289418974, 45.700002987750224],
            [1.910111609585294, 45.6800373468778],
            [1.8801477185687716, 45.6800373468778],
            [1.8699813984024516, 45.660071706005375],
            [1.8501838275522484, 45.669873020615476],
            [1.8202199365357261, 45.669873020615476],
            [1.7902560455192038, 45.6800373468778],
            [1.7800897253528838, 45.660071706005375],
            [1.7201619433198383, 45.640106065132954],
            [1.6602341612867928, 45.60997609799821],
            [1.6500678411204728, 45.590010457125786],
            [1.6297352007878327, 45.57984613086346],
            [1.5901400590874273, 45.57984613086346],
            [1.5799737389211073, 45.55988048999104],
            [1.550009847904585, 45.55007917538094],
            [1.5200459568880627, 45.55988048999104],
            [1.5098796367217417, 45.55007917538094],
            [1.4499518546886971, 45.55007917538094],
            [1.4301542838384949, 45.530113534508516],
            [1.409821643505854, 45.530113534508516],
            [1.4001903928219717, 45.510147893636095],
            [1.3498938614728093, 45.46985360023902],
            [1.2899660794397638, 45.48981924111144],
            [1.2600021884232415, 45.46985360023902],
            [1.2498358682569215, 45.4400866447565],
            [1.2300382974067183, 45.4400866447565],
            [1.2300382974067183, 45.46005228562892],
            [1.179741766057556, 45.46005228562892],
            [1.1599441952073537, 45.48001792650135],
            [1.1401466243571505, 45.46985360023902],
            [1.1198139840245105, 45.48981924111144],
            [1.1497778750410328, 45.51994920824619],
            [1.1299803041908305, 45.53991484911862],
            [1.080218842324106, 45.530113534508516],
            [1.0299223109749427, 45.57984613086346],
            [1.0400886311412627, 45.590010457125786],
            [1.0197559908086227, 45.60997609799821],
            [0.8999004267425326, 45.60997609799821],
            [0.8699365357260094, 45.62014042426053],
            [0.8399726447094871, 45.57984613086346],
            [0.8100087536929648, 45.57984613086346],
            [0.7998424335266439, 45.60017478338811],
            [0.7800448626764416, 45.590010457125786],
            [0.7500809716599193, 45.62014042426053],
            [0.7800448626764416, 45.669873020615476],
            [0.7602472918262393, 45.669873020615476],
            [0.7399146514935993, 45.6898386614879],
            [0.6500229784440315, 45.6898386614879],
            [0.6302254075938292, 45.71016731401255],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 15, name: "Cantal", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.9802505744611016, 44.64000896325067],
            [2.9401203632782584, 44.67994024499552],
            [2.9197877229456184, 44.73003585300269],
            [2.9299540431119384, 44.73983716761279],
            [2.9197877229456184, 44.76016582013744],
            [2.9299540431119384, 44.78013146100986],
            [2.9197877229456184, 44.78993277561996],
            [2.889823831929095, 44.78993277561996],
            [2.859859940912573, 44.84002838362713],
            [2.859859940912573, 44.870158350761876],
            [2.7897658387132074, 44.870158350761876],
            [2.780134588029325, 44.910089632506725],
            [2.759801947696685, 44.930055273379146],
            [2.7202068059962796, 44.930055273379146],
            [2.7100404858299596, 44.910089632506725],
            [2.6800765948134373, 44.910089632506725],
            [2.6597439544807973, 44.8901239916343],
            [2.6597439544807973, 44.870158350761876],
            [2.629780063464274, 44.870158350761876],
            [2.620148812780392, 44.84982969823723],
            [2.5998161724477518, 44.84002838362713],
            [2.5998161724477518, 44.78993277561996],
            [2.5698522814312295, 44.78993277561996],
            [2.5500547105810263, 44.76016582013744],
            [2.5500547105810263, 44.73003585300269],
            [2.560221030747347, 44.71987152674036],
            [2.499758179231864, 44.69010457125784],
            [2.4901269285479817, 44.65997460412309],
            [2.4697942882153407, 44.64000896325067],
            [2.4398303971988184, 44.64000896325067],
            [2.400235255498414, 44.650173289513],
            [2.3499387241492506, 44.64000896325067],
            [2.3199748331327283, 44.67013893038542],
            [2.290010942116205, 44.67013893038542],
            [2.249880730933363, 44.650173289513],
            [2.2097505197505196, 44.64000896325067],
            [2.2097505197505196, 44.62004332237825],
            [2.170155378050115, 44.64000896325067],
            [2.1797866287339973, 44.67013893038542],
            [2.149822737717475, 44.69990588586794],
            [2.149822737717475, 44.76996713474753],
            [2.170155378050115, 44.78013146100986],
            [2.170155378050115, 44.80989841649238],
            [2.1401914870335927, 44.82006274275471],
            [2.119858846700952, 44.84982969823723],
            [2.0898949556844295, 44.870158350761876],
            [2.0898949556844295, 44.8999253062444],
            [2.1102275960170696, 44.910089632506725],
            [2.0802637050005472, 44.930055273379146],
            [2.0802637050005472, 44.95002091425157],
            [2.059931064667907, 44.980150881386315],
            [2.1102275960170696, 44.980150881386315],
            [2.1300251668672727, 44.989952195996416],
            [2.1401914870335927, 45.00991783686884],
            [2.119858846700952, 45.020082163131164],
            [2.1000612758507495, 45.060013444876006],
            [2.1401914870335927, 45.090143412010754],
            [2.1797866287339973, 45.090143412010754],
            [2.1899529489003173, 45.119910367493276],
            [2.2199168399168405, 45.170005975500445],
            [2.2001192690666374, 45.18017030176277],
            [2.2001192690666374, 45.22010158350762],
            [2.2001192690666374, 45.229902898117714],
            [2.2402494802494806, 45.24986853899014],
            [2.2402494802494806, 45.26983417986256],
            [2.260047051099683, 45.26983417986256],
            [2.270213371266003, 45.29016283238721],
            [2.290010942116205, 45.29016283238721],
            [2.3199748331327283, 45.31992978786973],
            [2.3601050443155707, 45.33989542874216],
            [2.3601050443155707, 45.379826710487],
            [2.369736294999453, 45.38999103674933],
            [2.3499387241492506, 45.40995667762175],
            [2.390068935332094, 45.40995667762175],
            [2.4398303971988184, 45.38999103674933],
            [2.4398303971988184, 45.379826710487],
            [2.520090819564504, 45.379826710487],
            [2.530257139730824, 45.38999103674933],
            [2.4901269285479817, 45.42012100388408],
            [2.509924499398184, 45.48001792650135],
            [2.5398883904147063, 45.48001792650135],
            [2.5398883904147063, 45.46005228562892],
            [2.5698522814312295, 45.46005228562892],
            [2.5800186015975495, 45.4498879593666],
            [2.639946383630594, 45.4498879593666],
            [2.6597439544807973, 45.42992231849418],
            [2.6902429149797573, 45.4400866447565],
            [2.6800765948134373, 45.40995667762175],
            [2.6998741656636396, 45.40015536301165],
            [2.7100404858299596, 45.379826710487],
            [2.729838056680162, 45.38999103674933],
            [2.7897658387132074, 45.38999103674933],
            [2.8202647992121683, 45.40015536301165],
            [2.859859940912573, 45.379826710487],
            [2.889823831929095, 45.379826710487],
            [2.9197877229456184, 45.37002539587691],
            [2.9299540431119384, 45.33009411413206],
            [2.94975161396214, 45.31012847325964],
            [2.9700842542947816, 45.31012847325964],
            [3.000048145311303, 45.29016283238721],
            [3.019845716161506, 45.29016283238721],
            [3.0701422475106694, 45.31992978786973],
            [3.0701422475106694, 45.33989542874216],
            [3.100106138527191, 45.35005975500448],
            [3.109737389211074, 45.33009411413206],
            [3.100106138527191, 45.31992978786973],
            [3.109737389211074, 45.29996414699731],
            [3.130070029543714, 45.29016283238721],
            [3.1600339205602372, 45.29016283238721],
            [3.1702002407265573, 45.27999850612489],
            [3.219961702593282, 45.27999850612489],
            [3.230128022759602, 45.26983417986256],
            [3.219961702593282, 45.24986853899014],
            [3.239759273443485, 45.22010158350762],
            [3.270258233942445, 45.20993725724529],
            [3.260091913776125, 45.170005975500445],
            [3.2900558047926465, 45.119910367493276],
            [3.3098533756428496, 45.119910367493276],
            [3.349983586825693, 45.099944726620855],
            [3.3098533756428496, 45.090143412010754],
            [3.3002221249589683, 45.060013444876006],
            [3.3098533756428496, 45.020082163131164],
            [3.349983586825693, 45.000116522258736],
            [3.360149906992013, 44.969986555123995],
            [3.2900558047926465, 44.930055273379146],
            [3.260091913776125, 44.93985658798924],
            [3.249925593609805, 44.91989094711682],
            [3.230128022759602, 44.910089632506725],
            [3.230128022759602, 44.87995966537198],
            [3.1798314914104386, 44.85999402449955],
            [3.140236349710034, 44.8999253062444],
            [3.100106138527191, 44.87995966537198],
            [3.089939818360871, 44.85999402449955],
            [3.100106138527191, 44.84002838362713],
            [3.079773498194551, 44.82006274275471],
            [3.0599759273443494, 44.82006274275471],
            [3.0498096071780294, 44.78013146100986],
            [3.0300120363278262, 44.75000149387511],
            [3.0300120363278262, 44.71987152674036],
            [2.9802505744611016, 44.650173289513],
            [2.9802505744611016, 44.64000896325067],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 58, name: "Nièvre", REG: 27, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.6298249261407163, 46.74983268598745],
            [3.5800634642739917, 46.74983268598745],
            [3.599861035124193, 46.72986704511503],
            [3.5800634642739917, 46.72006573050493],
            [3.5500995732574685, 46.72006573050493],
            [3.5602658934237885, 46.68993576337019],
            [3.5399332530911485, 46.680134448760086],
            [3.5201356822409453, 46.68993576337019],
            [3.490171791224424, 46.66016880788766],
            [3.4602079002079007, 46.65000448162534],
            [3.4500415800415807, 46.66016880788766],
            [3.4500415800415807, 46.68993576337019],
            [3.4302440091913775, 46.70990140424261],
            [3.3799474778422143, 46.70990140424261],
            [3.3697811576758943, 46.68993576337019],
            [3.349983586825693, 46.680134448760086],
            [3.3002221249589683, 46.70010008963251],
            [3.3002221249589683, 46.72006573050493],
            [3.270258233942445, 46.72006573050493],
            [3.230128022759602, 46.70010008963251],
            [3.219961702593282, 46.680134448760086],
            [3.1702002407265573, 46.68993576337019],
            [3.130070029543714, 46.72986704511503],
            [3.100106138527191, 46.72986704511503],
            [3.0498096071780294, 46.75999701224978],
            [3.0300120363278262, 46.790126979384524],
            [3.0701422475106694, 46.850023902001794],
            [3.0498096071780294, 46.909920824619064],
            [3.0599759273443494, 46.94005079175381],
            [3.079773498194551, 46.949852106363906],
            [3.0599759273443494, 46.979982073498654],
            [3.0701422475106694, 46.99994771437108],
            [3.0701422475106694, 47.03007768150583],
            [3.0599759273443494, 47.05004332237825],
            [3.019845716161506, 47.05984463698835],
            [3.0300120363278262, 47.0899746041231],
            [3.0300120363278262, 47.12990588586794],
            [3.019845716161506, 47.16003585300269],
            [2.9802505744611016, 47.230097101882286],
            [2.9802505744611016, 47.25986405736481],
            [2.9401203632782584, 47.289994024499556],
            [2.880192581245213, 47.320123991634304],
            [2.870026261078893, 47.3299253062444],
            [2.889823831929095, 47.36985658798925],
            [2.9299540431119384, 47.43011652225874],
            [2.889823831929095, 47.509979085748434],
            [2.870026261078893, 47.52014341201075],
            [2.8502286902286906, 47.54010905288318],
            [2.859859940912573, 47.54991036749328],
            [2.899990152095415, 47.54991036749328],
            [2.9101564722617352, 47.5698760083657],
            [2.9599179341284616, 47.5600746937556],
            [2.9802505744611016, 47.5698760083657],
            [3.019845716161506, 47.5600746937556],
            [3.0599759273443494, 47.5698760083657],
            [3.089939818360871, 47.589841649238124],
            [3.119903709377394, 47.58004033462802],
            [3.119903709377394, 47.54010905288318],
            [3.140236349710034, 47.54010905288318],
            [3.1600339205602372, 47.52014341201075],
            [3.2001641317430787, 47.52014341201075],
            [3.239759273443485, 47.49001344487601],
            [3.270258233942445, 47.49001344487601],
            [3.2900558047926465, 47.50017777113833],
            [3.349983586825693, 47.479849118613686],
            [3.390113798008536, 47.50017777113833],
            [3.390113798008536, 47.509979085748434],
            [3.4500415800415807, 47.509979085748434],
            [3.490171791224424, 47.49001344487601],
            [3.490171791224424, 47.5600746937556],
            [3.5099693620746253, 47.54991036749328],
            [3.5099693620746253, 47.529944726620855],
            [3.5500995732574685, 47.50017777113833],
            [3.5800634642739917, 47.50017777113833],
            [3.5800634642739917, 47.459883477741265],
            [3.610027355290513, 47.470047804003585],
            [3.6597888171572377, 47.450082163131164],
            [3.6801214574898795, 47.43011652225874],
            [3.699919028340081, 47.43011652225874],
            [3.720251668672721, 47.399986555123995],
            [3.7801794507057673, 47.399986555123995],
            [3.8101433417222887, 47.380020914251574],
            [3.819774592406172, 47.399986555123995],
            [3.840107232738812, 47.410150881386315],
            [3.849738483422695, 47.43011652225874],
            [3.880237443921655, 47.43011652225874],
            [3.8898686946055365, 47.410150881386315],
            [3.859904803589015, 47.38982222886167],
            [3.870071123755335, 47.36985658798925],
            [3.9102013349381766, 47.380020914251574],
            [3.9401652259546998, 47.380020914251574],
            [3.959962796804903, 47.36985658798925],
            [3.9797603676551043, 47.320123991634304],
            [4.000093007987744, 47.30995966537198],
            [4.030056899004268, 47.30995966537198],
            [4.030056899004268, 47.3299253062444],
            [4.049854469854471, 47.340089632506725],
            [4.109782251887515, 47.340089632506725],
            [4.130114892220155, 47.320123991634304],
            [4.109782251887515, 47.289994024499556],
            [4.1397461429040385, 47.23989841649238],
            [4.17987635408688, 47.25006274275471],
            [4.220006565269723, 47.21993277561996],
            [4.230172885436043, 47.19996713474754],
            [4.209840245103403, 47.18000149387511],
            [4.209840245103403, 47.16003585300269],
            [4.190042674253202, 47.14987152674037],
            [4.17987635408688, 47.14987152674037],
            [4.1397461429040385, 47.14007021213027],
            [4.109782251887515, 47.14007021213027],
            [4.119948572053835, 47.12010457125784],
            [4.049854469854471, 47.12010457125784],
            [4.049854469854471, 47.0899746041231],
            [4.040223219170588, 47.080173289513],
            [4.070187110187111, 47.05984463698835],
            [4.060020790020791, 47.0199133552435],
            [4.040223219170588, 46.99994771437108],
            [4.000093007987744, 46.99014639976098],
            [4.010259328154066, 46.97018075888856],
            [4.040223219170588, 46.979982073498654],
            [4.049854469854471, 46.96001643262623],
            [4.040223219170588, 46.929886465491485],
            [4.040223219170588, 46.90011951000896],
            [4.070187110187111, 46.889955183746636],
            [4.100151001203634, 46.869989542874215],
            [4.049854469854471, 46.83985957573947],
            [4.060020790020791, 46.819893934867046],
            [4.060020790020791, 46.7799626531222],
            [4.040223219170588, 46.790126979384524],
            [3.959962796804903, 46.770161338512104],
            [3.949796476638583, 46.74983268598745],
            [3.9000350147718565, 46.72986704511503],
            [3.870071123755335, 46.72986704511503],
            [3.829940912572492, 46.70010008963251],
            [3.7898107013896487, 46.70010008963251],
            [3.7801794507057673, 46.740031371377356],
            [3.740049239522924, 46.74983268598745],
            [3.699919028340081, 46.74983268598745],
            [3.689752708173761, 46.740031371377356],
            [3.6399912463070363, 46.740031371377356],
            [3.6298249261407163, 46.74983268598745],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 26, name: "Drôme", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.650202429149798, 44.32999701224978],
            [4.650202429149798, 44.36992829399462],
            [4.670000000000001, 44.42982521661189],
            [4.699963891016522, 44.45015386913654],
            [4.699963891016522, 44.479920824619064],
            [4.689797570850202, 44.490085150881384],
            [4.689797570850202, 44.519852106363906],
            [4.710130211182844, 44.53001643262623],
            [4.689797570850202, 44.549982073498654],
            [4.710130211182844, 44.5801120406334],
            [4.7400941021993654, 44.60007768150582],
            [4.7502604223656855, 44.62004332237825],
            [4.780224313382209, 44.650173289513],
            [4.780224313382209, 44.67994024499552],
            [4.759891673049569, 44.71987152674036],
            [4.759891673049569, 44.76996713474753],
            [4.800021884232412, 44.78993277561996],
            [4.800021884232412, 44.80989841649238],
            [4.819819455082613, 44.82006274275471],
            [4.819819455082613, 44.84002838362713],
            [4.859949666265456, 44.870158350761876],
            [4.849783346099136, 44.8999253062444],
            [4.8701159864317765, 44.910089632506725],
            [4.879747237115658, 44.93985658798924],
            [4.840152095415253, 45.000116522258736],
            [4.840152095415253, 45.040047804003585],
            [4.849783346099136, 45.060013444876006],
            [4.829985775248933, 45.07017777113833],
            [4.829985775248933, 45.099944726620855],
            [4.810188204398732, 45.11010905288318],
            [4.800021884232412, 45.1300746937556],
            [4.829985775248933, 45.150040334628024],
            [4.810188204398732, 45.170005975500445],
            [4.810188204398732, 45.20013594263519],
            [4.800021884232412, 45.229902898117714],
            [4.810188204398732, 45.26003286525246],
            [4.810188204398732, 45.29016283238721],
            [4.800021884232412, 45.29996414699731],
            [4.859949666265456, 45.31012847325964],
            [4.879747237115658, 45.29996414699731],
            [4.979805230331547, 45.33989542874216],
            [5.009769121348069, 45.33989542874216],
            [5.019935441514389, 45.31992978786973],
            [5.049899332530912, 45.31992978786973],
            [5.090029543713755, 45.29016283238721],
            [5.119993434730277, 45.29016283238721],
            [5.119993434730277, 45.24986853899014],
            [5.179921216763323, 45.24986853899014],
            [5.179921216763323, 45.22010158350762],
            [5.169754896597003, 45.18997161637287],
            [5.190087536929643, 45.170005975500445],
            [5.190087536929643, 45.119910367493276],
            [5.16012364591312, 45.099944726620855],
            [5.179921216763323, 45.079979085748434],
            [5.230217748112486, 45.079979085748434],
            [5.250015318962688, 45.060013444876006],
            [5.269812889812891, 45.060013444876006],
            [5.3399069920122555, 45.060013444876006],
            [5.369870883028779, 45.040047804003585],
            [5.3998347740453, 45.040047804003585],
            [5.439964985228143, 45.060013444876006],
            [5.4699288762446665, 45.090143412010754],
            [5.4902615165773065, 45.079979085748434],
            [5.4699288762446665, 45.049849118613686],
            [5.4902615165773065, 44.989952195996416],
            [5.4800951964109865, 44.969986555123995],
            [5.4800951964109865, 44.8999253062444],
            [5.4597625560783465, 44.8298640573648],
            [5.4800951964109865, 44.80989841649238],
            [5.4800951964109865, 44.78993277561996],
            [5.550189298610351, 44.76996713474753],
            [5.550189298610351, 44.78993277561996],
            [5.580153189626874, 44.78013146100986],
            [5.5897844403107575, 44.76016582013744],
            [5.6101170806433975, 44.76016582013744],
            [5.650247291826239, 44.71987152674036],
            [5.700008753692965, 44.71987152674036],
            [5.75993653572601, 44.69990588586794],
            [5.800066746908853, 44.71007021213027],
            [5.830030637925375, 44.69010457125784],
            [5.800066746908853, 44.67994024499552],
            [5.789900426742533, 44.650173289513],
            [5.74977021555969, 44.650173289513],
            [5.729972644709487, 44.64000896325067],
            [5.680211182842762, 44.650173289513],
            [5.640080971659919, 44.650173289513],
            [5.640080971659919, 44.609878996115924],
            [5.6101170806433975, 44.569947714371075],
            [5.5999507604770775, 44.54018075888855],
            [5.650247291826239, 44.519852106363906],
            [5.659878542510122, 44.499886465491485],
            [5.629914651493599, 44.499886465491485],
            [5.619748331327279, 44.47011951000896],
            [5.5999507604770775, 44.47011951000896],
            [5.51005908742751, 44.490085150881384],
            [5.4597625560783465, 44.490085150881384],
            [5.4597625560783465, 44.45015386913654],
            [5.49989276726119, 44.439989542874216],
            [5.4800951964109865, 44.420023902001795],
            [5.439964985228143, 44.42982521661189],
            [5.420167414377942, 44.420023902001795],
            [5.439964985228143, 44.38989393486705],
            [5.429798665061823, 44.36992829399462],
            [5.4597625560783465, 44.36992829399462],
            [5.4699288762446665, 44.3499626531222],
            [5.4902615165773065, 44.3401613385121],
            [5.52022540759383, 44.3499626531222],
            [5.540022978444031, 44.32999701224978],
            [5.629914651493599, 44.32999701224978],
            [5.6101170806433975, 44.31983268598745],
            [5.640080971659919, 44.29006573050493],
            [5.650247291826239, 44.27010008963251],
            [5.670044862676442, 44.25993576337018],
            [5.689842433526645, 44.18987451449059],
            [5.680211182842762, 44.18987451449059],
            [5.650247291826239, 44.18987451449059],
            [5.640080971659919, 44.16990887361816],
            [5.680211182842762, 44.16010755900807],
            [5.680211182842762, 44.14994323274574],
            [5.629914651493599, 44.14994323274574],
            [5.640080971659919, 44.16990887361816],
            [5.6101170806433975, 44.18987451449059],
            [5.580153189626874, 44.18987451449059],
            [5.559820549294234, 44.16990887361816],
            [5.540022978444031, 44.12997759187332],
            [5.49989276726119, 44.12017627726322],
            [5.450131305394463, 44.12017627726322],
            [5.439964985228143, 44.14994323274574],
            [5.3998347740453, 44.14994323274574],
            [5.380037203195099, 44.16010755900807],
            [5.390203523361419, 44.18007319988049],
            [5.380037203195099, 44.20984015536301],
            [5.3399069920122555, 44.20003884075291],
            [5.299776780829412, 44.20984015536301],
            [5.260181639129008, 44.23016880788766],
            [5.239848998796368, 44.23016880788766],
            [5.239848998796368, 44.20984015536301],
            [5.2098851077798445, 44.20984015536301],
            [5.179921216763323, 44.22000448162534],
            [5.1499573257468, 44.23997012249776],
            [5.169754896597003, 44.29006573050493],
            [5.169754896597003, 44.31003137137735],
            [5.109827114563957, 44.27990140424261],
            [5.079863223547435, 44.27990140424261],
            [5.060065652697232, 44.31003137137735],
            [5.019935441514389, 44.29006573050493],
            [4.9899715504978674, 44.29006573050493],
            [4.940210088631141, 44.27010008963251],
            [4.930043768464821, 44.25993576337018],
            [4.879747237115658, 44.25993576337018],
            [4.829985775248933, 44.23016880788766],
            [4.810188204398732, 44.23016880788766],
            [4.810188204398732, 44.25993576337018],
            [4.800021884232412, 44.27010008963251],
            [4.800021884232412, 44.31003137137735],
            [4.759891673049569, 44.32999701224978],
            [4.719761461866725, 44.32999701224978],
            [4.710130211182844, 44.31983268598745],
            [4.680166320166321, 44.31983268598745],
            [4.650202429149798, 44.32999701224978],
          ],
          [
            [4.9899715504978674, 44.29006573050493],
            [4.9899715504978674, 44.31003137137735],
            [5.019935441514389, 44.3401613385121],
            [5.030101761680709, 44.360126979384525],
            [5.049899332530912, 44.360126979384525],
            [5.049899332530912, 44.380092620256946],
            [5.019935441514389, 44.38989393486705],
            [5.009769121348069, 44.40985957573947],
            [4.970173979647664, 44.42982521661189],
            [4.949841339315024, 44.40985957573947],
            [4.919877448298501, 44.40985957573947],
            [4.91024619761462, 44.40005826112937],
            [4.91024619761462, 44.36992829399462],
            [4.88991355728198, 44.36992829399462],
            [4.879747237115658, 44.32999701224978],
            [4.88991355728198, 44.29986704511503],
            [4.919877448298501, 44.31003137137735],
            [4.979805230331547, 44.29986704511503],
            [4.9899715504978674, 44.29006573050493],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 61, name: "Orne", REG: 28, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.8599431009957321, 48.49991186136839],
            [-0.8497767808294121, 48.51987750224082],
            [-0.8101816391290075, 48.550007469375565],
            [-0.7898489987963675, 48.550007469375565],
            [-0.750253857095962, 48.600103077382734],
            [-0.750253857095962, 48.620068718255155],
            [-0.7700514279461643, 48.64983567373768],
            [-0.740087536929642, 48.69012996713475],
            [-0.7700514279461643, 48.69012996713475],
            [-0.8198128898128898, 48.73006124887959],
            [-0.8497767808294121, 48.73006124887959],
            [-0.8401455301455298, 48.75002688975202],
            [-0.8101816391290075, 48.759828204362115],
            [-0.7802177481124852, 48.78995817149686],
            [-0.7101236459131197, 48.80012249775919],
            [-0.6801597548965974, 48.84005377950403],
            [-0.6501958638800742, 48.82988945324171],
            [-0.5998993325309119, 48.82988945324171],
            [-0.5501378706641864, 48.84985509411413],
            [-0.49984133931502317, 48.84985509411413],
            [-0.46987744829850087, 48.86982073498656],
            [-0.40994966626545537, 48.86982073498656],
            [-0.37998577524893307, 48.84985509411413],
            [-0.35002188423241076, 48.82008813863161],
            [-0.3302243133822085, 48.84005377950403],
            [-0.3302243133822085, 48.86001942037646],
            [-0.3002604223656853, 48.84985509411413],
            [-0.23979757085020204, 48.84985509411413],
            [-0.23016632016631977, 48.84005377950403],
            [-0.17986978881715743, 48.84005377950403],
            [-0.14990589780063424, 48.82008813863161],
            [-0.11994200678411193, 48.84985509411413],
            [-0.10977568661779191, 48.84005377950403],
            [-0.060014224751066436, 48.84005377950403],
            [-0.060014224751066436, 48.84985509411413],
            [-0.010252762884341848, 48.87998506124888],
            [0.0202461976146191, 48.8999507021213],
            [0.0502100886311414, 48.8999507021213],
            [0.0801739796476637, 48.93988198386615],
            [0.12993544151438918, 48.95004631012848],
            [0.14973301236459147, 48.93008066925605],
            [0.18023197286355153, 48.93008066925605],
            [0.1898632235474338, 48.93988198386615],
            [0.24015975489659702, 48.95984762473857],
            [0.2797548965970016, 48.95004631012848],
            [0.31025385709596254, 48.95004631012848],
            [0.3300514279461648, 48.93988198386615],
            [0.3600153189626871, 48.95004631012848],
            [0.3798128898128903, 48.9700119510009],
            [0.4097767808294126, 48.95004631012848],
            [0.3899792099792103, 48.91011502838363],
            [0.4199431009957326, 48.89014938751121],
            [0.47023963234489585, 48.89014938751121],
            [0.5002035233614182, 48.87998506124888],
            [0.5499649852281436, 48.87998506124888],
            [0.5799288762446659, 48.89014938751121],
            [0.6098927672611882, 48.87998506124888],
            [0.6098927672611882, 48.86001942037646],
            [0.6302254075938292, 48.82988945324171],
            [0.6901531896268738, 48.78995817149686],
            [0.7297483313272792, 48.78995817149686],
            [0.7602472918262393, 48.76999253062444],
            [0.7500809716599193, 48.759828204362115],
            [0.7800448626764416, 48.739862563489694],
            [0.7399146514935993, 48.719896922617274],
            [0.7297483313272792, 48.699931281744846],
            [0.7698785425101216, 48.699931281744846],
            [0.7602472918262393, 48.679965640872425],
            [0.7698785425101216, 48.670164326262324],
            [0.8100087536929648, 48.670164326262324],
            [0.829806324543167, 48.629870032865256],
            [0.8201750738592848, 48.609904391992835],
            [0.8501389648758071, 48.609904391992835],
            [0.8501389648758071, 48.58993875112041],
            [0.8699365357260094, 48.569973110247986],
            [0.8897341065762117, 48.569973110247986],
            [0.9400306379253749, 48.550007469375565],
            [0.9298643177590549, 48.53004182850314],
            [0.9699945289418972, 48.51987750224082],
            [0.9501969580916949, 48.49991186136839],
            [0.9400306379253749, 48.45998057962355],
            [0.9699945289418972, 48.44001493875112],
            [0.9501969580916949, 48.4200492978787],
            [0.9501969580916949, 48.40008365700628],
            [0.9100667469088526, 48.36995368987153],
            [0.8699365357260094, 48.36015237526143],
            [0.829806324543167, 48.33982372273678],
            [0.8201750738592848, 48.34998804899911],
            [0.7902111828427616, 48.33982372273678],
            [0.7698785425101216, 48.31985808186436],
            [0.7902111828427616, 48.27992680011951],
            [0.7902111828427616, 48.25996115924709],
            [0.829806324543167, 48.209865551239915],
            [0.7998424335266439, 48.189899910367494],
            [0.7602472918262393, 48.1800985957574],
            [0.720117080643397, 48.20006423662982],
            [0.6799868694605538, 48.25015984463699],
            [0.6500229784440315, 48.25996115924709],
            [0.6398566582777114, 48.23999551837467],
            [0.5799288762446659, 48.23999551837467],
            [0.5499649852281436, 48.25015984463699],
            [0.5301674143779405, 48.27012548550941],
            [0.5098347740453004, 48.27012548550941],
            [0.5002035233614182, 48.29009112638184],
            [0.46007331217857583, 48.31005676725426],
            [0.4397406718459349, 48.29989244099193],
            [0.4199431009957326, 48.31985808186436],
            [0.3798128898128903, 48.33002240812668],
            [0.3899792099792103, 48.34998804899911],
            [0.37018163912900803, 48.38991933074395],
            [0.3798128898128903, 48.4298506124888],
            [0.3498489987963671, 48.45998057962355],
            [0.3000875369296425, 48.47994622049597],
            [0.2599573257467993, 48.47994622049597],
            [0.2497910055804793, 48.470144905885874],
            [0.21982711456395698, 48.470144905885874],
            [0.1700656526972315, 48.45998057962355],
            [0.1598993325309115, 48.44001493875112],
            [0.11976912134806916, 48.44001493875112],
            [0.09997155049786599, 48.40988497161638],
            [0.07000765948134369, 48.40988497161638],
            [0.0502100886311414, 48.38991933074395],
            [0.0202461976146191, 48.380118016133856],
            [-0.019884013568224113, 48.38991933074395],
            [-0.049847904584746416, 48.380118016133856],
            [-0.060014224751066436, 48.4298506124888],
            [-0.049847904584746416, 48.450179265013446],
            [-0.13973957763431422, 48.450179265013446],
            [-0.14990589780063424, 48.47994622049597],
            [-0.17023853813327516, 48.49991186136839],
            [-0.17986978881715743, 48.53984314311324],
            [-0.20020242914979747, 48.560171795637885],
            [-0.23979757085020204, 48.560171795637885],
            [-0.23979757085020204, 48.53984314311324],
            [-0.2697614618667252, 48.51987750224082],
            [-0.32005799321588757, 48.51987750224082],
            [-0.35002188423241076, 48.47994622049597],
            [-0.3901520954152531, 48.510076187630716],
            [-0.46987744829850087, 48.510076187630716],
            [-0.4902100886311409, 48.49991186136839],
            [-0.5100076594813441, 48.510076187630716],
            [-0.5501378706641864, 48.470144905885874],
            [-0.589733012364591, 48.470144905885874],
            [-0.6501958638800742, 48.450179265013446],
            [-0.6801597548965974, 48.470144905885874],
            [-0.729921216763322, 48.470144905885874],
            [-0.719754896597002, 48.450179265013446],
            [-0.7598851077798443, 48.44001493875112],
            [-0.7802177481124852, 48.450179265013446],
            [-0.8101816391290075, 48.450179265013446],
            [-0.8198128898128898, 48.47994622049597],
            [-0.8599431009957321, 48.49991186136839],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 13,
        name: "Bouches-du-Rhône",
        REG: 93,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.230172885436043, 43.459858081864354],
            [4.239804136119926, 43.50015237526143],
            [4.29010066746909, 43.50995368987152],
            [4.320064558485611, 43.52991933074395],
            [4.350028449502134, 43.54008365700627],
            [4.429753802385382, 43.58001493875112],
            [4.450086442718022, 43.58001493875112],
            [4.469884013568225, 43.59998057962354],
            [4.429753802385382, 43.61994622049597],
            [4.450086442718022, 43.65987750224081],
            [4.480050333734545, 43.67004182850314],
            [4.490216653900865, 43.700171795637885],
            [4.520180544917387, 43.700171795637885],
            [4.53997811576759, 43.70997311024798],
            [4.599905897800634, 43.69000746937556],
            [4.629869788817158, 43.69000746937556],
            [4.610072217966954, 43.720137436510306],
            [4.629869788817158, 43.760068718255155],
            [4.650202429149798, 43.780034359127576],
            [4.650202429149798, 43.810164326262324],
            [4.640036108983478, 43.850095608007166],
            [4.670000000000001, 43.879862563489695],
            [4.710130211182844, 43.899828204362116],
            [4.7400941021993654, 43.92015685688676],
            [4.770057993215889, 43.92015685688676],
            [4.810188204398732, 43.909992530624436],
            [4.849783346099136, 43.909992530624436],
            [4.9000798774483, 43.890026889752015],
            [4.970173979647664, 43.870061248879594],
            [5.0001378706641875, 43.839931281744846],
            [5.030101761680709, 43.830129967134745],
            [5.049899332530912, 43.78983567373768],
            [5.13979100558048, 43.74990439199283],
            [5.190087536929643, 43.74010307738273],
            [5.239848998796368, 43.74990439199283],
            [5.260181639129008, 43.74010307738273],
            [5.320109421162054, 43.74010307738273],
            [5.3399069920122555, 43.720137436510306],
            [5.410001094211622, 43.69000746937556],
            [5.529856658277711, 43.65987750224081],
            [5.6101170806433975, 43.65987750224081],
            [5.640080971659919, 43.67004182850314],
            [5.659878542510122, 43.69000746937556],
            [5.710175073859285, 43.69000746937556],
            [5.740138964875807, 43.720137436510306],
            [5.74977021555969, 43.720137436510306],
            [5.779734106576213, 43.720137436510306],
            [5.800066746908853, 43.67984314311323],
            [5.800066746908853, 43.65987750224081],
            [5.77010285589233, 43.65987750224081],
            [5.719806324543167, 43.65007618763072],
            [5.700008753692965, 43.63991186136839],
            [5.680211182842762, 43.61014490588587],
            [5.689842433526645, 43.58001493875112],
            [5.659878542510122, 43.58001493875112],
            [5.670044862676442, 43.5600492978787],
            [5.710175073859285, 43.5600492978787],
            [5.719806324543167, 43.54008365700627],
            [5.700008753692965, 43.479823722736775],
            [5.729972644709487, 43.47002240812668],
            [5.74977021555969, 43.43009112638183],
            [5.779734106576213, 43.41012548550941],
            [5.74977021555969, 43.399961159247084],
            [5.700008753692965, 43.41012548550941],
            [5.689842433526645, 43.369831192112336],
            [5.700008753692965, 43.349865551239915],
            [5.680211182842762, 43.32009859575739],
            [5.689842433526645, 43.309934269495066],
            [5.729972644709487, 43.32009859575739],
            [5.75993653572601, 43.280167314012544],
            [5.740138964875807, 43.2598386614879],
            [5.680211182842762, 43.23987302061548],
            [5.680211182842762, 43.190140424260534],
            [5.670044862676442, 43.17997609799821],
            [5.650247291826239, 43.190140424260534],
            [5.619748331327279, 43.190140424260534],
            [5.5999507604770775, 43.160010457125786],
            [5.569986869460554, 43.170174783388106],
            [5.550189298610351, 43.210106065132955],
            [5.52022540759383, 43.19994173887063],
            [5.4902615165773065, 43.19994173887063],
            [5.450131305394463, 43.210106065132955],
            [5.3399069920122555, 43.210106065132955],
            [5.3500733121785755, 43.230071706005376],
            [5.369870883028779, 43.23987302061548],
            [5.369870883028779, 43.270002987750225],
            [5.3602396323448955, 43.289968628622645],
            [5.3602396323448955, 43.32009859575739],
            [5.3399069920122555, 43.340064236629814],
            [5.320109421162054, 43.36002987750224],
            [5.299776780829412, 43.36002987750224],
            [5.239848998796368, 43.329899910367494],
            [5.039733012364592, 43.329899910367494],
            [4.9899715504978674, 43.39015984463699],
            [5.0001378706641875, 43.399961159247084],
            [5.039733012364592, 43.399961159247084],
            [5.13979100558048, 43.399961159247084],
            [5.200253857095963, 43.43989244099193],
            [5.230217748112486, 43.45005676725425],
            [5.2200514279461645, 43.4899880489991],
            [5.200253857095963, 43.4899880489991],
            [5.1499573257468, 43.459858081864354],
            [5.119993434730277, 43.479823722736775],
            [5.100195863880075, 43.52991933074395],
            [5.060065652697232, 43.52991933074395],
            [5.049899332530912, 43.52011801613385],
            [5.019935441514389, 43.52991933074395],
            [5.0001378706641875, 43.50995368987152],
            [5.0001378706641875, 43.479823722736775],
            [5.009769121348069, 43.47002240812668],
            [5.049899332530912, 43.47002240812668],
            [5.049899332530912, 43.43989244099193],
            [5.060065652697232, 43.41012548550941],
            [5.039733012364592, 43.399961159247084],
            [5.0001378706641875, 43.399961159247084],
            [4.979805230331547, 43.399961159247084],
            [4.970173979647664, 43.43009112638183],
            [4.88991355728198, 43.43009112638183],
            [4.8701159864317765, 43.41012548550941],
            [4.829985775248933, 43.43009112638183],
            [4.819819455082613, 43.41992680011951],
            [4.859949666265456, 43.399961159247084],
            [4.849783346099136, 43.37999551837466],
            [4.879747237115658, 43.36002987750224],
            [4.859949666265456, 43.329899910367494],
            [4.840152095415253, 43.329899910367494],
            [4.770057993215889, 43.349865551239915],
            [4.659833679833681, 43.349865551239915],
            [4.559775686617793, 43.369831192112336],
            [4.569942006784113, 43.39015984463699],
            [4.599905897800634, 43.41012548550941],
            [4.589739577634314, 43.43009112638183],
            [4.55014443593391, 43.45005676725425],
            [4.520180544917387, 43.45005676725425],
            [4.460252762884342, 43.459858081864354],
            [4.420122551701499, 43.45005676725425],
            [4.379992340518657, 43.45005676725425],
            [4.230172885436043, 43.459858081864354],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 81, name: "Tarn", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.029967173651384, 43.43989244099193],
            [2.0101696028011817, 43.45005676725425],
            [2.019800853485064, 43.47002240812668],
            [1.9802057117846594, 43.4899880489991],
            [1.9502418207681371, 43.4899880489991],
            [1.9197428602691762, 43.50995368987152],
            [1.8699813984024516, 43.52991933074395],
            [1.8501838275522484, 43.54988497161637],
            [1.8400175073859284, 43.58001493875112],
            [1.7902560455192038, 43.58001493875112],
            [1.7699234051865629, 43.59998057962354],
            [1.7399595141700406, 43.59998057962354],
            [1.7201619433198383, 43.61994622049597],
            [1.690198052303316, 43.63011054675829],
            [1.6998293029871983, 43.65007618763072],
            [1.7201619433198383, 43.65987750224081],
            [1.7201619433198383, 43.69000746937556],
            [1.6602341612867928, 43.69000746937556],
            [1.7099956231535183, 43.720137436510306],
            [1.680031732136995, 43.74010307738273],
            [1.6500678411204728, 43.74990439199283],
            [1.6602341612867928, 43.76987003286525],
            [1.6500678411204728, 43.78983567373768],
            [1.5901400590874273, 43.819965640872425],
            [1.5901400590874273, 43.839931281744846],
            [1.5698074187547872, 43.850095608007166],
            [1.550009847904585, 43.890026889752015],
            [1.560176168070905, 43.92015685688676],
            [1.5698074187547872, 43.940122497759184],
            [1.539843527738265, 43.949923812369285],
            [1.5698074187547872, 43.969889453241706],
            [1.5901400590874273, 43.96008813863161],
            [1.6201039501039505, 43.969889453241706],
            [1.690198052303316, 44.01998506124888],
            [1.6998293029871983, 44.0399507021213],
            [1.690198052303316, 44.05991634299372],
            [1.6602341612867928, 44.07008066925605],
            [1.669865411970675, 44.09004631012847],
            [1.6500678411204728, 44.09984762473857],
            [1.669865411970675, 44.12017627726322],
            [1.690198052303316, 44.11001195100089],
            [1.7201619433198383, 44.12017627726322],
            [1.7800897253528838, 44.09984762473857],
            [1.810053616369406, 44.12997759187332],
            [1.8400175073859284, 44.14014191813564],
            [1.910111609585294, 44.14014191813564],
            [1.8897789692526539, 44.16010755900807],
            [1.9299091804354962, 44.16010755900807],
            [1.9700393916183394, 44.14014191813564],
            [1.9898369624685417, 44.14994323274574],
            [2.059931064667907, 44.16990887361816],
            [2.1102275960170696, 44.20003884075291],
            [2.149822737717475, 44.20003884075291],
            [2.149822737717475, 44.18007319988049],
            [2.1797866287339973, 44.16990887361816],
            [2.2199168399168405, 44.16990887361816],
            [2.2097505197505196, 44.14994323274574],
            [2.2402494802494806, 44.12997759187332],
            [2.279844621949885, 44.14994323274574],
            [2.300177262282526, 44.14014191813564],
            [2.290010942116205, 44.12017627726322],
            [2.3301411532990484, 44.12017627726322],
            [2.3601050443155707, 44.09984762473857],
            [2.390068935332094, 44.09004631012847],
            [2.409866506182296, 44.05991634299372],
            [2.4601630375314585, 44.05011502838363],
            [2.4601630375314585, 44.0301493875112],
            [2.499758179231864, 44.009820734986555],
            [2.4901269285479817, 44.000019420376454],
            [2.520090819564504, 43.98005377950403],
            [2.509924499398184, 43.949923812369285],
            [2.5500547105810263, 43.929958171496864],
            [2.5500547105810263, 43.890026889752015],
            [2.560221030747347, 43.850095608007166],
            [2.629780063464274, 43.780034359127576],
            [2.6800765948134373, 43.74010307738273],
            [2.7100404858299596, 43.74010307738273],
            [2.740004376846483, 43.72993875112041],
            [2.780134588029325, 43.74010307738273],
            [2.8100984790458474, 43.760068718255155],
            [2.870026261078893, 43.74010307738273],
            [2.9197877229456184, 43.74010307738273],
            [2.9401203632782584, 43.69000746937556],
            [2.9197877229456184, 43.69000746937556],
            [2.9197877229456184, 43.65987750224081],
            [2.9101564722617352, 43.65007618763072],
            [2.880192581245213, 43.65987750224081],
            [2.8502286902286906, 43.63991186136839],
            [2.8100984790458474, 43.63991186136839],
            [2.769968267863005, 43.61994622049597],
            [2.750170697012803, 43.61994622049597],
            [2.7202068059962796, 43.63991186136839],
            [2.6902429149797573, 43.65007618763072],
            [2.650112703796915, 43.65007618763072],
            [2.629780063464274, 43.63011054675829],
            [2.620148812780392, 43.59998057962354],
            [2.629780063464274, 43.58001493875112],
            [2.620148812780392, 43.56985061248879],
            [2.629780063464274, 43.54988497161637],
            [2.6597439544807973, 43.52011801613385],
            [2.6597439544807973, 43.459858081864354],
            [2.639946383630594, 43.459858081864354],
            [2.609982492614072, 43.43009112638183],
            [2.5698522814312295, 43.41992680011951],
            [2.520090819564504, 43.41992680011951],
            [2.4901269285479817, 43.43989244099193],
            [2.4499967173651385, 43.43009112638183],
            [2.409866506182296, 43.43009112638183],
            [2.400235255498414, 43.41992680011951],
            [2.369736294999453, 43.41992680011951],
            [2.3098085129664083, 43.43989244099193],
            [2.279844621949885, 43.43989244099193],
            [2.260047051099683, 43.45005676725425],
            [2.2199168399168405, 43.43009112638183],
            [2.2300831600831605, 43.41012548550941],
            [2.2199168399168405, 43.37999551837466],
            [2.1899529489003173, 43.39015984463699],
            [2.170155378050115, 43.41992680011951],
            [2.1401914870335927, 43.399961159247084],
            [2.0700973848342272, 43.399961159247084],
            [2.049764744501587, 43.43009112638183],
            [2.029967173651384, 43.43989244099193],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 971,
        name: "Guadeloupe",
        REG: "01",
        CAT: 0,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-4.389796476638582, 41.539889453241706],
              [-4.399962796804902, 41.530088138631605],
              [-4.429926687821425, 41.530088138631605],
              [-4.429926687821425, 41.55005377950403],
              [-4.4101291169712225, 41.570019420376454],
              [-4.3801652259547, 41.55005377950403],
              [-4.389796476638582, 41.539889453241706],
            ],
          ],
          [
            [
              [-4.350201334938177, 41.539889453241706],
              [-4.359832585622059, 41.55985509411413],
              [-4.329868694605537, 41.55985509411413],
              [-4.340035014771857, 41.579820734986555],
              [-4.320237443921655, 41.589985061248875],
              [-4.310071123755335, 41.570019420376454],
              [-4.320237443921655, 41.55005377950403],
              [-4.350201334938177, 41.539889453241706],
            ],
          ],
          [
            [
              [-3.860077689025058, 41.589985061248875],
              [-3.89004158004158, 41.589985061248875],
              [-3.9601356822409457, 41.6099507021213],
              [-3.979933253091148, 41.66004631012847],
              [-3.979933253091148, 41.68001195100089],
              [-3.9601356822409457, 41.68001195100089],
              [-3.9499693620746257, 41.71994323274574],
              [-3.930171791224423, 41.75007319988049],
              [-3.9098391508917825, 41.75987451449058],
              [-3.860077689025058, 41.73990887361816],
              [-3.8397450486924174, 41.73990887361816],
              [-3.8199474778422147, 41.71014191813564],
              [-3.7899835868256924, 41.69017627726322],
              [-3.77018601597549, 41.66004631012847],
              [-3.8397450486924174, 41.6001493875112],
              [-3.860077689025058, 41.589985061248875],
            ],
          ],
          [
            [
              [-3.640164131743079, 42.119982073498655],
              [-3.670128022759602, 42.11018075888855],
              [-3.670128022759602, 42.130146399760974],
              [-3.640164131743079, 42.1501120406334],
              [-3.619831491410439, 42.1501120406334],
              [-3.5497373892110735, 42.190043322378244],
              [-3.5299398183608712, 42.17007768150582],
              [-3.6000339205602367, 42.130146399760974],
              [-3.640164131743079, 42.119982073498655],
            ],
          ],
          [
            [
              [-3.670128022759602, 41.97005826112937],
              [-3.670128022759602, 41.95989393486704],
              [-3.7102582339424446, 41.95989393486704],
              [-3.7102582339424446, 41.97005826112937],
              [-3.670128022759602, 41.97005826112937],
            ],
          ],
          [
            [
              [-4.440093007987745, 42.060085150881385],
              [-4.419760367655105, 42.040119510008964],
              [-4.389796476638582, 42.040119510008964],
              [-4.36999890578838, 42.069886465491486],
              [-4.320237443921655, 42.080050791753806],
              [-4.310071123755335, 42.100016432626234],
              [-4.310071123755335, 42.130146399760974],
              [-4.259774592406171, 42.1501120406334],
              [-4.280107232738812, 42.190043322378244],
              [-4.310071123755335, 42.190043322378244],
              [-4.340035014771857, 42.26010457125784],
              [-4.310071123755335, 42.30003585300269],
              [-4.239977021555969, 42.33016582013744],
              [-4.210013130539447, 42.33016582013744],
              [-4.150085348506401, 42.28987152674036],
              [-4.129752708173761, 42.24013893038542],
              [-4.139919028340081, 42.21000896325067],
              [-4.120121457489879, 42.179878996115924],
              [-4.090157566473357, 42.1501120406334],
              [-4.0398610351241935, 42.139947714371075],
              [-4.000265893423789, 42.139947714371075],
              [-3.930171791224423, 42.130146399760974],
              [-3.89004158004158, 42.080050791753806],
              [-3.8199474778422147, 42.060085150881385],
              [-3.7899835868256924, 42.060085150881385],
              [-3.7798172666593723, 42.040119510008964],
              [-3.8499113688587374, 42.060085150881385],
              [-3.9002079002079, 42.060085150881385],
              [-3.9499693620746257, 42.040119510008964],
              [-4.000265893423789, 42.040119510008964],
              [-4.069824926140716, 42.020153869136536],
              [-4.069824926140716, 42.009989542874216],
              [-4.169882919356604, 41.97985957573947],
              [-4.1902155596892445, 41.97005826112937],
              [-4.259774592406171, 41.97005826112937],
              [-4.269940912572491, 41.99002390200179],
              [-4.299904803589015, 41.99002390200179],
              [-4.320237443921655, 42.020153869136536],
              [-4.329868694605537, 41.99982521661189],
              [-4.350201334938177, 42.009989542874216],
              [-4.3801652259547, 41.99982521661189],
              [-4.3801652259547, 41.93992829399462],
              [-4.350201334938177, 41.89999701224978],
              [-4.350201334938177, 41.88003137137735],
              [-4.329868694605537, 41.84010008963251],
              [-4.320237443921655, 41.77984015536301],
              [-4.340035014771857, 41.75007319988049],
              [-4.399962796804902, 41.69997759187331],
              [-4.399962796804902, 41.69017627726322],
              [-4.450259328154065, 41.68001195100089],
              [-4.48985446985447, 41.66004631012847],
              [-4.5299846810373126, 41.649881983866145],
              [-4.5299846810373126, 41.68001195100089],
              [-4.549782251887516, 41.69997759187331],
              [-4.589912463070358, 41.71994323274574],
              [-4.600078783236678, 41.75007319988049],
              [-4.630042674253201, 41.77003884075291],
              [-4.630042674253201, 41.80997012249776],
              [-4.6498402451034035, 41.86986704511503],
              [-4.679804136119926, 41.97985957573947],
              [-4.700136776452566, 41.99002390200179],
              [-4.709768027136448, 42.020153869136536],
              [-4.709768027136448, 42.04992082461906],
              [-4.679804136119926, 42.119982073498655],
              [-4.6498402451034035, 42.139947714371075],
              [-4.630042674253201, 42.139947714371075],
              [-4.589912463070358, 42.119982073498655],
              [-4.589912463070358, 42.11018075888855],
              [-4.540151001203633, 42.100016432626234],
              [-4.480223219170588, 42.100016432626234],
              [-4.480223219170588, 42.08985210636391],
              [-4.419760367655105, 42.080050791753806],
              [-4.419760367655105, 42.060085150881385],
              [-4.440093007987745, 42.060085150881385],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: "05",
        name: "Hautes-Alpes",
        REG: 93,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.689842433526645, 44.18987451449059],
            [5.680211182842762, 44.18987451449059],
            [5.650247291826239, 44.18987451449059],
            [5.640080971659919, 44.16990887361816],
            [5.650247291826239, 44.18987451449059],
            [5.680211182842762, 44.18987451449059],
            [5.689842433526645, 44.18987451449059],
            [5.670044862676442, 44.25993576337018],
            [5.650247291826239, 44.27010008963251],
            [5.640080971659919, 44.29006573050493],
            [5.6101170806433975, 44.31983268598745],
            [5.629914651493599, 44.32999701224978],
            [5.540022978444031, 44.32999701224978],
            [5.52022540759383, 44.3499626531222],
            [5.4902615165773065, 44.3401613385121],
            [5.4699288762446665, 44.3499626531222],
            [5.4597625560783465, 44.36992829399462],
            [5.429798665061823, 44.36992829399462],
            [5.439964985228143, 44.38989393486705],
            [5.420167414377942, 44.420023902001795],
            [5.439964985228143, 44.42982521661189],
            [5.4800951964109865, 44.420023902001795],
            [5.49989276726119, 44.439989542874216],
            [5.4597625560783465, 44.45015386913654],
            [5.4597625560783465, 44.490085150881384],
            [5.51005908742751, 44.490085150881384],
            [5.5999507604770775, 44.47011951000896],
            [5.619748331327279, 44.47011951000896],
            [5.629914651493599, 44.499886465491485],
            [5.659878542510122, 44.499886465491485],
            [5.650247291826239, 44.519852106363906],
            [5.5999507604770775, 44.54018075888855],
            [5.6101170806433975, 44.569947714371075],
            [5.640080971659919, 44.609878996115924],
            [5.640080971659919, 44.650173289513],
            [5.680211182842762, 44.650173289513],
            [5.729972644709487, 44.64000896325067],
            [5.74977021555969, 44.650173289513],
            [5.789900426742533, 44.650173289513],
            [5.800066746908853, 44.67994024499552],
            [5.830030637925375, 44.69010457125784],
            [5.800066746908853, 44.71007021213027],
            [5.810233067075173, 44.71007021213027],
            [5.830030637925375, 44.73983716761279],
            [5.849828208775578, 44.75000149387511],
            [5.919922310974942, 44.75000149387511],
            [5.949886201991466, 44.76996713474753],
            [5.979850093007989, 44.78013146100986],
            [5.960052522157786, 44.80009710188228],
            [5.979850093007989, 44.82006274275471],
            [6.000182733340629, 44.82006274275471],
            [6.030146624357152, 44.84002838362713],
            [6.060110515373673, 44.82006274275471],
            [6.13020461757304, 44.85999402449955],
            [6.160168508589561, 44.85999402449955],
            [6.169799759273444, 44.84982969823723],
            [6.199763650289966, 44.85999402449955],
            [6.250060181639129, 44.84982969823723],
            [6.269857752489332, 44.870158350761876],
            [6.299821643505855, 44.870158350761876],
            [6.339951854688697, 44.84982969823723],
            [6.3597494255389, 44.84982969823723],
            [6.350118174855017, 44.87995966537198],
            [6.350118174855017, 44.91989094711682],
            [6.3597494255389, 44.93985658798924],
            [6.329785534522377, 44.95002091425157],
            [6.320154283838495, 45.000116522258736],
            [6.250060181639129, 45.000116522258736],
            [6.199763650289966, 45.00991783686884],
            [6.220096290622608, 45.07017777113833],
            [6.239893861472809, 45.07017777113833],
            [6.230262610788928, 45.11010905288318],
            [6.260226501805449, 45.1300746937556],
            [6.280024072655652, 45.11010905288318],
            [6.320154283838495, 45.11010905288318],
            [6.329785534522377, 45.119910367493276],
            [6.36991574570522, 45.099944726620855],
            [6.3597494255389, 45.07017777113833],
            [6.399879636721743, 45.060013444876006],
            [6.429843527738265, 45.060013444876006],
            [6.450176168070905, 45.049849118613686],
            [6.489771309771311, 45.060013444876006],
            [6.480140059087428, 45.090143412010754],
            [6.510103950103951, 45.11010905288318],
            [6.529901520954152, 45.099944726620855],
            [6.559865411970676, 45.099944726620855],
            [6.580198052303316, 45.119910367493276],
            [6.610161943319839, 45.119910367493276],
            [6.62995951417004, 45.11010905288318],
            [6.62995951417004, 45.099944726620855],
            [6.6599234051865634, 45.07017777113833],
            [6.6700897253528835, 45.020082163131164],
            [6.74018382755225, 45.020082163131164],
            [6.759981398402451, 44.969986555123995],
            [6.749815078236131, 44.93985658798924],
            [6.759981398402451, 44.930055273379146],
            [6.749815078236131, 44.910089632506725],
            [6.809742860269176, 44.87995966537198],
            [6.860039391618339, 44.84982969823723],
            [6.9098008534850655, 44.84982969823723],
            [6.939764744501587, 44.85999402449955],
            [7.00022759601707, 44.84002838362713],
            [7.020025166867273, 44.80989841649238],
            [7.00022759601707, 44.78993277561996],
            [7.020025166867273, 44.76996713474753],
            [7.030191487033593, 44.73003585300269],
            [7.060155378050115, 44.71007021213027],
            [7.069786628733998, 44.69010457125784],
            [7.060155378050115, 44.67994024499552],
            [7.030191487033593, 44.69010457125784],
            [6.99006127585075, 44.69010457125784],
            [6.960097384834227, 44.67994024499552],
            [6.949931064667907, 44.650173289513],
            [6.9098008534850655, 44.65997460412309],
            [6.879836962468542, 44.629844636988345],
            [6.860039391618339, 44.629844636988345],
            [6.849873071452019, 44.609878996115924],
            [6.819909180435498, 44.609878996115924],
            [6.749815078236131, 44.569947714371075],
            [6.74018382755225, 44.549982073498654],
            [6.6802560455192035, 44.54018075888855],
            [6.6700897253528835, 44.499886465491485],
            [6.640125834336362, 44.490085150881384],
            [6.62995951417004, 44.45015386913654],
            [6.469973738921108, 44.45015386913654],
            [6.450176168070905, 44.47011951000896],
            [6.410045956888063, 44.47011951000896],
            [6.39024838603786, 44.499886465491485],
            [6.350118174855017, 44.519852106363906],
            [6.350118174855017, 44.499886465491485],
            [6.329785534522377, 44.47011951000896],
            [6.299821643505855, 44.47011951000896],
            [6.290190392821972, 44.479920824619064],
            [6.230262610788928, 44.45995518374664],
            [6.250060181639129, 44.439989542874216],
            [6.260226501805449, 44.40985957573947],
            [6.230262610788928, 44.380092620256946],
            [6.199763650289966, 44.420023902001795],
            [6.179966079439764, 44.420023902001795],
            [6.160168508589561, 44.45995518374664],
            [6.109871977240398, 44.479920824619064],
            [6.079908086223877, 44.45995518374664],
            [6.030146624357152, 44.439989542874216],
            [6.01998030419083, 44.420023902001795],
            [5.970218842324106, 44.40005826112937],
            [5.949886201991466, 44.40005826112937],
            [5.940254951307584, 44.360126979384525],
            [5.919922310974942, 44.3401613385121],
            [5.900124740124741, 44.3401613385121],
            [5.900124740124741, 44.31983268598745],
            [5.930088631141262, 44.31003137137735],
            [5.909755990808622, 44.29006573050493],
            [5.919922310974942, 44.27990140424261],
            [5.909755990808622, 44.250134448760086],
            [5.879792099792101, 44.27010008963251],
            [5.879792099792101, 44.29006573050493],
            [5.849828208775578, 44.29986704511503],
            [5.8198643177590546, 44.27990140424261],
            [5.830030637925375, 44.25993576337018],
            [5.859994528941898, 44.250134448760086],
            [5.870160849108218, 44.22000448162534],
            [5.909755990808622, 44.20003884075291],
            [5.900124740124741, 44.18987451449059],
            [5.859994528941898, 44.20003884075291],
            [5.830030637925375, 44.20003884075291],
            [5.810233067075173, 44.20984015536301],
            [5.74977021555969, 44.20984015536301],
            [5.740138964875807, 44.20003884075291],
            [5.710175073859285, 44.20003884075291],
            [5.689842433526645, 44.18987451449059],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 93,
        name: "Seine-Saint-Denis",
        REG: 11,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.420032826348616, 48.84985509411413],
            [2.400235255498414, 48.87998506124888],
            [2.400235255498414, 48.8999507021213],
            [2.3199748331327283, 48.8999507021213],
            [2.3098085129664083, 48.91011502838363],
            [2.3397724039829306, 48.93008066925605],
            [2.3098085129664083, 48.95004631012848],
            [2.290010942116205, 48.95004631012848],
            [2.3301411532990484, 48.95984762473857],
            [2.3397724039829306, 48.9700119510009],
            [2.379902615165773, 48.9700119510009],
            [2.409866506182296, 48.95984762473857],
            [2.4697942882153407, 48.95984762473857],
            [2.499758179231864, 48.9700119510009],
            [2.530257139730824, 49.00014191813565],
            [2.5500547105810263, 49.00994323274575],
            [2.5800186015975495, 49.00014191813565],
            [2.5698522814312295, 48.980176277263226],
            [2.5998161724477518, 48.93988198386615],
            [2.5901849217638695, 48.93008066925605],
            [2.5901849217638695, 48.8999507021213],
            [2.5698522814312295, 48.89014938751121],
            [2.5698522814312295, 48.84985509411413],
            [2.5998161724477518, 48.80992381236929],
            [2.5901849217638695, 48.80992381236929],
            [2.499758179231864, 48.86001942037646],
            [2.4499967173651385, 48.86001942037646],
            [2.420032826348616, 48.84985509411413],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 62,
        name: "Pas-de-Calais",
        REG: 32,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.6297352007878327, 50.370147893636094],
            [1.5997713097713095, 50.370147893636094],
            [1.560176168070905, 50.399914849118616],
            [1.5698074187547872, 50.439846130863465],
            [1.5698074187547872, 50.46997609799821],
            [1.5799737389211073, 50.489941738870634],
            [1.5799737389211073, 50.52007170600538],
            [1.5901400590874273, 50.5400373468778],
            [1.6399015209541528, 50.509907379743055],
            [1.6099376299376305, 50.5400373468778],
            [1.5799737389211073, 50.560002987750224],
            [1.5799737389211073, 50.63986555123992],
            [1.560176168070905, 50.68996115924709],
            [1.5698074187547872, 50.72009112638184],
            [1.5799737389211073, 50.72009112638184],
            [1.5901400590874273, 50.72989244099194],
            [1.5799737389211073, 50.72009112638184],
            [1.5997713097713095, 50.72989244099194],
            [1.5901400590874273, 50.72989244099194],
            [1.5997713097713095, 50.76982372273678],
            [1.5997713097713095, 50.79995368987153],
            [1.5799737389211073, 50.8598506124888],
            [1.669865411970675, 50.88998057962355],
            [1.690198052303316, 50.920110546758295],
            [1.7099956231535183, 50.920110546758295],
            [1.7297931940037206, 50.940076187630716],
            [1.8400175073859284, 50.96004182850314],
            [1.8501838275522484, 50.96004182850314],
            [1.8400175073859284, 50.96004182850314],
            [1.8501838275522484, 50.96004182850314],
            [1.8501838275522484, 50.96984314311324],
            [1.8897789692526539, 50.96984314311324],
            [1.9400755006018162, 50.99017179563789],
            [1.9898369624685417, 50.99017179563789],
            [2.0700973848342272, 51.01013743651031],
            [2.1102275960170696, 50.99017179563789],
            [2.1401914870335927, 50.96004182850314],
            [2.149822737717475, 50.929911861368396],
            [2.170155378050115, 50.90994622049597],
            [2.2097505197505196, 50.83988497161638],
            [2.2097505197505196, 50.810118016133856],
            [2.2300831600831605, 50.810118016133856],
            [2.270213371266003, 50.77998804899911],
            [2.290010942116205, 50.79015237526143],
            [2.3199748331327283, 50.77998804899911],
            [2.390068935332094, 50.77998804899911],
            [2.400235255498414, 50.76982372273678],
            [2.379902615165773, 50.74985808186436],
            [2.3397724039829306, 50.74005676725426],
            [2.369736294999453, 50.70992680011951],
            [2.390068935332094, 50.70012548550942],
            [2.409866506182296, 50.66999551837467],
            [2.4901269285479817, 50.63006423662982],
            [2.620148812780392, 50.63006423662982],
            [2.629780063464274, 50.619899910367494],
            [2.6699102746471173, 50.63006423662982],
            [2.7202068059962796, 50.63006423662982],
            [2.729838056680162, 50.6100985957574],
            [2.750170697012803, 50.6100985957574],
            [2.769968267863005, 50.65983119211234],
            [2.8400623700623706, 50.65983119211234],
            [2.870026261078893, 50.63006423662982],
            [2.8400623700623706, 50.63006423662982],
            [2.7897658387132074, 50.59013295488498],
            [2.8202647992121683, 50.57016731401255],
            [2.7999321588795274, 50.52987302061548],
            [2.889823831929095, 50.52987302061548],
            [2.880192581245213, 50.509907379743055],
            [2.9101564722617352, 50.50010606513296],
            [2.9299540431119384, 50.509907379743055],
            [2.9599179341284616, 50.509907379743055],
            [3.010214465477623, 50.489941738870634],
            [3.019845716161506, 50.46997609799821],
            [3.010214465477623, 50.46017478338811],
            [3.019845716161506, 50.439846130863465],
            [3.0401783564941463, 50.439846130863465],
            [3.0701422475106694, 50.46017478338811],
            [3.0701422475106694, 50.430044816253364],
            [3.0401783564941463, 50.419880489991044],
            [3.010214465477623, 50.399914849118616],
            [2.989881825144983, 50.399914849118616],
            [2.989881825144983, 50.379949208246195],
            [3.0401783564941463, 50.340017926501346],
            [3.079773498194551, 50.320052285628925],
            [3.0498096071780294, 50.28992231849418],
            [3.0401783564941463, 50.26995667762176],
            [3.140236349710034, 50.26995667762176],
            [3.149867600393917, 50.249991036749336],
            [3.1798314914104386, 50.23982671048701],
            [3.1798314914104386, 50.21986106961458],
            [3.140236349710034, 50.21986106961458],
            [3.130070029543714, 50.19989542874216],
            [3.149867600393917, 50.17992978786974],
            [3.100106138527191, 50.15996414699731],
            [3.140236349710034, 50.13999850612489],
            [3.100106138527191, 50.12003286525247],
            [3.109737389211074, 50.08990289811772],
            [3.089939818360871, 50.08010158350762],
            [3.089939818360871, 50.04997161637287],
            [3.0599759273443494, 50.04997161637287],
            [3.0300120363278262, 50.0601359426352],
            [3.019845716161506, 50.04997161637287],
            [2.9197877229456184, 50.04997161637287],
            [2.880192581245213, 50.04017030176278],
            [2.859859940912573, 50.0601359426352],
            [2.8202647992121683, 50.0699372572453],
            [2.780134588029325, 50.04017030176278],
            [2.740004376846483, 50.04997161637287],
            [2.780134588029325, 50.08990289811772],
            [2.780134588029325, 50.10986853899014],
            [2.750170697012803, 50.10986853899014],
            [2.729838056680162, 50.12983417986257],
            [2.7100404858299596, 50.12983417986257],
            [2.6998741656636396, 50.10006722438004],
            [2.650112703796915, 50.08990289811772],
            [2.629780063464274, 50.10986853899014],
            [2.5800186015975495, 50.10986853899014],
            [2.5698522814312295, 50.12003286525247],
            [2.5901849217638695, 50.13999850612489],
            [2.5500547105810263, 50.13999850612489],
            [2.530257139730824, 50.12003286525247],
            [2.509924499398184, 50.13999850612489],
            [2.4799606083816617, 50.13999850612489],
            [2.4499967173651385, 50.12003286525247],
            [2.430199146514936, 50.08990289811772],
            [2.400235255498414, 50.10986853899014],
            [2.379902615165773, 50.10986853899014],
            [2.390068935332094, 50.15996414699731],
            [2.4697942882153407, 50.190094114132066],
            [2.499758179231864, 50.190094114132066],
            [2.4499967173651385, 50.23002539587691],
            [2.409866506182296, 50.23002539587691],
            [2.3601050443155707, 50.21005975500449],
            [2.3301411532990484, 50.23982671048701],
            [2.3199748331327283, 50.21986106961458],
            [2.300177262282526, 50.21005975500449],
            [2.270213371266003, 50.23002539587691],
            [2.249880730933363, 50.21005975500449],
            [2.1000612758507495, 50.21005975500449],
            [2.059931064667907, 50.23982671048701],
            [2.0802637050005472, 50.249991036749336],
            [2.029967173651384, 50.26995667762176],
            [2.0000032826348617, 50.26995667762176],
            [1.9299091804354962, 50.300086644756504],
            [1.9598730714520194, 50.3098879593666],
            [1.9400755006018162, 50.32985360023902],
            [1.9197428602691762, 50.3098879593666],
            [1.899945289418974, 50.3098879593666],
            [1.8699813984024516, 50.32985360023902],
            [1.799887296203086, 50.359983567373774],
            [1.7597570850202429, 50.359983567373774],
            [1.6602341612867928, 50.32985360023902],
            [1.6297352007878327, 50.359983567373774],
            [1.6297352007878327, 50.370147893636094],
          ],
          [
            [3.100106138527191, 50.15996414699731],
            [3.0599759273443494, 50.17012847325964],
            [3.0401783564941463, 50.15016283238722],
            [3.000048145311303, 50.15016283238722],
            [2.989881825144983, 50.13999850612489],
            [3.000048145311303, 50.12003286525247],
            [3.0401783564941463, 50.12983417986257],
            [3.0701422475106694, 50.12983417986257],
            [3.0701422475106694, 50.15016283238722],
            [3.100106138527191, 50.15996414699731],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 12, name: "Aveyron", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.9401203632782584, 43.69000746937556],
            [2.9197877229456184, 43.74010307738273],
            [2.870026261078893, 43.74010307738273],
            [2.8100984790458474, 43.760068718255155],
            [2.780134588029325, 43.74010307738273],
            [2.740004376846483, 43.72993875112041],
            [2.7100404858299596, 43.74010307738273],
            [2.6800765948134373, 43.74010307738273],
            [2.629780063464274, 43.780034359127576],
            [2.560221030747347, 43.850095608007166],
            [2.5500547105810263, 43.890026889752015],
            [2.5500547105810263, 43.929958171496864],
            [2.509924499398184, 43.949923812369285],
            [2.520090819564504, 43.98005377950403],
            [2.4901269285479817, 44.000019420376454],
            [2.499758179231864, 44.009820734986555],
            [2.4601630375314585, 44.0301493875112],
            [2.4601630375314585, 44.05011502838363],
            [2.409866506182296, 44.05991634299372],
            [2.390068935332094, 44.09004631012847],
            [2.3601050443155707, 44.09984762473857],
            [2.3301411532990484, 44.12017627726322],
            [2.290010942116205, 44.12017627726322],
            [2.300177262282526, 44.14014191813564],
            [2.279844621949885, 44.14994323274574],
            [2.2402494802494806, 44.12997759187332],
            [2.2097505197505196, 44.14994323274574],
            [2.2199168399168405, 44.16990887361816],
            [2.1797866287339973, 44.16990887361816],
            [2.149822737717475, 44.18007319988049],
            [2.149822737717475, 44.20003884075291],
            [2.1102275960170696, 44.20003884075291],
            [2.059931064667907, 44.16990887361816],
            [1.9898369624685417, 44.14994323274574],
            [1.9700393916183394, 44.16990887361816],
            [1.9299091804354962, 44.18987451449059],
            [1.910111609585294, 44.18987451449059],
            [1.910111609585294, 44.20984015536301],
            [1.9400755006018162, 44.250134448760086],
            [1.9598730714520194, 44.25993576337018],
            [1.9700393916183394, 44.27990140424261],
            [1.899945289418974, 44.27990140424261],
            [1.8598150782361307, 44.31983268598745],
            [1.8801477185687716, 44.3401613385121],
            [1.910111609585294, 44.360126979384525],
            [1.8699813984024516, 44.38989393486705],
            [1.8699813984024516, 44.420023902001795],
            [1.8501838275522484, 44.439989542874216],
            [1.8501838275522484, 44.47011951000896],
            [1.8598150782361307, 44.490085150881384],
            [1.8801477185687716, 44.479920824619064],
            [1.910111609585294, 44.490085150881384],
            [1.9400755006018162, 44.519852106363906],
            [1.9598730714520194, 44.519852106363906],
            [2.0000032826348617, 44.56014639976098],
            [2.029967173651384, 44.56014639976098],
            [2.049764744501587, 44.5801120406334],
            [2.0700973848342272, 44.569947714371075],
            [2.149822737717475, 44.569947714371075],
            [2.170155378050115, 44.5899133552435],
            [2.2001192690666374, 44.5899133552435],
            [2.2097505197505196, 44.62004332237825],
            [2.2097505197505196, 44.64000896325067],
            [2.249880730933363, 44.650173289513],
            [2.290010942116205, 44.67013893038542],
            [2.3199748331327283, 44.67013893038542],
            [2.3499387241492506, 44.64000896325067],
            [2.400235255498414, 44.650173289513],
            [2.4398303971988184, 44.64000896325067],
            [2.4697942882153407, 44.64000896325067],
            [2.4901269285479817, 44.65997460412309],
            [2.499758179231864, 44.69010457125784],
            [2.560221030747347, 44.71987152674036],
            [2.5500547105810263, 44.73003585300269],
            [2.5500547105810263, 44.76016582013744],
            [2.5698522814312295, 44.78993277561996],
            [2.5998161724477518, 44.78993277561996],
            [2.5998161724477518, 44.84002838362713],
            [2.620148812780392, 44.84982969823723],
            [2.629780063464274, 44.870158350761876],
            [2.6597439544807973, 44.870158350761876],
            [2.6597439544807973, 44.8901239916343],
            [2.6800765948134373, 44.910089632506725],
            [2.7100404858299596, 44.910089632506725],
            [2.7202068059962796, 44.930055273379146],
            [2.759801947696685, 44.930055273379146],
            [2.780134588029325, 44.910089632506725],
            [2.7897658387132074, 44.870158350761876],
            [2.859859940912573, 44.870158350761876],
            [2.859859940912573, 44.84002838362713],
            [2.889823831929095, 44.78993277561996],
            [2.9197877229456184, 44.78993277561996],
            [2.9299540431119384, 44.78013146100986],
            [2.9197877229456184, 44.76016582013744],
            [2.9299540431119384, 44.73983716761279],
            [2.9197877229456184, 44.73003585300269],
            [2.9401203632782584, 44.67994024499552],
            [2.9802505744611016, 44.64000896325067],
            [3.0300120363278262, 44.60007768150582],
            [3.079773498194551, 44.569947714371075],
            [3.0701422475106694, 44.53001643262623],
            [3.079773498194551, 44.519852106363906],
            [3.0701422475106694, 44.499886465491485],
            [3.140236349710034, 44.45995518374664],
            [3.140236349710034, 44.38989393486705],
            [3.119903709377394, 44.38989393486705],
            [3.119903709377394, 44.360126979384525],
            [3.130070029543714, 44.3401613385121],
            [3.149867600393917, 44.32999701224978],
            [3.149867600393917, 44.31003137137735],
            [3.130070029543714, 44.29006573050493],
            [3.119903709377394, 44.25993576337018],
            [3.1600339205602372, 44.250134448760086],
            [3.1899978115767587, 44.250134448760086],
            [3.230128022759602, 44.23016880788766],
            [3.219961702593282, 44.20003884075291],
            [3.239759273443485, 44.18987451449059],
            [3.260091913776125, 44.20003884075291],
            [3.360149906992013, 44.20003884075291],
            [3.3697811576758943, 44.16990887361816],
            [3.339817266659373, 44.16010755900807],
            [3.3200196958091697, 44.14014191813564],
            [3.3098533756428496, 44.11001195100089],
            [3.270258233942445, 44.09004631012847],
            [3.3002221249589683, 44.07008066925605],
            [3.3200196958091697, 44.079881983866144],
            [3.349983586825693, 44.05011502838363],
            [3.390113798008536, 44.05011502838363],
            [3.4200776890250575, 44.0399507021213],
            [3.4398752598752607, 44.01998506124888],
            [3.4398752598752607, 44.000019420376454],
            [3.4200776890250575, 43.989855094114134],
            [3.4099113688587375, 43.969889453241706],
            [3.3799474778422143, 43.96008813863161],
            [3.349983586825693, 43.940122497759184],
            [3.360149906992013, 43.909992530624436],
            [3.339817266659373, 43.890026889752015],
            [3.2900558047926465, 43.890026889752015],
            [3.239759273443485, 43.870061248879594],
            [3.249925593609805, 43.839931281744846],
            [3.209795382426962, 43.810164326262324],
            [3.149867600393917, 43.810164326262324],
            [3.089939818360871, 43.839931281744846],
            [3.0599759273443494, 43.839931281744846],
            [3.0599759273443494, 43.810164326262324],
            [3.0498096071780294, 43.8],
            [3.0701422475106694, 43.760068718255155],
            [3.0498096071780294, 43.74010307738273],
            [3.0701422475106694, 43.70997311024798],
            [3.0300120363278262, 43.69000746937556],
            [3.000048145311303, 43.70997311024798],
            [2.9802505744611016, 43.70997311024798],
            [2.9401203632782584, 43.69000746937556],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 28, name: "Eure-et-Loir", REG: 24, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.550009847904585, 48.039976097998206],
            [1.5098796367217417, 48.03017478338811],
            [1.5200459568880627, 48.009846130863465],
            [1.5200459568880627, 47.980079175380936],
            [1.4900820658715395, 47.98988048999104],
            [1.4601181748550172, 48.009846130863465],
            [1.4397855345223771, 48.009846130863465],
            [1.4301542838384949, 48.000044816253364],
            [1.4397855345223771, 47.980079175380936],
            [1.409821643505854, 47.96991484911862],
            [1.3900240726556516, 47.980079175380936],
            [1.3702265018054494, 47.949949208246196],
            [1.340262610788927, 47.960113534508515],
            [1.309763650289966, 47.949949208246196],
            [1.3001323996060838, 47.96991484911862],
            [1.2701685085895615, 47.960113534508515],
            [1.2498358682569215, 47.980079175380936],
            [1.2198719772403983, 47.980079175380936],
            [1.189908086223876, 47.96991484911862],
            [1.189908086223876, 48.000044816253364],
            [1.1599441952073537, 48.020010457125785],
            [1.1299803041908305, 48.03017478338811],
            [1.1101827333406282, 48.059941738870634],
            [1.1101827333406282, 48.079907379743055],
            [1.070052522157786, 48.079907379743055],
            [1.059886201991465, 48.09007170600538],
            [1.0197559908086227, 48.09007170600538],
            [0.9897920997921004, 48.099873020615476],
            [1.0400886311412627, 48.119838661487904],
            [0.9999584199584204, 48.130002987750224],
            [0.9598282087755772, 48.099873020615476],
            [0.9298643177590549, 48.1100373468778],
            [0.9100667469088526, 48.099873020615476],
            [0.8699365357260094, 48.1100373468778],
            [0.8399726447094871, 48.099873020615476],
            [0.8501389648758071, 48.130002987750224],
            [0.9100667469088526, 48.14016731401255],
            [0.9100667469088526, 48.14996862862265],
            [0.8597702155596894, 48.16993426949507],
            [0.829806324543167, 48.16993426949507],
            [0.7998424335266439, 48.189899910367494],
            [0.829806324543167, 48.209865551239915],
            [0.7902111828427616, 48.25996115924709],
            [0.7902111828427616, 48.27992680011951],
            [0.7698785425101216, 48.31985808186436],
            [0.7902111828427616, 48.33982372273678],
            [0.8201750738592848, 48.34998804899911],
            [0.829806324543167, 48.33982372273678],
            [0.8699365357260094, 48.36015237526143],
            [0.9100667469088526, 48.36995368987153],
            [0.9501969580916949, 48.40008365700628],
            [0.9501969580916949, 48.4200492978787],
            [0.9699945289418972, 48.44001493875112],
            [0.9400306379253749, 48.45998057962355],
            [0.9501969580916949, 48.49991186136839],
            [0.9699945289418972, 48.51987750224082],
            [0.9298643177590549, 48.53004182850314],
            [0.9400306379253749, 48.550007469375565],
            [0.8897341065762117, 48.569973110247986],
            [0.8699365357260094, 48.569973110247986],
            [0.8501389648758071, 48.58993875112041],
            [0.8501389648758071, 48.609904391992835],
            [0.8201750738592848, 48.609904391992835],
            [0.829806324543167, 48.629870032865256],
            [0.8100087536929648, 48.670164326262324],
            [0.8501389648758071, 48.679965640872425],
            [0.8801028558923294, 48.719896922617274],
            [0.9202330670751726, 48.71009560800717],
            [0.9598282087755772, 48.73006124887959],
            [1.0400886311412627, 48.73006124887959],
            [1.070052522157786, 48.75002688975202],
            [1.1101827333406282, 48.75002688975202],
            [1.1198139840245105, 48.78995817149686],
            [1.1497778750410328, 48.78995817149686],
            [1.1599441952073537, 48.76999253062444],
            [1.2498358682569215, 48.76999253062444],
            [1.2797997592734438, 48.759828204362115],
            [1.3001323996060838, 48.76999253062444],
            [1.330096290622607, 48.759828204362115],
            [1.3798577524893316, 48.78995817149686],
            [1.3600601816391293, 48.82988945324171],
            [1.4001903928219717, 48.86001942037646],
            [1.4301542838384949, 48.86982073498656],
            [1.4601181748550172, 48.86982073498656],
            [1.4697494255388994, 48.8999507021213],
            [1.4499518546886971, 48.91991634299373],
            [1.4601181748550172, 48.93988198386615],
            [1.5002483860378595, 48.93988198386615],
            [1.5098796367217417, 48.91991634299373],
            [1.539843527738265, 48.91011502838363],
            [1.560176168070905, 48.89014938751121],
            [1.550009847904585, 48.86982073498656],
            [1.5799737389211073, 48.86001942037646],
            [1.5799737389211073, 48.78995817149686],
            [1.5901400590874273, 48.76999253062444],
            [1.6099376299376305, 48.759828204362115],
            [1.6201039501039505, 48.739862563489694],
            [1.5799737389211073, 48.699931281744846],
            [1.6099376299376305, 48.69012996713475],
            [1.5997713097713095, 48.660000000000004],
            [1.6399015209541528, 48.64983567373768],
            [1.680031732136995, 48.620068718255155],
            [1.690198052303316, 48.609904391992835],
            [1.7201619433198383, 48.609904391992835],
            [1.6998293029871983, 48.58013743651031],
            [1.7399595141700406, 48.569973110247986],
            [1.7902560455192038, 48.550007469375565],
            [1.7800897253528838, 48.510076187630716],
            [1.799887296203086, 48.470144905885874],
            [1.8298511872196084, 48.470144905885874],
            [1.8598150782361307, 48.44001493875112],
            [1.899945289418974, 48.44001493875112],
            [1.9197428602691762, 48.45998057962355],
            [1.9400755006018162, 48.44001493875112],
            [1.9400755006018162, 48.4200492978787],
            [1.9598730714520194, 48.40008365700628],
            [1.9802057117846594, 48.40008365700628],
            [1.9802057117846594, 48.36015237526143],
            [1.9700393916183394, 48.33982372273678],
            [1.9898369624685417, 48.29009112638184],
            [1.9898369624685417, 48.27012548550941],
            [1.9700393916183394, 48.25015984463699],
            [1.9502418207681371, 48.189899910367494],
            [1.9700393916183394, 48.16993426949507],
            [1.9197428602691762, 48.16993426949507],
            [1.899945289418974, 48.14996862862265],
            [1.899945289418974, 48.130002987750224],
            [1.8801477185687716, 48.099873020615476],
            [1.8298511872196084, 48.079907379743055],
            [1.799887296203086, 48.09007170600538],
            [1.7699234051865629, 48.070106065132954],
            [1.6297352007878327, 48.070106065132954],
            [1.6201039501039505, 48.05014042426053],
            [1.5901400590874273, 48.03017478338811],
            [1.550009847904585, 48.039976097998206],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 22,
        name: "Côtes-d'Armor",
        REG: 53,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-3.3201925812452133, 48.16013295488497],
            [-3.3501564722617356, 48.16993426949507],
            [-3.38975161396214, 48.14996862862265],
            [-3.420250574461101, 48.14996862862265],
            [-3.420250574461101, 48.16993426949507],
            [-3.480178356494146, 48.189899910367494],
            [-3.4999759273443485, 48.1800985957574],
            [-3.5497373892110735, 48.1800985957574],
            [-3.5599037093773935, 48.189899910367494],
            [-3.519773498194551, 48.189899910367494],
            [-3.5599037093773935, 48.22983119211234],
            [-3.5299398183608712, 48.25996115924709],
            [-3.519773498194551, 48.27992680011951],
            [-3.5401061385271912, 48.29989244099193],
            [-3.5299398183608712, 48.31985808186436],
            [-3.5497373892110735, 48.31005676725426],
            [-3.5599037093773935, 48.33982372273678],
            [-3.5497373892110735, 48.36995368987153],
            [-3.5599037093773935, 48.380118016133856],
            [-3.6000339205602367, 48.38991933074395],
            [-3.6000339205602367, 48.4200492978787],
            [-3.570070029543714, 48.450179265013446],
            [-3.6000339205602367, 48.470144905885874],
            [-3.6000339205602367, 48.49991186136839],
            [-3.580236349710034, 48.49991186136839],
            [-3.5497373892110735, 48.53984314311324],
            [-3.6102002407265568, 48.58993875112041],
            [-3.640164131743079, 48.58993875112041],
            [-3.659961702593282, 48.660000000000004],
            [-3.640164131743079, 48.670164326262324],
            [-3.570070029543714, 48.670164326262324],
            [-3.580236349710034, 48.69012996713475],
            [-3.580236349710034, 48.719896922617274],
            [-3.5497373892110735, 48.73006124887959],
            [-3.5497373892110735, 48.75002688975202],
            [-3.5898676003939163, 48.76999253062444],
            [-3.580236349710034, 48.78995817149686],
            [-3.570070029543714, 48.80012249775919],
            [-3.5299398183608712, 48.82988945324171],
            [-3.4898096071780285, 48.82988945324171],
            [-3.4598457161615057, 48.82008813863161],
            [-3.4298818251449834, 48.82008813863161],
            [-3.4400481453113034, 48.80012249775919],
            [-3.38975161396214, 48.80012249775919],
            [-3.369954043111938, 48.82008813863161],
            [-3.3501564722617356, 48.82008813863161],
            [-3.3201925812452133, 48.84005377950403],
            [-3.2998599409125724, 48.82988945324171],
            [-3.220134588029325, 48.86982073498656],
            [-3.2099682678630046, 48.84005377950403],
            [-3.1698380566801623, 48.84005377950403],
            [-3.0997439544807968, 48.86982073498656],
            [-3.0799463836305945, 48.84985509411413],
            [-3.0997439544807968, 48.82988945324171],
            [-3.0997439544807968, 48.78015685688677],
            [-3.0901127037969145, 48.80992381236929],
            [-3.069780063464274, 48.82008813863161],
            [-3.009852281431229, 48.82008813863161],
            [-3.009852281431229, 48.80012249775919],
            [-3.0499824926140717, 48.78995817149686],
            [-3.020018601597549, 48.76999253062444],
            [-2.9900547105810267, 48.759828204362115],
            [-2.930126928547981, 48.759828204362115],
            [-2.949924499398184, 48.73006124887959],
            [-2.919960608381661, 48.71009560800717],
            [-2.8899967173651384, 48.699931281744846],
            [-2.8798303971988184, 48.670164326262324],
            [-2.860032826348616, 48.679965640872425],
            [-2.8402352554984134, 48.660000000000004],
            [-2.8199026151657733, 48.620068718255155],
            [-2.8199026151657733, 48.58993875112041],
            [-2.719844621949885, 48.550007469375565],
            [-2.719844621949885, 48.53004182850314],
            [-2.6802494802494805, 48.490110546758295],
            [-2.6802494802494805, 48.53004182850314],
            [-2.6401192690666377, 48.51987750224082],
            [-2.599989057883795, 48.550007469375565],
            [-2.5801914870335922, 48.58013743651031],
            [-2.55022759601707, 48.600103077382734],
            [-2.5298949556844295, 48.600103077382734],
            [-2.4699671736513844, 48.620068718255155],
            [-2.4699671736513844, 48.64003435912758],
            [-2.4400032826348617, 48.64983567373768],
            [-2.410039391618339, 48.64003435912758],
            [-2.369909180435496, 48.660000000000004],
            [-2.309981398402451, 48.670164326262324],
            [-2.2800175073859283, 48.670164326262324],
            [-2.309981398402451, 48.64003435912758],
            [-2.299815078236131, 48.629870032865256],
            [-2.260219936535726, 48.64003435912758],
            [-2.2302560455192033, 48.609904391992835],
            [-2.2099234051865633, 48.58013743651031],
            [-2.1697931940037205, 48.58013743651031],
            [-2.1697931940037205, 48.600103077382734],
            [-2.1499956231535178, 48.620068718255155],
            [-2.1200317321369955, 48.600103077382734],
            [-2.1200317321369955, 48.58993875112041],
            [-2.0900678411204727, 48.569973110247986],
            [-2.06010395010395, 48.569973110247986],
            [-2.03977130977131, 48.53984314311324],
            [-2.009807418754787, 48.569973110247986],
            [-1.990009847904585, 48.550007469375565],
            [-1.9702122770543822, 48.550007469375565],
            [-1.9798435277382644, 48.51987750224082],
            [-1.9798435277382644, 48.49991186136839],
            [-1.990009847904585, 48.49991186136839],
            [-1.9798435277382644, 48.49991186136839],
            [-1.9498796367217421, 48.51987750224082],
            [-1.9498796367217421, 48.53984314311324],
            [-1.9300820658715394, 48.53984314311324],
            [-1.9097494255388994, 48.51987750224082],
            [-1.9300820658715394, 48.47994622049597],
            [-1.9300820658715394, 48.45998057962355],
            [-1.9498796367217421, 48.450179265013446],
            [-1.9402483860378599, 48.4200492978787],
            [-1.9402483860378599, 48.38991933074395],
            [-1.9498796367217421, 48.36995368987153],
            [-1.9300820658715394, 48.34998804899911],
            [-1.9498796367217421, 48.33982372273678],
            [-1.9600459568880622, 48.31985808186436],
            [-1.9600459568880622, 48.29009112638184],
            [-2.000176168070905, 48.29989244099193],
            [-2.000176168070905, 48.27992680011951],
            [-2.04993762993763, 48.29009112638184],
            [-2.1200317321369955, 48.25996115924709],
            [-2.1499956231535178, 48.25996115924709],
            [-2.1799595141700405, 48.25015984463699],
            [-2.1901258343363605, 48.22002987750224],
            [-2.2302560455192033, 48.209865551239915],
            [-2.2200897253528833, 48.20006423662982],
            [-2.2200897253528833, 48.16993426949507],
            [-2.250053616369406, 48.14996862862265],
            [-2.2800175073859283, 48.14996862862265],
            [-2.290183827552249, 48.130002987750224],
            [-2.369909180435496, 48.130002987750224],
            [-2.410039391618339, 48.16993426949507],
            [-2.4501696028011817, 48.16993426949507],
            [-2.459800853485064, 48.16013295488497],
            [-2.5298949556844295, 48.16013295488497],
            [-2.510097384834227, 48.130002987750224],
            [-2.55022759601707, 48.099873020615476],
            [-2.55022759601707, 48.079907379743055],
            [-2.5801914870335922, 48.070106065132954],
            [-2.6197866287339973, 48.039976097998206],
            [-2.65991683991684, 48.039976097998206],
            [-2.67008316008316, 48.059941738870634],
            [-2.64975051975052, 48.119838661487904],
            [-2.6802494802494805, 48.130002987750224],
            [-2.700047051099683, 48.119838661487904],
            [-2.7300109421162055, 48.119838661487904],
            [-2.7797724039829306, 48.09007170600538],
            [-2.7797724039829306, 48.119838661487904],
            [-2.809736294999453, 48.14996862862265],
            [-2.8498665061822956, 48.14016731401255],
            [-2.9397581792318634, 48.16993426949507],
            [-2.979888390414706, 48.16013295488497],
            [-3.009852281431229, 48.16993426949507],
            [-3.020018601597549, 48.20006423662982],
            [-3.0499824926140717, 48.20006423662982],
            [-3.0601488127803917, 48.209865551239915],
            [-3.120076594813437, 48.209865551239915],
            [-3.1398741656636395, 48.189899910367494],
            [-3.1302429149797573, 48.1800985957574],
            [-3.15004048582996, 48.16013295488497],
            [-3.1998019476966846, 48.16013295488497],
            [-3.2099682678630046, 48.14016731401255],
            [-3.239932158879528, 48.14996862862265],
            [-3.28006237006237, 48.14016731401255],
            [-3.2998599409125724, 48.16013295488497],
            [-3.3201925812452133, 48.16013295488497],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: "08", name: "Ardennes", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.049854469854471, 49.40998207349866],
            [4.040223219170588, 49.42014639976098],
            [4.049854469854471, 49.4499133552435],
            [4.040223219170588, 49.46987899611592],
            [4.040223219170588, 49.510173289513],
            [4.079818360870992, 49.5199746041231],
            [4.079818360870992, 49.53994024499552],
            [4.060020790020791, 49.55010457125785],
            [4.060020790020791, 49.59983716761279],
            [4.030056899004268, 49.62016582013744],
            [4.070187110187111, 49.640131461009865],
            [4.119948572053835, 49.62996713474754],
            [4.119948572053835, 49.660097101882286],
            [4.1397461429040385, 49.68986405736481],
            [4.17987635408688, 49.70002838362713],
            [4.190042674253202, 49.719994024499556],
            [4.230172885436043, 49.73015835076188],
            [4.239804136119926, 49.770089632506725],
            [4.209840245103403, 49.770089632506725],
            [4.220006565269723, 49.79005527337915],
            [4.209840245103403, 49.810020914251574],
            [4.230172885436043, 49.849952195996416],
            [4.249970456286246, 49.86011652225874],
            [4.260136776452566, 49.90004780400359],
            [4.220006565269723, 49.909849118613685],
            [4.230172885436043, 49.95994472662086],
            [4.320064558485611, 49.95994472662086],
            [4.350028449502134, 49.95014341201076],
            [4.420122551701499, 49.95014341201076],
            [4.450086442718022, 49.93997908574843],
            [4.480050333734545, 49.95014341201076],
            [4.520180544917387, 49.95014341201076],
            [4.53997811576759, 49.97010905288318],
            [4.569942006784113, 49.97010905288318],
            [4.599905897800634, 49.9900746937556],
            [4.629869788817158, 49.9900746937556],
            [4.689797570850202, 49.9998760083657],
            [4.689797570850202, 50.03000597550045],
            [4.699963891016522, 50.04997161637287],
            [4.680166320166321, 50.0699372572453],
            [4.699963891016522, 50.10006722438004],
            [4.7502604223656855, 50.10986853899014],
            [4.770057993215889, 50.13999850612489],
            [4.829985775248933, 50.15996414699731],
            [4.8701159864317765, 50.15016283238722],
            [4.879747237115658, 50.12983417986257],
            [4.8701159864317765, 50.12003286525247],
            [4.8701159864317765, 50.08990289811772],
            [4.840152095415253, 50.08990289811772],
            [4.840152095415253, 50.04017030176278],
            [4.819819455082613, 50.01984164923813],
            [4.819819455082613, 49.9900746937556],
            [4.78985556406609, 49.97010905288318],
            [4.810188204398732, 49.95014341201076],
            [4.849783346099136, 49.95014341201076],
            [4.859949666265456, 49.93017777113833],
            [4.88991355728198, 49.909849118613685],
            [4.859949666265456, 49.869917836868844],
            [4.8701159864317765, 49.81982222886167],
            [4.849783346099136, 49.79005527337915],
            [4.940210088631141, 49.79005527337915],
            [4.949841339315024, 49.79985658798925],
            [4.9899715504978674, 49.79985658798925],
            [5.009769121348069, 49.779890947116826],
            [5.070231972863552, 49.7599253062444],
            [5.100195863880075, 49.7599253062444],
            [5.13979100558048, 49.70982969823723],
            [5.169754896597003, 49.70982969823723],
            [5.169754896597003, 49.68986405736481],
            [5.250015318962688, 49.68986405736481],
            [5.269812889812891, 49.70002838362713],
            [5.320109421162054, 49.660097101882286],
            [5.299776780829412, 49.62996713474754],
            [5.309943100995732, 49.61000149387512],
            [5.3500733121785755, 49.62996713474754],
            [5.390203523361419, 49.62016582013744],
            [5.380037203195099, 49.59003585300269],
            [5.3399069920122555, 49.59003585300269],
            [5.309943100995732, 49.55990588586795],
            [5.279979209979211, 49.53994024499552],
            [5.260181639129008, 49.53994024499552],
            [5.250015318962688, 49.55990588586795],
            [5.230217748112486, 49.57007021213027],
            [5.179921216763323, 49.57007021213027],
            [5.1499573257468, 49.59003585300269],
            [5.109827114563957, 49.59003585300269],
            [5.109827114563957, 49.55990588586795],
            [5.090029543713755, 49.53994024499552],
            [5.100195863880075, 49.53013893038542],
            [5.079863223547435, 49.510173289513],
            [5.079863223547435, 49.46987899611592],
            [5.109827114563957, 49.46007768150583],
            [5.100195863880075, 49.44011204063341],
            [5.109827114563957, 49.42014639976098],
            [5.079863223547435, 49.40018075888856],
            [5.100195863880075, 49.39001643262623],
            [5.090029543713755, 49.37005079175381],
            [5.060065652697232, 49.359886465491485],
            [5.030101761680709, 49.339920824619064],
            [5.039733012364592, 49.31995518374664],
            [5.030101761680709, 49.31015386913654],
            [5.060065652697232, 49.289825216611895],
            [5.049899332530912, 49.269859575739474],
            [5.009769121348069, 49.269859575739474],
            [5.0001378706641875, 49.26005826112937],
            [4.949841339315024, 49.24009262025695],
            [4.879747237115658, 49.26005826112937],
            [4.859949666265456, 49.24009262025695],
            [4.7400941021993654, 49.24009262025695],
            [4.729927782033045, 49.249893934867046],
            [4.699963891016522, 49.249893934867046],
            [4.640036108983478, 49.229928293994625],
            [4.620238538133276, 49.24009262025695],
            [4.599905897800634, 49.289825216611895],
            [4.559775686617793, 49.299989542874215],
            [4.520180544917387, 49.280023902001794],
            [4.429753802385382, 49.280023902001794],
            [4.390158660684977, 49.299989542874215],
            [4.379992340518657, 49.31995518374664],
            [4.339862129335814, 49.31995518374664],
            [4.309898238319291, 49.33011951000897],
            [4.29010066746909, 49.35008515088139],
            [4.260136776452566, 49.359886465491485],
            [4.249970456286246, 49.37985210636391],
            [4.200208994419522, 49.37985210636391],
            [4.190042674253202, 49.40018075888856],
            [4.070187110187111, 49.40018075888856],
            [4.049854469854471, 49.40998207349866],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 974,
        name: "La Réunion",
        REG: "04",
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.11976912134806916, 41.62011502838362],
            [0.0502100886311414, 41.62011502838362],
            [0.029877448298501363, 41.629916342993724],
            [-0.07981179560126961, 41.66004631012847],
            [-0.08997811576758963, 41.66984762473857],
            [-0.14990589780063424, 41.68001195100089],
            [-0.20020242914979747, 41.71994323274574],
            [-0.2697614618667252, 41.73010755900806],
            [-0.3002604223656853, 41.77003884075291],
            [-0.33985556406609074, 41.79000448162533],
            [-0.36981945508261305, 41.82993576337018],
            [-0.35002188423241076, 41.8499014042426],
            [-0.3601882043987308, 41.88003137137735],
            [-0.3901520954152531, 41.89999701224978],
            [-0.40994966626545537, 41.93012697938452],
            [-0.46987744829850087, 41.97985957573947],
            [-0.46987744829850087, 42.009989542874216],
            [-0.4800437684648209, 42.02995518374664],
            [-0.4500798774482986, 42.04992082461906],
            [-0.42974723711565854, 42.04992082461906],
            [-0.39978334609913535, 42.069886465491486],
            [-0.37998577524893307, 42.100016432626234],
            [-0.3901520954152531, 42.130146399760974],
            [-0.37998577524893307, 42.17007768150582],
            [-0.3302243133822085, 42.17007768150582],
            [-0.24996389101652294, 42.21000896325067],
            [-0.20983367983367973, 42.24013893038542],
            [-0.16007221796695514, 42.249940244995514],
            [-0.13010832695043195, 42.249940244995514],
            [-0.10977568661779191, 42.22997460412309],
            [-0.049847904584746416, 42.24013893038542],
            [-0.019884013568224113, 42.24013893038542],
            [0.010079877448298191, 42.22997460412309],
            [0.1101378706641869, 42.22997460412309],
            [0.11976912134806916, 42.21000896325067],
            [0.14973301236459147, 42.21000896325067],
            [0.18023197286355153, 42.199844636988345],
            [0.2599573257467993, 42.139947714371075],
            [0.2599573257467993, 42.08985210636391],
            [0.3198851077798448, 42.040119510008964],
            [0.3198851077798448, 42.02995518374664],
            [0.40014553014553034, 41.950092620256946],
            [0.47023963234489585, 41.93012697938452],
            [0.49003720319509814, 41.88983268598745],
            [0.47023963234489585, 41.86986704511503],
            [0.4397406718459349, 41.79000448162533],
            [0.46007331217857583, 41.68001195100089],
            [0.4097767808294126, 41.64008066925605],
            [0.3000875369296425, 41.629916342993724],
            [0.2599573257467993, 41.62011502838362],
            [0.2497910055804793, 41.6099507021213],
            [0.14973301236459147, 41.6001493875112],
            [0.11976912134806916, 41.62011502838362],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 39, name: "Jura", REG: 27, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.309943100995732, 46.44998506124888],
            [5.320109421162054, 46.46014938751121],
            [5.380037203195099, 46.46014938751121],
            [5.410001094211622, 46.4699507021213],
            [5.420167414377942, 46.50008066925605],
            [5.3602396323448955, 46.52004631012847],
            [5.3602396323448955, 46.57994323274574],
            [5.410001094211622, 46.57994323274574],
            [5.410001094211622, 46.61007319988049],
            [5.439964985228143, 46.63984015536301],
            [5.420167414377942, 46.65000448162534],
            [5.420167414377942, 46.66997012249776],
            [5.3998347740453, 46.68993576337019],
            [5.410001094211622, 46.70010008963251],
            [5.390203523361419, 46.72986704511503],
            [5.3602396323448955, 46.72986704511503],
            [5.390203523361419, 46.770161338512104],
            [5.3602396323448955, 46.790126979384524],
            [5.3399069920122555, 46.790126979384524],
            [5.3297406718459355, 46.810092620256945],
            [5.380037203195099, 46.83005826112937],
            [5.4597625560783465, 46.83005826112937],
            [5.4597625560783465, 46.859825216611895],
            [5.420167414377942, 46.859825216611895],
            [5.3998347740453, 46.869989542874215],
            [5.3998347740453, 46.889955183746636],
            [5.369870883028779, 46.88015386913654],
            [5.309943100995732, 46.909920824619064],
            [5.309943100995732, 46.94005079175381],
            [5.279979209979211, 46.94005079175381],
            [5.260181639129008, 46.929886465491485],
            [5.260181639129008, 46.979982073498654],
            [5.279979209979211, 46.99994771437108],
            [5.320109421162054, 47.0199133552435],
            [5.279979209979211, 47.03007768150583],
            [5.279979209979211, 47.05004332237825],
            [5.309943100995732, 47.05984463698835],
            [5.3297406718459355, 47.080173289513],
            [5.390203523361419, 47.080173289513],
            [5.410001094211622, 47.12990588586794],
            [5.450131305394463, 47.16003585300269],
            [5.4597625560783465, 47.18000149387511],
            [5.450131305394463, 47.19996713474754],
            [5.4800951964109865, 47.21993277561996],
            [5.4800951964109865, 47.25986405736481],
            [5.51005908742751, 47.27982969823723],
            [5.52022540759383, 47.300158350761876],
            [5.559820549294234, 47.27982969823723],
            [5.569986869460554, 47.25986405736481],
            [5.6101170806433975, 47.25986405736481],
            [5.619748331327279, 47.25006274275471],
            [5.659878542510122, 47.27002838362713],
            [5.700008753692965, 47.27002838362713],
            [5.719806324543167, 47.23989841649238],
            [5.719806324543167, 47.21993277561996],
            [5.75993653572601, 47.21013146100986],
            [5.75993653572601, 47.19016582013744],
            [5.789900426742533, 47.19016582013744],
            [5.789900426742533, 47.16983716761279],
            [5.810233067075173, 47.16983716761279],
            [5.810233067075173, 47.14987152674037],
            [5.830030637925375, 47.14007021213027],
            [5.800066746908853, 47.12010457125784],
            [5.789900426742533, 47.10013893038542],
            [5.77010285589233, 47.0899746041231],
            [5.779734106576213, 47.05004332237825],
            [5.740138964875807, 47.03007768150583],
            [5.75993653572601, 47.0101120406334],
            [5.789900426742533, 47.0199133552435],
            [5.800066746908853, 47.039878996115924],
            [5.8198643177590546, 47.039878996115924],
            [5.830030637925375, 47.0101120406334],
            [5.879792099792101, 47.0101120406334],
            [5.879792099792101, 46.99994771437108],
            [5.940254951307584, 46.979982073498654],
            [5.970218842324106, 46.979982073498654],
            [5.979850093007989, 46.96001643262623],
            [5.970218842324106, 46.949852106363906],
            [6.000182733340629, 46.929886465491485],
            [5.979850093007989, 46.909920824619064],
            [6.00981398402451, 46.90011951000896],
            [6.00981398402451, 46.869989542874215],
            [6.01998030419083, 46.850023902001794],
            [6.049944195207353, 46.850023902001794],
            [6.0697417660575566, 46.859825216611895],
            [6.090074406390197, 46.83985957573947],
            [6.109871977240398, 46.83985957573947],
            [6.150002188423241, 46.819893934867046],
            [6.160168508589561, 46.799928293994626],
            [6.199763650289966, 46.7799626531222],
            [6.179966079439764, 46.740031371377356],
            [6.13020461757304, 46.72006573050493],
            [6.0697417660575566, 46.68993576337019],
            [6.100240726556517, 46.65000448162534],
            [6.079908086223877, 46.63984015536301],
            [6.049944195207353, 46.61007319988049],
            [6.13020461757304, 46.55017627726322],
            [6.139835868256921, 46.55997759187332],
            [6.160168508589561, 46.55017627726322],
            [6.150002188423241, 46.52984762473857],
            [6.12003829740672, 46.52004631012847],
            [6.100240726556517, 46.48011502838363],
            [6.0697417660575566, 46.46014938751121],
            [6.090074406390197, 46.439820734986554],
            [6.060110515373673, 46.41985509411413],
            [6.030146624357152, 46.39008813863161],
            [5.979850093007989, 46.359958171496864],
            [5.979850093007989, 46.35015685688676],
            [5.940254951307584, 46.309862563489695],
            [5.919922310974942, 46.309862563489695],
            [5.919922310974942, 46.289896922617274],
            [5.889958419958421, 46.289896922617274],
            [5.879792099792101, 46.269931281744846],
            [5.849828208775578, 46.260129967134745],
            [5.8198643177590546, 46.260129967134745],
            [5.77010285589233, 46.269931281744846],
            [5.729972644709487, 46.260129967134745],
            [5.710175073859285, 46.309862563489695],
            [5.680211182842762, 46.320026889752015],
            [5.650247291826239, 46.320026889752015],
            [5.6101170806433975, 46.329828204362116],
            [5.6101170806433975, 46.309862563489695],
            [5.5897844403107575, 46.289896922617274],
            [5.559820549294234, 46.289896922617274],
            [5.540022978444031, 46.269931281744846],
            [5.51005908742751, 46.260129967134745],
            [5.4800951964109865, 46.260129967134745],
            [5.4597625560783465, 46.28009560800717],
            [5.4800951964109865, 46.320026889752015],
            [5.439964985228143, 46.320026889752015],
            [5.420167414377942, 46.33999253062444],
            [5.380037203195099, 46.33999253062444],
            [5.380037203195099, 46.379923812369285],
            [5.3500733121785755, 46.39988945324171],
            [5.309943100995732, 46.41005377950403],
            [5.320109421162054, 46.43001942037646],
            [5.309943100995732, 46.44998506124888],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 17,
        name: "Charente-Maritime",
        REG: 75,
        CAT: 0,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-1.5100525221577854, 46.21983567373768],
              [-1.4800886311412627, 46.210034359127576],
              [-1.4597559908086226, 46.230000000000004],
              [-1.4201608491082176, 46.230000000000004],
              [-1.4201608491082176, 46.210034359127576],
              [-1.3998282087755771, 46.199870032865256],
              [-1.350066746908852, 46.210034359127576],
              [-1.3201028558923298, 46.190068718255155],
              [-1.2997702155596893, 46.190068718255155],
              [-1.279972644709487, 46.170103077382734],
              [-1.279972644709487, 46.150137436510306],
              [-1.3099365357260093, 46.139973110247986],
              [-1.3201028558923298, 46.150137436510306],
              [-1.350066746908852, 46.150137436510306],
              [-1.3602330670751726, 46.15993875112041],
              [-1.4699223109749426, 46.199870032865256],
              [-1.5100525221577854, 46.190068718255155],
              [-1.5298500930079877, 46.199870032865256],
              [-1.5400164131743082, 46.21983567373768],
              [-1.5598139840245104, 46.230000000000004],
              [-1.4998862019914654, 46.260129967134745],
              [-1.4800886311412627, 46.249965640872425],
              [-1.4902549513075831, 46.230000000000004],
              [-1.5100525221577854, 46.21983567373768],
            ],
          ],
          [
            [
              [-0.27992778203304525, 45.35005975500448],
              [-0.24996389101652294, 45.35986106961458],
              [-0.24996389101652294, 45.33989542874216],
              [-0.27992778203304525, 45.35005975500448],
              [-0.29009410219936527, 45.33009411413206],
              [-0.27992778203304525, 45.31012847325964],
              [-0.16007221796695514, 45.31012847325964],
              [-0.14990589780063424, 45.29016283238721],
              [-0.10977568661779191, 45.29016283238721],
              [-0.10977568661779191, 45.24986853899014],
              [-0.04021665390086415, 45.24986853899014],
              [-0.030050333734544132, 45.229902898117714],
              [-0.00008644271802182857, 45.229902898117714],
              [-0.00008644271802182857, 45.18017030176277],
              [-0.019884013568224113, 45.170005975500445],
              [-0.00008644271802182857, 45.150040334628024],
              [-0.04021665390086415, 45.139876008365704],
              [-0.030050333734544132, 45.1300746937556],
              [-0.04021665390086415, 45.099944726620855],
              [-0.07018054491738734, 45.099944726620855],
              [-0.08997811576758963, 45.119910367493276],
              [-0.10977568661779191, 45.119910367493276],
              [-0.13973957763431422, 45.090143412010754],
              [-0.19003610898347745, 45.090143412010754],
              [-0.21999999999999975, 45.11010905288318],
              [-0.26013021118284296, 45.11010905288318],
              [-0.27992778203304525, 45.139876008365704],
              [-0.30989167304956755, 45.150040334628024],
              [-0.33985556406609074, 45.170005975500445],
              [-0.37998577524893307, 45.159841649238125],
              [-0.4201159864317763, 45.20013594263519],
              [-0.40994966626545537, 45.22010158350762],
              [-0.40994966626545537, 45.24986853899014],
              [-0.42974723711565854, 45.27999850612489],
              [-0.4602461976146186, 45.29016283238721],
              [-0.5501378706641864, 45.29016283238721],
              [-0.589733012364591, 45.31992978786973],
              [-0.6501958638800742, 45.31992978786973],
              [-0.719754896597002, 45.33009411413206],
              [-0.729921216763322, 45.35986106961458],
              [-0.750253857095962, 45.42012100388408],
              [-0.7898489987963675, 45.46005228562892],
              [-0.8000153189626875, 45.48001792650135],
              [-0.9000733121785753, 45.530113534508516],
              [-0.9300372031950976, 45.55988048999104],
              [-0.9498347740452999, 45.55007917538094],
              [-0.9701674143779409, 45.55988048999104],
              [-0.9797986650618231, 45.57984613086346],
              [-1.0199288762446654, 45.62014042426053],
              [-1.0498927672611886, 45.62014042426053],
              [-1.079856658277711, 45.640106065132954],
              [-1.1098205492942332, 45.649907379743055],
              [-1.2098785425101215, 45.700002987750224],
              [-1.2398424335266442, 45.6898386614879],
              [-1.2398424335266442, 45.79002987750224],
              [-1.1900809716599192, 45.79002987750224],
              [-1.1301531896268737, 45.80999551837466],
              [-1.1697483313272787, 45.84012548550941],
              [-1.1697483313272787, 45.86009112638183],
              [-1.1199868694605537, 45.86009112638183],
              [-1.0702254075938287, 45.90982372273678],
              [-1.0702254075938287, 45.93015237526143],
              [-1.100189298610351, 45.95011801613385],
              [-1.079856658277711, 45.95991933074395],
              [-1.090022978444031, 45.9900492978787],
              [-1.0498927672611886, 46.01001493875112],
              [-1.0702254075938287, 46.04994622049597],
              [-1.090022978444031, 46.04994622049597],
              [-1.090022978444031, 46.080076187630716],
              [-1.1199868694605537, 46.10984314311324],
              [-1.1301531896268737, 46.130171795637885],
              [-1.1499507604770765, 46.130171795637885],
              [-1.1697483313272787, 46.150137436510306],
              [-1.230211182842762, 46.150137436510306],
              [-1.2002472918262392, 46.190068718255155],
              [-1.2098785425101215, 46.199870032865256],
              [-1.1900809716599192, 46.21983567373768],
              [-1.1697483313272787, 46.21983567373768],
              [-1.1601170806433965, 46.240164326262324],
              [-1.1098205492942332, 46.260129967134745],
              [-1.1301531896268737, 46.309862563489695],
              [-1.100189298610351, 46.309862563489695],
              [-1.0498927672611886, 46.33999253062444],
              [-1.0199288762446654, 46.35015685688676],
              [-0.9701674143779409, 46.35015685688676],
              [-0.9498347740452999, 46.359958171496864],
              [-0.9402035233614177, 46.33999253062444],
              [-0.9600010942116208, 46.320026889752015],
              [-0.9102396323448954, 46.309862563489695],
              [-0.8899069920122553, 46.329828204362116],
              [-0.870109421162053, 46.320026889752015],
              [-0.8401455301455298, 46.33999253062444],
              [-0.8000153189626875, 46.33999253062444],
              [-0.8000153189626875, 46.329828204362116],
              [-0.750253857095962, 46.300061248879594],
              [-0.740087536929642, 46.269931281744846],
              [-0.750253857095962, 46.249965640872425],
              [-0.6999573257467997, 46.21983567373768],
              [-0.6801597548965974, 46.199870032865256],
              [-0.6897910055804797, 46.17990439199283],
              [-0.6598271145639565, 46.170103077382734],
              [-0.6298632235474342, 46.170103077382734],
              [-0.6202319728635519, 46.15993875112041],
              [-0.6298632235474342, 46.139973110247986],
              [-0.5298052303315464, 46.139973110247986],
              [-0.5201739796476641, 46.10984314311324],
              [-0.46987744829850087, 46.10004182850314],
              [-0.43991355728197856, 46.10004182850314],
              [-0.39978334609913535, 46.080076187630716],
              [-0.3901520954152531, 46.10004182850314],
              [-0.3601882043987308, 46.080076187630716],
              [-0.27992778203304525, 46.080076187630716],
              [-0.2697614618667252, 46.060110546758295],
              [-0.23016632016631977, 46.04994622049597],
              [-0.19003610898347745, 46.04994622049597],
              [-0.19003610898347745, 46.02998057962354],
              [-0.13973957763431422, 45.9998506124888],
              [-0.13973957763431422, 45.97988497161637],
              [-0.10014443593390965, 45.97008365700628],
              [-0.08997811576758963, 45.95011801613385],
              [-0.10014443593390965, 45.93015237526143],
              [-0.14990589780063424, 45.93015237526143],
              [-0.13010832695043195, 45.90982372273678],
              [-0.13973957763431422, 45.90002240812668],
              [-0.11994200678411193, 45.86989244099193],
              [-0.11994200678411193, 45.84992680011951],
              [-0.13973957763431422, 45.84992680011951],
              [-0.13973957763431422, 45.82015984463699],
              [-0.14990589780063424, 45.79002987750224],
              [-0.19003610898347745, 45.79002987750224],
              [-0.21999999999999975, 45.779865551239915],
              [-0.24996389101652294, 45.80999551837466],
              [-0.29009410219936527, 45.80999551837466],
              [-0.32005799321588757, 45.779865551239915],
              [-0.33985556406609074, 45.79002987750224],
              [-0.36981945508261305, 45.779865551239915],
              [-0.39978334609913535, 45.79002987750224],
              [-0.39978334609913535, 45.77006423662982],
              [-0.42974723711565854, 45.759899910367494],
              [-0.4500798774482986, 45.77006423662982],
              [-0.4602461976146186, 45.73993426949507],
              [-0.39978334609913535, 45.73993426949507],
              [-0.4201159864317763, 45.719968628622645],
              [-0.4201159864317763, 45.6898386614879],
              [-0.37998577524893307, 45.660071706005375],
              [-0.40994966626545537, 45.660071706005375],
              [-0.42974723711565854, 45.62014042426053],
              [-0.3901520954152531, 45.62994173887063],
              [-0.37998577524893307, 45.60997609799821],
              [-0.35002188423241076, 45.590010457125786],
              [-0.3302243133822085, 45.590010457125786],
              [-0.3002604223656853, 45.55988048999104],
              [-0.32005799321588757, 45.530113534508516],
              [-0.2697614618667252, 45.530113534508516],
              [-0.2697614618667252, 45.510147893636095],
              [-0.24996389101652294, 45.48981924111144],
              [-0.2697614618667252, 45.46985360023902],
              [-0.2697614618667252, 45.4498879593666],
              [-0.24996389101652294, 45.4400866447565],
              [-0.24996389101652294, 45.40015536301165],
              [-0.27992778203304525, 45.38999103674933],
              [-0.30989167304956755, 45.38999103674933],
              [-0.27992778203304525, 45.35005975500448],
            ],
          ],
          [
            [
              [-1.2098785425101215, 45.84992680011951],
              [-1.2002472918262392, 45.82996115924709],
              [-1.230211182842762, 45.799831192112336],
              [-1.2500087536929643, 45.80999551837466],
              [-1.2500087536929643, 45.84992680011951],
              [-1.2601750738592843, 45.86989244099193],
              [-1.290138964875807, 45.90002240812668],
              [-1.339900426742532, 45.9199880489991],
              [-1.3800306379253748, 45.95011801613385],
              [-1.3901969580916949, 45.95011801613385],
              [-1.3901969580916949, 45.9998506124888],
              [-1.4099945289418976, 46.04994622049597],
              [-1.3698643177590548, 46.04014490588587],
              [-1.3602330670751726, 46.02017926501345],
              [-1.3201028558923298, 45.9998506124888],
              [-1.3201028558923298, 45.9900492978787],
              [-1.2500087536929643, 45.9900492978787],
              [-1.2398424335266442, 45.97988497161637],
              [-1.2398424335266442, 45.95011801613385],
              [-1.2200448626764415, 45.90982372273678],
              [-1.1900809716599192, 45.889858081864354],
              [-1.2002472918262392, 45.84992680011951],
              [-1.2098785425101215, 45.84992680011951],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 16, name: "Charente", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.00008644271802182857, 45.18997161637287],
            [-0.00008644271802182857, 45.229902898117714],
            [-0.030050333734544132, 45.229902898117714],
            [-0.04021665390086415, 45.24986853899014],
            [-0.10977568661779191, 45.24986853899014],
            [-0.10977568661779191, 45.29016283238721],
            [-0.14990589780063424, 45.29016283238721],
            [-0.16007221796695514, 45.31012847325964],
            [-0.27992778203304525, 45.31012847325964],
            [-0.29009410219936527, 45.33009411413206],
            [-0.27992778203304525, 45.35005975500448],
            [-0.24996389101652294, 45.33989542874216],
            [-0.24996389101652294, 45.35986106961458],
            [-0.27992778203304525, 45.35005975500448],
            [-0.30989167304956755, 45.38999103674933],
            [-0.27992778203304525, 45.38999103674933],
            [-0.24996389101652294, 45.40015536301165],
            [-0.24996389101652294, 45.4400866447565],
            [-0.2697614618667252, 45.4498879593666],
            [-0.2697614618667252, 45.46985360023902],
            [-0.24996389101652294, 45.48981924111144],
            [-0.2697614618667252, 45.510147893636095],
            [-0.2697614618667252, 45.530113534508516],
            [-0.32005799321588757, 45.530113534508516],
            [-0.3002604223656853, 45.55988048999104],
            [-0.3302243133822085, 45.590010457125786],
            [-0.35002188423241076, 45.590010457125786],
            [-0.37998577524893307, 45.60997609799821],
            [-0.3901520954152531, 45.62994173887063],
            [-0.42974723711565854, 45.62014042426053],
            [-0.40994966626545537, 45.660071706005375],
            [-0.37998577524893307, 45.660071706005375],
            [-0.4201159864317763, 45.6898386614879],
            [-0.4201159864317763, 45.719968628622645],
            [-0.39978334609913535, 45.73993426949507],
            [-0.4602461976146186, 45.73993426949507],
            [-0.4500798774482986, 45.77006423662982],
            [-0.42974723711565854, 45.759899910367494],
            [-0.39978334609913535, 45.77006423662982],
            [-0.39978334609913535, 45.79002987750224],
            [-0.36981945508261305, 45.779865551239915],
            [-0.33985556406609074, 45.79002987750224],
            [-0.32005799321588757, 45.779865551239915],
            [-0.29009410219936527, 45.80999551837466],
            [-0.24996389101652294, 45.80999551837466],
            [-0.21999999999999975, 45.779865551239915],
            [-0.19003610898347745, 45.79002987750224],
            [-0.14990589780063424, 45.79002987750224],
            [-0.13973957763431422, 45.82015984463699],
            [-0.13973957763431422, 45.84992680011951],
            [-0.11994200678411193, 45.84992680011951],
            [-0.11994200678411193, 45.86989244099193],
            [-0.13973957763431422, 45.90002240812668],
            [-0.13010832695043195, 45.90982372273678],
            [-0.14990589780063424, 45.93015237526143],
            [-0.10014443593390965, 45.93015237526143],
            [-0.08997811576758963, 45.95011801613385],
            [-0.10014443593390965, 45.97008365700628],
            [-0.049847904584746416, 45.9900492978787],
            [-0.049847904584746416, 46.02017926501345],
            [-0.030050333734544132, 46.060110546758295],
            [-0.00008644271802182857, 46.060110546758295],
            [0.0202461976146191, 46.04994622049597],
            [0.0502100886311414, 46.080076187630716],
            [0.08980523033154597, 46.10004182850314],
            [0.1401017616807092, 46.10004182850314],
            [0.1700656526972315, 46.080076187630716],
            [0.2000295437137547, 46.10004182850314],
            [0.24015975489659702, 46.080076187630716],
            [0.2599573257467993, 46.080076187630716],
            [0.2797548965970016, 46.060110546758295],
            [0.3198851077798448, 46.060110546758295],
            [0.3498489987963671, 46.06991186136839],
            [0.4097767808294126, 46.04994622049597],
            [0.4499069920122549, 46.04994622049597],
            [0.47023963234489585, 46.060110546758295],
            [0.4798708830287781, 46.080076187630716],
            [0.4499069920122549, 46.08987750224081],
            [0.47023963234489585, 46.130171795637885],
            [0.5002035233614182, 46.12000746937556],
            [0.5601313053944637, 46.08987750224081],
            [0.5697625560783459, 46.080076187630716],
            [0.6098927672611882, 46.080076187630716],
            [0.6698205492942337, 46.10004182850314],
            [0.7099507604770761, 46.139973110247986],
            [0.7500809716599193, 46.139973110247986],
            [0.7902111828427616, 46.130171795637885],
            [0.8201750738592848, 46.130171795637885],
            [0.8100087536929648, 46.12000746937556],
            [0.829806324543167, 46.10004182850314],
            [0.8201750738592848, 46.080076187630716],
            [0.829806324543167, 46.06991186136839],
            [0.8201750738592848, 46.04994622049597],
            [0.8501389648758071, 46.04014490588587],
            [0.8699365357260094, 46.02017926501345],
            [0.9100667469088526, 46.02017926501345],
            [0.9400306379253749, 45.95991933074395],
            [0.9298643177590549, 45.95011801613385],
            [0.9202330670751726, 45.95011801613385],
            [0.8801028558923294, 45.9199880489991],
            [0.8201750738592848, 45.9199880489991],
            [0.8100087536929648, 45.90002240812668],
            [0.829806324543167, 45.88005676725426],
            [0.7998424335266439, 45.82996115924709],
            [0.7602472918262393, 45.799831192112336],
            [0.7099507604770761, 45.799831192112336],
            [0.7099507604770761, 45.759899910367494],
            [0.6500229784440315, 45.73993426949507],
            [0.6500229784440315, 45.719968628622645],
            [0.6302254075938292, 45.71016731401255],
            [0.5697625560783459, 45.649907379743055],
            [0.5601313053944637, 45.62994173887063],
            [0.5301674143779405, 45.640106065132954],
            [0.5002035233614182, 45.62014042426053],
            [0.5200010942116204, 45.590010457125786],
            [0.5002035233614182, 45.55007917538094],
            [0.47023963234489585, 45.53991484911862],
            [0.4499069920122549, 45.510147893636095],
            [0.4097767808294126, 45.48981924111144],
            [0.3000875369296425, 45.4498879593666],
            [0.3000875369296425, 45.42992231849418],
            [0.2797548965970016, 45.42992231849418],
            [0.2497910055804793, 45.379826710487],
            [0.2497910055804793, 45.35986106961458],
            [0.2701236459131193, 45.29996414699731],
            [0.2497910055804793, 45.29016283238721],
            [0.21982711456395698, 45.29016283238721],
            [0.2000295437137547, 45.26003286525246],
            [0.18023197286355153, 45.26003286525246],
            [0.14973301236459147, 45.20993725724529],
            [0.1101378706641869, 45.20993725724529],
            [0.09997155049786599, 45.229902898117714],
            [0.0801739796476637, 45.22010158350762],
            [0.05984133931502367, 45.229902898117714],
            [0.04004376846482138, 45.20993725724529],
            [-0.00008644271802182857, 45.18997161637287],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 56, name: "Morbihan", REG: 53, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-3.120076594813437, 47.320123991634304],
              [-3.069780063464274, 47.320123991634304],
              [-3.0601488127803917, 47.30995966537198],
              [-3.0901127037969145, 47.27982969823723],
              [-3.109910274647117, 47.289994024499556],
              [-3.16020680599628, 47.289994024499556],
              [-3.1698380566801623, 47.300158350761876],
              [-3.1998019476966846, 47.300158350761876],
              [-3.220134588029325, 47.289994024499556],
              [-3.250098479045848, 47.30995966537198],
              [-3.239932158879528, 47.320123991634304],
              [-3.260264799212168, 47.34989094711682],
              [-3.239932158879528, 47.38982222886167],
              [-3.220134588029325, 47.36985658798925],
              [-3.1901706970128023, 47.36985658798925],
              [-3.16020680599628, 47.360055273379146],
              [-3.15004048582996, 47.3299253062444],
              [-3.120076594813437, 47.320123991634304],
            ],
          ],
          [
            [
              [-2.860032826348616, 47.5698760083657],
              [-2.860032826348616, 47.589841649238124],
              [-2.8402352554984134, 47.589841649238124],
              [-2.860032826348616, 47.5698760083657],
            ],
          ],
          [
            [
              [-3.420250574461101, 47.61997161637287],
              [-3.4400481453113034, 47.6301359426352],
              [-3.4598457161615057, 47.61997161637287],
              [-3.510142247510669, 47.63993725724529],
              [-3.510142247510669, 47.65010158350762],
              [-3.4598457161615057, 47.65010158350762],
              [-3.4298818251449834, 47.63993725724529],
              [-3.420250574461101, 47.61997161637287],
            ],
          ],
          [
            [
              [-2.8899967173651384, 47.54010905288318],
              [-2.909794288215341, 47.54010905288318],
              [-2.8899967173651384, 47.54010905288318],
              [-2.909794288215341, 47.54010905288318],
              [-2.909794288215341, 47.5600746937556],
              [-2.870199146514936, 47.5600746937556],
              [-2.860032826348616, 47.54010905288318],
              [-2.8199026151657733, 47.54010905288318],
              [-2.8199026151657733, 47.5600746937556],
              [-2.7797724039829306, 47.54010905288318],
              [-2.7300109421162055, 47.54010905288318],
              [-2.7300109421162055, 47.5698760083657],
              [-2.710213371266003, 47.58004033462802],
              [-2.719844621949885, 47.60000597550045],
              [-2.7401772622825256, 47.61017030176277],
              [-2.759974833132728, 47.6301359426352],
              [-2.7899387241492506, 47.61997161637287],
              [-2.860032826348616, 47.61997161637287],
              [-2.860032826348616, 47.60000597550045],
              [-2.8899967173651384, 47.60000597550045],
              [-2.930126928547981, 47.589841649238124],
              [-2.9397581792318634, 47.589841649238124],
              [-2.960090819564504, 47.6301359426352],
              [-2.970257139730824, 47.65010158350762],
              [-2.960090819564504, 47.6301359426352],
              [-2.970257139730824, 47.589841649238124],
              [-2.930126928547981, 47.5600746937556],
              [-2.960090819564504, 47.5600746937556],
              [-2.970257139730824, 47.5698760083657],
              [-3.009852281431229, 47.5698760083657],
              [-3.020018601597549, 47.589841649238124],
              [-3.0398161724477517, 47.589841649238124],
              [-3.0601488127803917, 47.5698760083657],
              [-3.0997439544807968, 47.5600746937556],
              [-3.1302429149797573, 47.60000597550045],
              [-3.1302429149797573, 47.509979085748434],
              [-3.120076594813437, 47.479849118613686],
              [-3.1398741656636395, 47.479849118613686],
              [-3.15004048582996, 47.50017777113833],
              [-3.15004048582996, 47.529944726620855],
              [-3.1302429149797573, 47.54991036749328],
              [-3.1398741656636395, 47.58004033462802],
              [-3.16020680599628, 47.61017030176277],
              [-3.1998019476966846, 47.61997161637287],
              [-3.2099682678630046, 47.63993725724529],
              [-3.1998019476966846, 47.65010158350762],
              [-3.2099682678630046, 47.67006722438004],
              [-3.2099682678630046, 47.65010158350762],
              [-3.26989604989605, 47.67986853899014],
              [-3.2998599409125724, 47.69003286525247],
              [-3.310026261078893, 47.69003286525247],
              [-3.3501564722617356, 47.69983417986256],
              [-3.310026261078893, 47.69003286525247],
              [-3.2998599409125724, 47.69003286525247],
              [-3.310026261078893, 47.70999850612489],
              [-3.3399901520954156, 47.70999850612489],
              [-3.3501564722617356, 47.69983417986256],
              [-3.3399901520954156, 47.72016283238722],
              [-3.310026261078893, 47.74992978786973],
              [-3.2998599409125724, 47.76989542874216],
              [-3.29022869022869, 47.76989542874216],
              [-3.29022869022869, 47.78986106961458],
              [-3.29022869022869, 47.76989542874216],
              [-3.2998599409125724, 47.76989542874216],
              [-3.3399901520954156, 47.74012847325964],
              [-3.359787722945618, 47.76009411413206],
              [-3.369954043111938, 47.76989542874216],
              [-3.38975161396214, 47.809826710487],
              [-3.369954043111938, 47.76989542874216],
              [-3.359787722945618, 47.76009411413206],
              [-3.3501564722617356, 47.74012847325964],
              [-3.369954043111938, 47.72996414699731],
              [-3.380120363278258, 47.69983417986256],
              [-3.4598457161615057, 47.69983417986256],
              [-3.4999759273443485, 47.72996414699731],
              [-3.510142247510669, 47.74992978786973],
              [-3.5299398183608712, 47.76009411413206],
              [-3.5299398183608712, 47.78005975500449],
              [-3.5299398183608712, 47.78986106961458],
              [-3.519773498194551, 47.80002539587691],
              [-3.5401061385271912, 47.81999103674933],
              [-3.5401061385271912, 47.83995667762175],
              [-3.519773498194551, 47.85012100388408],
              [-3.510142247510669, 47.830155363011656],
              [-3.4898096071780285, 47.830155363011656],
              [-3.4502144654776234, 47.85012100388408],
              [-3.3999179341284607, 47.890052285628926],
              [-3.410084254294781, 47.91981924111145],
              [-3.38975161396214, 47.949949208246196],
              [-3.3999179341284607, 47.96991484911862],
              [-3.420250574461101, 47.96991484911862],
              [-3.4598457161615057, 47.949949208246196],
              [-3.480178356494146, 47.949949208246196],
              [-3.4999759273443485, 47.980079175380936],
              [-3.5299398183608712, 47.98988048999104],
              [-3.640164131743079, 47.98988048999104],
              [-3.659961702593282, 48.020010457125785],
              [-3.670128022759602, 48.05014042426053],
              [-3.7000919137761246, 48.059941738870634],
              [-3.7000919137761246, 48.09007170600538],
              [-3.730055804792647, 48.099873020615476],
              [-3.7000919137761246, 48.14996862862265],
              [-3.670128022759602, 48.14996862862265],
              [-3.6497953824269613, 48.16013295488497],
              [-3.5599037093773935, 48.189899910367494],
              [-3.5497373892110735, 48.1800985957574],
              [-3.4999759273443485, 48.1800985957574],
              [-3.480178356494146, 48.189899910367494],
              [-3.420250574461101, 48.16993426949507],
              [-3.420250574461101, 48.14996862862265],
              [-3.38975161396214, 48.14996862862265],
              [-3.3501564722617356, 48.16993426949507],
              [-3.3201925812452133, 48.16013295488497],
              [-3.2998599409125724, 48.16013295488497],
              [-3.28006237006237, 48.14016731401255],
              [-3.239932158879528, 48.14996862862265],
              [-3.2099682678630046, 48.14016731401255],
              [-3.1998019476966846, 48.16013295488497],
              [-3.15004048582996, 48.16013295488497],
              [-3.1302429149797573, 48.1800985957574],
              [-3.1398741656636395, 48.189899910367494],
              [-3.120076594813437, 48.209865551239915],
              [-3.0601488127803917, 48.209865551239915],
              [-3.0499824926140717, 48.20006423662982],
              [-3.020018601597549, 48.20006423662982],
              [-3.009852281431229, 48.16993426949507],
              [-2.979888390414706, 48.16013295488497],
              [-2.9397581792318634, 48.16993426949507],
              [-2.8498665061822956, 48.14016731401255],
              [-2.809736294999453, 48.14996862862265],
              [-2.7797724039829306, 48.119838661487904],
              [-2.7797724039829306, 48.09007170600538],
              [-2.7300109421162055, 48.119838661487904],
              [-2.700047051099683, 48.119838661487904],
              [-2.6802494802494805, 48.130002987750224],
              [-2.64975051975052, 48.119838661487904],
              [-2.67008316008316, 48.059941738870634],
              [-2.65991683991684, 48.039976097998206],
              [-2.6197866287339973, 48.039976097998206],
              [-2.5801914870335922, 48.070106065132954],
              [-2.55022759601707, 48.079907379743055],
              [-2.55022759601707, 48.099873020615476],
              [-2.510097384834227, 48.130002987750224],
              [-2.5298949556844295, 48.16013295488497],
              [-2.459800853485064, 48.16013295488497],
              [-2.4501696028011817, 48.16993426949507],
              [-2.410039391618339, 48.16993426949507],
              [-2.369909180435496, 48.130002987750224],
              [-2.290183827552249, 48.130002987750224],
              [-2.260219936535726, 48.1100373468778],
              [-2.2398872962030856, 48.059941738870634],
              [-2.2200897253528833, 48.079907379743055],
              [-2.1697931940037205, 48.079907379743055],
              [-2.1697931940037205, 48.059941738870634],
              [-2.1901258343363605, 48.05014042426053],
              [-2.250053616369406, 48.05014042426053],
              [-2.2800175073859283, 48.020010457125785],
              [-2.290183827552249, 47.98988048999104],
              [-2.2398872962030856, 48.000044816253364],
              [-2.1799595141700405, 47.980079175380936],
              [-2.1398293029871978, 47.980079175380936],
              [-2.0799015209541527, 47.91981924111145],
              [-2.0900678411204727, 47.89985360023902],
              [-2.109865411970675, 47.890052285628926],
              [-2.1002341612867927, 47.83995667762175],
              [-2.0697352007878322, 47.85012100388408],
              [-2.03977130977131, 47.830155363011656],
              [-2.0697352007878322, 47.809826710487],
              [-2.0697352007878322, 47.78986106961458],
              [-2.1301980523033155, 47.76009411413206],
              [-2.0900678411204727, 47.76009411413206],
              [-2.06010395010395, 47.74012847325964],
              [-2.109865411970675, 47.74012847325964],
              [-2.1301980523033155, 47.72016283238722],
              [-2.1200317321369955, 47.70999850612489],
              [-2.1200317321369955, 47.67986853899014],
              [-2.1002341612867927, 47.67986853899014],
              [-2.109865411970675, 47.65010158350762],
              [-2.1002341612867927, 47.6301359426352],
              [-2.0799015209541527, 47.61997161637287],
              [-2.1002341612867927, 47.60000597550045],
              [-2.1002341612867927, 47.529944726620855],
              [-2.1499956231535178, 47.52014341201075],
              [-2.1697931940037205, 47.49001344487601],
              [-2.1901258343363605, 47.49001344487601],
              [-2.1901258343363605, 47.509979085748434],
              [-2.2200897253528833, 47.509979085748434],
              [-2.2398872962030856, 47.49001344487601],
              [-2.299815078236131, 47.52014341201075],
              [-2.299815078236131, 47.50017777113833],
              [-2.320147718568771, 47.459883477741265],
              [-2.410039391618339, 47.459883477741265],
              [-2.4400032826348617, 47.470047804003585],
              [-2.459800853485064, 47.450082163131164],
              [-2.4801334938177044, 47.43991783686884],
              [-2.4999310646679067, 47.459883477741265],
              [-2.4897647445015867, 47.470047804003585],
              [-2.4999310646679067, 47.49001344487601],
              [-2.4202057117846594, 47.49001344487601],
              [-2.520263705000547, 47.529944726620855],
              [-2.559858846700952, 47.509979085748434],
              [-2.599989057883795, 47.52014341201075],
              [-2.6197866287339973, 47.509979085748434],
              [-2.65991683991684, 47.52014341201075],
              [-2.6802494802494805, 47.49001344487601],
              [-2.7300109421162055, 47.509979085748434],
              [-2.749808512966408, 47.50017777113833],
              [-2.7797724039829306, 47.50017777113833],
              [-2.809736294999453, 47.49001344487601],
              [-2.8498665061822956, 47.50017777113833],
              [-2.8498665061822956, 47.52014341201075],
              [-2.8899967173651384, 47.54010905288318],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 11, name: "Aude", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.170155378050115, 42.660143412010754],
            [2.1797866287339973, 42.680109052883175],
            [2.159989057883795, 42.7000746937556],
            [2.1102275960170696, 42.720040334628024],
            [2.0802637050005472, 42.75017030176277],
            [2.059931064667907, 42.75997161637287],
            [2.0000032826348617, 42.729841649238125],
            [1.9502418207681371, 42.740005975500445],
            [1.9299091804354962, 42.77013594263519],
            [1.899945289418974, 42.799902898117715],
            [1.8699813984024516, 42.81006722438004],
            [1.8598150782361307, 42.83003286525246],
            [1.8897789692526539, 42.849998506124884],
            [1.9898369624685417, 42.86996414699731],
            [1.9802057117846594, 42.88012847325963],
            [1.9898369624685417, 42.90989542874215],
            [1.9802057117846594, 42.92986106961458],
            [1.9299091804354962, 42.9400253958769],
            [1.9502418207681371, 42.95999103674933],
            [2.0000032826348617, 42.95999103674933],
            [1.9700393916183394, 43.0100866447565],
            [1.9898369624685417, 43.01988795936659],
            [1.9802057117846594, 43.03985360023902],
            [1.9400755006018162, 43.05981924111144],
            [1.9598730714520194, 43.06998356737377],
            [1.9502418207681371, 43.12007917538094],
            [1.9299091804354962, 43.12988048999104],
            [1.899945289418974, 43.12988048999104],
            [1.8501838275522484, 43.14984613086346],
            [1.8202199365357261, 43.14984613086346],
            [1.7501258343363606, 43.170174783388106],
            [1.7297931940037206, 43.190140424260534],
            [1.7201619433198383, 43.230071706005376],
            [1.690198052303316, 43.270002987750225],
            [1.7099956231535183, 43.30013295488497],
            [1.7399595141700406, 43.32009859575739],
            [1.7297931940037206, 43.340064236629814],
            [1.799887296203086, 43.340064236629814],
            [1.810053616369406, 43.36002987750224],
            [1.799887296203086, 43.39015984463699],
            [1.8298511872196084, 43.39015984463699],
            [1.8202199365357261, 43.41012548550941],
            [1.8598150782361307, 43.43989244099193],
            [1.899945289418974, 43.41012548550941],
            [1.9197428602691762, 43.41992680011951],
            [1.9700393916183394, 43.41992680011951],
            [1.9898369624685417, 43.41012548550941],
            [2.0101696028011817, 43.41992680011951],
            [2.040133493817705, 43.41992680011951],
            [2.029967173651384, 43.43989244099193],
            [2.049764744501587, 43.43009112638183],
            [2.0700973848342272, 43.399961159247084],
            [2.1401914870335927, 43.399961159247084],
            [2.170155378050115, 43.41992680011951],
            [2.1899529489003173, 43.39015984463699],
            [2.2199168399168405, 43.37999551837466],
            [2.2300831600831605, 43.41012548550941],
            [2.2199168399168405, 43.43009112638183],
            [2.260047051099683, 43.45005676725425],
            [2.279844621949885, 43.43989244099193],
            [2.3098085129664083, 43.43989244099193],
            [2.369736294999453, 43.41992680011951],
            [2.400235255498414, 43.41992680011951],
            [2.409866506182296, 43.43009112638183],
            [2.4499967173651385, 43.43009112638183],
            [2.4901269285479817, 43.43989244099193],
            [2.520090819564504, 43.41992680011951],
            [2.5698522814312295, 43.41992680011951],
            [2.5698522814312295, 43.399961159247084],
            [2.5500547105810263, 43.37999551837466],
            [2.560221030747347, 43.369831192112336],
            [2.5398883904147063, 43.349865551239915],
            [2.5800186015975495, 43.329899910367494],
            [2.620148812780392, 43.289968628622645],
            [2.6597439544807973, 43.289968628622645],
            [2.6902429149797573, 43.32009859575739],
            [2.7100404858299596, 43.289968628622645],
            [2.750170697012803, 43.2500373468778],
            [2.7897658387132074, 43.270002987750225],
            [2.7897658387132074, 43.289968628622645],
            [2.8502286902286906, 43.329899910367494],
            [2.870026261078893, 43.329899910367494],
            [2.870026261078893, 43.36002987750224],
            [2.889823831929095, 43.369831192112336],
            [2.889823831929095, 43.329899910367494],
            [2.9197877229456184, 43.329899910367494],
            [2.94975161396214, 43.309934269495066],
            [3.000048145311303, 43.32009859575739],
            [3.010214465477623, 43.280167314012544],
            [3.0498096071780294, 43.280167314012544],
            [3.079773498194551, 43.2598386614879],
            [3.140236349710034, 43.2598386614879],
            [3.1600339205602372, 43.23987302061548],
            [3.2001641317430787, 43.2500373468778],
            [3.209795382426962, 43.230071706005376],
            [3.239759273443485, 43.210106065132955],
            [3.1798314914104386, 43.170174783388106],
            [3.149867600393917, 43.14004481625336],
            [3.089939818360871, 43.05981924111144],
            [3.0401783564941463, 42.95999103674933],
            [3.0401783564941463, 42.92986106961458],
            [3.0599759273443494, 42.92005975500448],
            [3.0401783564941463, 42.839834179862564],
            [3.010214465477623, 42.849998506124884],
            [2.9802505744611016, 42.86996414699731],
            [2.9197877229456184, 42.88012847325963],
            [2.9101564722617352, 42.90009411413206],
            [2.880192581245213, 42.90009411413206],
            [2.870026261078893, 42.92005975500448],
            [2.8100984790458474, 42.90009411413206],
            [2.759801947696685, 42.86996414699731],
            [2.729838056680162, 42.83003286525246],
            [2.6800765948134373, 42.83003286525246],
            [2.6699102746471173, 42.839834179862564],
            [2.639946383630594, 42.83003286525246],
            [2.5998161724477518, 42.839834179862564],
            [2.5698522814312295, 42.839834179862564],
            [2.560221030747347, 42.849998506124884],
            [2.520090819564504, 42.839834179862564],
            [2.499758179231864, 42.849998506124884],
            [2.4601630375314585, 42.839834179862564],
            [2.400235255498414, 42.839834179862564],
            [2.369736294999453, 42.849998506124884],
            [2.3199748331327283, 42.83003286525246],
            [2.3397724039829306, 42.799902898117715],
            [2.3397724039829306, 42.77013594263519],
            [2.3601050443155707, 42.729841649238125],
            [2.290010942116205, 42.7000746937556],
            [2.260047051099683, 42.7000746937556],
            [2.2402494802494806, 42.680109052883175],
            [2.1899529489003173, 42.660143412010754],
            [2.170155378050115, 42.660143412010754],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 80, name: "Somme", REG: 32, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.94975161396214, 49.68006274275471],
            [2.9299540431119384, 49.68006274275471],
            [2.9101564722617352, 49.70002838362713],
            [2.880192581245213, 49.68006274275471],
            [2.859859940912573, 49.68006274275471],
            [2.8502286902286906, 49.660097101882286],
            [2.7897658387132074, 49.660097101882286],
            [2.7999321588795274, 49.62996713474754],
            [2.780134588029325, 49.61000149387512],
            [2.740004376846483, 49.62996713474754],
            [2.6998741656636396, 49.62016582013744],
            [2.6699102746471173, 49.59983716761279],
            [2.6699102746471173, 49.57987152674037],
            [2.650112703796915, 49.57007021213027],
            [2.629780063464274, 49.57987152674037],
            [2.620148812780392, 49.61000149387512],
            [2.5901849217638695, 49.61000149387512],
            [2.5500547105810263, 49.62016582013744],
            [2.509924499398184, 49.640131461009865],
            [2.4799606083816617, 49.62016582013744],
            [2.4697942882153407, 49.640131461009865],
            [2.409866506182296, 49.660097101882286],
            [2.3499387241492506, 49.660097101882286],
            [2.3199748331327283, 49.68986405736481],
            [2.290010942116205, 49.68006274275471],
            [2.260047051099683, 49.70002838362713],
            [2.149822737717475, 49.70002838362713],
            [2.1401914870335927, 49.68986405736481],
            [2.059931064667907, 49.68986405736481],
            [2.029967173651384, 49.70982969823723],
            [1.9802057117846594, 49.70982969823723],
            [1.9502418207681371, 49.70002838362713],
            [1.9197428602691762, 49.70982969823723],
            [1.8897789692526539, 49.70002838362713],
            [1.8501838275522484, 49.70002838362713],
            [1.8400175073859284, 49.70982969823723],
            [1.8400175073859284, 49.73995966537198],
            [1.8202199365357261, 49.73995966537198],
            [1.7800897253528838, 49.7599253062444],
            [1.7297931940037206, 49.810020914251574],
            [1.7297931940037206, 49.84015088138632],
            [1.680031732136995, 49.92001344487601],
            [1.6500678411204728, 49.93017777113833],
            [1.6201039501039505, 49.93017777113833],
            [1.5901400590874273, 49.95994472662086],
            [1.5302122770543827, 49.9998760083657],
            [1.4499518546886971, 50.04017030176278],
            [1.4601181748550172, 50.0601359426352],
            [1.4199879636721748, 50.0699372572453],
            [1.409821643505854, 50.0601359426352],
            [1.3798577524893316, 50.0699372572453],
            [1.4499518546886971, 50.10986853899014],
            [1.4697494255388994, 50.13999850612489],
            [1.4799157457052194, 50.17012847325964],
            [1.5098796367217417, 50.19989542874216],
            [1.550009847904585, 50.21005975500449],
            [1.5901400590874273, 50.190094114132066],
            [1.669865411970675, 50.190094114132066],
            [1.669865411970675, 50.21005975500449],
            [1.6201039501039505, 50.21986106961458],
            [1.5901400590874273, 50.260155363011656],
            [1.550009847904585, 50.260155363011656],
            [1.539843527738265, 50.300086644756504],
            [1.560176168070905, 50.359983567373774],
            [1.6099376299376305, 50.359983567373774],
            [1.6297352007878327, 50.370147893636094],
            [1.6297352007878327, 50.359983567373774],
            [1.6602341612867928, 50.32985360023902],
            [1.7597570850202429, 50.359983567373774],
            [1.799887296203086, 50.359983567373774],
            [1.8699813984024516, 50.32985360023902],
            [1.899945289418974, 50.3098879593666],
            [1.9197428602691762, 50.3098879593666],
            [1.9400755006018162, 50.32985360023902],
            [1.9598730714520194, 50.3098879593666],
            [1.9299091804354962, 50.300086644756504],
            [2.0000032826348617, 50.26995667762176],
            [2.029967173651384, 50.26995667762176],
            [2.0802637050005472, 50.249991036749336],
            [2.059931064667907, 50.23982671048701],
            [2.1000612758507495, 50.21005975500449],
            [2.249880730933363, 50.21005975500449],
            [2.270213371266003, 50.23002539587691],
            [2.300177262282526, 50.21005975500449],
            [2.3199748331327283, 50.21986106961458],
            [2.3301411532990484, 50.23982671048701],
            [2.3601050443155707, 50.21005975500449],
            [2.409866506182296, 50.23002539587691],
            [2.4499967173651385, 50.23002539587691],
            [2.499758179231864, 50.190094114132066],
            [2.4697942882153407, 50.190094114132066],
            [2.390068935332094, 50.15996414699731],
            [2.379902615165773, 50.10986853899014],
            [2.400235255498414, 50.10986853899014],
            [2.430199146514936, 50.08990289811772],
            [2.4499967173651385, 50.12003286525247],
            [2.4799606083816617, 50.13999850612489],
            [2.509924499398184, 50.13999850612489],
            [2.530257139730824, 50.12003286525247],
            [2.5500547105810263, 50.13999850612489],
            [2.5901849217638695, 50.13999850612489],
            [2.5698522814312295, 50.12003286525247],
            [2.5800186015975495, 50.10986853899014],
            [2.629780063464274, 50.10986853899014],
            [2.650112703796915, 50.08990289811772],
            [2.6998741656636396, 50.10006722438004],
            [2.7100404858299596, 50.12983417986257],
            [2.729838056680162, 50.12983417986257],
            [2.750170697012803, 50.10986853899014],
            [2.780134588029325, 50.10986853899014],
            [2.780134588029325, 50.08990289811772],
            [2.740004376846483, 50.04997161637287],
            [2.780134588029325, 50.04017030176278],
            [2.8202647992121683, 50.0699372572453],
            [2.859859940912573, 50.0601359426352],
            [2.880192581245213, 50.04017030176278],
            [2.9197877229456184, 50.04997161637287],
            [3.019845716161506, 50.04997161637287],
            [3.0300120363278262, 50.0601359426352],
            [3.0599759273443494, 50.04997161637287],
            [3.089939818360871, 50.04997161637287],
            [3.119903709377394, 50.03000597550045],
            [3.149867600393917, 50.03000597550045],
            [3.1702002407265573, 50.01004033462803],
            [3.1600339205602372, 49.9900746937556],
            [3.1702002407265573, 49.97010905288318],
            [3.1600339205602372, 49.95014341201076],
            [3.119903709377394, 49.92001344487601],
            [3.119903709377394, 49.88008216313116],
            [3.079773498194551, 49.869917836868844],
            [3.079773498194551, 49.849952195996416],
            [3.0599759273443494, 49.829986555123995],
            [3.089939818360871, 49.79005527337915],
            [3.0701422475106694, 49.770089632506725],
            [3.089939818360871, 49.7599253062444],
            [3.119903709377394, 49.70982969823723],
            [3.0498096071780294, 49.70982969823723],
            [3.0599759273443494, 49.68986405736481],
            [3.0300120363278262, 49.68006274275471],
            [2.989881825144983, 49.70982969823723],
            [2.94975161396214, 49.68986405736481],
            [2.94975161396214, 49.68006274275471],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 65,
        name: "Hautes-Pyrénées",
        REG: 76,
        CAT: 0,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-0.10977568661779191, 43.309934269495066],
              [-0.08997811576758963, 43.30013295488497],
              [-0.07981179560126961, 43.2598386614879],
              [-0.11994200678411193, 43.2500373468778],
              [-0.13973957763431422, 43.270002987750225],
              [-0.10977568661779191, 43.309934269495066],
            ],
          ],
          [
            [
              [-0.10977568661779191, 43.309934269495066],
              [-0.07018054491738734, 43.340064236629814],
              [-0.07018054491738734, 43.309934269495066],
              [-0.10977568661779191, 43.309934269495066],
            ],
          ],
          [
            [
              [0.4798708830287781, 42.7000746937556],
              [0.46007331217857583, 42.689910367493276],
              [0.43010942116205264, 42.689910367493276],
              [0.40014553014553034, 42.7000746937556],
              [0.37018163912900803, 42.720040334628024],
              [0.3300514279461648, 42.7098760083657],
              [0.3198851077798448, 42.689910367493276],
              [0.3000875369296425, 42.680109052883175],
              [0.2701236459131193, 42.689910367493276],
              [0.2599573257467993, 42.720040334628024],
              [0.21982711456395698, 42.720040334628024],
              [0.18023197286355153, 42.740005975500445],
              [0.1598993325309115, 42.720040334628024],
              [0.12993544151438918, 42.720040334628024],
              [0.1101378706641869, 42.7098760083657],
              [0.08980523033154597, 42.720040334628024],
              [0.07000765948134369, 42.7000746937556],
              [0.0202461976146191, 42.7000746937556],
              [-0.010252762884341848, 42.680109052883175],
              [-0.060014224751066436, 42.689910367493276],
              [-0.07018054491738734, 42.720040334628024],
              [-0.10977568661779191, 42.720040334628024],
              [-0.11994200678411193, 42.75017030176277],
              [-0.13973957763431422, 42.75997161637287],
              [-0.16007221796695514, 42.799902898117715],
              [-0.17023853813327516, 42.79010158350762],
              [-0.20020242914979747, 42.79010158350762],
              [-0.20983367983367973, 42.799902898117715],
              [-0.26013021118284296, 42.819868538990136],
              [-0.27992778203304525, 42.839834179862564],
              [-0.30989167304956755, 42.849998506124884],
              [-0.32005799321588757, 42.88012847325963],
              [-0.30989167304956755, 42.92005975500448],
              [-0.27992778203304525, 42.92986106961458],
              [-0.29009410219936527, 42.95999103674933],
              [-0.29009410219936527, 43.0100866447565],
              [-0.26013021118284296, 43.0100866447565],
              [-0.26013021118284296, 43.03985360023902],
              [-0.21999999999999975, 43.03005228562892],
              [-0.19003610898347745, 43.05001792650134],
              [-0.20020242914979747, 43.06998356737377],
              [-0.17986978881715743, 43.10991484911861],
              [-0.14990589780063424, 43.12988048999104],
              [-0.13010832695043195, 43.170174783388106],
              [-0.10977568661779191, 43.17997609799821],
              [-0.07018054491738734, 43.17997609799821],
              [-0.07018054491738734, 43.21990737974305],
              [-0.04021665390086415, 43.230071706005376],
              [-0.019884013568224113, 43.270002987750225],
              [-0.04021665390086415, 43.280167314012544],
              [-0.030050333734544132, 43.329899910367494],
              [0.010079877448298191, 43.329899910367494],
              [0.029877448298501363, 43.349865551239915],
              [-0.00008644271802182857, 43.369831192112336],
              [-0.00008644271802182857, 43.399961159247084],
              [0.010079877448298191, 43.41992680011951],
              [-0.019884013568224113, 43.43989244099193],
              [-0.04021665390086415, 43.41992680011951],
              [-0.07018054491738734, 43.43009112638183],
              [-0.060014224751066436, 43.45005676725425],
              [-0.07018054491738734, 43.459858081864354],
              [-0.030050333734544132, 43.47002240812668],
              [-0.049847904584746416, 43.50015237526143],
              [-0.04021665390086415, 43.52011801613385],
              [-0.060014224751066436, 43.52991933074395],
              [-0.07018054491738734, 43.54988497161637],
              [-0.10014443593390965, 43.58001493875112],
              [-0.07981179560126961, 43.59017926501345],
              [-0.07018054491738734, 43.61014490588587],
              [-0.019884013568224113, 43.61014490588587],
              [0.0202461976146191, 43.54008365700627],
              [0.04004376846482138, 43.54008365700627],
              [0.0502100886311414, 43.52011801613385],
              [0.1101378706641869, 43.52011801613385],
              [0.12993544151438918, 43.50015237526143],
              [0.12993544151438918, 43.47002240812668],
              [0.14973301236459147, 43.47002240812668],
              [0.1700656526972315, 43.43989244099193],
              [0.1401017616807092, 43.43009112638183],
              [0.1401017616807092, 43.41992680011951],
              [0.1700656526972315, 43.399961159247084],
              [0.18023197286355153, 43.369831192112336],
              [0.24015975489659702, 43.369831192112336],
              [0.3000875369296425, 43.39015984463699],
              [0.3000875369296425, 43.369831192112336],
              [0.3300514279461648, 43.369831192112336],
              [0.34021774811248484, 43.340064236629814],
              [0.3798128898128903, 43.36002987750224],
              [0.40014553014553034, 43.349865551239915],
              [0.40014553014553034, 43.329899910367494],
              [0.5499649852281436, 43.329899910367494],
              [0.6098927672611882, 43.309934269495066],
              [0.6398566582777114, 43.30013295488497],
              [0.6200590874275083, 43.280167314012544],
              [0.5499649852281436, 43.23987302061548],
              [0.5697625560783459, 43.21990737974305],
              [0.5499649852281436, 43.210106065132955],
              [0.5200010942116204, 43.210106065132955],
              [0.5200010942116204, 43.190140424260534],
              [0.5002035233614182, 43.170174783388106],
              [0.46007331217857583, 43.14984613086346],
              [0.4499069920122549, 43.12988048999104],
              [0.46007331217857583, 43.10991484911861],
              [0.49003720319509814, 43.12007917538094],
              [0.5002035233614182, 43.100113534508516],
              [0.5301674143779405, 43.08014789363609],
              [0.5601313053944637, 43.06998356737377],
              [0.5697625560783459, 43.03985360023902],
              [0.5397986650618227, 43.03985360023902],
              [0.5301674143779405, 42.99992231849417],
              [0.5499649852281436, 42.99992231849417],
              [0.5601313053944637, 43.01988795936659],
              [0.590095196410986, 43.01988795936659],
              [0.6098927672611882, 43.03005228562892],
              [0.6302254075938292, 42.99992231849417],
              [0.6200590874275083, 42.97015536301165],
              [0.6500229784440315, 42.95999103674933],
              [0.6302254075938292, 42.9400253958769],
              [0.600261516577306, 42.92986106961458],
              [0.5799288762446659, 42.86996414699731],
              [0.5601313053944637, 42.86016283238721],
              [0.5301674143779405, 42.86996414699731],
              [0.5002035233614182, 42.86996414699731],
              [0.4798708830287781, 42.88012847325963],
              [0.46007331217857583, 42.849998506124884],
              [0.46007331217857583, 42.740005975500445],
              [0.4499069920122549, 42.729841649238125],
              [0.4798708830287781, 42.7098760083657],
              [0.4798708830287781, 42.7000746937556],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: "09", name: "Ariège", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.8597702155596894, 42.83003286525246],
            [0.8399726447094871, 42.86996414699731],
            [0.8399726447094871, 42.90009411413206],
            [0.829806324543167, 42.92005975500448],
            [0.8399726447094871, 42.92986106961458],
            [0.8801028558923294, 42.92986106961458],
            [0.8897341065762117, 42.9400253958769],
            [0.8699365357260094, 42.95999103674933],
            [0.9100667469088526, 42.95999103674933],
            [0.9298643177590549, 42.97015536301165],
            [0.9801608491082181, 42.97015536301165],
            [1.0101247401247404, 43.0100866447565],
            [0.9897920997921004, 43.01988795936659],
            [0.9897920997921004, 43.08994920824619],
            [1.0101247401247404, 43.10991484911861],
            [1.0400886311412627, 43.100113534508516],
            [1.059886201991465, 43.14004481625336],
            [1.0898500930079882, 43.12988048999104],
            [1.1101827333406282, 43.14004481625336],
            [1.1198139840245105, 43.160010457125786],
            [1.1497778750410328, 43.14004481625336],
            [1.200074406390196, 43.12988048999104],
            [1.2198719772403983, 43.08994920824619],
            [1.2600021884232415, 43.08994920824619],
            [1.2600021884232415, 43.10991484911861],
            [1.3001323996060838, 43.12007917538094],
            [1.2701685085895615, 43.14984613086346],
            [1.2198719772403983, 43.14984613086346],
            [1.2300382974067183, 43.170174783388106],
            [1.2797997592734438, 43.19994173887063],
            [1.3001323996060838, 43.190140424260534],
            [1.3798577524893316, 43.21990737974305],
            [1.3702265018054494, 43.23987302061548],
            [1.3498938614728093, 43.23987302061548],
            [1.330096290622607, 43.2598386614879],
            [1.3001323996060838, 43.270002987750225],
            [1.3001323996060838, 43.289968628622645],
            [1.3498938614728093, 43.32009859575739],
            [1.3702265018054494, 43.309934269495066],
            [1.3798577524893316, 43.289968628622645],
            [1.4301542838384949, 43.2598386614879],
            [1.4199879636721748, 43.230071706005376],
            [1.4499518546886971, 43.210106065132955],
            [1.4697494255388994, 43.210106065132955],
            [1.5002483860378595, 43.2500373468778],
            [1.4900820658715395, 43.2598386614879],
            [1.5002483860378595, 43.289968628622645],
            [1.5200459568880627, 43.289968628622645],
            [1.5698074187547872, 43.270002987750225],
            [1.5997713097713095, 43.270002987750225],
            [1.6399015209541528, 43.2500373468778],
            [1.669865411970675, 43.280167314012544],
            [1.690198052303316, 43.270002987750225],
            [1.7201619433198383, 43.230071706005376],
            [1.7297931940037206, 43.190140424260534],
            [1.7501258343363606, 43.170174783388106],
            [1.8202199365357261, 43.14984613086346],
            [1.8501838275522484, 43.14984613086346],
            [1.899945289418974, 43.12988048999104],
            [1.9299091804354962, 43.12988048999104],
            [1.9502418207681371, 43.12007917538094],
            [1.9598730714520194, 43.06998356737377],
            [1.9400755006018162, 43.05981924111144],
            [1.9802057117846594, 43.03985360023902],
            [1.9898369624685417, 43.01988795936659],
            [1.9700393916183394, 43.0100866447565],
            [2.0000032826348617, 42.95999103674933],
            [1.9502418207681371, 42.95999103674933],
            [1.9299091804354962, 42.9400253958769],
            [1.9802057117846594, 42.92986106961458],
            [1.9898369624685417, 42.90989542874215],
            [1.9802057117846594, 42.88012847325963],
            [1.9898369624685417, 42.86996414699731],
            [1.8897789692526539, 42.849998506124884],
            [1.8598150782361307, 42.83003286525246],
            [1.8699813984024516, 42.81006722438004],
            [1.899945289418974, 42.799902898117715],
            [1.9299091804354962, 42.77013594263519],
            [1.9502418207681371, 42.740005975500445],
            [2.0000032826348617, 42.729841649238125],
            [2.059931064667907, 42.75997161637287],
            [2.0802637050005472, 42.75017030176277],
            [2.1102275960170696, 42.720040334628024],
            [2.159989057883795, 42.7000746937556],
            [2.1797866287339973, 42.680109052883175],
            [2.170155378050115, 42.660143412010754],
            [2.1102275960170696, 42.660143412010754],
            [2.0700973848342272, 42.669944726620855],
            [2.019800853485064, 42.64997908574843],
            [1.9898369624685417, 42.64997908574843],
            [1.9802057117846594, 42.61984911861368],
            [1.9502418207681371, 42.61984911861368],
            [1.9400755006018162, 42.610047804003585],
            [1.8897789692526539, 42.610047804003585],
            [1.8897789692526539, 42.59008216313116],
            [1.8699813984024516, 42.57991783686884],
            [1.8202199365357261, 42.57991783686884],
            [1.7902560455192038, 42.570116522258736],
            [1.7297931940037206, 42.59008216313116],
            [1.7399595141700406, 42.61984911861368],
            [1.6602341612867928, 42.61984911861368],
            [1.6500678411204728, 42.630013444876006],
            [1.5997713097713095, 42.630013444876006],
            [1.5698074187547872, 42.64997908574843],
            [1.4799157457052194, 42.64997908574843],
            [1.4697494255388994, 42.610047804003585],
            [1.4397855345223771, 42.59988347774126],
            [1.409821643505854, 42.64997908574843],
            [1.3900240726556516, 42.669944726620855],
            [1.3900240726556516, 42.689910367493276],
            [1.3600601816391293, 42.7000746937556],
            [1.3600601816391293, 42.720040334628024],
            [1.189908086223876, 42.720040334628024],
            [1.1701105153736737, 42.7098760083657],
            [1.1401466243571505, 42.729841649238125],
            [1.1299803041908305, 42.75017030176277],
            [1.0898500930079882, 42.779937257245294],
            [1.0502549513075827, 42.779937257245294],
            [1.0400886311412627, 42.79010158350762],
            [0.9801608491082181, 42.79010158350762],
            [0.9598282087755772, 42.81006722438004],
            [0.9298643177590549, 42.79010158350762],
            [0.8801028558923294, 42.81006722438004],
            [0.8597702155596894, 42.83003286525246],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 68, name: "Haut-Rhin", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7.130249480249481, 47.50017777113833],
            [7.1398807309333625, 47.529944726620855],
            [7.109916839916841, 47.5698760083657],
            [7.090119269066638, 47.5698760083657],
            [7.079952948900318, 47.60000597550045],
            [7.009858846700953, 47.60000597550045],
            [7.009858846700953, 47.6301359426352],
            [7.020025166867273, 47.65010158350762],
            [7.039822737717475, 47.65010158350762],
            [7.039822737717475, 47.69003286525247],
            [7.020025166867273, 47.72996414699731],
            [7.00022759601707, 47.74992978786973],
            [6.970263705000547, 47.74992978786973],
            [6.939764744501587, 47.76989542874216],
            [6.9098008534850655, 47.78005975500449],
            [6.860039391618339, 47.78005975500449],
            [6.849873071452019, 47.81999103674933],
            [6.870205711784659, 47.830155363011656],
            [6.900169602801182, 47.830155363011656],
            [6.9098008534850655, 47.85012100388408],
            [6.9098008534850655, 47.8798879593666],
            [6.9199671736513855, 47.89985360023902],
            [6.9199671736513855, 47.949949208246196],
            [6.960097384834227, 48.000044816253364],
            [7.00022759601707, 48.020010457125785],
            [7.030191487033593, 48.079907379743055],
            [7.049989057883795, 48.079907379743055],
            [7.079952948900318, 48.130002987750224],
            [7.060155378050115, 48.14016731401255],
            [7.079952948900318, 48.16013295488497],
            [7.079952948900318, 48.1800985957574],
            [7.109916839916841, 48.189899910367494],
            [7.130249480249481, 48.23999551837467],
            [7.160213371266004, 48.27012548550941],
            [7.169844621949886, 48.29989244099193],
            [7.199808512966409, 48.31005676725426],
            [7.250105044315572, 48.29989244099193],
            [7.2800689353320935, 48.29989244099193],
            [7.299866506182297, 48.27992680011951],
            [7.329830397198818, 48.27012548550941],
            [7.310032826348617, 48.25015984463699],
            [7.35016303753146, 48.25015984463699],
            [7.3999244993981845, 48.22983119211234],
            [7.4100908195645045, 48.22002987750224],
            [7.440054710581028, 48.22002987750224],
            [7.470018601597549, 48.20006423662982],
            [7.470018601597549, 48.16013295488497],
            [7.5197800634642755, 48.14996862862265],
            [7.5197800634642755, 48.130002987750224],
            [7.580242914979757, 48.119838661487904],
            [7.570076594813437, 48.09007170600538],
            [7.570076594813437, 48.039976097998206],
            [7.580242914979757, 48.020010457125785],
            [7.61020680599628, 48.000044816253364],
            [7.619838056680163, 47.96991484911862],
            [7.580242914979757, 47.92998356737377],
            [7.580242914979757, 47.890052285628926],
            [7.559910274647117, 47.8798879593666],
            [7.559910274647117, 47.83995667762175],
            [7.5299463836305955, 47.76989542874216],
            [7.549743954480797, 47.74012847325964],
            [7.540112703796916, 47.72016283238722],
            [7.510148812780392, 47.69983417986256],
            [7.5197800634642755, 47.65990289811772],
            [7.570076594813437, 47.6301359426352],
            [7.58987416566364, 47.61017030176277],
            [7.580242914979757, 47.58004033462802],
            [7.549743954480797, 47.5600746937556],
            [7.5197800634642755, 47.54991036749328],
            [7.5299463836305955, 47.529944726620855],
            [7.510148812780392, 47.50017777113833],
            [7.470018601597549, 47.479849118613686],
            [7.429888390414708, 47.50017777113833],
            [7.440054710581028, 47.459883477741265],
            [7.3897581792318645, 47.43011652225874],
            [7.35016303753146, 47.43011652225874],
            [7.33999671736514, 47.43991783686884],
            [7.299866506182297, 47.43991783686884],
            [7.250105044315572, 47.419952195996416],
            [7.23993872414925, 47.43991783686884],
            [7.209974833132729, 47.43011652225874],
            [7.169844621949886, 47.43991783686884],
            [7.190177262282526, 47.479849118613686],
            [7.130249480249481, 47.50017777113833],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 29, name: "Finistère", REG: 53, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-5.050072217966955, 48.45998057962355],
              [-5.090202429149798, 48.44001493875112],
              [-5.11, 48.45998057962355],
              [-5.080036108983478, 48.470144905885874],
              [-5.050072217966955, 48.45998057962355],
            ],
          ],
          [
            [
              [-4.770230878651931, 48.36015237526143],
              [-4.760064558485611, 48.36015237526143],
              [-4.770230878651931, 48.36015237526143],
              [-4.760064558485611, 48.36995368987153],
              [-4.790028449502134, 48.4200492978787],
              [-4.770230878651931, 48.470144905885874],
              [-4.760064558485611, 48.470144905885874],
              [-4.779862129335814, 48.49991186136839],
              [-4.760064558485611, 48.53004182850314],
              [-4.730100667469089, 48.560171795637885],
              [-4.700136776452566, 48.550007469375565],
              [-4.700136776452566, 48.569973110247986],
              [-4.6498402451034035, 48.569973110247986],
              [-4.630042674253201, 48.58013743651031],
              [-4.589912463070358, 48.560171795637885],
              [-4.579746142904038, 48.560171795637885],
              [-4.589912463070358, 48.560171795637885],
              [-4.579746142904038, 48.560171795637885],
              [-4.610245103402998, 48.58013743651031],
              [-4.600078783236678, 48.58993875112041],
              [-4.559948572053836, 48.600103077382734],
              [-4.5198183608709925, 48.58993875112041],
              [-4.50002079002079, 48.58993875112041],
              [-4.5198183608709925, 48.58993875112041],
              [-4.559948572053836, 48.600103077382734],
              [-4.5299846810373126, 48.629870032865256],
              [-4.51018711018711, 48.620068718255155],
              [-4.459890578837948, 48.629870032865256],
              [-4.429926687821425, 48.64983567373768],
              [-4.350201334938177, 48.679965640872425],
              [-4.289738483422694, 48.660000000000004],
              [-4.310071123755335, 48.64003435912758],
              [-4.280107232738812, 48.64983567373768],
              [-4.250143341722289, 48.64983567373768],
              [-4.220179450705767, 48.660000000000004],
              [-4.1902155596892445, 48.679965640872425],
              [-4.129752708173761, 48.699931281744846],
              [-4.109955137323558, 48.69012996713475],
              [-4.079991246307036, 48.69012996713475],
              [-4.0601936754568335, 48.679965640872425],
              [-4.0601936754568335, 48.69012996713475],
              [-3.990099573257468, 48.73006124887959],
              [-3.9601356822409457, 48.719896922617274],
              [-3.969766932924828, 48.679965640872425],
              [-3.9499693620746257, 48.670164326262324],
              [-3.9601356822409457, 48.64983567373768],
              [-3.9499693620746257, 48.64003435912758],
              [-3.9499693620746257, 48.64983567373768],
              [-3.920005471058103, 48.670164326262324],
              [-3.89004158004158, 48.670164326262324],
              [-3.9002079002079, 48.64983567373768],
              [-3.860077689025058, 48.629870032865256],
              [-3.860077689025058, 48.609904391992835],
              [-3.8499113688587374, 48.629870032865256],
              [-3.8499113688587374, 48.69012996713475],
              [-3.8199474778422147, 48.719896922617274],
              [-3.7899835868256924, 48.699931281744846],
              [-3.7600196958091696, 48.71009560800717],
              [-3.719889484626327, 48.71009560800717],
              [-3.7000919137761246, 48.69012996713475],
              [-3.659961702593282, 48.699931281744846],
              [-3.640164131743079, 48.69012996713475],
              [-3.640164131743079, 48.670164326262324],
              [-3.659961702593282, 48.660000000000004],
              [-3.640164131743079, 48.58993875112041],
              [-3.6102002407265568, 48.58993875112041],
              [-3.5497373892110735, 48.53984314311324],
              [-3.580236349710034, 48.49991186136839],
              [-3.6000339205602367, 48.49991186136839],
              [-3.6000339205602367, 48.470144905885874],
              [-3.570070029543714, 48.450179265013446],
              [-3.6000339205602367, 48.4200492978787],
              [-3.6000339205602367, 48.38991933074395],
              [-3.5599037093773935, 48.380118016133856],
              [-3.5497373892110735, 48.36995368987153],
              [-3.5599037093773935, 48.33982372273678],
              [-3.5497373892110735, 48.31005676725426],
              [-3.5299398183608712, 48.31985808186436],
              [-3.5401061385271912, 48.29989244099193],
              [-3.519773498194551, 48.27992680011951],
              [-3.5299398183608712, 48.25996115924709],
              [-3.5599037093773935, 48.22983119211234],
              [-3.519773498194551, 48.189899910367494],
              [-3.5599037093773935, 48.189899910367494],
              [-3.6497953824269613, 48.16013295488497],
              [-3.670128022759602, 48.14996862862265],
              [-3.7000919137761246, 48.14996862862265],
              [-3.730055804792647, 48.099873020615476],
              [-3.7000919137761246, 48.09007170600538],
              [-3.7000919137761246, 48.059941738870634],
              [-3.670128022759602, 48.05014042426053],
              [-3.659961702593282, 48.020010457125785],
              [-3.640164131743079, 47.98988048999104],
              [-3.5299398183608712, 47.98988048999104],
              [-3.4999759273443485, 47.980079175380936],
              [-3.480178356494146, 47.949949208246196],
              [-3.4598457161615057, 47.949949208246196],
              [-3.420250574461101, 47.96991484911862],
              [-3.3999179341284607, 47.96991484911862],
              [-3.38975161396214, 47.949949208246196],
              [-3.410084254294781, 47.91981924111145],
              [-3.3999179341284607, 47.890052285628926],
              [-3.4502144654776234, 47.85012100388408],
              [-3.4898096071780285, 47.830155363011656],
              [-3.510142247510669, 47.830155363011656],
              [-3.519773498194551, 47.85012100388408],
              [-3.5401061385271912, 47.85992231849418],
              [-3.5401061385271912, 47.83995667762175],
              [-3.5401061385271912, 47.81999103674933],
              [-3.519773498194551, 47.80002539587691],
              [-3.5299398183608712, 47.78986106961458],
              [-3.5299398183608712, 47.78005975500449],
              [-3.5401061385271912, 47.76009411413206],
              [-3.570070029543714, 47.76989542874216],
              [-3.619831491410439, 47.76989542874216],
              [-3.6497953824269613, 47.78005975500449],
              [-3.679759273443484, 47.78005975500449],
              [-3.719889484626327, 47.80002539587691],
              [-3.7000919137761246, 47.81999103674933],
              [-3.6497953824269613, 47.81999103674933],
              [-3.670128022759602, 47.830155363011656],
              [-3.7000919137761246, 47.81999103674933],
              [-3.730055804792647, 47.80002539587691],
              [-3.7498533756428496, 47.830155363011656],
              [-3.7498533756428496, 47.83995667762175],
              [-3.7498533756428496, 47.830155363011656],
              [-3.7498533756428496, 47.81999103674933],
              [-3.7402221249589673, 47.80002539587691],
              [-3.7600196958091696, 47.78986106961458],
              [-3.8097811576758946, 47.78986106961458],
              [-3.8397450486924174, 47.80002539587691],
              [-3.8499113688587374, 47.78986106961458],
              [-3.9002079002079, 47.83995667762175],
              [-3.9002079002079, 47.85012100388408],
              [-3.9098391508917825, 47.8700866447565],
              [-3.9499693620746257, 47.89985360023902],
              [-3.969766932924828, 47.890052285628926],
              [-3.990099573257468, 47.8798879593666],
              [-3.979933253091148, 47.85992231849418],
              [-4.0398610351241935, 47.85012100388408],
              [-4.090157566473357, 47.85992231849418],
              [-4.109955137323558, 47.8700866447565],
              [-4.120121457489879, 47.8798879593666],
              [-4.139919028340081, 47.89985360023902],
              [-4.129752708173761, 47.92998356737377],
              [-4.109955137323558, 47.940147893636095],
              [-4.099788817157238, 47.940147893636095],
              [-4.109955137323558, 47.940147893636095],
              [-4.109955137323558, 47.949949208246196],
              [-4.099788817157238, 47.96991484911862],
              [-4.109955137323558, 47.960113534508515],
              [-4.109955137323558, 47.949949208246196],
              [-4.109955137323558, 47.940147893636095],
              [-4.129752708173761, 47.92998356737377],
              [-4.139919028340081, 47.89985360023902],
              [-4.120121457489879, 47.8798879593666],
              [-4.109955137323558, 47.8700866447565],
              [-4.120121457489879, 47.8700866447565],
              [-4.169882919356604, 47.83995667762175],
              [-4.169882919356604, 47.8798879593666],
              [-4.199846810373127, 47.85992231849418],
              [-4.160251668672721, 47.830155363011656],
              [-4.169882919356604, 47.809826710487],
              [-4.210013130539447, 47.80002539587691],
              [-4.229810701389649, 47.78986106961458],
              [-4.289738483422694, 47.78986106961458],
              [-4.299904803589015, 47.80002539587691],
              [-4.36999890578838, 47.80002539587691],
              [-4.3801652259547, 47.81999103674933],
              [-4.350201334938177, 47.830155363011656],
              [-4.350201334938177, 47.85992231849418],
              [-4.36999890578838, 47.91001792650135],
              [-4.419760367655105, 47.960113534508515],
              [-4.459890578837948, 47.98988048999104],
              [-4.540151001203633, 48.009846130863465],
              [-4.5299846810373126, 48.039976097998206],
              [-4.540151001203633, 48.009846130863465],
              [-4.570114892220156, 48.000044816253364],
              [-4.600078783236678, 48.020010457125785],
              [-4.630042674253201, 48.03017478338811],
              [-4.730100667469089, 48.03017478338811],
              [-4.709768027136448, 48.039976097998206],
              [-4.709768027136448, 48.070106065132954],
              [-4.61987635408688, 48.070106065132954],
              [-4.579746142904038, 48.079907379743055],
              [-4.549782251887516, 48.079907379743055],
              [-4.5299846810373126, 48.09007170600538],
              [-4.48985446985447, 48.09007170600538],
              [-4.459890578837948, 48.099873020615476],
              [-4.429926687821425, 48.099873020615476],
              [-4.4101291169712225, 48.1100373468778],
              [-4.389796476638582, 48.099873020615476],
              [-4.359832585622059, 48.1100373468778],
              [-4.299904803589015, 48.09007170600538],
              [-4.280107232738812, 48.1100373468778],
              [-4.269940912572491, 48.14996862862265],
              [-4.299904803589015, 48.1800985957574],
              [-4.299904803589015, 48.20006423662982],
              [-4.329868694605537, 48.209865551239915],
              [-4.36999890578838, 48.209865551239915],
              [-4.419760367655105, 48.22983119211234],
              [-4.459890578837948, 48.23999551837467],
              [-4.48985446985447, 48.22983119211234],
              [-4.5198183608709925, 48.189899910367494],
              [-4.540151001203633, 48.1800985957574],
              [-4.559948572053836, 48.22983119211234],
              [-4.540151001203633, 48.23999551837467],
              [-4.559948572053836, 48.25996115924709],
              [-4.600078783236678, 48.25015984463699],
              [-4.630042674253201, 48.25996115924709],
              [-4.61987635408688, 48.27992680011951],
              [-4.600078783236678, 48.29009112638184],
              [-4.570114892220156, 48.29009112638184],
              [-4.579746142904038, 48.31985808186436],
              [-4.559948572053836, 48.33982372273678],
              [-4.5299846810373126, 48.33982372273678],
              [-4.559948572053836, 48.29989244099193],
              [-4.540151001203633, 48.27992680011951],
              [-4.5198183608709925, 48.29009112638184],
              [-4.50002079002079, 48.27992680011951],
              [-4.470056899004268, 48.29009112638184],
              [-4.419760367655105, 48.29009112638184],
              [-4.4101291169712225, 48.27992680011951],
              [-4.36999890578838, 48.27992680011951],
              [-4.310071123755335, 48.29989244099193],
              [-4.289738483422694, 48.29009112638184],
              [-4.280107232738812, 48.27012548550941],
              [-4.239977021555969, 48.25015984463699],
              [-4.220179450705767, 48.25996115924709],
              [-4.210013130539447, 48.25015984463699],
              [-4.139919028340081, 48.23999551837467],
              [-4.109955137323558, 48.23999551837467],
              [-4.139919028340081, 48.23999551837467],
              [-4.150085348506401, 48.25015984463699],
              [-4.210013130539447, 48.25015984463699],
              [-4.220179450705767, 48.25996115924709],
              [-4.239977021555969, 48.25015984463699],
              [-4.259774592406171, 48.27992680011951],
              [-4.229810701389649, 48.29009112638184],
              [-4.239977021555969, 48.31005676725426],
              [-4.289738483422694, 48.31005676725426],
              [-4.320237443921655, 48.33002240812668],
              [-4.280107232738812, 48.33982372273678],
              [-4.289738483422694, 48.34998804899911],
              [-4.299904803589015, 48.33982372273678],
              [-4.329868694605537, 48.33982372273678],
              [-4.340035014771857, 48.36015237526143],
              [-4.36999890578838, 48.34998804899911],
              [-4.36999890578838, 48.33002240812668],
              [-4.399962796804902, 48.33982372273678],
              [-4.450259328154065, 48.33002240812668],
              [-4.429926687821425, 48.36015237526143],
              [-4.36999890578838, 48.40008365700628],
              [-4.350201334938177, 48.40008365700628],
              [-4.310071123755335, 48.4200492978787],
              [-4.329868694605537, 48.4200492978787],
              [-4.36999890578838, 48.40008365700628],
              [-4.4101291169712225, 48.38991933074395],
              [-4.429926687821425, 48.40008365700628],
              [-4.5299846810373126, 48.36015237526143],
              [-4.559948572053836, 48.36015237526143],
              [-4.570114892220156, 48.34998804899911],
              [-4.610245103402998, 48.33982372273678],
              [-4.640208994419521, 48.33982372273678],
              [-4.679804136119926, 48.36015237526143],
              [-4.700136776452566, 48.34998804899911],
              [-4.709768027136448, 48.33002240812668],
              [-4.770230878651931, 48.33002240812668],
              [-4.770230878651931, 48.36015237526143],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 52, name: "Haute-Marne", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.369870883028779, 47.60000597550045],
            [5.3399069920122555, 47.61017030176277],
            [5.309943100995732, 47.61017030176277],
            [5.260181639129008, 47.58004033462802],
            [5.239848998796368, 47.60000597550045],
            [5.230217748112486, 47.6301359426352],
            [5.190087536929643, 47.65010158350762],
            [5.169754896597003, 47.65010158350762],
            [5.179921216763323, 47.67986853899014],
            [5.130159754896597, 47.65010158350762],
            [5.079863223547435, 47.65990289811772],
            [5.030101761680709, 47.69003286525247],
            [5.030101761680709, 47.70999850612489],
            [4.970173979647664, 47.69003286525247],
            [4.960007659481344, 47.70999850612489],
            [4.970173979647664, 47.74012847325964],
            [4.960007659481344, 47.76009411413206],
            [4.919877448298501, 47.76989542874216],
            [4.940210088631141, 47.78986106961458],
            [4.9899715504978674, 47.80002539587691],
            [4.979805230331547, 47.830155363011656],
            [4.960007659481344, 47.83995667762175],
            [4.949841339315024, 47.8700866447565],
            [4.930043768464821, 47.8700866447565],
            [4.91024619761462, 47.91981924111145],
            [4.8701159864317765, 47.91981924111145],
            [4.859949666265456, 47.89985360023902],
            [4.829985775248933, 47.91001792650135],
            [4.8701159864317765, 47.940147893636095],
            [4.849783346099136, 47.960113534508515],
            [4.800021884232412, 47.960113534508515],
            [4.78985556406609, 47.96991484911862],
            [4.810188204398732, 47.98988048999104],
            [4.78985556406609, 48.009846130863465],
            [4.7502604223656855, 48.000044816253364],
            [4.699963891016522, 48.020010457125785],
            [4.710130211182844, 48.05014042426053],
            [4.689797570850202, 48.070106065132954],
            [4.689797570850202, 48.09007170600538],
            [4.729927782033045, 48.119838661487904],
            [4.759891673049569, 48.119838661487904],
            [4.810188204398732, 48.099873020615476],
            [4.829985775248933, 48.1100373468778],
            [4.840152095415253, 48.16993426949507],
            [4.859949666265456, 48.189899910367494],
            [4.859949666265456, 48.209865551239915],
            [4.840152095415253, 48.25015984463699],
            [4.859949666265456, 48.27012548550941],
            [4.840152095415253, 48.27992680011951],
            [4.849783346099136, 48.29989244099193],
            [4.810188204398732, 48.31985808186436],
            [4.829985775248933, 48.33982372273678],
            [4.819819455082613, 48.34998804899911],
            [4.7502604223656855, 48.36995368987153],
            [4.759891673049569, 48.38991933074395],
            [4.699963891016522, 48.38991933074395],
            [4.680166320166321, 48.4200492978787],
            [4.689797570850202, 48.4298506124888],
            [4.640036108983478, 48.45998057962355],
            [4.659833679833681, 48.49991186136839],
            [4.680166320166321, 48.51987750224082],
            [4.670000000000001, 48.53004182850314],
            [4.670000000000001, 48.53984314311324],
            [4.719761461866725, 48.53984314311324],
            [4.78985556406609, 48.53004182850314],
            [4.780224313382209, 48.550007469375565],
            [4.78985556406609, 48.569973110247986],
            [4.770057993215889, 48.58993875112041],
            [4.829985775248933, 48.609904391992835],
            [4.849783346099136, 48.609904391992835],
            [4.849783346099136, 48.64003435912758],
            [4.840152095415253, 48.64983567373768],
            [4.770057993215889, 48.64983567373768],
            [4.780224313382209, 48.670164326262324],
            [4.8701159864317765, 48.670164326262324],
            [4.91024619761462, 48.69012996713475],
            [4.940210088631141, 48.679965640872425],
            [4.949841339315024, 48.69012996713475],
            [4.979805230331547, 48.69012996713475],
            [4.9899715504978674, 48.679965640872425],
            [5.009769121348069, 48.670164326262324],
            [4.9899715504978674, 48.64983567373768],
            [5.009769121348069, 48.609904391992835],
            [5.030101761680709, 48.609904391992835],
            [5.049899332530912, 48.629870032865256],
            [5.070231972863552, 48.600103077382734],
            [5.090029543713755, 48.58993875112041],
            [5.119993434730277, 48.600103077382734],
            [5.13979100558048, 48.560171795637885],
            [5.169754896597003, 48.560171795637885],
            [5.200253857095963, 48.550007469375565],
            [5.2098851077798445, 48.53004182850314],
            [5.230217748112486, 48.53004182850314],
            [5.269812889812891, 48.510076187630716],
            [5.3297406718459355, 48.510076187630716],
            [5.3500733121785755, 48.47994622049597],
            [5.369870883028779, 48.47994622049597],
            [5.3998347740453, 48.45998057962355],
            [5.429798665061823, 48.4298506124888],
            [5.4699288762446665, 48.4200492978787],
            [5.410001094211622, 48.38991933074395],
            [5.439964985228143, 48.380118016133856],
            [5.420167414377942, 48.36015237526143],
            [5.420167414377942, 48.33982372273678],
            [5.4597625560783465, 48.34998804899911],
            [5.529856658277711, 48.34998804899911],
            [5.52022540759383, 48.33982372273678],
            [5.5897844403107575, 48.27992680011951],
            [5.6101170806433975, 48.29009112638184],
            [5.650247291826239, 48.27012548550941],
            [5.640080971659919, 48.23999551837467],
            [5.710175073859285, 48.22002987750224],
            [5.729972644709487, 48.189899910367494],
            [5.700008753692965, 48.189899910367494],
            [5.680211182842762, 48.1800985957574],
            [5.689842433526645, 48.14996862862265],
            [5.659878542510122, 48.130002987750224],
            [5.629914651493599, 48.079907379743055],
            [5.700008753692965, 48.079907379743055],
            [5.719806324543167, 48.05014042426053],
            [5.740138964875807, 48.05014042426053],
            [5.75993653572601, 48.03017478338811],
            [5.779734106576213, 48.03017478338811],
            [5.789900426742533, 48.009846130863465],
            [5.779734106576213, 47.980079175380936],
            [5.789900426742533, 47.949949208246196],
            [5.830030637925375, 47.960113534508515],
            [5.859994528941898, 47.949949208246196],
            [5.879792099792101, 47.92998356737377],
            [5.889958419958421, 47.89985360023902],
            [5.849828208775578, 47.89985360023902],
            [5.8198643177590546, 47.8700866447565],
            [5.800066746908853, 47.85992231849418],
            [5.75993653572601, 47.85992231849418],
            [5.740138964875807, 47.85012100388408],
            [5.74977021555969, 47.81999103674933],
            [5.700008753692965, 47.81999103674933],
            [5.689842433526645, 47.809826710487],
            [5.680211182842762, 47.76989542874216],
            [5.710175073859285, 47.76989542874216],
            [5.710175073859285, 47.74012847325964],
            [5.680211182842762, 47.70999850612489],
            [5.689842433526645, 47.67986853899014],
            [5.6101170806433975, 47.67986853899014],
            [5.569986869460554, 47.70999850612489],
            [5.529856658277711, 47.67006722438004],
            [5.51005908742751, 47.67986853899014],
            [5.4800951964109865, 47.67986853899014],
            [5.4699288762446665, 47.67006722438004],
            [5.410001094211622, 47.67006722438004],
            [5.3998347740453, 47.65010158350762],
            [5.369870883028779, 47.61997161637287],
            [5.369870883028779, 47.60000597550045],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: "2A",
        name: "Corse-du-Sud",
        REG: 94,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8.57975270817376, 42.179878996115924],
            [8.57975270817376, 42.21000896325067],
            [8.57012145748988, 42.24013893038542],
            [8.640215559689246, 42.26010457125784],
            [8.689977021555968, 42.26010457125784],
            [8.660013130539447, 42.30003585300269],
            [8.6000853485064, 42.32000149387511],
            [8.630049239522926, 42.33996713474753],
            [8.619882919356606, 42.35013146100986],
            [8.58991902834008, 42.35013146100986],
            [8.57012145748988, 42.33996713474753],
            [8.54978881715724, 42.35013146100986],
            [8.54978881715724, 42.37009710188228],
            [8.57012145748988, 42.37989841649238],
            [8.6000853485064, 42.37009710188228],
            [8.640215559689246, 42.37009710188228],
            [8.679810701389648, 42.35013146100986],
            [8.709774592406173, 42.35013146100986],
            [8.719940912572493, 42.33996713474753],
            [8.760071123755335, 42.33996713474753],
            [8.770237443921655, 42.32000149387511],
            [8.790035014771856, 42.33016582013744],
            [8.819998905788381, 42.32000149387511],
            [8.860129116971223, 42.33016582013744],
            [8.860129116971223, 42.30003585300269],
            [8.890093007987744, 42.28007021213026],
            [8.879926687821424, 42.26990588586794],
            [8.900259328154064, 42.249940244995514],
            [8.920056899004269, 42.26010457125784],
            [8.95002079002079, 42.22997460412309],
            [8.969818360870992, 42.22997460412309],
            [8.990151001203632, 42.21000896325067],
            [9.020114892220157, 42.199844636988345],
            [9.050078783236678, 42.21000896325067],
            [9.050078783236678, 42.17007768150582],
            [9.06987635408688, 42.17007768150582],
            [9.0800426742532, 42.119982073498655],
            [9.110006565269725, 42.119982073498655],
            [9.129804136119926, 42.08985210636391],
            [9.129804136119926, 42.04992082461906],
            [9.159768027136447, 42.02995518374664],
            [9.220230878651932, 42.02995518374664],
            [9.220230878651932, 41.97985957573947],
            [9.229862129335814, 41.97005826112937],
            [9.220230878651932, 41.950092620256946],
            [9.229862129335814, 41.93012697938452],
            [9.220230878651932, 41.9101613385121],
            [9.250194769668454, 41.89999701224978],
            [9.229862129335814, 41.86006573050493],
            [9.269992340518659, 41.84010008963251],
            [9.340086442718022, 41.84010008963251],
            [9.380216653900867, 41.86986704511503],
            [9.400014224751068, 41.86006573050493],
            [9.410180544917388, 41.82013444876008],
            [9.400014224751068, 41.80016880788766],
            [9.400014224751068, 41.77003884075291],
            [9.410180544917388, 41.75987451449058],
            [9.400014224751068, 41.73010755900806],
            [9.400014224751068, 41.69017627726322],
            [9.370050333734547, 41.68001195100089],
            [9.380216653900867, 41.649881983866145],
            [9.350252762884342, 41.64008066925605],
            [9.350252762884342, 41.62011502838362],
            [9.3101225517015, 41.62011502838362],
            [9.280158660684979, 41.6001493875112],
            [9.29995623153518, 41.589985061248875],
            [9.319753802385382, 41.6001493875112],
            [9.350252762884342, 41.579820734986555],
            [9.350252762884342, 41.55985509411413],
            [9.319753802385382, 41.55985509411413],
            [9.28978991136886, 41.530088138631605],
            [9.280158660684979, 41.510122497759184],
            [9.280158660684979, 41.479992530624436],
            [9.220230878651932, 41.42989692261727],
            [9.220230878651932, 41.409931281744846],
            [9.250194769668454, 41.409931281744846],
            [9.220230878651932, 41.380164326262324],
            [9.220230878651932, 41.37],
            [9.180100667469091, 41.37],
            [9.129804136119926, 41.400129967134745],
            [9.099840245103405, 41.38996564087242],
            [9.090208994419523, 41.400129967134745],
            [9.110006565269725, 41.420095608007166],
            [9.099840245103405, 41.440061248879594],
            [9.06987635408688, 41.440061248879594],
            [9.050078783236678, 41.460026889752015],
            [9.020114892220157, 41.460026889752015],
            [8.990151001203632, 41.49015685688676],
            [8.920056899004269, 41.49015685688676],
            [8.909890578837949, 41.510122497759184],
            [8.849962796804903, 41.530088138631605],
            [8.839796476638583, 41.55005377950403],
            [8.809832585622061, 41.55005377950403],
            [8.790035014771856, 41.589985061248875],
            [8.790035014771856, 41.629916342993724],
            [8.819998905788381, 41.629916342993724],
            [8.849962796804903, 41.649881983866145],
            [8.879926687821424, 41.649881983866145],
            [8.879926687821424, 41.66984762473857],
            [8.920056899004269, 41.68001195100089],
            [8.879926687821424, 41.69997759187331],
            [8.839796476638583, 41.69997759187331],
            [8.830165225954701, 41.71014191813564],
            [8.800201334938176, 41.71014191813564],
            [8.770237443921655, 41.71994323274574],
            [8.770237443921655, 41.73990887361816],
            [8.719940912572493, 41.71994323274574],
            [8.709774592406173, 41.73990887361816],
            [8.660013130539447, 41.73990887361816],
            [8.709774592406173, 41.75987451449058],
            [8.730107232738813, 41.77984015536301],
            [8.730107232738813, 41.80016880788766],
            [8.770237443921655, 41.80997012249776],
            [8.790035014771856, 41.8499014042426],
            [8.800201334938176, 41.9101613385121],
            [8.779868694605536, 41.93012697938452],
            [8.719940912572493, 41.9101613385121],
            [8.640215559689246, 41.9101613385121],
            [8.61025166867272, 41.89999701224978],
            [8.619882919356606, 41.93012697938452],
            [8.58991902834008, 41.95989393486704],
            [8.61025166867272, 41.97005826112937],
            [8.649846810373127, 41.97005826112937],
            [8.660013130539447, 42.009989542874216],
            [8.689977021555968, 42.02995518374664],
            [8.719940912572493, 42.02995518374664],
            [8.749904803589015, 42.04992082461906],
            [8.719940912572493, 42.060085150881385],
            [8.719940912572493, 42.080050791753806],
            [8.700143341722288, 42.11018075888855],
            [8.660013130539447, 42.11018075888855],
            [8.649846810373127, 42.119982073498655],
            [8.619882919356606, 42.119982073498655],
            [8.58991902834008, 42.139947714371075],
            [8.57975270817376, 42.179878996115924],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: "04",
        name: "Alpes-de-Haute-Provence",
        REG: 93,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6.640125834336362, 43.78983567373768],
            [6.589829302987199, 43.810164326262324],
            [6.550234161286794, 43.780034359127576],
            [6.5400678411204725, 43.8],
            [6.519735200787832, 43.810164326262324],
            [6.489771309771311, 43.78983567373768],
            [6.420212277054383, 43.78983567373768],
            [6.410045956888063, 43.760068718255155],
            [6.38008206587154, 43.74010307738273],
            [6.350118174855017, 43.74010307738273],
            [6.260226501805449, 43.780034359127576],
            [6.260226501805449, 43.8],
            [6.209929970456288, 43.8],
            [6.179966079439764, 43.76987003286525],
            [6.169799759273444, 43.74990439199283],
            [6.139835868256921, 43.74010307738273],
            [6.109871977240398, 43.74990439199283],
            [6.100240726556517, 43.72993875112041],
            [6.0697417660575566, 43.700171795637885],
            [6.049944195207353, 43.700171795637885],
            [6.039777875041033, 43.67984314311323],
            [6.01998030419083, 43.67004182850314],
            [5.970218842324106, 43.720137436510306],
            [5.940254951307584, 43.72993875112041],
            [5.940254951307584, 43.74990439199283],
            [5.919922310974942, 43.760068718255155],
            [5.889958419958421, 43.72993875112041],
            [5.849828208775578, 43.720137436510306],
            [5.830030637925375, 43.74990439199283],
            [5.779734106576213, 43.760068718255155],
            [5.75993653572601, 43.72993875112041],
            [5.719806324543167, 43.760068718255155],
            [5.710175073859285, 43.780034359127576],
            [5.689842433526645, 43.780034359127576],
            [5.650247291826239, 43.830129967134745],
            [5.569986869460554, 43.830129967134745],
            [5.540022978444031, 43.819965640872425],
            [5.550189298610351, 43.850095608007166],
            [5.569986869460554, 43.85989692261727],
            [5.6101170806433975, 43.92015685688676],
            [5.580153189626874, 43.92015685688676],
            [5.569986869460554, 43.940122497759184],
            [5.540022978444031, 43.940122497759184],
            [5.51005908742751, 43.949923812369285],
            [5.51005908742751, 43.969889453241706],
            [5.540022978444031, 44.01998506124888],
            [5.540022978444031, 44.07008066925605],
            [5.49989276726119, 44.05991634299372],
            [5.49989276726119, 44.12017627726322],
            [5.540022978444031, 44.12997759187332],
            [5.559820549294234, 44.16990887361816],
            [5.580153189626874, 44.18987451449059],
            [5.6101170806433975, 44.18987451449059],
            [5.640080971659919, 44.16990887361816],
            [5.629914651493599, 44.14994323274574],
            [5.680211182842762, 44.14994323274574],
            [5.680211182842762, 44.16010755900807],
            [5.640080971659919, 44.16990887361816],
            [5.650247291826239, 44.18987451449059],
            [5.680211182842762, 44.18987451449059],
            [5.689842433526645, 44.18987451449059],
            [5.710175073859285, 44.20003884075291],
            [5.740138964875807, 44.20003884075291],
            [5.74977021555969, 44.20984015536301],
            [5.810233067075173, 44.20984015536301],
            [5.830030637925375, 44.20003884075291],
            [5.859994528941898, 44.20003884075291],
            [5.900124740124741, 44.18987451449059],
            [5.909755990808622, 44.20003884075291],
            [5.870160849108218, 44.22000448162534],
            [5.859994528941898, 44.250134448760086],
            [5.830030637925375, 44.25993576337018],
            [5.8198643177590546, 44.27990140424261],
            [5.849828208775578, 44.29986704511503],
            [5.879792099792101, 44.29006573050493],
            [5.879792099792101, 44.27010008963251],
            [5.909755990808622, 44.250134448760086],
            [5.919922310974942, 44.27990140424261],
            [5.909755990808622, 44.29006573050493],
            [5.930088631141262, 44.31003137137735],
            [5.900124740124741, 44.31983268598745],
            [5.900124740124741, 44.3401613385121],
            [5.919922310974942, 44.3401613385121],
            [5.940254951307584, 44.360126979384525],
            [5.949886201991466, 44.40005826112937],
            [5.970218842324106, 44.40005826112937],
            [6.01998030419083, 44.420023902001795],
            [6.030146624357152, 44.439989542874216],
            [6.079908086223877, 44.45995518374664],
            [6.109871977240398, 44.479920824619064],
            [6.160168508589561, 44.45995518374664],
            [6.179966079439764, 44.420023902001795],
            [6.199763650289966, 44.420023902001795],
            [6.230262610788928, 44.380092620256946],
            [6.260226501805449, 44.40985957573947],
            [6.250060181639129, 44.439989542874216],
            [6.230262610788928, 44.45995518374664],
            [6.290190392821972, 44.479920824619064],
            [6.299821643505855, 44.47011951000896],
            [6.329785534522377, 44.47011951000896],
            [6.350118174855017, 44.499886465491485],
            [6.350118174855017, 44.519852106363906],
            [6.39024838603786, 44.499886465491485],
            [6.410045956888063, 44.47011951000896],
            [6.450176168070905, 44.47011951000896],
            [6.469973738921108, 44.45015386913654],
            [6.62995951417004, 44.45015386913654],
            [6.640125834336362, 44.490085150881384],
            [6.6700897253528835, 44.499886465491485],
            [6.6802560455192035, 44.54018075888855],
            [6.74018382755225, 44.549982073498654],
            [6.749815078236131, 44.569947714371075],
            [6.819909180435498, 44.609878996115924],
            [6.849873071452019, 44.609878996115924],
            [6.860039391618339, 44.629844636988345],
            [6.879836962468542, 44.629844636988345],
            [6.9098008534850655, 44.65997460412309],
            [6.949931064667907, 44.650173289513],
            [6.949931064667907, 44.62004332237825],
            [6.9301334938177055, 44.569947714371075],
            [6.879836962468542, 44.549982073498654],
            [6.860039391618339, 44.53001643262623],
            [6.860039391618339, 44.499886465491485],
            [6.900169602801182, 44.47011951000896],
            [6.9098008534850655, 44.45015386913654],
            [6.939764744501587, 44.439989542874216],
            [6.9301334938177055, 44.420023902001795],
            [6.890003282634862, 44.420023902001795],
            [6.900169602801182, 44.380092620256946],
            [6.890003282634862, 44.360126979384525],
            [6.8001116095852945, 44.31983268598745],
            [6.7899452894189745, 44.27010008963251],
            [6.759981398402451, 44.27990140424261],
            [6.759981398402451, 44.25993576337018],
            [6.719851187219608, 44.250134448760086],
            [6.719851187219608, 44.20984015536301],
            [6.689887296203087, 44.16990887361816],
            [6.710219936535727, 44.12017627726322],
            [6.759981398402451, 44.079881983866144],
            [6.749815078236131, 44.0399507021213],
            [6.840241820768138, 43.989855094114134],
            [6.849873071452019, 43.96008813863161],
            [6.890003282634862, 43.929958171496864],
            [6.9098008534850655, 43.929958171496864],
            [6.939764744501587, 43.899828204362116],
            [6.9199671736513855, 43.890026889752015],
            [6.879836962468542, 43.890026889752015],
            [6.879836962468542, 43.899828204362116],
            [6.830075500601818, 43.92015685688676],
            [6.8001116095852945, 43.909992530624436],
            [6.779778969252654, 43.879862563489695],
            [6.749815078236131, 43.870061248879594],
            [6.719851187219608, 43.879862563489695],
            [6.6802560455192035, 43.850095608007166],
            [6.6700897253528835, 43.830129967134745],
            [6.700053616369407, 43.819965640872425],
            [6.689887296203087, 43.8],
            [6.640125834336362, 43.8],
            [6.640125834336362, 43.78983567373768],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 30, name: "Gard", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.230172885436043, 43.459858081864354],
            [4.160078783236679, 43.47002240812668],
            [4.130114892220155, 43.4899880489991],
            [4.119948572053835, 43.52011801613385],
            [4.130114892220155, 43.54008365700627],
            [4.100151001203634, 43.54988497161637],
            [4.109782251887515, 43.56985061248879],
            [4.079818360870992, 43.59017926501345],
            [4.1499124630703585, 43.59017926501345],
            [4.170245103402999, 43.61014490588587],
            [4.190042674253202, 43.65007618763072],
            [4.160078783236679, 43.69000746937556],
            [4.170245103402999, 43.700171795637885],
            [4.1397461429040385, 43.74010307738273],
            [4.109782251887515, 43.74010307738273],
            [4.079818360870992, 43.76987003286525],
            [4.049854469854471, 43.76987003286525],
            [4.049854469854471, 43.78983567373768],
            [4.000093007987744, 43.810164326262324],
            [3.970129116971223, 43.8],
            [3.959962796804903, 43.819965640872425],
            [3.9797603676551043, 43.830129967134745],
            [3.959962796804903, 43.850095608007166],
            [3.9198325856220597, 43.85989692261727],
            [3.9000350147718565, 43.879862563489695],
            [3.859904803589015, 43.879862563489695],
            [3.849738483422695, 43.870061248879594],
            [3.819774592406172, 43.870061248879594],
            [3.7999770215559687, 43.890026889752015],
            [3.829940912572492, 43.940122497759184],
            [3.7999770215559687, 43.940122497759184],
            [3.7898107013896487, 43.969889453241706],
            [3.729882919356604, 43.969889453241706],
            [3.6801214574898795, 43.949923812369285],
            [3.6699551373235595, 43.909992530624436],
            [3.6399912463070363, 43.909992530624436],
            [3.620193675456833, 43.92015685688676],
            [3.5800634642739917, 43.879862563489695],
            [3.5800634642739917, 43.839931281744846],
            [3.5500995732574685, 43.850095608007166],
            [3.5201356822409453, 43.870061248879594],
            [3.5099693620746253, 43.899828204362116],
            [3.480005471058104, 43.890026889752015],
            [3.4602079002079007, 43.870061248879594],
            [3.4302440091913775, 43.870061248879594],
            [3.4398752598752607, 43.899828204362116],
            [3.4200776890250575, 43.909992530624436],
            [3.360149906992013, 43.909992530624436],
            [3.349983586825693, 43.940122497759184],
            [3.3799474778422143, 43.96008813863161],
            [3.4099113688587375, 43.969889453241706],
            [3.4200776890250575, 43.989855094114134],
            [3.4398752598752607, 44.000019420376454],
            [3.4398752598752607, 44.01998506124888],
            [3.4200776890250575, 44.0399507021213],
            [3.390113798008536, 44.05011502838363],
            [3.349983586825693, 44.05011502838363],
            [3.3200196958091697, 44.079881983866144],
            [3.3002221249589683, 44.07008066925605],
            [3.270258233942445, 44.09004631012847],
            [3.3098533756428496, 44.11001195100089],
            [3.3200196958091697, 44.14014191813564],
            [3.339817266659373, 44.16010755900807],
            [3.3697811576758943, 44.16990887361816],
            [3.4302440091913775, 44.14994323274574],
            [3.4398752598752607, 44.12997759187332],
            [3.480005471058104, 44.12017627726322],
            [3.5099693620746253, 44.12997759187332],
            [3.5399332530911485, 44.11001195100089],
            [3.5698971441076717, 44.12017627726322],
            [3.6298249261407163, 44.12017627726322],
            [3.6399912463070363, 44.14014191813564],
            [3.6298249261407163, 44.16010755900807],
            [3.6399912463070363, 44.18007319988049],
            [3.6699551373235595, 44.18007319988049],
            [3.7598468103731273, 44.14994323274574],
            [3.7999770215559687, 44.12997759187332],
            [3.829940912572492, 44.14014191813564],
            [3.870071123755335, 44.12997759187332],
            [3.8898686946055365, 44.14994323274574],
            [3.9299989057883797, 44.16010755900807],
            [3.9299989057883797, 44.18007319988049],
            [3.970129116971223, 44.16010755900807],
            [3.959962796804903, 44.18987451449059],
            [3.9401652259546998, 44.18987451449059],
            [3.949796476638583, 44.22000448162534],
            [3.949796476638583, 44.27010008963251],
            [3.9198325856220597, 44.31003137137735],
            [3.949796476638583, 44.32999701224978],
            [3.8898686946055365, 44.38989393486705],
            [3.9198325856220597, 44.40985957573947],
            [3.949796476638583, 44.40005826112937],
            [3.970129116971223, 44.42982521661189],
            [4.000093007987744, 44.45995518374664],
            [4.040223219170588, 44.45015386913654],
            [4.049854469854471, 44.40985957573947],
            [4.070187110187111, 44.40985957573947],
            [4.049854469854471, 44.380092620256946],
            [4.049854469854471, 44.31983268598745],
            [4.070187110187111, 44.32999701224978],
            [4.119948572053835, 44.32999701224978],
            [4.1397461429040385, 44.31003137137735],
            [4.17987635408688, 44.31983268598745],
            [4.190042674253202, 44.29986704511503],
            [4.220006565269723, 44.29006573050493],
            [4.260136776452566, 44.25993576337018],
            [4.27993434730277, 44.27010008963251],
            [4.30026698763541, 44.31003137137735],
            [4.320064558485611, 44.31983268598745],
            [4.330230878651931, 44.3401613385121],
            [4.369826020352337, 44.3401613385121],
            [4.390158660684977, 44.3499626531222],
            [4.399789911368859, 44.32999701224978],
            [4.390158660684977, 44.29006573050493],
            [4.429753802385382, 44.29006573050493],
            [4.450086442718022, 44.29986704511503],
            [4.450086442718022, 44.32999701224978],
            [4.460252762884342, 44.3401613385121],
            [4.510014224751067, 44.3401613385121],
            [4.52981179560127, 44.31983268598745],
            [4.55014443593391, 44.31983268598745],
            [4.559775686617793, 44.29986704511503],
            [4.599905897800634, 44.29006573050493],
            [4.650202429149798, 44.27010008963251],
            [4.650202429149798, 44.25993576337018],
            [4.680166320166321, 44.23016880788766],
            [4.710130211182844, 44.20984015536301],
            [4.719761461866725, 44.18987451449059],
            [4.719761461866725, 44.14014191813564],
            [4.710130211182844, 44.11001195100089],
            [4.729927782033045, 44.079881983866144],
            [4.759891673049569, 44.079881983866144],
            [4.78985556406609, 44.07008066925605],
            [4.78985556406609, 44.05991634299372],
            [4.840152095415253, 44.009820734986555],
            [4.840152095415253, 43.989855094114134],
            [4.810188204398732, 43.989855094114134],
            [4.810188204398732, 43.96008813863161],
            [4.7400941021993654, 43.92015685688676],
            [4.710130211182844, 43.899828204362116],
            [4.670000000000001, 43.879862563489695],
            [4.640036108983478, 43.850095608007166],
            [4.650202429149798, 43.810164326262324],
            [4.650202429149798, 43.780034359127576],
            [4.629869788817158, 43.760068718255155],
            [4.610072217966954, 43.720137436510306],
            [4.629869788817158, 43.69000746937556],
            [4.599905897800634, 43.69000746937556],
            [4.53997811576759, 43.70997311024798],
            [4.520180544917387, 43.700171795637885],
            [4.490216653900865, 43.700171795637885],
            [4.480050333734545, 43.67004182850314],
            [4.450086442718022, 43.65987750224081],
            [4.429753802385382, 43.61994622049597],
            [4.469884013568225, 43.59998057962354],
            [4.450086442718022, 43.58001493875112],
            [4.429753802385382, 43.58001493875112],
            [4.350028449502134, 43.54008365700627],
            [4.320064558485611, 43.52991933074395],
            [4.29010066746909, 43.50995368987152],
            [4.239804136119926, 43.50015237526143],
            [4.230172885436043, 43.459858081864354],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 89, name: "Yonne", REG: 27, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.9802505744611016, 47.5698760083657],
            [2.9599179341284616, 47.5698760083657],
            [2.9599179341284616, 47.589841649238124],
            [2.9401203632782584, 47.60000597550045],
            [2.9299540431119384, 47.6301359426352],
            [2.94975161396214, 47.65010158350762],
            [2.9299540431119384, 47.65990289811772],
            [2.9197877229456184, 47.67986853899014],
            [2.889823831929095, 47.69983417986256],
            [2.880192581245213, 47.72016283238722],
            [2.8502286902286906, 47.72996414699731],
            [2.859859940912573, 47.74992978786973],
            [2.8502286902286906, 47.76009411413206],
            [2.9299540431119384, 47.76009411413206],
            [2.9802505744611016, 47.78005975500449],
            [2.989881825144983, 47.78986106961458],
            [3.019845716161506, 47.78986106961458],
            [3.0300120363278262, 47.80002539587691],
            [3.010214465477623, 47.830155363011656],
            [3.0300120363278262, 47.83995667762175],
            [3.010214465477623, 47.8798879593666],
            [3.010214465477623, 47.89985360023902],
            [3.079773498194551, 47.92998356737377],
            [3.109737389211074, 47.960113534508515],
            [3.130070029543714, 47.96991484911862],
            [3.119903709377394, 47.98988048999104],
            [3.119903709377394, 48.03017478338811],
            [3.089939818360871, 48.05014042426053],
            [3.0599759273443494, 48.059941738870634],
            [3.0401783564941463, 48.09007170600538],
            [3.0401783564941463, 48.119838661487904],
            [3.019845716161506, 48.14016731401255],
            [2.989881825144983, 48.14996862862265],
            [2.9599179341284616, 48.14996862862265],
            [2.9401203632782584, 48.16013295488497],
            [2.9299540431119384, 48.1800985957574],
            [2.9599179341284616, 48.189899910367494],
            [3.010214465477623, 48.22002987750224],
            [3.0401783564941463, 48.27012548550941],
            [3.019845716161506, 48.31005676725426],
            [3.0401783564941463, 48.33002240812668],
            [3.0498096071780294, 48.36015237526143],
            [3.100106138527191, 48.36015237526143],
            [3.119903709377394, 48.36995368987153],
            [3.249925593609805, 48.36995368987153],
            [3.2798894846263265, 48.380118016133856],
            [3.3098533756428496, 48.36995368987153],
            [3.349983586825693, 48.36995368987153],
            [3.360149906992013, 48.380118016133856],
            [3.3799474778422143, 48.40008365700628],
            [3.4099113688587375, 48.38991933074395],
            [3.4302440091913775, 48.36015237526143],
            [3.4500415800415807, 48.36995368987153],
            [3.4998030419083053, 48.36995368987153],
            [3.5297669329248285, 48.33982372273678],
            [3.5500995732574685, 48.33002240812668],
            [3.5602658934237885, 48.31005676725426],
            [3.5902297844403117, 48.29989244099193],
            [3.5800634642739917, 48.27992680011951],
            [3.620193675456833, 48.27012548550941],
            [3.599861035124193, 48.23999551837467],
            [3.620193675456833, 48.22983119211234],
            [3.610027355290513, 48.209865551239915],
            [3.5800634642739917, 48.189899910367494],
            [3.5902297844403117, 48.1800985957574],
            [3.620193675456833, 48.189899910367494],
            [3.6597888171572377, 48.16013295488497],
            [3.689752708173761, 48.14996862862265],
            [3.720251668672721, 48.14996862862265],
            [3.710085348506401, 48.16993426949507],
            [3.750215559689244, 48.16993426949507],
            [3.740049239522924, 48.130002987750224],
            [3.7700131305394473, 48.130002987750224],
            [3.7999770215559687, 48.1100373468778],
            [3.7999770215559687, 48.09007170600538],
            [3.829940912572492, 48.059941738870634],
            [3.849738483422695, 48.03017478338811],
            [3.870071123755335, 48.020010457125785],
            [3.840107232738812, 48.000044816253364],
            [3.849738483422695, 47.980079175380936],
            [3.880237443921655, 47.980079175380936],
            [3.9000350147718565, 48.000044816253364],
            [3.9102013349381766, 47.960113534508515],
            [3.8898686946055365, 47.92998356737377],
            [3.949796476638583, 47.92998356737377],
            [3.959962796804903, 47.940147893636095],
            [3.9899266878214243, 47.92998356737377],
            [4.049854469854471, 47.92998356737377],
            [4.060020790020791, 47.949949208246196],
            [4.119948572053835, 47.92998356737377],
            [4.170245103402999, 47.960113534508515],
            [4.190042674253202, 47.940147893636095],
            [4.209840245103403, 47.949949208246196],
            [4.200208994419522, 47.96991484911862],
            [4.230172885436043, 47.96991484911862],
            [4.220006565269723, 47.949949208246196],
            [4.269768027136448, 47.91981924111145],
            [4.29010066746909, 47.92998356737377],
            [4.309898238319291, 47.91981924111145],
            [4.309898238319291, 47.89985360023902],
            [4.269768027136448, 47.89985360023902],
            [4.249970456286246, 47.8798879593666],
            [4.260136776452566, 47.8700866447565],
            [4.260136776452566, 47.83995667762175],
            [4.29010066746909, 47.85012100388408],
            [4.320064558485611, 47.85012100388408],
            [4.320064558485611, 47.809826710487],
            [4.339862129335814, 47.76989542874216],
            [4.29010066746909, 47.72996414699731],
            [4.27993434730277, 47.74012847325964],
            [4.239804136119926, 47.72016283238722],
            [4.269768027136448, 47.69983417986256],
            [4.230172885436043, 47.67986853899014],
            [4.249970456286246, 47.65990289811772],
            [4.220006565269723, 47.6301359426352],
            [4.220006565269723, 47.60000597550045],
            [4.200208994419522, 47.60000597550045],
            [4.190042674253202, 47.5698760083657],
            [4.119948572053835, 47.509979085748434],
            [4.119948572053835, 47.479849118613686],
            [4.130114892220155, 47.470047804003585],
            [4.119948572053835, 47.43991783686884],
            [4.079818360870992, 47.43991783686884],
            [4.070187110187111, 47.399986555123995],
            [4.079818360870992, 47.380020914251574],
            [4.100151001203634, 47.36985658798925],
            [4.109782251887515, 47.340089632506725],
            [4.049854469854471, 47.340089632506725],
            [4.030056899004268, 47.3299253062444],
            [4.030056899004268, 47.30995966537198],
            [4.000093007987744, 47.30995966537198],
            [3.9797603676551043, 47.320123991634304],
            [3.959962796804903, 47.36985658798925],
            [3.9401652259546998, 47.380020914251574],
            [3.9102013349381766, 47.380020914251574],
            [3.870071123755335, 47.36985658798925],
            [3.859904803589015, 47.38982222886167],
            [3.8898686946055365, 47.410150881386315],
            [3.880237443921655, 47.43011652225874],
            [3.849738483422695, 47.43011652225874],
            [3.840107232738812, 47.410150881386315],
            [3.819774592406172, 47.399986555123995],
            [3.8101433417222887, 47.380020914251574],
            [3.7801794507057673, 47.399986555123995],
            [3.720251668672721, 47.399986555123995],
            [3.699919028340081, 47.43011652225874],
            [3.6801214574898795, 47.43011652225874],
            [3.6597888171572377, 47.450082163131164],
            [3.610027355290513, 47.470047804003585],
            [3.5800634642739917, 47.459883477741265],
            [3.5800634642739917, 47.50017777113833],
            [3.5500995732574685, 47.50017777113833],
            [3.5099693620746253, 47.529944726620855],
            [3.5099693620746253, 47.54991036749328],
            [3.490171791224424, 47.5600746937556],
            [3.490171791224424, 47.49001344487601],
            [3.4500415800415807, 47.509979085748434],
            [3.390113798008536, 47.509979085748434],
            [3.390113798008536, 47.50017777113833],
            [3.349983586825693, 47.479849118613686],
            [3.2900558047926465, 47.50017777113833],
            [3.270258233942445, 47.49001344487601],
            [3.239759273443485, 47.49001344487601],
            [3.2001641317430787, 47.52014341201075],
            [3.1600339205602372, 47.52014341201075],
            [3.140236349710034, 47.54010905288318],
            [3.119903709377394, 47.54010905288318],
            [3.119903709377394, 47.58004033462802],
            [3.089939818360871, 47.589841649238124],
            [3.0599759273443494, 47.5698760083657],
            [3.019845716161506, 47.5600746937556],
            [2.9802505744611016, 47.5698760083657],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 35,
        name: "Ille-et-Vilaine",
        REG: 53,
        CAT: 0,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-1.990009847904585, 48.58013743651031],
              [-2.009807418754787, 48.569973110247986],
              [-2.03977130977131, 48.53984314311324],
              [-2.06010395010395, 48.569973110247986],
              [-2.0900678411204727, 48.569973110247986],
              [-2.1200317321369955, 48.58993875112041],
              [-2.1200317321369955, 48.600103077382734],
              [-2.1499956231535178, 48.629870032865256],
              [-2.1301980523033155, 48.64003435912758],
              [-2.04993762993763, 48.64003435912758],
              [-2.019973738921107, 48.600103077382734],
              [-1.990009847904585, 48.58013743651031],
            ],
          ],
          [
            [
              [-2.1002341612867927, 47.6301359426352],
              [-2.109865411970675, 47.65010158350762],
              [-2.1002341612867927, 47.67986853899014],
              [-2.1200317321369955, 47.67986853899014],
              [-2.1200317321369955, 47.70999850612489],
              [-2.1301980523033155, 47.72016283238722],
              [-2.109865411970675, 47.74012847325964],
              [-2.06010395010395, 47.74012847325964],
              [-2.0900678411204727, 47.76009411413206],
              [-2.1301980523033155, 47.76009411413206],
              [-2.0697352007878322, 47.78986106961458],
              [-2.0697352007878322, 47.809826710487],
              [-2.03977130977131, 47.830155363011656],
              [-2.0697352007878322, 47.85012100388408],
              [-2.1002341612867927, 47.83995667762175],
              [-2.109865411970675, 47.890052285628926],
              [-2.0900678411204727, 47.89985360023902],
              [-2.0799015209541527, 47.91981924111145],
              [-2.1398293029871978, 47.980079175380936],
              [-2.1799595141700405, 47.980079175380936],
              [-2.2398872962030856, 48.000044816253364],
              [-2.290183827552249, 47.98988048999104],
              [-2.2800175073859283, 48.020010457125785],
              [-2.250053616369406, 48.05014042426053],
              [-2.1901258343363605, 48.05014042426053],
              [-2.1697931940037205, 48.059941738870634],
              [-2.1697931940037205, 48.079907379743055],
              [-2.2200897253528833, 48.079907379743055],
              [-2.2398872962030856, 48.059941738870634],
              [-2.260219936535726, 48.1100373468778],
              [-2.290183827552249, 48.130002987750224],
              [-2.2800175073859283, 48.14996862862265],
              [-2.250053616369406, 48.14996862862265],
              [-2.2200897253528833, 48.16993426949507],
              [-2.2200897253528833, 48.20006423662982],
              [-2.2302560455192033, 48.209865551239915],
              [-2.1901258343363605, 48.22002987750224],
              [-2.1799595141700405, 48.25015984463699],
              [-2.1499956231535178, 48.25996115924709],
              [-2.1200317321369955, 48.25996115924709],
              [-2.04993762993763, 48.29009112638184],
              [-2.000176168070905, 48.27992680011951],
              [-2.000176168070905, 48.29989244099193],
              [-1.9600459568880622, 48.29009112638184],
              [-1.9600459568880622, 48.31985808186436],
              [-1.9498796367217421, 48.33982372273678],
              [-1.9300820658715394, 48.34998804899911],
              [-1.9498796367217421, 48.36995368987153],
              [-1.9402483860378599, 48.38991933074395],
              [-1.9402483860378599, 48.4200492978787],
              [-1.9498796367217421, 48.450179265013446],
              [-1.9300820658715394, 48.45998057962355],
              [-1.9300820658715394, 48.47994622049597],
              [-1.9097494255388994, 48.51987750224082],
              [-1.9300820658715394, 48.53984314311324],
              [-1.9498796367217421, 48.53984314311324],
              [-1.9702122770543822, 48.569973110247986],
              [-1.990009847904585, 48.58013743651031],
              [-1.9702122770543822, 48.58993875112041],
              [-2.000176168070905, 48.58993875112041],
              [-2.009807418754787, 48.609904391992835],
              [-2.0301400590874277, 48.629870032865256],
              [-2.019973738921107, 48.64983567373768],
              [-1.990009847904585, 48.660000000000004],
              [-1.9798435277382644, 48.679965640872425],
              [-1.9600459568880622, 48.69012996713475],
              [-1.900118174855017, 48.69012996713475],
              [-1.8701542838384944, 48.699931281744846],
              [-1.8401903928219716, 48.679965640872425],
              [-1.8599879636721743, 48.670164326262324],
              [-1.8701542838384944, 48.64003435912758],
              [-1.8599879636721743, 48.620068718255155],
              [-1.8198577524893316, 48.609904391992835],
              [-1.7898938614728088, 48.609904391992835],
              [-1.7700962906226065, 48.600103077382734],
              [-1.6700382974067187, 48.609904391992835],
              [-1.640074406390196, 48.609904391992835],
              [-1.5699803041908305, 48.629870032865256],
              [-1.5699803041908305, 48.609904391992835],
              [-1.5400164131743082, 48.600103077382734],
              [-1.5400164131743082, 48.58013743651031],
              [-1.5202188423241054, 48.569973110247986],
              [-1.5298500930079877, 48.550007469375565],
              [-1.4902549513075831, 48.490110546758295],
              [-1.4501247401247404, 48.490110546758295],
              [-1.4297920997920999, 48.45998057962355],
              [-1.3698643177590548, 48.45998057962355],
              [-1.329734106576212, 48.49991186136839],
              [-1.2997702155596893, 48.49991186136839],
              [-1.279972644709487, 48.510076187630716],
              [-1.2698063245431666, 48.53004182850314],
              [-1.2500087536929643, 48.53984314311324],
              [-1.2098785425101215, 48.53984314311324],
              [-1.2002472918262392, 48.53004182850314],
              [-1.1697483313272787, 48.53004182850314],
              [-1.1601170806433965, 48.51987750224082],
              [-1.1199868694605537, 48.51987750224082],
              [-1.100189298610351, 48.510076187630716],
              [-1.0702254075938287, 48.510076187630716],
              [-1.079856658277711, 48.490110546758295],
              [-1.0702254075938287, 48.47994622049597],
              [-1.0702254075938287, 48.450179265013446],
              [-1.079856658277711, 48.4200492978787],
              [-1.0600590874275087, 48.380118016133856],
              [-1.0600590874275087, 48.33982372273678],
              [-1.0498927672611886, 48.33002240812668],
              [-1.0600590874275087, 48.31005676725426],
              [-1.090022978444031, 48.29009112638184],
              [-1.100189298610351, 48.25015984463699],
              [-1.0702254075938287, 48.20006423662982],
              [-1.079856658277711, 48.1800985957574],
              [-1.0600590874275087, 48.16013295488497],
              [-1.0600590874275087, 48.130002987750224],
              [-1.0498927672611886, 48.09007170600538],
              [-1.0300951964109855, 48.070106065132954],
              [-1.0300951964109855, 48.03017478338811],
              [-1.0199288762446654, 48.000044816253364],
              [-1.0498927672611886, 47.980079175380936],
              [-1.079856658277711, 47.980079175380936],
              [-1.090022978444031, 47.98988048999104],
              [-1.1199868694605537, 47.98988048999104],
              [-1.1301531896268737, 47.96991484911862],
              [-1.1601170806433965, 47.960113534508515],
              [-1.1601170806433965, 47.92998356737377],
              [-1.2002472918262392, 47.890052285628926],
              [-1.1900809716599192, 47.8700866447565],
              [-1.2200448626764415, 47.85012100388408],
              [-1.2200448626764415, 47.81999103674933],
              [-1.2398424335266442, 47.809826710487],
              [-1.2500087536929643, 47.78005975500449],
              [-1.339900426742532, 47.78986106961458],
              [-1.3602330670751726, 47.80002539587691],
              [-1.3901969580916949, 47.830155363011656],
              [-1.4800886311412627, 47.830155363011656],
              [-1.4699223109749426, 47.809826710487],
              [-1.4800886311412627, 47.80002539587691],
              [-1.5100525221577854, 47.80002539587691],
              [-1.5298500930079877, 47.78005975500449],
              [-1.5897778750410332, 47.78005975500449],
              [-1.6101105153736732, 47.76009411413206],
              [-1.629908086223876, 47.76009411413206],
              [-1.640074406390196, 47.72016283238722],
              [-1.6598719772403983, 47.70999850612489],
              [-1.7101685085895615, 47.70999850612489],
              [-1.7299660794397638, 47.69983417986256],
              [-1.749763650289966, 47.70999850612489],
              [-1.7898938614728088, 47.69983417986256],
              [-1.8198577524893316, 47.70999850612489],
              [-1.8599879636721743, 47.70999850612489],
              [-1.8797855345223766, 47.69983417986256],
              [-1.9402483860378599, 47.69003286525247],
              [-1.9702122770543822, 47.69003286525247],
              [-2.009807418754787, 47.67006722438004],
              [-2.03977130977131, 47.67006722438004],
              [-2.04993762993763, 47.65010158350762],
              [-2.0799015209541527, 47.65010158350762],
              [-2.1002341612867927, 47.6301359426352],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 27, name: "Eure", REG: 28, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.4799157457052194, 49.00994323274575],
            [1.4697494255388994, 48.98997759187332],
            [1.5002483860378595, 48.9700119510009],
            [1.5002483860378595, 48.93988198386615],
            [1.4601181748550172, 48.93988198386615],
            [1.4499518546886971, 48.91991634299373],
            [1.4697494255388994, 48.8999507021213],
            [1.4601181748550172, 48.86982073498656],
            [1.4301542838384949, 48.86982073498656],
            [1.4001903928219717, 48.86001942037646],
            [1.3600601816391293, 48.82988945324171],
            [1.3798577524893316, 48.78995817149686],
            [1.330096290622607, 48.759828204362115],
            [1.3001323996060838, 48.76999253062444],
            [1.2797997592734438, 48.759828204362115],
            [1.2498358682569215, 48.76999253062444],
            [1.1599441952073537, 48.76999253062444],
            [1.1497778750410328, 48.78995817149686],
            [1.1198139840245105, 48.78995817149686],
            [1.1101827333406282, 48.75002688975202],
            [1.070052522157786, 48.75002688975202],
            [1.0400886311412627, 48.73006124887959],
            [0.9598282087755772, 48.73006124887959],
            [0.9202330670751726, 48.71009560800717],
            [0.8801028558923294, 48.719896922617274],
            [0.8501389648758071, 48.679965640872425],
            [0.8100087536929648, 48.670164326262324],
            [0.7698785425101216, 48.670164326262324],
            [0.7602472918262393, 48.679965640872425],
            [0.7698785425101216, 48.699931281744846],
            [0.7297483313272792, 48.699931281744846],
            [0.7399146514935993, 48.719896922617274],
            [0.7800448626764416, 48.739862563489694],
            [0.7500809716599193, 48.759828204362115],
            [0.7602472918262393, 48.76999253062444],
            [0.7297483313272792, 48.78995817149686],
            [0.6901531896268738, 48.78995817149686],
            [0.6302254075938292, 48.82988945324171],
            [0.6098927672611882, 48.86001942037646],
            [0.6098927672611882, 48.87998506124888],
            [0.5799288762446659, 48.89014938751121],
            [0.5499649852281436, 48.87998506124888],
            [0.5002035233614182, 48.87998506124888],
            [0.47023963234489585, 48.89014938751121],
            [0.4199431009957326, 48.89014938751121],
            [0.3899792099792103, 48.91011502838363],
            [0.4097767808294126, 48.95004631012848],
            [0.43010942116205264, 48.9700119510009],
            [0.43010942116205264, 49.00014191813565],
            [0.4499069920122549, 49.02010755900807],
            [0.3798128898128903, 49.040073199880496],
            [0.3798128898128903, 49.06984015536301],
            [0.4097767808294126, 49.08000448162534],
            [0.4097767808294126, 49.11993576337019],
            [0.43010942116205264, 49.150065730504934],
            [0.3899792099792103, 49.150065730504934],
            [0.3899792099792103, 49.220126979384524],
            [0.34021774811248484, 49.229928293994625],
            [0.34021774811248484, 49.249893934867046],
            [0.3798128898128903, 49.26005826112937],
            [0.3798128898128903, 49.289825216611895],
            [0.3498489987963671, 49.299989542874215],
            [0.3198851077798448, 49.280023902001794],
            [0.3198851077798448, 49.31015386913654],
            [0.31025385709596254, 49.31995518374664],
            [0.3198851077798448, 49.339920824619064],
            [0.3000875369296425, 49.37005079175381],
            [0.31025385709596254, 49.39001643262623],
            [0.3000875369296425, 49.42994771437108],
            [0.34021774811248484, 49.44011204063341],
            [0.37018163912900803, 49.44011204063341],
            [0.3899792099792103, 49.4499133552435],
            [0.4397406718459349, 49.46007768150583],
            [0.47023963234489585, 49.48004332237825],
            [0.5200010942116204, 49.48004332237825],
            [0.5799288762446659, 49.42994771437108],
            [0.6098927672611882, 49.42994771437108],
            [0.6398566582777114, 49.44011204063341],
            [0.6601892986103515, 49.42014639976098],
            [0.6901531896268738, 49.40998207349866],
            [0.7399146514935993, 49.40998207349866],
            [0.7698785425101216, 49.42014639976098],
            [0.7800448626764416, 49.40998207349866],
            [0.8100087536929648, 49.40998207349866],
            [0.829806324543167, 49.39001643262623],
            [0.8597702155596894, 49.39001643262623],
            [0.8801028558923294, 49.37005079175381],
            [0.9202330670751726, 49.39001643262623],
            [0.9202330670751726, 49.339920824619064],
            [0.8897341065762117, 49.35008515088139],
            [0.8501389648758071, 49.33011951000897],
            [0.8597702155596894, 49.31995518374664],
            [0.8999004267425326, 49.31995518374664],
            [0.9501969580916949, 49.299989542874215],
            [0.9897920997921004, 49.26005826112937],
            [0.9999584199584204, 49.249893934867046],
            [1.0400886311412627, 49.26005826112937],
            [1.070052522157786, 49.280023902001794],
            [1.0502549513075827, 49.299989542874215],
            [1.070052522157786, 49.31015386913654],
            [1.1299803041908305, 49.31015386913654],
            [1.1497778750410328, 49.339920824619064],
            [1.200074406390196, 49.339920824619064],
            [1.200074406390196, 49.35008515088139],
            [1.2701685085895615, 49.35008515088139],
            [1.2899660794397638, 49.359886465491485],
            [1.2899660794397638, 49.39001643262623],
            [1.3199299704562861, 49.40998207349866],
            [1.309763650289966, 49.42994771437108],
            [1.340262610788927, 49.44011204063341],
            [1.409821643505854, 49.46007768150583],
            [1.4397855345223771, 49.46007768150583],
            [1.4499518546886971, 49.4499133552435],
            [1.4900820658715395, 49.4499133552435],
            [1.5002483860378595, 49.44011204063341],
            [1.5799737389211073, 49.44011204063341],
            [1.6099376299376305, 49.40998207349866],
            [1.6500678411204728, 49.40018075888856],
            [1.669865411970675, 49.40998207349866],
            [1.690198052303316, 49.39001643262623],
            [1.7099956231535183, 49.40998207349866],
            [1.7201619433198383, 49.40018075888856],
            [1.7597570850202429, 49.359886465491485],
            [1.7699234051865629, 49.339920824619064],
            [1.7699234051865629, 49.289825216611895],
            [1.799887296203086, 49.269859575739474],
            [1.7902560455192038, 49.249893934867046],
            [1.7501258343363606, 49.269859575739474],
            [1.7297931940037206, 49.269859575739474],
            [1.6998293029871983, 49.249893934867046],
            [1.6998293029871983, 49.229928293994625],
            [1.680031732136995, 49.209962653122204],
            [1.669865411970675, 49.170031371377355],
            [1.6500678411204728, 49.130100089632506],
            [1.6201039501039505, 49.099970122497766],
            [1.6099376299376305, 49.08000448162534],
            [1.5698074187547872, 49.08000448162534],
            [1.560176168070905, 49.06984015536301],
            [1.5200459568880627, 49.06984015536301],
            [1.4799157457052194, 49.04987451449059],
            [1.4499518546886971, 49.04987451449059],
            [1.4799157457052194, 49.00994323274575],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 54,
        name: "Meurthe-et-Moselle",
        REG: 44,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.77010285589233, 48.49991186136839],
            [5.75993653572601, 48.51987750224082],
            [5.779734106576213, 48.53984314311324],
            [5.75993653572601, 48.550007469375565],
            [5.729972644709487, 48.550007469375565],
            [5.710175073859285, 48.569973110247986],
            [5.719806324543167, 48.58993875112041],
            [5.74977021555969, 48.609904391992835],
            [5.800066746908853, 48.609904391992835],
            [5.800066746908853, 48.629870032865256],
            [5.75993653572601, 48.620068718255155],
            [5.740138964875807, 48.660000000000004],
            [5.75993653572601, 48.69012996713475],
            [5.74977021555969, 48.71009560800717],
            [5.719806324543167, 48.73006124887959],
            [5.719806324543167, 48.75002688975202],
            [5.77010285589233, 48.78995817149686],
            [5.779734106576213, 48.84005377950403],
            [5.77010285589233, 48.86982073498656],
            [5.789900426742533, 48.89014938751121],
            [5.74977021555969, 48.91991634299373],
            [5.779734106576213, 48.93008066925605],
            [5.800066746908853, 48.95004631012848],
            [5.830030637925375, 48.93988198386615],
            [5.849828208775578, 48.95984762473857],
            [5.830030637925375, 48.980176277263226],
            [5.8198643177590546, 49.02010755900807],
            [5.849828208775578, 49.040073199880496],
            [5.840196958091696, 49.06984015536301],
            [5.810233067075173, 49.06003884075292],
            [5.8198643177590546, 49.110134448760085],
            [5.75993653572601, 49.110134448760085],
            [5.74977021555969, 49.11993576337019],
            [5.75993653572601, 49.13990140424261],
            [5.74977021555969, 49.15986704511503],
            [5.77010285589233, 49.2001613385121],
            [5.729972644709487, 49.2001613385121],
            [5.719806324543167, 49.220126979384524],
            [5.740138964875807, 49.229928293994625],
            [5.719806324543167, 49.249893934867046],
            [5.719806324543167, 49.269859575739474],
            [5.75993653572601, 49.280023902001794],
            [5.77010285589233, 49.299989542874215],
            [5.75993653572601, 49.31015386913654],
            [5.729972644709487, 49.31015386913654],
            [5.719806324543167, 49.33011951000897],
            [5.740138964875807, 49.339920824619064],
            [5.740138964875807, 49.359886465491485],
            [5.710175073859285, 49.359886465491485],
            [5.710175073859285, 49.37985210636391],
            [5.689842433526645, 49.39001643262623],
            [5.680211182842762, 49.42014639976098],
            [5.629914651493599, 49.44011204063341],
            [5.619748331327279, 49.42014639976098],
            [5.550189298610351, 49.42014639976098],
            [5.529856658277711, 49.40998207349866],
            [5.49989276726119, 49.40998207349866],
            [5.4800951964109865, 49.40018075888856],
            [5.4902615165773065, 49.40998207349866],
            [5.4800951964109865, 49.42994771437108],
            [5.4902615165773065, 49.4499133552435],
            [5.4597625560783465, 49.46987899611592],
            [5.4699288762446665, 49.48004332237825],
            [5.4597625560783465, 49.48004332237825],
            [5.4699288762446665, 49.48004332237825],
            [5.4699288762446665, 49.50000896325068],
            [5.4800951964109865, 49.510173289513],
            [5.529856658277711, 49.510173289513],
            [5.550189298610351, 49.53013893038542],
            [5.569986869460554, 49.53013893038542],
            [5.6101170806433975, 49.510173289513],
            [5.619748331327279, 49.53013893038542],
            [5.650247291826239, 49.55010457125785],
            [5.689842433526645, 49.55010457125785],
            [5.700008753692965, 49.53994024499552],
            [5.75993653572601, 49.53994024499552],
            [5.75993653572601, 49.55990588586795],
            [5.800066746908853, 49.55010457125785],
            [5.810233067075173, 49.53994024499552],
            [5.840196958091696, 49.53994024499552],
            [5.840196958091696, 49.5199746041231],
            [5.859994528941898, 49.50000896325068],
            [5.889958419958421, 49.50000896325068],
            [5.900124740124741, 49.48004332237825],
            [5.930088631141262, 49.46987899611592],
            [5.940254951307584, 49.42994771437108],
            [5.919922310974942, 49.42014639976098],
            [5.940254951307584, 49.37985210636391],
            [5.930088631141262, 49.37005079175381],
            [5.960052522157786, 49.35008515088139],
            [5.949886201991466, 49.33011951000897],
            [5.990016413174309, 49.31015386913654],
            [6.00981398402451, 49.31015386913654],
            [6.000182733340629, 49.280023902001794],
            [6.00981398402451, 49.26005826112937],
            [6.030146624357152, 49.249893934867046],
            [6.030146624357152, 49.229928293994625],
            [6.00981398402451, 49.220126979384524],
            [5.979850093007989, 49.189997012249776],
            [6.01998030419083, 49.170031371377355],
            [6.000182733340629, 49.150065730504934],
            [5.979850093007989, 49.13990140424261],
            [6.000182733340629, 49.110134448760085],
            [5.930088631141262, 49.110134448760085],
            [5.930088631141262, 49.08000448162534],
            [5.970218842324106, 49.040073199880496],
            [5.990016413174309, 49.040073199880496],
            [6.039777875041033, 49.00994323274575],
            [6.039777875041033, 48.98997759187332],
            [6.0697417660575566, 48.980176277263226],
            [6.079908086223877, 48.95984762473857],
            [6.109871977240398, 48.9700119510009],
            [6.13020461757304, 48.93988198386615],
            [6.220096290622608, 48.93988198386615],
            [6.239893861472809, 48.91991634299373],
            [6.260226501805449, 48.93008066925605],
            [6.290190392821972, 48.93008066925605],
            [6.309987963672175, 48.91011502838363],
            [6.309987963672175, 48.86001942037646],
            [6.290190392821972, 48.84005377950403],
            [6.329785534522377, 48.82008813863161],
            [6.3597494255389, 48.78015685688677],
            [6.39024838603786, 48.78015685688677],
            [6.429843527738265, 48.78995817149686],
            [6.450176168070905, 48.76999253062444],
            [6.489771309771311, 48.76999253062444],
            [6.510103950103951, 48.75002688975202],
            [6.5400678411204725, 48.75002688975202],
            [6.559865411970676, 48.759828204362115],
            [6.580198052303316, 48.73006124887959],
            [6.640125834336362, 48.699931281744846],
            [6.6599234051865634, 48.71009560800717],
            [6.689887296203087, 48.670164326262324],
            [6.73001750738593, 48.660000000000004],
            [6.759981398402451, 48.670164326262324],
            [6.759981398402451, 48.64983567373768],
            [6.779778969252654, 48.64003435912758],
            [6.809742860269176, 48.64983567373768],
            [6.849873071452019, 48.620068718255155],
            [6.890003282634862, 48.629870032865256],
            [6.9098008534850655, 48.620068718255155],
            [6.939764744501587, 48.620068718255155],
            [6.960097384834227, 48.609904391992835],
            [7.020025166867273, 48.609904391992835],
            [7.00022759601707, 48.58993875112041],
            [7.030191487033593, 48.58013743651031],
            [7.039822737717475, 48.560171795637885],
            [7.079952948900318, 48.53984314311324],
            [7.079952948900318, 48.51987750224082],
            [7.079952948900318, 48.510076187630716],
            [7.079952948900318, 48.51987750224082],
            [7.120083160083161, 48.510076187630716],
            [7.090119269066638, 48.510076187630716],
            [7.079952948900318, 48.510076187630716],
            [7.009858846700953, 48.47994622049597],
            [6.97989495568443, 48.47994622049597],
            [6.9301334938177055, 48.44001493875112],
            [6.890003282634862, 48.4200492978787],
            [6.830075500601818, 48.4200492978787],
            [6.819909180435498, 48.40008365700628],
            [6.770147718568771, 48.40008365700628],
            [6.74018382755225, 48.4200492978787],
            [6.710219936535727, 48.4200492978787],
            [6.700053616369407, 48.40988497161638],
            [6.640125834336362, 48.450179265013446],
            [6.640125834336362, 48.470144905885874],
            [6.599995623153519, 48.470144905885874],
            [6.580198052303316, 48.45998057962355],
            [6.570031732136996, 48.44001493875112],
            [6.499937629937631, 48.40988497161638],
            [6.420212277054383, 48.40988497161638],
            [6.410045956888063, 48.38991933074395],
            [6.38008206587154, 48.38991933074395],
            [6.39024838603786, 48.40988497161638],
            [6.3597494255389, 48.40988497161638],
            [6.339951854688697, 48.40008365700628],
            [6.309987963672175, 48.40988497161638],
            [6.299821643505855, 48.4298506124888],
            [6.230262610788928, 48.40008365700628],
            [6.179966079439764, 48.40008365700628],
            [6.150002188423241, 48.40988497161638],
            [6.150002188423241, 48.380118016133856],
            [6.12003829740672, 48.34998804899911],
            [6.100240726556517, 48.36015237526143],
            [6.00981398402451, 48.36015237526143],
            [5.990016413174309, 48.34998804899911],
            [5.960052522157786, 48.34998804899911],
            [5.960052522157786, 48.36995368987153],
            [5.940254951307584, 48.380118016133856],
            [5.930088631141262, 48.40008365700628],
            [5.909755990808622, 48.40988497161638],
            [5.909755990808622, 48.4298506124888],
            [5.900124740124741, 48.40988497161638],
            [5.879792099792101, 48.40008365700628],
            [5.859994528941898, 48.4200492978787],
            [5.879792099792101, 48.44001493875112],
            [5.900124740124741, 48.47994622049597],
            [5.859994528941898, 48.510076187630716],
            [5.840196958091696, 48.49991186136839],
            [5.810233067075173, 48.49991186136839],
            [5.789900426742533, 48.47994622049597],
            [5.77010285589233, 48.49991186136839],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 49,
        name: "Maine-et-Loire",
        REG: 52,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.8899069920122553, 46.979982073498654],
            [-0.9198708830287776, 46.99994771437108],
            [-0.9600010942116208, 46.99994771437108],
            [-0.9899649852281431, 47.0101120406334],
            [-1.0199288762446654, 46.99994771437108],
            [-1.0498927672611886, 47.0101120406334],
            [-1.079856658277711, 47.0101120406334],
            [-1.090022978444031, 47.0199133552435],
            [-1.139784440310756, 47.0199133552435],
            [-1.1499507604770765, 47.03007768150583],
            [-1.1199868694605537, 47.039878996115924],
            [-1.1199868694605537, 47.05984463698835],
            [-1.1499507604770765, 47.07000896325067],
            [-1.1697483313272787, 47.0899746041231],
            [-1.230211182842762, 47.10013893038542],
            [-1.230211182842762, 47.12990588586794],
            [-1.1697483313272787, 47.16983716761279],
            [-1.1601170806433965, 47.19016582013744],
            [-1.1900809716599192, 47.21993277561996],
            [-1.1799146514935988, 47.23989841649238],
            [-1.2002472918262392, 47.25006274275471],
            [-1.230211182842762, 47.23989841649238],
            [-1.279972644709487, 47.27002838362713],
            [-1.290138964875807, 47.300158350761876],
            [-1.350066746908852, 47.300158350761876],
            [-1.339900426742532, 47.320123991634304],
            [-1.279972644709487, 47.340089632506725],
            [-1.230211182842762, 47.34989094711682],
            [-1.1799146514935988, 47.34989094711682],
            [-1.139784440310756, 47.36985658798925],
            [-0.9797986650618231, 47.36985658798925],
            [-0.9498347740452999, 47.38982222886167],
            [-0.9498347740452999, 47.450082163131164],
            [-0.9701674143779409, 47.470047804003585],
            [-0.9701674143779409, 47.49001344487601],
            [-1.0097625560783454, 47.49001344487601],
            [-1.0402615165773064, 47.509979085748434],
            [-1.0402615165773064, 47.54991036749328],
            [-1.0097625560783454, 47.589841649238124],
            [-1.0300951964109855, 47.60000597550045],
            [-1.079856658277711, 47.61017030176277],
            [-1.100189298610351, 47.61997161637287],
            [-1.139784440310756, 47.61997161637287],
            [-1.1601170806433965, 47.63993725724529],
            [-1.1601170806433965, 47.65990289811772],
            [-1.1799146514935988, 47.67006722438004],
            [-1.1697483313272787, 47.69003286525247],
            [-1.2002472918262392, 47.70999850612489],
            [-1.2500087536929643, 47.72996414699731],
            [-1.2398424335266442, 47.76009411413206],
            [-1.2500087536929643, 47.78005975500449],
            [-1.2398424335266442, 47.809826710487],
            [-1.2002472918262392, 47.80002539587691],
            [-1.1799146514935988, 47.78005975500449],
            [-1.100189298610351, 47.78005975500449],
            [-1.079856658277711, 47.76989542874216],
            [-1.0097625560783454, 47.76989542874216],
            [-0.9797986650618231, 47.76009411413206],
            [-0.9600010942116208, 47.80002539587691],
            [-0.9000733121785753, 47.76989542874216],
            [-0.8899069920122553, 47.76009411413206],
            [-0.8599431009957321, 47.76009411413206],
            [-0.8401455301455298, 47.76989542874216],
            [-0.8101816391290075, 47.76989542874216],
            [-0.7802177481124852, 47.74992978786973],
            [-0.750253857095962, 47.74012847325964],
            [-0.6100656526972319, 47.74012847325964],
            [-0.5801017616807087, 47.76009411413206],
            [-0.5298052303315464, 47.74992978786973],
            [-0.5201739796476641, 47.78986106961458],
            [-0.4800437684648209, 47.78005975500449],
            [-0.4500798774482986, 47.76009411413206],
            [-0.40994966626545537, 47.78005975500449],
            [-0.37998577524893307, 47.76989542874216],
            [-0.37998577524893307, 47.76009411413206],
            [-0.35002188423241076, 47.70999850612489],
            [-0.3302243133822085, 47.72016283238722],
            [-0.29009410219936527, 47.72016283238722],
            [-0.23979757085020204, 47.69983417986256],
            [-0.20020242914979747, 47.72996414699731],
            [-0.17986978881715743, 47.70999850612489],
            [-0.21999999999999975, 47.69003286525247],
            [-0.21999999999999975, 47.67986853899014],
            [-0.19003610898347745, 47.65010158350762],
            [-0.17023853813327516, 47.63993725724529],
            [-0.10977568661779191, 47.63993725724529],
            [-0.10977568661779191, 47.65990289811772],
            [-0.07981179560126961, 47.65990289811772],
            [-0.019884013568224113, 47.63993725724529],
            [-0.00008644271802182857, 47.65010158350762],
            [0.010079877448298191, 47.61997161637287],
            [0.07000765948134369, 47.61017030176277],
            [0.14973301236459147, 47.58004033462802],
            [0.18023197286355153, 47.589841649238124],
            [0.2000295437137547, 47.61017030176277],
            [0.229993434730277, 47.61017030176277],
            [0.229993434730277, 47.58004033462802],
            [0.21019586388007472, 47.5698760083657],
            [0.2000295437137547, 47.54010905288318],
            [0.21982711456395698, 47.529944726620855],
            [0.21982711456395698, 47.50017777113833],
            [0.1898632235474338, 47.470047804003585],
            [0.18023197286355153, 47.450082163131164],
            [0.1898632235474338, 47.43011652225874],
            [0.1700656526972315, 47.399986555123995],
            [0.18023197286355153, 47.380020914251574],
            [0.14973301236459147, 47.360055273379146],
            [0.1401017616807092, 47.340089632506725],
            [0.11976912134806916, 47.3299253062444],
            [0.0801739796476637, 47.289994024499556],
            [0.0801739796476637, 47.25006274275471],
            [0.07000765948134369, 47.21993277561996],
            [0.0502100886311414, 47.19996713474754],
            [0.07000765948134369, 47.19016582013744],
            [0.0502100886311414, 47.16003585300269],
            [0.0202461976146191, 47.18000149387511],
            [-0.010252762884341848, 47.16003585300269],
            [-0.030050333734544132, 47.12990588586794],
            [-0.030050333734544132, 47.10013893038542],
            [-0.04021665390086415, 47.0899746041231],
            [-0.10014443593390965, 47.0899746041231],
            [-0.10014443593390965, 47.05984463698835],
            [-0.13010832695043195, 47.05004332237825],
            [-0.17023853813327516, 47.080173289513],
            [-0.16007221796695514, 47.10013893038542],
            [-0.19003610898347745, 47.10013893038542],
            [-0.20983367983367973, 47.0899746041231],
            [-0.23979757085020204, 47.10994024499552],
            [-0.26013021118284296, 47.10013893038542],
            [-0.3002604223656853, 47.10013893038542],
            [-0.30989167304956755, 47.0899746041231],
            [-0.39978334609913535, 47.0899746041231],
            [-0.39978334609913535, 47.07000896325067],
            [-0.4800437684648209, 47.07000896325067],
            [-0.5201739796476641, 47.080173289513],
            [-0.5597691213480687, 47.05984463698835],
            [-0.5399715504978664, 47.039878996115924],
            [-0.5597691213480687, 47.03007768150583],
            [-0.589733012364591, 46.99994771437108],
            [-0.6202319728635519, 46.99014639976098],
            [-0.7101236459131197, 46.99014639976098],
            [-0.729921216763322, 46.99994771437108],
            [-0.750253857095962, 46.99014639976098],
            [-0.7898489987963675, 47.0101120406334],
            [-0.8101816391290075, 46.99014639976098],
            [-0.8497767808294121, 46.99014639976098],
            [-0.8599431009957321, 46.979982073498654],
            [-0.8899069920122553, 46.979982073498654],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 70, name: "Haute-Saône", REG: 27, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.700008753692965, 47.27002838362713],
            [5.659878542510122, 47.27002838362713],
            [5.619748331327279, 47.25006274275471],
            [5.6101170806433975, 47.25986405736481],
            [5.569986869460554, 47.25986405736481],
            [5.559820549294234, 47.27982969823723],
            [5.52022540759383, 47.300158350761876],
            [5.4699288762446665, 47.320123991634304],
            [5.49989276726119, 47.340089632506725],
            [5.4800951964109865, 47.38982222886167],
            [5.450131305394463, 47.380020914251574],
            [5.429798665061823, 47.419952195996416],
            [5.429798665061823, 47.43991783686884],
            [5.410001094211622, 47.459883477741265],
            [5.380037203195099, 47.450082163131164],
            [5.380037203195099, 47.470047804003585],
            [5.3998347740453, 47.50017777113833],
            [5.450131305394463, 47.50017777113833],
            [5.4699288762446665, 47.529944726620855],
            [5.4902615165773065, 47.529944726620855],
            [5.49989276726119, 47.54991036749328],
            [5.4800951964109865, 47.5698760083657],
            [5.4902615165773065, 47.58004033462802],
            [5.4800951964109865, 47.61017030176277],
            [5.429798665061823, 47.6301359426352],
            [5.3998347740453, 47.60000597550045],
            [5.369870883028779, 47.60000597550045],
            [5.369870883028779, 47.61997161637287],
            [5.3998347740453, 47.65010158350762],
            [5.410001094211622, 47.67006722438004],
            [5.4699288762446665, 47.67006722438004],
            [5.4800951964109865, 47.67986853899014],
            [5.51005908742751, 47.67986853899014],
            [5.529856658277711, 47.67006722438004],
            [5.569986869460554, 47.70999850612489],
            [5.6101170806433975, 47.67986853899014],
            [5.689842433526645, 47.67986853899014],
            [5.680211182842762, 47.70999850612489],
            [5.710175073859285, 47.74012847325964],
            [5.710175073859285, 47.76989542874216],
            [5.680211182842762, 47.76989542874216],
            [5.689842433526645, 47.809826710487],
            [5.700008753692965, 47.81999103674933],
            [5.74977021555969, 47.81999103674933],
            [5.740138964875807, 47.85012100388408],
            [5.75993653572601, 47.85992231849418],
            [5.800066746908853, 47.85992231849418],
            [5.8198643177590546, 47.8700866447565],
            [5.849828208775578, 47.89985360023902],
            [5.889958419958421, 47.89985360023902],
            [5.879792099792101, 47.92998356737377],
            [5.919922310974942, 47.949949208246196],
            [5.919922310974942, 47.96991484911862],
            [5.949886201991466, 47.980079175380936],
            [5.970218842324106, 47.960113534508515],
            [6.00981398402451, 47.960113534508515],
            [6.01998030419083, 47.98988048999104],
            [6.0697417660575566, 48.020010457125785],
            [6.109871977240398, 48.009846130863465],
            [6.13020461757304, 48.020010457125785],
            [6.160168508589561, 48.009846130863465],
            [6.160168508589561, 47.96991484911862],
            [6.169799759273444, 47.949949208246196],
            [6.209929970456288, 47.949949208246196],
            [6.239893861472809, 47.92998356737377],
            [6.260226501805449, 47.949949208246196],
            [6.290190392821972, 47.960113534508515],
            [6.320154283838495, 47.949949208246196],
            [6.3597494255389, 47.960113534508515],
            [6.39024838603786, 47.960113534508515],
            [6.410045956888063, 47.940147893636095],
            [6.429843527738265, 47.940147893636095],
            [6.480140059087428, 47.890052285628926],
            [6.499937629937631, 47.89985360023902],
            [6.5400678411204725, 47.89985360023902],
            [6.570031732136996, 47.92998356737377],
            [6.599995623153519, 47.940147893636095],
            [6.62995951417004, 47.92998356737377],
            [6.649757085020243, 47.89985360023902],
            [6.689887296203087, 47.890052285628926],
            [6.74018382755225, 47.85992231849418],
            [6.779778969252654, 47.85012100388408],
            [6.7899452894189745, 47.830155363011656],
            [6.819909180435498, 47.809826710487],
            [6.7899452894189745, 47.78005975500449],
            [6.770147718568771, 47.76989542874216],
            [6.759981398402451, 47.74992978786973],
            [6.759981398402451, 47.72016283238722],
            [6.779778969252654, 47.69983417986256],
            [6.779778969252654, 47.65990289811772],
            [6.8001116095852945, 47.63993725724529],
            [6.779778969252654, 47.61997161637287],
            [6.809742860269176, 47.5600746937556],
            [6.779778969252654, 47.54010905288318],
            [6.759981398402451, 47.54010905288318],
            [6.74018382755225, 47.5600746937556],
            [6.719851187219608, 47.54991036749328],
            [6.6700897253528835, 47.5600746937556],
            [6.62995951417004, 47.529944726620855],
            [6.610161943319839, 47.54010905288318],
            [6.580198052303316, 47.54010905288318],
            [6.580198052303316, 47.509979085748434],
            [6.550234161286794, 47.49001344487601],
            [6.499937629937631, 47.509979085748434],
            [6.469973738921108, 47.49001344487601],
            [6.450176168070905, 47.52014341201075],
            [6.399879636721743, 47.52014341201075],
            [6.39024838603786, 47.509979085748434],
            [6.329785534522377, 47.509979085748434],
            [6.320154283838495, 47.49001344487601],
            [6.299821643505855, 47.49001344487601],
            [6.280024072655652, 47.450082163131164],
            [6.260226501805449, 47.450082163131164],
            [6.260226501805449, 47.43011652225874],
            [6.209929970456288, 47.43011652225874],
            [6.190132399606084, 47.410150881386315],
            [6.169799759273444, 47.38982222886167],
            [6.12003829740672, 47.38982222886167],
            [6.079908086223877, 47.36985658798925],
            [6.079908086223877, 47.34989094711682],
            [6.049944195207353, 47.34989094711682],
            [6.01998030419083, 47.3299253062444],
            [6.000182733340629, 47.340089632506725],
            [5.979850093007989, 47.3299253062444],
            [5.960052522157786, 47.340089632506725],
            [5.930088631141262, 47.340089632506725],
            [5.900124740124741, 47.320123991634304],
            [5.859994528941898, 47.320123991634304],
            [5.849828208775578, 47.300158350761876],
            [5.8198643177590546, 47.300158350761876],
            [5.75993653572601, 47.27982969823723],
            [5.740138964875807, 47.25986405736481],
            [5.700008753692965, 47.27002838362713],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 79, name: "Deux-Sèvres", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.10014443593390965, 45.97008365700628],
            [-0.13973957763431422, 45.97988497161637],
            [-0.13973957763431422, 45.9998506124888],
            [-0.19003610898347745, 46.02998057962354],
            [-0.19003610898347745, 46.04994622049597],
            [-0.23016632016631977, 46.04994622049597],
            [-0.2697614618667252, 46.060110546758295],
            [-0.27992778203304525, 46.080076187630716],
            [-0.3601882043987308, 46.080076187630716],
            [-0.3901520954152531, 46.10004182850314],
            [-0.39978334609913535, 46.080076187630716],
            [-0.43991355728197856, 46.10004182850314],
            [-0.46987744829850087, 46.10004182850314],
            [-0.5201739796476641, 46.10984314311324],
            [-0.5298052303315464, 46.139973110247986],
            [-0.6298632235474342, 46.139973110247986],
            [-0.6202319728635519, 46.15993875112041],
            [-0.6298632235474342, 46.170103077382734],
            [-0.6598271145639565, 46.170103077382734],
            [-0.6897910055804797, 46.17990439199283],
            [-0.6801597548965974, 46.199870032865256],
            [-0.6999573257467997, 46.21983567373768],
            [-0.750253857095962, 46.249965640872425],
            [-0.740087536929642, 46.269931281744846],
            [-0.750253857095962, 46.300061248879594],
            [-0.729921216763322, 46.300061248879594],
            [-0.6999573257467997, 46.329828204362116],
            [-0.6699934347302765, 46.320026889752015],
            [-0.6400295437137542, 46.320026889752015],
            [-0.5998993325309119, 46.359958171496864],
            [-0.5597691213480687, 46.359958171496864],
            [-0.5399715504978664, 46.39008813863161],
            [-0.5699354415143887, 46.39008813863161],
            [-0.6100656526972319, 46.41005377950403],
            [-0.6400295437137542, 46.41005377950403],
            [-0.6400295437137542, 46.43001942037646],
            [-0.6202319728635519, 46.439820734986554],
            [-0.6202319728635519, 46.4699507021213],
            [-0.6400295437137542, 46.50988198386615],
            [-0.6298632235474342, 46.52984762473857],
            [-0.5998993325309119, 46.52984762473857],
            [-0.6202319728635519, 46.55997759187332],
            [-0.6202319728635519, 46.59990887361817],
            [-0.6100656526972319, 46.61987451449059],
            [-0.6598271145639565, 46.680134448760086],
            [-0.6699934347302765, 46.72006573050493],
            [-0.6897910055804797, 46.72986704511503],
            [-0.729921216763322, 46.770161338512104],
            [-0.719754896597002, 46.799928293994626],
            [-0.6999573257467997, 46.810092620256945],
            [-0.7802177481124852, 46.83985957573947],
            [-0.7898489987963675, 46.859825216611895],
            [-0.8198128898128898, 46.88015386913654],
            [-0.8101816391290075, 46.909920824619064],
            [-0.8299792099792098, 46.929886465491485],
            [-0.870109421162053, 46.949852106363906],
            [-0.8899069920122553, 46.979982073498654],
            [-0.8599431009957321, 46.979982073498654],
            [-0.8497767808294121, 46.99014639976098],
            [-0.8101816391290075, 46.99014639976098],
            [-0.7898489987963675, 47.0101120406334],
            [-0.750253857095962, 46.99014639976098],
            [-0.729921216763322, 46.99994771437108],
            [-0.7101236459131197, 46.99014639976098],
            [-0.6202319728635519, 46.99014639976098],
            [-0.589733012364591, 46.99994771437108],
            [-0.5597691213480687, 47.03007768150583],
            [-0.5399715504978664, 47.039878996115924],
            [-0.5597691213480687, 47.05984463698835],
            [-0.5201739796476641, 47.080173289513],
            [-0.4800437684648209, 47.07000896325067],
            [-0.39978334609913535, 47.07000896325067],
            [-0.39978334609913535, 47.0899746041231],
            [-0.30989167304956755, 47.0899746041231],
            [-0.3002604223656853, 47.10013893038542],
            [-0.26013021118284296, 47.10013893038542],
            [-0.23979757085020204, 47.10994024499552],
            [-0.20983367983367973, 47.0899746041231],
            [-0.19003610898347745, 47.10013893038542],
            [-0.16007221796695514, 47.10013893038542],
            [-0.17023853813327516, 47.080173289513],
            [-0.13010832695043195, 47.05004332237825],
            [-0.10014443593390965, 47.05984463698835],
            [-0.08997811576758963, 47.039878996115924],
            [-0.08997811576758963, 46.99014639976098],
            [-0.04021665390086415, 46.99014639976098],
            [-0.049847904584746416, 46.97018075888856],
            [-0.019884013568224113, 46.94005079175381],
            [-0.010252762884341848, 46.909920824619064],
            [-0.04021665390086415, 46.869989542874215],
            [-0.010252762884341848, 46.869989542874215],
            [-0.00008644271802182857, 46.850023902001794],
            [-0.030050333734544132, 46.83985957573947],
            [-0.049847904584746416, 46.819893934867046],
            [-0.019884013568224113, 46.810092620256945],
            [-0.019884013568224113, 46.770161338512104],
            [0.0202461976146191, 46.740031371377356],
            [-0.00008644271802182857, 46.72006573050493],
            [-0.010252762884341848, 46.680134448760086],
            [-0.030050333734544132, 46.66997012249776],
            [-0.04021665390086415, 46.65000448162534],
            [-0.060014224751066436, 46.63984015536301],
            [-0.07018054491738734, 46.61987451449059],
            [-0.00008644271802182857, 46.63984015536301],
            [-0.010252762884341848, 46.61987451449059],
            [0.0202461976146191, 46.61007319988049],
            [0.029877448298501363, 46.59010755900807],
            [-0.010252762884341848, 46.55997759187332],
            [0.010079877448298191, 46.55017627726322],
            [-0.010252762884341848, 46.52004631012847],
            [-0.030050333734544132, 46.52004631012847],
            [-0.04021665390086415, 46.50008066925605],
            [-0.04021665390086415, 46.4699507021213],
            [-0.010252762884341848, 46.4699507021213],
            [-0.010252762884341848, 46.43001942037646],
            [-0.019884013568224113, 46.41005377950403],
            [-0.010252762884341848, 46.39008813863161],
            [0.010079877448298191, 46.39008813863161],
            [0.029877448298501363, 46.37012249775919],
            [0.010079877448298191, 46.359958171496864],
            [0.0202461976146191, 46.33999253062444],
            [0.0801739796476637, 46.300061248879594],
            [0.09997155049786599, 46.329828204362116],
            [0.1401017616807092, 46.35015685688676],
            [0.18023197286355153, 46.329828204362116],
            [0.14973301236459147, 46.300061248879594],
            [0.1700656526972315, 46.28009560800717],
            [0.1598993325309115, 46.269931281744846],
            [0.12993544151438918, 46.269931281744846],
            [0.1401017616807092, 46.240164326262324],
            [0.1101378706641869, 46.190068718255155],
            [0.1401017616807092, 46.17990439199283],
            [0.18023197286355153, 46.150137436510306],
            [0.21982711456395698, 46.15993875112041],
            [0.21982711456395698, 46.139973110247986],
            [0.2000295437137547, 46.130171795637885],
            [0.1898632235474338, 46.10984314311324],
            [0.2000295437137547, 46.10004182850314],
            [0.1700656526972315, 46.080076187630716],
            [0.1401017616807092, 46.10004182850314],
            [0.08980523033154597, 46.10004182850314],
            [0.0502100886311414, 46.080076187630716],
            [0.0202461976146191, 46.04994622049597],
            [-0.00008644271802182857, 46.060110546758295],
            [-0.030050333734544132, 46.060110546758295],
            [-0.049847904584746416, 46.02017926501345],
            [-0.049847904584746416, 45.9900492978787],
            [-0.10014443593390965, 45.97008365700628],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 57, name: "Moselle", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7.079952948900318, 48.53984314311324],
            [7.039822737717475, 48.560171795637885],
            [7.030191487033593, 48.58013743651031],
            [7.00022759601707, 48.58993875112041],
            [7.020025166867273, 48.609904391992835],
            [6.960097384834227, 48.609904391992835],
            [6.939764744501587, 48.620068718255155],
            [6.9098008534850655, 48.620068718255155],
            [6.890003282634862, 48.629870032865256],
            [6.849873071452019, 48.620068718255155],
            [6.809742860269176, 48.64983567373768],
            [6.779778969252654, 48.64003435912758],
            [6.759981398402451, 48.64983567373768],
            [6.759981398402451, 48.670164326262324],
            [6.73001750738593, 48.660000000000004],
            [6.689887296203087, 48.670164326262324],
            [6.6599234051865634, 48.71009560800717],
            [6.640125834336362, 48.699931281744846],
            [6.580198052303316, 48.73006124887959],
            [6.559865411970676, 48.759828204362115],
            [6.5400678411204725, 48.75002688975202],
            [6.510103950103951, 48.75002688975202],
            [6.489771309771311, 48.76999253062444],
            [6.450176168070905, 48.76999253062444],
            [6.429843527738265, 48.78995817149686],
            [6.39024838603786, 48.78015685688677],
            [6.3597494255389, 48.78015685688677],
            [6.329785534522377, 48.82008813863161],
            [6.290190392821972, 48.84005377950403],
            [6.309987963672175, 48.86001942037646],
            [6.309987963672175, 48.91011502838363],
            [6.290190392821972, 48.93008066925605],
            [6.260226501805449, 48.93008066925605],
            [6.239893861472809, 48.91991634299373],
            [6.220096290622608, 48.93988198386615],
            [6.13020461757304, 48.93988198386615],
            [6.109871977240398, 48.9700119510009],
            [6.079908086223877, 48.95984762473857],
            [6.0697417660575566, 48.980176277263226],
            [6.039777875041033, 48.98997759187332],
            [6.039777875041033, 49.00994323274575],
            [5.990016413174309, 49.040073199880496],
            [5.970218842324106, 49.040073199880496],
            [5.930088631141262, 49.08000448162534],
            [5.930088631141262, 49.110134448760085],
            [6.000182733340629, 49.110134448760085],
            [5.979850093007989, 49.13990140424261],
            [6.000182733340629, 49.150065730504934],
            [6.01998030419083, 49.170031371377355],
            [5.979850093007989, 49.189997012249776],
            [6.00981398402451, 49.220126979384524],
            [6.030146624357152, 49.229928293994625],
            [6.030146624357152, 49.249893934867046],
            [6.00981398402451, 49.26005826112937],
            [6.000182733340629, 49.280023902001794],
            [6.00981398402451, 49.31015386913654],
            [5.990016413174309, 49.31015386913654],
            [5.949886201991466, 49.33011951000897],
            [5.960052522157786, 49.35008515088139],
            [5.930088631141262, 49.37005079175381],
            [5.940254951307584, 49.37985210636391],
            [5.919922310974942, 49.42014639976098],
            [5.940254951307584, 49.42994771437108],
            [5.930088631141262, 49.46987899611592],
            [5.900124740124741, 49.48004332237825],
            [5.889958419958421, 49.50000896325068],
            [5.940254951307584, 49.50000896325068],
            [5.970218842324106, 49.48984463698835],
            [5.970218842324106, 49.46987899611592],
            [6.030146624357152, 49.4499133552435],
            [6.060110515373673, 49.46987899611592],
            [6.090074406390197, 49.46007768150583],
            [6.12003829740672, 49.46987899611592],
            [6.13020461757304, 49.48984463698835],
            [6.160168508589561, 49.48984463698835],
            [6.179966079439764, 49.510173289513],
            [6.239893861472809, 49.510173289513],
            [6.280024072655652, 49.50000896325068],
            [6.329785534522377, 49.46987899611592],
            [6.399879636721743, 49.46987899611592],
            [6.420212277054383, 49.48004332237825],
            [6.450176168070905, 49.46007768150583],
            [6.499937629937631, 49.4499133552435],
            [6.5400678411204725, 49.42994771437108],
            [6.550234161286794, 49.39001643262623],
            [6.580198052303316, 49.39001643262623],
            [6.599995623153519, 49.37005079175381],
            [6.559865411970676, 49.359886465491485],
            [6.589829302987199, 49.33011951000897],
            [6.589829302987199, 49.31995518374664],
            [6.61979319400372, 49.299989542874215],
            [6.6700897253528835, 49.280023902001794],
            [6.6599234051865634, 49.26005826112937],
            [6.689887296203087, 49.249893934867046],
            [6.689887296203087, 49.220126979384524],
            [6.719851187219608, 49.220126979384524],
            [6.73001750738593, 49.209962653122204],
            [6.710219936535727, 49.189997012249776],
            [6.74018382755225, 49.15986704511503],
            [6.749815078236131, 49.170031371377355],
            [6.779778969252654, 49.170031371377355],
            [6.830075500601818, 49.150065730504934],
            [6.840241820768138, 49.170031371377355],
            [6.860039391618339, 49.179832685987456],
            [6.840241820768138, 49.209962653122204],
            [6.860039391618339, 49.220126979384524],
            [6.890003282634862, 49.209962653122204],
            [6.9199671736513855, 49.220126979384524],
            [6.960097384834227, 49.2001613385121],
            [6.97989495568443, 49.209962653122204],
            [7.00022759601707, 49.189997012249776],
            [7.030191487033593, 49.189997012249776],
            [7.030191487033593, 49.150065730504934],
            [7.069786628733998, 49.11993576337019],
            [7.079952948900318, 49.150065730504934],
            [7.099750519750521, 49.150065730504934],
            [7.130249480249481, 49.130100089632506],
            [7.160213371266004, 49.11993576337019],
            [7.180010942116206, 49.130100089632506],
            [7.209974833132729, 49.11993576337019],
            [7.250105044315572, 49.130100089632506],
            [7.299866506182297, 49.11993576337019],
            [7.310032826348617, 49.13990140424261],
            [7.359794288215341, 49.150065730504934],
            [7.380126928547981, 49.179832685987456],
            [7.440054710581028, 49.179832685987456],
            [7.459852281431229, 49.15986704511503],
            [7.480184921763869, 49.170031371377355],
            [7.499982492614072, 49.15986704511503],
            [7.489816172447752, 49.13990140424261],
            [7.499982492614072, 49.11993576337019],
            [7.5197800634642755, 49.11993576337019],
            [7.5299463836305955, 49.099970122497766],
            [7.559910274647117, 49.08000448162534],
            [7.60004048582996, 49.08000448162534],
            [7.630004376846483, 49.06984015536301],
            [7.640170697012803, 49.04987451449059],
            [7.630004376846483, 49.02990887361817],
            [7.58987416566364, 48.98997759187332],
            [7.580242914979757, 48.95984762473857],
            [7.549743954480797, 48.93988198386615],
            [7.510148812780392, 48.93988198386615],
            [7.480184921763869, 48.95984762473857],
            [7.450221030747348, 48.9700119510009],
            [7.429888390414708, 48.95984762473857],
            [7.3999244993981845, 48.95984762473857],
            [7.3897581792318645, 48.95004631012848],
            [7.310032826348617, 48.95004631012848],
            [7.310032826348617, 48.95984762473857],
            [7.23993872414925, 48.98997759187332],
            [7.209974833132729, 48.980176277263226],
            [7.169844621949886, 49.00994323274575],
            [7.130249480249481, 49.00994323274575],
            [7.120083160083161, 49.040073199880496],
            [7.099750519750521, 49.06003884075292],
            [7.049989057883795, 49.02990887361817],
            [7.049989057883795, 49.00014191813565],
            [7.030191487033593, 48.95984762473857],
            [6.99006127585075, 48.95984762473857],
            [6.97989495568443, 48.93008066925605],
            [6.960097384834227, 48.91991634299373],
            [6.960097384834227, 48.89014938751121],
            [6.99006127585075, 48.89014938751121],
            [7.060155378050115, 48.86001942037646],
            [7.049989057883795, 48.84985509411413],
            [7.049989057883795, 48.80992381236929],
            [7.090119269066638, 48.78995817149686],
            [7.130249480249481, 48.82008813863161],
            [7.1398807309333625, 48.84005377950403],
            [7.169844621949886, 48.84005377950403],
            [7.190177262282526, 48.82988945324171],
            [7.22977240398293, 48.82988945324171],
            [7.250105044315572, 48.80992381236929],
            [7.290235255498414, 48.78995817149686],
            [7.310032826348617, 48.76999253062444],
            [7.290235255498414, 48.75002688975202],
            [7.290235255498414, 48.73006124887959],
            [7.2597362949994535, 48.699931281744846],
            [7.23993872414925, 48.69012996713475],
            [7.2699026151657735, 48.660000000000004],
            [7.299866506182297, 48.660000000000004],
            [7.2699026151657735, 48.629870032865256],
            [7.2800689353320935, 48.620068718255155],
            [7.2597362949994535, 48.58993875112041],
            [7.220141153299049, 48.550007469375565],
            [7.190177262282526, 48.550007469375565],
            [7.169844621949886, 48.53004182850314],
            [7.1398807309333625, 48.53004182850314],
            [7.120083160083161, 48.53984314311324],
            [7.090119269066638, 48.53004182850314],
            [7.079952948900318, 48.53984314311324],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 50, name: "Manche", REG: 28, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.5699803041908305, 48.629870032865256],
            [-1.5202188423241054, 48.629870032865256],
            [-1.5100525221577854, 48.620068718255155],
            [-1.4501247401247404, 48.620068718255155],
            [-1.4297920997920999, 48.64003435912758],
            [-1.3698643177590548, 48.64003435912758],
            [-1.3998282087755771, 48.660000000000004],
            [-1.3901969580916949, 48.679965640872425],
            [-1.3698643177590548, 48.69012996713475],
            [-1.3800306379253748, 48.69012996713475],
            [-1.3901969580916949, 48.679965640872425],
            [-1.4297920997920999, 48.670164326262324],
            [-1.4597559908086226, 48.670164326262324],
            [-1.4902549513075831, 48.69012996713475],
            [-1.5100525221577854, 48.69012996713475],
            [-1.5298500930079877, 48.73006124887959],
            [-1.5598139840245104, 48.73006124887959],
            [-1.5699803041908305, 48.739862563489694],
            [-1.5699803041908305, 48.82008813863161],
            [-1.5999441952073532, 48.84005377950403],
            [-1.580146624357151, 48.86001942037646],
            [-1.5598139840245104, 48.91991634299373],
            [-1.5598139840245104, 49.040073199880496],
            [-1.580146624357151, 49.02010755900807],
            [-1.5999441952073532, 49.040073199880496],
            [-1.6101105153736732, 49.06984015536301],
            [-1.6101105153736732, 49.08000448162534],
            [-1.6101105153736732, 49.06984015536301],
            [-1.6101105153736732, 49.08000448162534],
            [-1.6101105153736732, 49.110134448760085],
            [-1.5897778750410332, 49.130100089632506],
            [-1.5999441952073532, 49.13990140424261],
            [-1.6101105153736732, 49.189997012249776],
            [-1.6101105153736732, 49.220126979384524],
            [-1.640074406390196, 49.220126979384524],
            [-1.6802046175730387, 49.289825216611895],
            [-1.6700382974067187, 49.280023902001794],
            [-1.6802046175730387, 49.289825216611895],
            [-1.700002188423241, 49.31015386913654],
            [-1.689835868256921, 49.33011951000897],
            [-1.7197997592734438, 49.33011951000897],
            [-1.7802626107889266, 49.37005079175381],
            [-1.7898938614728088, 49.37005079175381],
            [-1.7898938614728088, 49.37985210636391],
            [-1.7802626107889266, 49.37005079175381],
            [-1.7898938614728088, 49.37985210636391],
            [-1.7898938614728088, 49.37005079175381],
            [-1.8102265018054493, 49.37005079175381],
            [-1.8198577524893316, 49.39001643262623],
            [-1.8198577524893316, 49.44011204063341],
            [-1.8498216435058539, 49.46987899611592],
            [-1.8498216435058539, 49.510173289513],
            [-1.8701542838384944, 49.510173289513],
            [-1.8899518546886966, 49.53013893038542],
            [-1.8401903928219716, 49.57007021213027],
            [-1.8401903928219716, 49.61000149387512],
            [-1.8498216435058539, 49.640131461009865],
            [-1.8701542838384944, 49.660097101882286],
            [-1.900118174855017, 49.66989841649239],
            [-1.9402483860378599, 49.66989841649239],
            [-1.9498796367217421, 49.70982969823723],
            [-1.9402483860378599, 49.73015835076188],
            [-1.8797855345223766, 49.70982969823723],
            [-1.8498216435058539, 49.719994024499556],
            [-1.8300240726556516, 49.68986405736481],
            [-1.7898938614728088, 49.68986405736481],
            [-1.7700962906226065, 49.68006274275471],
            [-1.7197997592734438, 49.68006274275471],
            [-1.6802046175730387, 49.660097101882286],
            [-1.629908086223876, 49.660097101882286],
            [-1.6101105153736732, 49.640131461009865],
            [-1.5999441952073532, 49.64993277561996],
            [-1.5699803041908305, 49.660097101882286],
            [-1.5501827333406282, 49.64993277561996],
            [-1.5298500930079877, 49.660097101882286],
            [-1.4998862019914654, 49.660097101882286],
            [-1.4699223109749426, 49.70002838362713],
            [-1.4501247401247404, 49.68986405736481],
            [-1.3901969580916949, 49.70982969823723],
            [-1.350066746908852, 49.70002838362713],
            [-1.3201028558923298, 49.70002838362713],
            [-1.2698063245431666, 49.68006274275471],
            [-1.2398424335266442, 49.64993277561996],
            [-1.230211182842762, 49.61000149387512],
            [-1.2500087536929643, 49.61000149387512],
            [-1.2698063245431666, 49.57987152674037],
            [-1.290138964875807, 49.59003585300269],
            [-1.3099365357260093, 49.55990588586795],
            [-1.290138964875807, 49.5199746041231],
            [-1.230211182842762, 49.46007768150583],
            [-1.2200448626764415, 49.46007768150583],
            [-1.1697483313272787, 49.40998207349866],
            [-1.1601170806433965, 49.39001643262623],
            [-1.1799146514935988, 49.37985210636391],
            [-1.139784440310756, 49.359886465491485],
            [-1.1199868694605537, 49.359886465491485],
            [-1.1098205492942332, 49.33011951000897],
            [-1.139784440310756, 49.31015386913654],
            [-1.1301531896268737, 49.269859575739474],
            [-1.090022978444031, 49.249893934867046],
            [-1.0702254075938287, 49.229928293994625],
            [-1.0300951964109855, 49.220126979384524],
            [-1.0199288762446654, 49.2001613385121],
            [-0.9899649852281431, 49.2001613385121],
            [-0.9701674143779409, 49.189997012249776],
            [-0.9402035233614177, 49.220126979384524],
            [-0.9198708830287776, 49.220126979384524],
            [-0.9000733121785753, 49.2001613385121],
            [-0.9300372031950976, 49.15986704511503],
            [-0.9402035233614177, 49.150065730504934],
            [-0.9000733121785753, 49.13990140424261],
            [-0.8797406718459353, 49.11993576337019],
            [-0.8797406718459353, 49.090168807887665],
            [-0.870109421162053, 49.08000448162534],
            [-0.870109421162053, 49.040073199880496],
            [-0.9402035233614177, 48.9700119510009],
            [-0.9899649852281431, 48.95004631012848],
            [-1.0097625560783454, 48.91991634299373],
            [-1.0702254075938287, 48.86982073498656],
            [-1.100189298610351, 48.86982073498656],
            [-1.1601170806433965, 48.82988945324171],
            [-1.1098205492942332, 48.82008813863161],
            [-1.090022978444031, 48.80012249775919],
            [-1.100189298610351, 48.78995817149686],
            [-1.0600590874275087, 48.76999253062444],
            [-1.0402615165773064, 48.78015685688677],
            [-1.0199288762446654, 48.76999253062444],
            [-0.9701674143779409, 48.78995817149686],
            [-0.9498347740452999, 48.78995817149686],
            [-0.9198708830287776, 48.76999253062444],
            [-0.8899069920122553, 48.76999253062444],
            [-0.8797406718459353, 48.759828204362115],
            [-0.8497767808294121, 48.759828204362115],
            [-0.8401455301455298, 48.75002688975202],
            [-0.8497767808294121, 48.73006124887959],
            [-0.8198128898128898, 48.73006124887959],
            [-0.7700514279461643, 48.69012996713475],
            [-0.740087536929642, 48.69012996713475],
            [-0.7700514279461643, 48.64983567373768],
            [-0.750253857095962, 48.620068718255155],
            [-0.750253857095962, 48.600103077382734],
            [-0.7898489987963675, 48.550007469375565],
            [-0.8101816391290075, 48.550007469375565],
            [-0.8497767808294121, 48.51987750224082],
            [-0.8599431009957321, 48.49991186136839],
            [-0.9000733121785753, 48.490110546758295],
            [-0.9198708830287776, 48.510076187630716],
            [-0.9600010942116208, 48.510076187630716],
            [-0.9701674143779409, 48.490110546758295],
            [-1.0097625560783454, 48.490110546758295],
            [-1.0600590874275087, 48.51987750224082],
            [-1.0702254075938287, 48.510076187630716],
            [-1.100189298610351, 48.510076187630716],
            [-1.1199868694605537, 48.51987750224082],
            [-1.1601170806433965, 48.51987750224082],
            [-1.1697483313272787, 48.53004182850314],
            [-1.2002472918262392, 48.53004182850314],
            [-1.2098785425101215, 48.53984314311324],
            [-1.2500087536929643, 48.53984314311324],
            [-1.2698063245431666, 48.53004182850314],
            [-1.279972644709487, 48.510076187630716],
            [-1.2997702155596893, 48.49991186136839],
            [-1.329734106576212, 48.49991186136839],
            [-1.3698643177590548, 48.45998057962355],
            [-1.4297920997920999, 48.45998057962355],
            [-1.4501247401247404, 48.490110546758295],
            [-1.4902549513075831, 48.490110546758295],
            [-1.5298500930079877, 48.550007469375565],
            [-1.5202188423241054, 48.569973110247986],
            [-1.5400164131743082, 48.58013743651031],
            [-1.5400164131743082, 48.600103077382734],
            [-1.5699803041908305, 48.609904391992835],
            [-1.5699803041908305, 48.629870032865256],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 47,
        name: "Lot-et-Garonne",
        REG: 75,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.0801739796476637, 43.98005377950403],
            [0.05984133931502367, 44.000019420376454],
            [0.05984133931502367, 44.01998506124888],
            [0.0801739796476637, 44.0301493875112],
            [0.09997155049786599, 44.09004631012847],
            [0.1401017616807092, 44.11001195100089],
            [0.12993544151438918, 44.12017627726322],
            [0.029877448298501363, 44.12997759187332],
            [0.029877448298501363, 44.14014191813564],
            [-0.00008644271802182857, 44.14994323274574],
            [-0.060014224751066436, 44.14994323274574],
            [-0.08997811576758963, 44.16010755900807],
            [-0.13010832695043195, 44.14994323274574],
            [-0.13010832695043195, 44.20003884075291],
            [-0.13973957763431422, 44.23016880788766],
            [-0.11994200678411193, 44.23997012249776],
            [-0.10014443593390965, 44.23016880788766],
            [-0.049847904584746416, 44.27010008963251],
            [-0.030050333734544132, 44.29986704511503],
            [-0.08997811576758963, 44.3401613385121],
            [-0.060014224751066436, 44.360126979384525],
            [-0.030050333734544132, 44.360126979384525],
            [-0.019884013568224113, 44.36992829399462],
            [0.010079877448298191, 44.36992829399462],
            [0.0202461976146191, 44.38989393486705],
            [-0.010252762884341848, 44.420023902001795],
            [-0.00008644271802182857, 44.439989542874216],
            [-0.019884013568224113, 44.499886465491485],
            [0.0202461976146191, 44.53001643262623],
            [0.029877448298501363, 44.549982073498654],
            [0.07000765948134369, 44.549982073498654],
            [0.08980523033154597, 44.5801120406334],
            [0.11976912134806916, 44.5899133552435],
            [0.1401017616807092, 44.629844636988345],
            [0.1700656526972315, 44.629844636988345],
            [0.18023197286355153, 44.67013893038542],
            [0.12993544151438918, 44.67013893038542],
            [0.09997155049786599, 44.69990588586794],
            [0.1101378706641869, 44.71007021213027],
            [0.1401017616807092, 44.71007021213027],
            [0.18023197286355153, 44.75000149387511],
            [0.2000295437137547, 44.71987152674036],
            [0.21982711456395698, 44.76016582013744],
            [0.2497910055804793, 44.75000149387511],
            [0.3000875369296425, 44.76016582013744],
            [0.34021774811248484, 44.73983716761279],
            [0.3498489987963671, 44.71987152674036],
            [0.34021774811248484, 44.69990588586794],
            [0.3600153189626871, 44.69010457125784],
            [0.3498489987963671, 44.65997460412309],
            [0.3798128898128903, 44.650173289513],
            [0.4199431009957326, 44.650173289513],
            [0.47023963234489585, 44.67013893038542],
            [0.5697625560783459, 44.67013893038542],
            [0.590095196410986, 44.69990588586794],
            [0.6500229784440315, 44.69990588586794],
            [0.6601892986103515, 44.67994024499552],
            [0.7800448626764416, 44.67994024499552],
            [0.7902111828427616, 44.69990588586794],
            [0.8201750738592848, 44.69990588586794],
            [0.8399726447094871, 44.67013893038542],
            [0.8399726447094871, 44.64000896325067],
            [0.8201750738592848, 44.629844636988345],
            [0.8399726447094871, 44.609878996115924],
            [0.8699365357260094, 44.60007768150582],
            [0.9100667469088526, 44.62004332237825],
            [0.9298643177590549, 44.64000896325067],
            [0.9801608491082181, 44.64000896325067],
            [1.0502549513075827, 44.60007768150582],
            [1.070052522157786, 44.60007768150582],
            [1.080218842324106, 44.5801120406334],
            [1.0299223109749427, 44.549982073498654],
            [0.9897920997921004, 44.549982073498654],
            [0.9801608491082181, 44.54018075888855],
            [1.0197559908086227, 44.499886465491485],
            [1.0101247401247404, 44.490085150881384],
            [1.0299223109749427, 44.47011951000896],
            [1.0197559908086227, 44.45015386913654],
            [1.0299223109749427, 44.42982521661189],
            [1.059886201991465, 44.42982521661189],
            [1.059886201991465, 44.380092620256946],
            [1.0502549513075827, 44.360126979384525],
            [1.0197559908086227, 44.360126979384525],
            [0.9999584199584204, 44.36992829399462],
            [0.9801608491082181, 44.360126979384525],
            [0.9501969580916949, 44.360126979384525],
            [0.9202330670751726, 44.380092620256946],
            [0.8897341065762117, 44.36992829399462],
            [0.8897341065762117, 44.3499626531222],
            [0.8699365357260094, 44.31983268598745],
            [0.8999004267425326, 44.29986704511503],
            [0.9501969580916949, 44.27990140424261],
            [0.9202330670751726, 44.23997012249776],
            [0.9298643177590549, 44.23016880788766],
            [0.8999004267425326, 44.18987451449059],
            [0.8597702155596894, 44.18987451449059],
            [0.8501389648758071, 44.16990887361816],
            [0.8897341065762117, 44.16990887361816],
            [0.8897341065762117, 44.14014191813564],
            [0.8597702155596894, 44.12997759187332],
            [0.8201750738592848, 44.14014191813564],
            [0.7500809716599193, 44.09984762473857],
            [0.7399146514935993, 44.07008066925605],
            [0.6901531896268738, 44.05011502838363],
            [0.6799868694605538, 44.0301493875112],
            [0.6601892986103515, 44.01998506124888],
            [0.6302254075938292, 44.05991634299372],
            [0.600261516577306, 44.07008066925605],
            [0.5397986650618227, 44.05011502838363],
            [0.5098347740453004, 44.05991634299372],
            [0.4798708830287781, 44.05011502838363],
            [0.46007331217857583, 44.05991634299372],
            [0.4397406718459349, 44.0301493875112],
            [0.3798128898128903, 44.009820734986555],
            [0.3600153189626871, 44.01998506124888],
            [0.3198851077798448, 44.009820734986555],
            [0.3000875369296425, 43.989855094114134],
            [0.2797548965970016, 44.000019420376454],
            [0.2497910055804793, 44.000019420376454],
            [0.21019586388007472, 44.01998506124888],
            [0.1898632235474338, 44.009820734986555],
            [0.14973301236459147, 43.969889453241706],
            [0.12993544151438918, 44.000019420376454],
            [0.0801739796476637, 43.98005377950403],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 78, name: "Yvelines", REG: 11, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.680031732136995, 48.620068718255155],
            [1.6399015209541528, 48.64983567373768],
            [1.5997713097713095, 48.660000000000004],
            [1.6099376299376305, 48.69012996713475],
            [1.5799737389211073, 48.699931281744846],
            [1.6201039501039505, 48.739862563489694],
            [1.6099376299376305, 48.759828204362115],
            [1.5901400590874273, 48.76999253062444],
            [1.5799737389211073, 48.78995817149686],
            [1.5799737389211073, 48.86001942037646],
            [1.550009847904585, 48.86982073498656],
            [1.560176168070905, 48.89014938751121],
            [1.539843527738265, 48.91011502838363],
            [1.5098796367217417, 48.91991634299373],
            [1.5002483860378595, 48.93988198386615],
            [1.5002483860378595, 48.9700119510009],
            [1.4697494255388994, 48.98997759187332],
            [1.4799157457052194, 49.00994323274575],
            [1.4499518546886971, 49.04987451449059],
            [1.4799157457052194, 49.04987451449059],
            [1.5200459568880627, 49.06984015536301],
            [1.560176168070905, 49.06984015536301],
            [1.5698074187547872, 49.08000448162534],
            [1.6099376299376305, 49.08000448162534],
            [1.6201039501039505, 49.06984015536301],
            [1.669865411970675, 49.08000448162534],
            [1.7201619433198383, 49.040073199880496],
            [1.7501258343363606, 49.06003884075292],
            [1.7902560455192038, 49.06003884075292],
            [1.8202199365357261, 49.08000448162534],
            [1.8400175073859284, 49.06003884075292],
            [1.8699813984024516, 49.06003884075292],
            [1.8501838275522484, 49.02990887361817],
            [1.8801477185687716, 49.02990887361817],
            [1.910111609585294, 49.040073199880496],
            [1.9400755006018162, 49.02010755900807],
            [1.9898369624685417, 49.02010755900807],
            [2.019800853485064, 49.00014191813565],
            [2.049764744501587, 49.00014191813565],
            [2.059931064667907, 49.00994323274575],
            [2.1300251668672727, 49.00994323274575],
            [2.119858846700952, 48.98997759187332],
            [2.149822737717475, 48.98997759187332],
            [2.170155378050115, 48.980176277263226],
            [2.2001192690666374, 48.93988198386615],
            [2.2001192690666374, 48.91011502838363],
            [2.170155378050115, 48.8999507021213],
            [2.149822737717475, 48.86982073498656],
            [2.149822737717475, 48.82008813863161],
            [2.2001192690666374, 48.80012249775919],
            [2.2300831600831605, 48.78015685688677],
            [2.2300831600831605, 48.76999253062444],
            [2.2001192690666374, 48.76999253062444],
            [2.1401914870335927, 48.739862563489694],
            [2.1000612758507495, 48.739862563489694],
            [2.1102275960170696, 48.71009560800717],
            [2.0802637050005472, 48.69012996713475],
            [2.049764744501587, 48.69012996713475],
            [2.029967173651384, 48.679965640872425],
            [2.019800853485064, 48.64003435912758],
            [2.059931064667907, 48.620068718255155],
            [2.019800853485064, 48.58013743651031],
            [2.019800853485064, 48.560171795637885],
            [1.9400755006018162, 48.560171795637885],
            [1.9299091804354962, 48.550007469375565],
            [1.9598730714520194, 48.53004182850314],
            [1.9299091804354962, 48.49991186136839],
            [1.9197428602691762, 48.45998057962355],
            [1.899945289418974, 48.44001493875112],
            [1.8598150782361307, 48.44001493875112],
            [1.8298511872196084, 48.470144905885874],
            [1.799887296203086, 48.470144905885874],
            [1.7800897253528838, 48.510076187630716],
            [1.7902560455192038, 48.550007469375565],
            [1.7399595141700406, 48.569973110247986],
            [1.6998293029871983, 48.58013743651031],
            [1.7201619433198383, 48.609904391992835],
            [1.690198052303316, 48.609904391992835],
            [1.680031732136995, 48.620068718255155],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 69, name: "Rhône", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.759891673049569, 45.46005228562892],
            [4.7400941021993654, 45.46985360023902],
            [4.7400941021993654, 45.48981924111144],
            [4.699963891016522, 45.48001792650135],
            [4.670000000000001, 45.48001792650135],
            [4.650202429149798, 45.48981924111144],
            [4.650202429149798, 45.530113534508516],
            [4.659833679833681, 45.53991484911862],
            [4.689797570850202, 45.55007917538094],
            [4.670000000000001, 45.57004481625336],
            [4.650202429149798, 45.55007917538094],
            [4.659833679833681, 45.53991484911862],
            [4.640036108983478, 45.53991484911862],
            [4.629869788817158, 45.57004481625336],
            [4.610072217966954, 45.57984613086346],
            [4.589739577634314, 45.57004481625336],
            [4.55014443593391, 45.57984613086346],
            [4.520180544917387, 45.57004481625336],
            [4.499847904584747, 45.590010457125786],
            [4.469884013568225, 45.590010457125786],
            [4.439920122551702, 45.62014042426053],
            [4.390158660684977, 45.649907379743055],
            [4.369826020352337, 45.669873020615476],
            [4.369826020352337, 45.700002987750224],
            [4.390158660684977, 45.73993426949507],
            [4.390158660684977, 45.759899910367494],
            [4.360194769668454, 45.75009859575739],
            [4.350028449502134, 45.77006423662982],
            [4.379992340518657, 45.779865551239915],
            [4.379992340518657, 45.82996115924709],
            [4.399789911368859, 45.86009112638183],
            [4.390158660684977, 45.86989244099193],
            [4.360194769668454, 45.86989244099193],
            [4.339862129335814, 45.88005676725426],
            [4.330230878651931, 45.90002240812668],
            [4.350028449502134, 45.93015237526143],
            [4.29010066746909, 45.95011801613385],
            [4.30026698763541, 45.95991933074395],
            [4.27993434730277, 45.97988497161637],
            [4.260136776452566, 45.97988497161637],
            [4.239804136119926, 45.9998506124888],
            [4.29010066746909, 45.9998506124888],
            [4.27993434730277, 46.02017926501345],
            [4.249970456286246, 46.04994622049597],
            [4.29010066746909, 46.04994622049597],
            [4.309898238319291, 46.080076187630716],
            [4.309898238319291, 46.10984314311324],
            [4.330230878651931, 46.139973110247986],
            [4.360194769668454, 46.139973110247986],
            [4.379992340518657, 46.150137436510306],
            [4.409956231535179, 46.139973110247986],
            [4.439920122551702, 46.170103077382734],
            [4.409956231535179, 46.17990439199283],
            [4.390158660684977, 46.21983567373768],
            [4.390158660684977, 46.249965640872425],
            [4.409956231535179, 46.300061248879594],
            [4.460252762884342, 46.300061248879594],
            [4.499847904584747, 46.269931281744846],
            [4.55014443593391, 46.269931281744846],
            [4.569942006784113, 46.28009560800717],
            [4.620238538133276, 46.260129967134745],
            [4.620238538133276, 46.28009560800717],
            [4.640036108983478, 46.300061248879594],
            [4.689797570850202, 46.300061248879594],
            [4.710130211182844, 46.269931281744846],
            [4.680166320166321, 46.269931281744846],
            [4.689797570850202, 46.249965640872425],
            [4.719761461866725, 46.240164326262324],
            [4.719761461866725, 46.17990439199283],
            [4.7502604223656855, 46.170103077382734],
            [4.780224313382209, 46.17990439199283],
            [4.800021884232412, 46.15993875112041],
            [4.800021884232412, 46.139973110247986],
            [4.770057993215889, 46.12000746937556],
            [4.7502604223656855, 46.08987750224081],
            [4.759891673049569, 46.060110546758295],
            [4.7400941021993654, 46.04994622049597],
            [4.7502604223656855, 46.02998057962354],
            [4.7400941021993654, 46.02017926501345],
            [4.7502604223656855, 45.9998506124888],
            [4.7502604223656855, 45.95991933074395],
            [4.729927782033045, 45.95011801613385],
            [4.759891673049569, 45.93015237526143],
            [4.780224313382209, 45.93995368987153],
            [4.78985556406609, 45.9199880489991],
            [4.810188204398732, 45.9199880489991],
            [4.810188204398732, 45.90002240812668],
            [4.849783346099136, 45.90982372273678],
            [4.879747237115658, 45.90002240812668],
            [4.879747237115658, 45.88005676725426],
            [4.940210088631141, 45.80999551837466],
            [5.100195863880075, 45.80999551837466],
            [5.090029543713755, 45.79002987750224],
            [5.060065652697232, 45.79002987750224],
            [5.070231972863552, 45.77006423662982],
            [5.090029543713755, 45.77006423662982],
            [5.090029543713755, 45.73993426949507],
            [5.130159754896597, 45.73993426949507],
            [5.130159754896597, 45.73013295488497],
            [5.16012364591312, 45.719968628622645],
            [5.16012364591312, 45.700002987750224],
            [5.130159754896597, 45.71016731401255],
            [5.100195863880075, 45.700002987750224],
            [5.039733012364592, 45.649907379743055],
            [5.039733012364592, 45.62014042426053],
            [5.030101761680709, 45.60997609799821],
            [5.0001378706641875, 45.62014042426053],
            [5.0001378706641875, 45.60017478338811],
            [4.970173979647664, 45.60997609799821],
            [4.91024619761462, 45.60997609799821],
            [4.859949666265456, 45.590010457125786],
            [4.780224313382209, 45.590010457125786],
            [4.780224313382209, 45.57984613086346],
            [4.810188204398732, 45.57004481625336],
            [4.840152095415253, 45.53991484911862],
            [4.8701159864317765, 45.53991484911862],
            [4.849783346099136, 45.49998356737377],
            [4.840152095415253, 45.49998356737377],
            [4.759891673049569, 45.46005228562892],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 55, name: "Meuse", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.77010285589233, 48.49991186136839],
            [5.74977021555969, 48.490110546758295],
            [5.740138964875807, 48.470144905885874],
            [5.719806324543167, 48.45998057962355],
            [5.689842433526645, 48.470144905885874],
            [5.650247291826239, 48.45998057962355],
            [5.619748331327279, 48.44001493875112],
            [5.559820549294234, 48.44001493875112],
            [5.52022540759383, 48.4298506124888],
            [5.49989276726119, 48.40988497161638],
            [5.4699288762446665, 48.4200492978787],
            [5.429798665061823, 48.4298506124888],
            [5.3998347740453, 48.45998057962355],
            [5.369870883028779, 48.47994622049597],
            [5.3500733121785755, 48.47994622049597],
            [5.3297406718459355, 48.510076187630716],
            [5.269812889812891, 48.510076187630716],
            [5.230217748112486, 48.53004182850314],
            [5.2098851077798445, 48.53004182850314],
            [5.200253857095963, 48.550007469375565],
            [5.169754896597003, 48.560171795637885],
            [5.13979100558048, 48.560171795637885],
            [5.119993434730277, 48.600103077382734],
            [5.090029543713755, 48.58993875112041],
            [5.070231972863552, 48.600103077382734],
            [5.049899332530912, 48.629870032865256],
            [5.030101761680709, 48.609904391992835],
            [5.009769121348069, 48.609904391992835],
            [4.9899715504978674, 48.64983567373768],
            [5.009769121348069, 48.670164326262324],
            [4.9899715504978674, 48.679965640872425],
            [5.009769121348069, 48.699931281744846],
            [5.009769121348069, 48.739862563489694],
            [4.9899715504978674, 48.739862563489694],
            [4.930043768464821, 48.78995817149686],
            [4.88991355728198, 48.80012249775919],
            [4.88991355728198, 48.82008813863161],
            [4.940210088631141, 48.84005377950403],
            [4.91024619761462, 48.86982073498656],
            [4.930043768464821, 48.91011502838363],
            [4.949841339315024, 48.93008066925605],
            [4.970173979647664, 48.93008066925605],
            [5.030101761680709, 48.95004631012848],
            [5.039733012364592, 48.9700119510009],
            [5.030101761680709, 49.00014191813565],
            [5.039733012364592, 49.02010755900807],
            [5.009769121348069, 49.02990887361817],
            [4.970173979647664, 49.02010755900807],
            [5.009769121348069, 49.06003884075292],
            [5.0001378706641875, 49.06984015536301],
            [5.0001378706641875, 49.110134448760085],
            [4.970173979647664, 49.130100089632506],
            [4.940210088631141, 49.189997012249776],
            [4.9899715504978674, 49.209962653122204],
            [4.970173979647664, 49.24009262025695],
            [4.949841339315024, 49.24009262025695],
            [5.0001378706641875, 49.26005826112937],
            [5.009769121348069, 49.269859575739474],
            [5.049899332530912, 49.269859575739474],
            [5.060065652697232, 49.289825216611895],
            [5.030101761680709, 49.31015386913654],
            [5.039733012364592, 49.31995518374664],
            [5.030101761680709, 49.339920824619064],
            [5.060065652697232, 49.359886465491485],
            [5.090029543713755, 49.37005079175381],
            [5.100195863880075, 49.39001643262623],
            [5.079863223547435, 49.40018075888856],
            [5.109827114563957, 49.42014639976098],
            [5.100195863880075, 49.44011204063341],
            [5.109827114563957, 49.46007768150583],
            [5.079863223547435, 49.46987899611592],
            [5.079863223547435, 49.510173289513],
            [5.100195863880075, 49.53013893038542],
            [5.090029543713755, 49.53994024499552],
            [5.109827114563957, 49.55990588586795],
            [5.109827114563957, 49.59003585300269],
            [5.1499573257468, 49.59003585300269],
            [5.179921216763323, 49.57007021213027],
            [5.230217748112486, 49.57007021213027],
            [5.250015318962688, 49.55990588586795],
            [5.260181639129008, 49.53994024499552],
            [5.279979209979211, 49.53994024499552],
            [5.309943100995732, 49.55990588586795],
            [5.3399069920122555, 49.59003585300269],
            [5.380037203195099, 49.59003585300269],
            [5.390203523361419, 49.62016582013744],
            [5.429798665061823, 49.59003585300269],
            [5.450131305394463, 49.55010457125785],
            [5.4699288762446665, 49.53994024499552],
            [5.450131305394463, 49.5199746041231],
            [5.4699288762446665, 49.50000896325068],
            [5.4699288762446665, 49.48004332237825],
            [5.4597625560783465, 49.48004332237825],
            [5.4699288762446665, 49.48004332237825],
            [5.4597625560783465, 49.46987899611592],
            [5.4902615165773065, 49.4499133552435],
            [5.4800951964109865, 49.42994771437108],
            [5.4902615165773065, 49.40998207349866],
            [5.4800951964109865, 49.40018075888856],
            [5.49989276726119, 49.40998207349866],
            [5.529856658277711, 49.40998207349866],
            [5.550189298610351, 49.42014639976098],
            [5.619748331327279, 49.42014639976098],
            [5.629914651493599, 49.44011204063341],
            [5.680211182842762, 49.42014639976098],
            [5.689842433526645, 49.39001643262623],
            [5.710175073859285, 49.37985210636391],
            [5.710175073859285, 49.359886465491485],
            [5.740138964875807, 49.359886465491485],
            [5.740138964875807, 49.339920824619064],
            [5.719806324543167, 49.33011951000897],
            [5.729972644709487, 49.31015386913654],
            [5.75993653572601, 49.31015386913654],
            [5.77010285589233, 49.299989542874215],
            [5.75993653572601, 49.280023902001794],
            [5.719806324543167, 49.269859575739474],
            [5.719806324543167, 49.249893934867046],
            [5.740138964875807, 49.229928293994625],
            [5.719806324543167, 49.220126979384524],
            [5.729972644709487, 49.2001613385121],
            [5.77010285589233, 49.2001613385121],
            [5.74977021555969, 49.15986704511503],
            [5.75993653572601, 49.13990140424261],
            [5.74977021555969, 49.11993576337019],
            [5.75993653572601, 49.110134448760085],
            [5.8198643177590546, 49.110134448760085],
            [5.810233067075173, 49.06003884075292],
            [5.840196958091696, 49.06984015536301],
            [5.849828208775578, 49.040073199880496],
            [5.8198643177590546, 49.02010755900807],
            [5.830030637925375, 48.980176277263226],
            [5.849828208775578, 48.95984762473857],
            [5.830030637925375, 48.93988198386615],
            [5.800066746908853, 48.95004631012848],
            [5.779734106576213, 48.93008066925605],
            [5.74977021555969, 48.91991634299373],
            [5.789900426742533, 48.89014938751121],
            [5.77010285589233, 48.86982073498656],
            [5.779734106576213, 48.84005377950403],
            [5.77010285589233, 48.78995817149686],
            [5.719806324543167, 48.75002688975202],
            [5.719806324543167, 48.73006124887959],
            [5.74977021555969, 48.71009560800717],
            [5.75993653572601, 48.69012996713475],
            [5.740138964875807, 48.660000000000004],
            [5.75993653572601, 48.620068718255155],
            [5.800066746908853, 48.629870032865256],
            [5.800066746908853, 48.609904391992835],
            [5.74977021555969, 48.609904391992835],
            [5.719806324543167, 48.58993875112041],
            [5.710175073859285, 48.569973110247986],
            [5.729972644709487, 48.550007469375565],
            [5.75993653572601, 48.550007469375565],
            [5.779734106576213, 48.53984314311324],
            [5.75993653572601, 48.51987750224082],
            [5.77010285589233, 48.49991186136839],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 92,
        name: "Hauts-de-Seine",
        REG: 11,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.2300831600831605, 48.76999253062444],
            [2.2300831600831605, 48.78015685688677],
            [2.2001192690666374, 48.80012249775919],
            [2.149822737717475, 48.82008813863161],
            [2.149822737717475, 48.86982073498656],
            [2.170155378050115, 48.8999507021213],
            [2.2001192690666374, 48.91011502838363],
            [2.270213371266003, 48.95004631012848],
            [2.290010942116205, 48.95004631012848],
            [2.3098085129664083, 48.95004631012848],
            [2.3397724039829306, 48.93008066925605],
            [2.3098085129664083, 48.91011502838363],
            [2.3199748331327283, 48.8999507021213],
            [2.279844621949885, 48.87998506124888],
            [2.249880730933363, 48.87998506124888],
            [2.2300831600831605, 48.86982073498656],
            [2.2199168399168405, 48.84985509411413],
            [2.249880730933363, 48.84985509411413],
            [2.260047051099683, 48.82988945324171],
            [2.300177262282526, 48.82988945324171],
            [2.3301411532990484, 48.82008813863161],
            [2.3199748331327283, 48.80992381236929],
            [2.3199748331327283, 48.75002688975202],
            [2.279844621949885, 48.73006124887959],
            [2.270213371266003, 48.739862563489694],
            [2.279844621949885, 48.759828204362115],
            [2.249880730933363, 48.759828204362115],
            [2.2300831600831605, 48.76999253062444],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 86, name: "Vienne", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.8201750738592848, 46.130171795637885],
            [0.7902111828427616, 46.130171795637885],
            [0.7500809716599193, 46.139973110247986],
            [0.7099507604770761, 46.139973110247986],
            [0.6698205492942337, 46.10004182850314],
            [0.6098927672611882, 46.080076187630716],
            [0.5697625560783459, 46.080076187630716],
            [0.5601313053944637, 46.08987750224081],
            [0.5002035233614182, 46.12000746937556],
            [0.47023963234489585, 46.130171795637885],
            [0.4499069920122549, 46.08987750224081],
            [0.4798708830287781, 46.080076187630716],
            [0.47023963234489585, 46.060110546758295],
            [0.4499069920122549, 46.04994622049597],
            [0.4097767808294126, 46.04994622049597],
            [0.3498489987963671, 46.06991186136839],
            [0.3198851077798448, 46.060110546758295],
            [0.2797548965970016, 46.060110546758295],
            [0.2599573257467993, 46.080076187630716],
            [0.24015975489659702, 46.080076187630716],
            [0.2000295437137547, 46.10004182850314],
            [0.1898632235474338, 46.10984314311324],
            [0.2000295437137547, 46.130171795637885],
            [0.21982711456395698, 46.139973110247986],
            [0.21982711456395698, 46.15993875112041],
            [0.18023197286355153, 46.150137436510306],
            [0.1401017616807092, 46.17990439199283],
            [0.1101378706641869, 46.190068718255155],
            [0.1401017616807092, 46.240164326262324],
            [0.12993544151438918, 46.269931281744846],
            [0.1598993325309115, 46.269931281744846],
            [0.1700656526972315, 46.28009560800717],
            [0.14973301236459147, 46.300061248879594],
            [0.18023197286355153, 46.329828204362116],
            [0.1401017616807092, 46.35015685688676],
            [0.09997155049786599, 46.329828204362116],
            [0.0801739796476637, 46.300061248879594],
            [0.0202461976146191, 46.33999253062444],
            [0.010079877448298191, 46.359958171496864],
            [0.029877448298501363, 46.37012249775919],
            [0.010079877448298191, 46.39008813863161],
            [-0.010252762884341848, 46.39008813863161],
            [-0.019884013568224113, 46.41005377950403],
            [-0.010252762884341848, 46.43001942037646],
            [-0.010252762884341848, 46.4699507021213],
            [-0.04021665390086415, 46.4699507021213],
            [-0.04021665390086415, 46.50008066925605],
            [-0.030050333734544132, 46.52004631012847],
            [-0.010252762884341848, 46.52004631012847],
            [0.010079877448298191, 46.55017627726322],
            [-0.010252762884341848, 46.55997759187332],
            [0.029877448298501363, 46.59010755900807],
            [0.0202461976146191, 46.61007319988049],
            [-0.010252762884341848, 46.61987451449059],
            [-0.00008644271802182857, 46.63984015536301],
            [-0.07018054491738734, 46.61987451449059],
            [-0.060014224751066436, 46.63984015536301],
            [-0.04021665390086415, 46.65000448162534],
            [-0.030050333734544132, 46.66997012249776],
            [-0.010252762884341848, 46.680134448760086],
            [-0.00008644271802182857, 46.72006573050493],
            [0.0202461976146191, 46.740031371377356],
            [-0.019884013568224113, 46.770161338512104],
            [-0.019884013568224113, 46.810092620256945],
            [-0.049847904584746416, 46.819893934867046],
            [-0.030050333734544132, 46.83985957573947],
            [-0.00008644271802182857, 46.850023902001794],
            [-0.010252762884341848, 46.869989542874215],
            [-0.04021665390086415, 46.869989542874215],
            [-0.010252762884341848, 46.909920824619064],
            [-0.019884013568224113, 46.94005079175381],
            [-0.049847904584746416, 46.97018075888856],
            [-0.04021665390086415, 46.99014639976098],
            [-0.08997811576758963, 46.99014639976098],
            [-0.08997811576758963, 47.039878996115924],
            [-0.10014443593390965, 47.05984463698835],
            [-0.10014443593390965, 47.0899746041231],
            [-0.04021665390086415, 47.0899746041231],
            [-0.030050333734544132, 47.10013893038542],
            [-0.030050333734544132, 47.12990588586794],
            [-0.010252762884341848, 47.16003585300269],
            [0.0202461976146191, 47.18000149387511],
            [0.0502100886311414, 47.16003585300269],
            [0.0801739796476637, 47.14987152674037],
            [0.0801739796476637, 47.12010457125784],
            [0.1101378706641869, 47.12990588586794],
            [0.12993544151438918, 47.12010457125784],
            [0.1598993325309115, 47.10013893038542],
            [0.18023197286355153, 47.12010457125784],
            [0.2000295437137547, 47.0899746041231],
            [0.18023197286355153, 47.07000896325067],
            [0.21019586388007472, 47.05004332237825],
            [0.24015975489659702, 47.07000896325067],
            [0.2599573257467993, 47.07000896325067],
            [0.2599573257467993, 47.05004332237825],
            [0.31025385709596254, 47.05004332237825],
            [0.3000875369296425, 47.0199133552435],
            [0.31025385709596254, 46.979982073498654],
            [0.3000875369296425, 46.96001643262623],
            [0.31025385709596254, 46.94005079175381],
            [0.3300514279461648, 46.929886465491485],
            [0.3600153189626871, 46.949852106363906],
            [0.3899792099792103, 46.94005079175381],
            [0.4397406718459349, 46.94005079175381],
            [0.49003720319509814, 46.96001643262623],
            [0.600261516577306, 46.96001643262623],
            [0.5697625560783459, 46.979982073498654],
            [0.590095196410986, 47.0101120406334],
            [0.6200590874275083, 47.0101120406334],
            [0.6200590874275083, 46.99014639976098],
            [0.6601892986103515, 46.99014639976098],
            [0.6901531896268738, 46.97018075888856],
            [0.7099507604770761, 46.94005079175381],
            [0.699784440310756, 46.90011951000896],
            [0.7698785425101216, 46.850023902001794],
            [0.7998424335266439, 46.850023902001794],
            [0.8100087536929648, 46.83005826112937],
            [0.8100087536929648, 46.790126979384524],
            [0.829806324543167, 46.790126979384524],
            [0.8399726447094871, 46.75999701224978],
            [0.8699365357260094, 46.74983268598745],
            [0.8999004267425326, 46.740031371377356],
            [0.9202330670751726, 46.70010008963251],
            [0.9100667469088526, 46.680134448760086],
            [0.9100667469088526, 46.65000448162534],
            [0.8999004267425326, 46.63003884075292],
            [0.9202330670751726, 46.59990887361817],
            [0.9598282087755772, 46.57994323274574],
            [0.9598282087755772, 46.57014191813565],
            [1.0101247401247404, 46.57014191813565],
            [1.0197559908086227, 46.5400119510009],
            [1.0898500930079882, 46.5400119510009],
            [1.1401466243571505, 46.50008066925605],
            [1.1497778750410328, 46.44998506124888],
            [1.1701105153736737, 46.44998506124888],
            [1.210240726556516, 46.43001942037646],
            [1.189908086223876, 46.41005377950403],
            [1.200074406390196, 46.39988945324171],
            [1.179741766057556, 46.379923812369285],
            [1.1599441952073537, 46.39008813863161],
            [1.1497778750410328, 46.37012249775919],
            [1.1101827333406282, 46.35015685688676],
            [1.1000164131743082, 46.359958171496864],
            [1.0502549513075827, 46.359958171496864],
            [1.0299223109749427, 46.33999253062444],
            [1.0299223109749427, 46.320026889752015],
            [0.9897920997921004, 46.28009560800717],
            [0.9699945289418972, 46.289896922617274],
            [0.9400306379253749, 46.289896922617274],
            [0.9298643177590549, 46.28009560800717],
            [0.8999004267425326, 46.289896922617274],
            [0.8897341065762117, 46.269931281744846],
            [0.8597702155596894, 46.260129967134745],
            [0.8501389648758071, 46.230000000000004],
            [0.8100087536929648, 46.230000000000004],
            [0.7902111828427616, 46.210034359127576],
            [0.829806324543167, 46.17990439199283],
            [0.829806324543167, 46.15993875112041],
            [0.8501389648758071, 46.139973110247986],
            [0.8201750738592848, 46.130171795637885],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 36, name: "Indre", REG: 24, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.170155378050115, 46.41985509411413],
            [2.119858846700952, 46.41985509411413],
            [2.1000612758507495, 46.41005377950403],
            [2.0700973848342272, 46.41985509411413],
            [2.029967173651384, 46.41985509411413],
            [2.019800853485064, 46.43001942037646],
            [1.9898369624685417, 46.43001942037646],
            [1.9802057117846594, 46.439820734986554],
            [1.9299091804354962, 46.43001942037646],
            [1.9197428602691762, 46.439820734986554],
            [1.8897789692526539, 46.439820734986554],
            [1.8801477185687716, 46.43001942037646],
            [1.8202199365357261, 46.43001942037646],
            [1.799887296203086, 46.44998506124888],
            [1.7501258343363606, 46.44998506124888],
            [1.7597570850202429, 46.43001942037646],
            [1.7501258343363606, 46.41005377950403],
            [1.7099956231535183, 46.39008813863161],
            [1.680031732136995, 46.41985509411413],
            [1.6602341612867928, 46.39988945324171],
            [1.6297352007878327, 46.39008813863161],
            [1.5901400590874273, 46.41005377950403],
            [1.550009847904585, 46.39988945324171],
            [1.5302122770543827, 46.43001942037646],
            [1.5098796367217417, 46.41985509411413],
            [1.4799157457052194, 46.39008813863161],
            [1.4199879636721748, 46.35015685688676],
            [1.3600601816391293, 46.39988945324171],
            [1.3199299704562861, 46.39008813863161],
            [1.309763650289966, 46.37012249775919],
            [1.2797997592734438, 46.379923812369285],
            [1.2498358682569215, 46.379923812369285],
            [1.2402046175730392, 46.37012249775919],
            [1.210240726556516, 46.37012249775919],
            [1.210240726556516, 46.39008813863161],
            [1.179741766057556, 46.379923812369285],
            [1.200074406390196, 46.39988945324171],
            [1.189908086223876, 46.41005377950403],
            [1.210240726556516, 46.43001942037646],
            [1.1701105153736737, 46.44998506124888],
            [1.1497778750410328, 46.44998506124888],
            [1.1401466243571505, 46.50008066925605],
            [1.0898500930079882, 46.5400119510009],
            [1.0197559908086227, 46.5400119510009],
            [1.0101247401247404, 46.57014191813565],
            [0.9598282087755772, 46.57014191813565],
            [0.9598282087755772, 46.57994323274574],
            [0.9202330670751726, 46.59990887361817],
            [0.8999004267425326, 46.63003884075292],
            [0.9100667469088526, 46.65000448162534],
            [0.9100667469088526, 46.680134448760086],
            [0.9202330670751726, 46.70010008963251],
            [0.8999004267425326, 46.740031371377356],
            [0.8699365357260094, 46.74983268598745],
            [0.8897341065762117, 46.75999701224978],
            [0.9298643177590549, 46.75999701224978],
            [0.9501969580916949, 46.740031371377356],
            [0.9801608491082181, 46.75999701224978],
            [1.0101247401247404, 46.75999701224978],
            [0.9897920997921004, 46.799928293994626],
            [1.0101247401247404, 46.810092620256945],
            [1.0101247401247404, 46.83985957573947],
            [1.0299223109749427, 46.88015386913654],
            [1.0299223109749427, 46.909920824619064],
            [1.0400886311412627, 46.949852106363906],
            [1.059886201991465, 46.949852106363906],
            [1.0502549513075827, 46.979982073498654],
            [1.080218842324106, 47.0199133552435],
            [1.1101827333406282, 47.03007768150583],
            [1.1198139840245105, 47.0199133552435],
            [1.1599441952073537, 47.039878996115924],
            [1.210240726556516, 47.03007768150583],
            [1.2300382974067183, 47.0101120406334],
            [1.2797997592734438, 47.039878996115924],
            [1.2899660794397638, 47.07000896325067],
            [1.3199299704562861, 47.080173289513],
            [1.3199299704562861, 47.10013893038542],
            [1.3600601816391293, 47.10994024499552],
            [1.3600601816391293, 47.14007021213027],
            [1.330096290622607, 47.19016582013744],
            [1.3498938614728093, 47.19016582013744],
            [1.4499518546886971, 47.23989841649238],
            [1.4799157457052194, 47.23989841649238],
            [1.5200459568880627, 47.230097101882286],
            [1.5302122770543827, 47.25006274275471],
            [1.5200459568880627, 47.25986405736481],
            [1.5901400590874273, 47.25986405736481],
            [1.6201039501039505, 47.27002838362713],
            [1.6500678411204728, 47.25986405736481],
            [1.6998293029871983, 47.25986405736481],
            [1.7201619433198383, 47.27982969823723],
            [1.7501258343363606, 47.25006274275471],
            [1.7800897253528838, 47.230097101882286],
            [1.810053616369406, 47.230097101882286],
            [1.8400175073859284, 47.21993277561996],
            [1.8400175073859284, 47.18000149387511],
            [1.810053616369406, 47.16983716761279],
            [1.810053616369406, 47.14987152674037],
            [1.7800897253528838, 47.12990588586794],
            [1.799887296203086, 47.12010457125784],
            [1.8298511872196084, 47.12010457125784],
            [1.8801477185687716, 47.10013893038542],
            [1.910111609585294, 47.10994024499552],
            [1.9197428602691762, 47.10013893038542],
            [1.9502418207681371, 47.12010457125784],
            [2.0000032826348617, 47.12990588586794],
            [2.0000032826348617, 47.10013893038542],
            [2.049764744501587, 47.10013893038542],
            [2.059931064667907, 47.080173289513],
            [2.029967173651384, 47.05004332237825],
            [2.1000612758507495, 47.0101120406334],
            [2.0898949556844295, 46.97018075888856],
            [2.0700973848342272, 46.949852106363906],
            [2.0700973848342272, 46.929886465491485],
            [2.1102275960170696, 46.909920824619064],
            [2.1401914870335927, 46.92008515088139],
            [2.149822737717475, 46.909920824619064],
            [2.1401914870335927, 46.889955183746636],
            [2.1000612758507495, 46.869989542874215],
            [2.0898949556844295, 46.850023902001794],
            [2.059931064667907, 46.83005826112937],
            [2.0700973848342272, 46.810092620256945],
            [2.1102275960170696, 46.7799626531222],
            [2.0700973848342272, 46.74983268598745],
            [2.0700973848342272, 46.72986704511503],
            [2.0898949556844295, 46.72986704511503],
            [2.0898949556844295, 46.70990140424261],
            [2.1300251668672727, 46.70990140424261],
            [2.159989057883795, 46.68993576337019],
            [2.1401914870335927, 46.66997012249776],
            [2.1797866287339973, 46.65000448162534],
            [2.1899529489003173, 46.61987451449059],
            [2.170155378050115, 46.59990887361817],
            [2.170155378050115, 46.57014191813565],
            [2.159989057883795, 46.55997759187332],
            [2.2001192690666374, 46.48991634299372],
            [2.1899529489003173, 46.4699507021213],
            [2.149822737717475, 46.46014938751121],
            [2.170155378050115, 46.41985509411413],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 42, name: "Loire", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.9000350147718565, 45.35986106961458],
            [3.8898686946055365, 45.38999103674933],
            [3.9000350147718565, 45.40995667762175],
            [3.970129116971223, 45.4498879593666],
            [3.970129116971223, 45.46985360023902],
            [3.9899266878214243, 45.48981924111144],
            [3.959962796804903, 45.49998356737377],
            [3.949796476638583, 45.55988048999104],
            [3.9102013349381766, 45.60017478338811],
            [3.880237443921655, 45.60017478338811],
            [3.859904803589015, 45.62014042426053],
            [3.819774592406172, 45.62994173887063],
            [3.819774592406172, 45.649907379743055],
            [3.7898107013896487, 45.669873020615476],
            [3.7801794507057673, 45.6898386614879],
            [3.7801794507057673, 45.719968628622645],
            [3.7598468103731273, 45.75009859575739],
            [3.729882919356604, 45.759899910367494],
            [3.729882919356604, 45.779865551239915],
            [3.699919028340081, 45.779865551239915],
            [3.729882919356604, 45.82996115924709],
            [3.720251668672721, 45.84992680011951],
            [3.750215559689244, 45.889858081864354],
            [3.740049239522924, 45.90982372273678],
            [3.689752708173761, 45.93015237526143],
            [3.699919028340081, 45.97008365700628],
            [3.7801794507057673, 45.97008365700628],
            [3.8101433417222887, 45.97988497161637],
            [3.829940912572492, 45.9998506124888],
            [3.8101433417222887, 46.04014490588587],
            [3.819774592406172, 46.08987750224081],
            [3.7999770215559687, 46.10984314311324],
            [3.7898107013896487, 46.15993875112041],
            [3.8101433417222887, 46.15993875112041],
            [3.7898107013896487, 46.190068718255155],
            [3.7898107013896487, 46.210034359127576],
            [3.7700131305394473, 46.230000000000004],
            [3.7999770215559687, 46.240164326262324],
            [3.8101433417222887, 46.260129967134745],
            [3.870071123755335, 46.260129967134745],
            [3.880237443921655, 46.28009560800717],
            [3.9000350147718565, 46.28009560800717],
            [3.9102013349381766, 46.240164326262324],
            [3.8898686946055365, 46.210034359127576],
            [3.9198325856220597, 46.199870032865256],
            [3.9401652259546998, 46.210034359127576],
            [3.970129116971223, 46.199870032865256],
            [3.9899266878214243, 46.170103077382734],
            [4.030056899004268, 46.170103077382734],
            [4.060020790020791, 46.190068718255155],
            [4.100151001203634, 46.199870032865256],
            [4.130114892220155, 46.17990439199283],
            [4.17987635408688, 46.170103077382734],
            [4.17987635408688, 46.190068718255155],
            [4.249970456286246, 46.190068718255155],
            [4.260136776452566, 46.17990439199283],
            [4.249970456286246, 46.15993875112041],
            [4.27993434730277, 46.15993875112041],
            [4.29010066746909, 46.170103077382734],
            [4.320064558485611, 46.170103077382734],
            [4.390158660684977, 46.21983567373768],
            [4.409956231535179, 46.17990439199283],
            [4.439920122551702, 46.170103077382734],
            [4.409956231535179, 46.139973110247986],
            [4.379992340518657, 46.150137436510306],
            [4.360194769668454, 46.139973110247986],
            [4.330230878651931, 46.139973110247986],
            [4.309898238319291, 46.10984314311324],
            [4.309898238319291, 46.080076187630716],
            [4.29010066746909, 46.04994622049597],
            [4.249970456286246, 46.04994622049597],
            [4.27993434730277, 46.02017926501345],
            [4.29010066746909, 45.9998506124888],
            [4.239804136119926, 45.9998506124888],
            [4.260136776452566, 45.97988497161637],
            [4.27993434730277, 45.97988497161637],
            [4.30026698763541, 45.95991933074395],
            [4.29010066746909, 45.95011801613385],
            [4.350028449502134, 45.93015237526143],
            [4.330230878651931, 45.90002240812668],
            [4.339862129335814, 45.88005676725426],
            [4.360194769668454, 45.86989244099193],
            [4.390158660684977, 45.86989244099193],
            [4.399789911368859, 45.86009112638183],
            [4.379992340518657, 45.82996115924709],
            [4.379992340518657, 45.779865551239915],
            [4.350028449502134, 45.77006423662982],
            [4.360194769668454, 45.75009859575739],
            [4.390158660684977, 45.759899910367494],
            [4.390158660684977, 45.73993426949507],
            [4.369826020352337, 45.700002987750224],
            [4.369826020352337, 45.669873020615476],
            [4.390158660684977, 45.649907379743055],
            [4.439920122551702, 45.62014042426053],
            [4.469884013568225, 45.590010457125786],
            [4.499847904584747, 45.590010457125786],
            [4.520180544917387, 45.57004481625336],
            [4.55014443593391, 45.57984613086346],
            [4.589739577634314, 45.57004481625336],
            [4.610072217966954, 45.57984613086346],
            [4.629869788817158, 45.57004481625336],
            [4.640036108983478, 45.53991484911862],
            [4.659833679833681, 45.53991484911862],
            [4.650202429149798, 45.55007917538094],
            [4.670000000000001, 45.57004481625336],
            [4.689797570850202, 45.55007917538094],
            [4.659833679833681, 45.53991484911862],
            [4.650202429149798, 45.530113534508516],
            [4.650202429149798, 45.48981924111144],
            [4.670000000000001, 45.48001792650135],
            [4.699963891016522, 45.48001792650135],
            [4.7400941021993654, 45.48981924111144],
            [4.7400941021993654, 45.46985360023902],
            [4.759891673049569, 45.46005228562892],
            [4.759891673049569, 45.42992231849418],
            [4.7400941021993654, 45.42012100388408],
            [4.759891673049569, 45.37002539587691],
            [4.719761461866725, 45.35005975500448],
            [4.680166320166321, 45.35005975500448],
            [4.640036108983478, 45.33009411413206],
            [4.620238538133276, 45.31012847325964],
            [4.620238538133276, 45.29016283238721],
            [4.599905897800634, 45.29016283238721],
            [4.589739577634314, 45.26983417986256],
            [4.610072217966954, 45.24986853899014],
            [4.580108326950433, 45.24006722438004],
            [4.559775686617793, 45.24986853899014],
            [4.510014224751067, 45.229902898117714],
            [4.480050333734545, 45.24006722438004],
            [4.420122551701499, 45.27999850612489],
            [4.390158660684977, 45.26003286525246],
            [4.369826020352337, 45.26003286525246],
            [4.350028449502134, 45.27999850612489],
            [4.350028449502134, 45.29996414699731],
            [4.330230878651931, 45.31992978786973],
            [4.360194769668454, 45.33989542874216],
            [4.339862129335814, 45.37002539587691],
            [4.309898238319291, 45.35986106961458],
            [4.269768027136448, 45.35986106961458],
            [4.239804136119926, 45.38999103674933],
            [4.200208994419522, 45.379826710487],
            [4.160078783236679, 45.38999103674933],
            [4.109782251887515, 45.35986106961458],
            [4.079818360870992, 45.35986106961458],
            [4.079818360870992, 45.33989542874216],
            [4.030056899004268, 45.35005975500448],
            [4.010259328154066, 45.33009411413206],
            [4.000093007987744, 45.35986106961458],
            [3.9797603676551043, 45.379826710487],
            [3.9401652259546998, 45.37002539587691],
            [3.9198325856220597, 45.35005975500448],
            [3.9000350147718565, 45.35986106961458],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: "06",
        name: "Alpes-Maritimes",
        REG: 93,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7.329830397198818, 43.700171795637885],
            [7.299866506182297, 43.69000746937556],
            [7.250105044315572, 43.69000746937556],
            [7.22977240398293, 43.67984314311323],
            [7.22977240398293, 43.65987750224081],
            [7.209974833132729, 43.65007618763072],
            [7.180010942116206, 43.65987750224081],
            [7.160213371266004, 43.65007618763072],
            [7.130249480249481, 43.61994622049597],
            [7.130249480249481, 43.56985061248879],
            [7.099750519750521, 43.56985061248879],
            [7.069786628733998, 43.5600492978787],
            [7.039822737717475, 43.54008365700627],
            [7.030191487033593, 43.54988497161637],
            [6.970263705000547, 43.54988497161637],
            [6.939764744501587, 43.52011801613385],
            [6.949931064667907, 43.4899880489991],
            [6.9301334938177055, 43.479823722736775],
            [6.900169602801182, 43.50015237526143],
            [6.900169602801182, 43.52011801613385],
            [6.879836962468542, 43.52991933074395],
            [6.9098008534850655, 43.56985061248879],
            [6.900169602801182, 43.58001493875112],
            [6.9098008534850655, 43.59998057962354],
            [6.890003282634862, 43.61014490588587],
            [6.840241820768138, 43.61014490588587],
            [6.7899452894189745, 43.63991186136839],
            [6.779778969252654, 43.65987750224081],
            [6.759981398402451, 43.67004182850314],
            [6.770147718568771, 43.69000746937556],
            [6.770147718568771, 43.720137436510306],
            [6.749815078236131, 43.74010307738273],
            [6.710219936535727, 43.74010307738273],
            [6.689887296203087, 43.760068718255155],
            [6.6599234051865634, 43.74990439199283],
            [6.640125834336362, 43.76987003286525],
            [6.640125834336362, 43.78983567373768],
            [6.640125834336362, 43.8],
            [6.689887296203087, 43.8],
            [6.700053616369407, 43.819965640872425],
            [6.6700897253528835, 43.830129967134745],
            [6.6802560455192035, 43.850095608007166],
            [6.719851187219608, 43.879862563489695],
            [6.749815078236131, 43.870061248879594],
            [6.779778969252654, 43.879862563489695],
            [6.8001116095852945, 43.909992530624436],
            [6.830075500601818, 43.92015685688676],
            [6.879836962468542, 43.899828204362116],
            [6.879836962468542, 43.890026889752015],
            [6.9199671736513855, 43.890026889752015],
            [6.939764744501587, 43.899828204362116],
            [6.9098008534850655, 43.929958171496864],
            [6.890003282634862, 43.929958171496864],
            [6.849873071452019, 43.96008813863161],
            [6.840241820768138, 43.989855094114134],
            [6.749815078236131, 44.0399507021213],
            [6.759981398402451, 44.079881983866144],
            [6.710219936535727, 44.12017627726322],
            [6.689887296203087, 44.16990887361816],
            [6.719851187219608, 44.20984015536301],
            [6.719851187219608, 44.250134448760086],
            [6.759981398402451, 44.25993576337018],
            [6.759981398402451, 44.27990140424261],
            [6.7899452894189745, 44.27010008963251],
            [6.8001116095852945, 44.31983268598745],
            [6.890003282634862, 44.360126979384525],
            [6.9098008534850655, 44.360126979384525],
            [6.9301334938177055, 44.32999701224978],
            [6.960097384834227, 44.31003137137735],
            [6.970263705000547, 44.29006573050493],
            [7.00022759601707, 44.27010008963251],
            [7.00022759601707, 44.250134448760086],
            [7.039822737717475, 44.22000448162534],
            [7.079952948900318, 44.23016880788766],
            [7.1398807309333625, 44.20003884075291],
            [7.160213371266004, 44.20984015536301],
            [7.199808512966409, 44.18007319988049],
            [7.23993872414925, 44.16990887361816],
            [7.2597362949994535, 44.14994323274574],
            [7.290235255498414, 44.14014191813564],
            [7.33999671736514, 44.14994323274574],
            [7.359794288215341, 44.12017627726322],
            [7.3897581792318645, 44.12017627726322],
            [7.429888390414708, 44.11001195100089],
            [7.429888390414708, 44.12997759187332],
            [7.459852281431229, 44.12997759187332],
            [7.540112703796916, 44.14994323274574],
            [7.619838056680163, 44.14994323274574],
            [7.640170697012803, 44.18007319988049],
            [7.679765838713208, 44.18007319988049],
            [7.670134588029325, 44.14994323274574],
            [7.679765838713208, 44.14014191813564],
            [7.670134588029325, 44.12017627726322],
            [7.689932158879528, 44.11001195100089],
            [7.719896049896051, 44.079881983866144],
            [7.700098479045848, 44.0399507021213],
            [7.659968267863005, 44.0301493875112],
            [7.670134588029325, 44.000019420376454],
            [7.649801947696685, 43.98005377950403],
            [7.61020680599628, 43.96008813863161],
            [7.570076594813437, 43.949923812369285],
            [7.559910274647117, 43.899828204362116],
            [7.510148812780392, 43.879862563489695],
            [7.499982492614072, 43.850095608007166],
            [7.510148812780392, 43.839931281744846],
            [7.5197800634642755, 43.8],
            [7.510148812780392, 43.780034359127576],
            [7.480184921763869, 43.760068718255155],
            [7.459852281431229, 43.760068718255155],
            [7.420257139730825, 43.74010307738273],
            [7.420257139730825, 43.720137436510306],
            [7.359794288215341, 43.720137436510306],
            [7.329830397198818, 43.700171795637885],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 38, name: "Isère", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.800021884232412, 45.29996414699731],
            [4.759891673049569, 45.31992978786973],
            [4.770057993215889, 45.35005975500448],
            [4.759891673049569, 45.37002539587691],
            [4.7400941021993654, 45.42012100388408],
            [4.759891673049569, 45.42992231849418],
            [4.759891673049569, 45.46005228562892],
            [4.840152095415253, 45.49998356737377],
            [4.849783346099136, 45.49998356737377],
            [4.8701159864317765, 45.53991484911862],
            [4.840152095415253, 45.53991484911862],
            [4.810188204398732, 45.57004481625336],
            [4.780224313382209, 45.57984613086346],
            [4.780224313382209, 45.590010457125786],
            [4.859949666265456, 45.590010457125786],
            [4.91024619761462, 45.60997609799821],
            [4.970173979647664, 45.60997609799821],
            [5.0001378706641875, 45.60017478338811],
            [5.0001378706641875, 45.62014042426053],
            [5.030101761680709, 45.60997609799821],
            [5.039733012364592, 45.62014042426053],
            [5.039733012364592, 45.649907379743055],
            [5.100195863880075, 45.700002987750224],
            [5.130159754896597, 45.71016731401255],
            [5.16012364591312, 45.700002987750224],
            [5.16012364591312, 45.719968628622645],
            [5.130159754896597, 45.73013295488497],
            [5.130159754896597, 45.73993426949507],
            [5.090029543713755, 45.73993426949507],
            [5.090029543713755, 45.77006423662982],
            [5.070231972863552, 45.77006423662982],
            [5.060065652697232, 45.79002987750224],
            [5.090029543713755, 45.79002987750224],
            [5.100195863880075, 45.80999551837466],
            [5.13979100558048, 45.799831192112336],
            [5.169754896597003, 45.799831192112336],
            [5.190087536929643, 45.779865551239915],
            [5.2200514279461645, 45.77006423662982],
            [5.260181639129008, 45.779865551239915],
            [5.290145530145531, 45.80999551837466],
            [5.299776780829412, 45.84992680011951],
            [5.3297406718459355, 45.86009112638183],
            [5.3500733121785755, 45.88005676725426],
            [5.420167414377942, 45.84992680011951],
            [5.429798665061823, 45.82996115924709],
            [5.420167414377942, 45.80999551837466],
            [5.4597625560783465, 45.779865551239915],
            [5.4800951964109865, 45.75009859575739],
            [5.52022540759383, 45.73013295488497],
            [5.559820549294234, 45.700002987750224],
            [5.550189298610351, 45.6800373468778],
            [5.559820549294234, 45.669873020615476],
            [5.5897844403107575, 45.669873020615476],
            [5.619748331327279, 45.60997609799821],
            [5.670044862676442, 45.55988048999104],
            [5.670044862676442, 45.55007917538094],
            [5.700008753692965, 45.51994920824619],
            [5.719806324543167, 45.48001792650135],
            [5.740138964875807, 45.46985360023902],
            [5.729972644709487, 45.4498879593666],
            [5.740138964875807, 45.4400866447565],
            [5.789900426742533, 45.4400866447565],
            [5.830030637925375, 45.42012100388408],
            [5.879792099792101, 45.40995667762175],
            [5.889958419958421, 45.38999103674933],
            [5.909755990808622, 45.38999103674933],
            [5.930088631141262, 45.40995667762175],
            [5.900124740124741, 45.42992231849418],
            [5.919922310974942, 45.4400866447565],
            [5.930088631141262, 45.46005228562892],
            [5.919922310974942, 45.48001792650135],
            [5.970218842324106, 45.48981924111144],
            [6.00981398402451, 45.46985360023902],
            [6.00981398402451, 45.4498879593666],
            [6.049944195207353, 45.4400866447565],
            [6.090074406390197, 45.4400866447565],
            [6.100240726556517, 45.42992231849418],
            [6.13020461757304, 45.4400866447565],
            [6.150002188423241, 45.40995667762175],
            [6.179966079439764, 45.38999103674933],
            [6.190132399606084, 45.37002539587691],
            [6.179966079439764, 45.35986106961458],
            [6.190132399606084, 45.33009411413206],
            [6.139835868256921, 45.29996414699731],
            [6.13020461757304, 45.27999850612489],
            [6.139835868256921, 45.26003286525246],
            [6.13020461757304, 45.229902898117714],
            [6.160168508589561, 45.18997161637287],
            [6.139835868256921, 45.150040334628024],
            [6.169799759273444, 45.150040334628024],
            [6.179966079439764, 45.159841649238125],
            [6.209929970456288, 45.159841649238125],
            [6.220096290622608, 45.139876008365704],
            [6.239893861472809, 45.150040334628024],
            [6.260226501805449, 45.1300746937556],
            [6.230262610788928, 45.11010905288318],
            [6.239893861472809, 45.07017777113833],
            [6.220096290622608, 45.07017777113833],
            [6.199763650289966, 45.00991783686884],
            [6.250060181639129, 45.000116522258736],
            [6.320154283838495, 45.000116522258736],
            [6.329785534522377, 44.95002091425157],
            [6.3597494255389, 44.93985658798924],
            [6.350118174855017, 44.91989094711682],
            [6.350118174855017, 44.87995966537198],
            [6.3597494255389, 44.84982969823723],
            [6.339951854688697, 44.84982969823723],
            [6.299821643505855, 44.870158350761876],
            [6.269857752489332, 44.870158350761876],
            [6.250060181639129, 44.84982969823723],
            [6.199763650289966, 44.85999402449955],
            [6.169799759273444, 44.84982969823723],
            [6.160168508589561, 44.85999402449955],
            [6.13020461757304, 44.85999402449955],
            [6.060110515373673, 44.82006274275471],
            [6.030146624357152, 44.84002838362713],
            [6.000182733340629, 44.82006274275471],
            [5.979850093007989, 44.82006274275471],
            [5.960052522157786, 44.80009710188228],
            [5.979850093007989, 44.78013146100986],
            [5.949886201991466, 44.76996713474753],
            [5.919922310974942, 44.75000149387511],
            [5.849828208775578, 44.75000149387511],
            [5.830030637925375, 44.73983716761279],
            [5.810233067075173, 44.71007021213027],
            [5.800066746908853, 44.71007021213027],
            [5.75993653572601, 44.69990588586794],
            [5.700008753692965, 44.71987152674036],
            [5.650247291826239, 44.71987152674036],
            [5.6101170806433975, 44.76016582013744],
            [5.5897844403107575, 44.76016582013744],
            [5.580153189626874, 44.78013146100986],
            [5.550189298610351, 44.78993277561996],
            [5.550189298610351, 44.76996713474753],
            [5.4800951964109865, 44.78993277561996],
            [5.4800951964109865, 44.80989841649238],
            [5.4597625560783465, 44.8298640573648],
            [5.4800951964109865, 44.8999253062444],
            [5.4800951964109865, 44.969986555123995],
            [5.4902615165773065, 44.989952195996416],
            [5.4699288762446665, 45.049849118613686],
            [5.4902615165773065, 45.079979085748434],
            [5.4699288762446665, 45.090143412010754],
            [5.439964985228143, 45.060013444876006],
            [5.3998347740453, 45.040047804003585],
            [5.369870883028779, 45.040047804003585],
            [5.3399069920122555, 45.060013444876006],
            [5.269812889812891, 45.060013444876006],
            [5.250015318962688, 45.060013444876006],
            [5.230217748112486, 45.079979085748434],
            [5.179921216763323, 45.079979085748434],
            [5.16012364591312, 45.099944726620855],
            [5.190087536929643, 45.119910367493276],
            [5.190087536929643, 45.170005975500445],
            [5.169754896597003, 45.18997161637287],
            [5.179921216763323, 45.22010158350762],
            [5.179921216763323, 45.24986853899014],
            [5.119993434730277, 45.24986853899014],
            [5.119993434730277, 45.29016283238721],
            [5.090029543713755, 45.29016283238721],
            [5.049899332530912, 45.31992978786973],
            [5.019935441514389, 45.31992978786973],
            [5.009769121348069, 45.33989542874216],
            [4.979805230331547, 45.33989542874216],
            [4.879747237115658, 45.29996414699731],
            [4.859949666265456, 45.31012847325964],
            [4.800021884232412, 45.29996414699731],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 19, name: "Corrèze", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.2001192690666374, 45.22010158350762],
            [2.2001192690666374, 45.18017030176277],
            [2.2199168399168405, 45.170005975500445],
            [2.1899529489003173, 45.119910367493276],
            [2.1797866287339973, 45.090143412010754],
            [2.1401914870335927, 45.090143412010754],
            [2.1000612758507495, 45.060013444876006],
            [2.119858846700952, 45.020082163131164],
            [2.1401914870335927, 45.00991783686884],
            [2.1300251668672727, 44.989952195996416],
            [2.1102275960170696, 44.980150881386315],
            [2.059931064667907, 44.980150881386315],
            [2.0101696028011817, 44.980150881386315],
            [1.9400755006018162, 44.95002091425157],
            [1.9400755006018162, 44.969986555123995],
            [1.910111609585294, 44.980150881386315],
            [1.8897789692526539, 44.95982222886167],
            [1.8501838275522484, 44.95002091425157],
            [1.8298511872196084, 44.930055273379146],
            [1.7699234051865629, 44.930055273379146],
            [1.7501258343363606, 44.93985658798924],
            [1.7501258343363606, 44.95982222886167],
            [1.7099956231535183, 44.969986555123995],
            [1.6998293029871983, 44.989952195996416],
            [1.669865411970675, 45.000116522258736],
            [1.6500678411204728, 45.02988347774126],
            [1.6099376299376305, 45.02988347774126],
            [1.5799737389211073, 45.040047804003585],
            [1.550009847904585, 45.02988347774126],
            [1.539843527738265, 45.040047804003585],
            [1.5098796367217417, 45.040047804003585],
            [1.4499518546886971, 45.020082163131164],
            [1.409821643505854, 45.049849118613686],
            [1.409821643505854, 45.07017777113833],
            [1.3798577524893316, 45.11010905288318],
            [1.409821643505854, 45.11010905288318],
            [1.4001903928219717, 45.1300746937556],
            [1.3798577524893316, 45.139876008365704],
            [1.2899660794397638, 45.139876008365704],
            [1.2600021884232415, 45.159841649238125],
            [1.2797997592734438, 45.170005975500445],
            [1.2899660794397638, 45.18997161637287],
            [1.2701685085895615, 45.20013594263519],
            [1.2300382974067183, 45.20013594263519],
            [1.2300382974067183, 45.22010158350762],
            [1.2797997592734438, 45.24006722438004],
            [1.2300382974067183, 45.26983417986256],
            [1.2402046175730392, 45.29016283238721],
            [1.2402046175730392, 45.31992978786973],
            [1.2600021884232415, 45.31992978786973],
            [1.3001323996060838, 45.35986106961458],
            [1.3199299704562861, 45.35986106961458],
            [1.3199299704562861, 45.379826710487],
            [1.3001323996060838, 45.38999103674933],
            [1.2701685085895615, 45.38999103674933],
            [1.2600021884232415, 45.40015536301165],
            [1.2701685085895615, 45.4400866447565],
            [1.2498358682569215, 45.4400866447565],
            [1.2600021884232415, 45.46985360023902],
            [1.2899660794397638, 45.48981924111144],
            [1.3498938614728093, 45.46985360023902],
            [1.4001903928219717, 45.510147893636095],
            [1.409821643505854, 45.530113534508516],
            [1.4301542838384949, 45.530113534508516],
            [1.4499518546886971, 45.55007917538094],
            [1.5098796367217417, 45.55007917538094],
            [1.5200459568880627, 45.55988048999104],
            [1.550009847904585, 45.55007917538094],
            [1.5799737389211073, 45.55988048999104],
            [1.5901400590874273, 45.57984613086346],
            [1.6297352007878327, 45.57984613086346],
            [1.6500678411204728, 45.590010457125786],
            [1.6602341612867928, 45.60997609799821],
            [1.7201619433198383, 45.640106065132954],
            [1.7800897253528838, 45.660071706005375],
            [1.7902560455192038, 45.6800373468778],
            [1.8202199365357261, 45.669873020615476],
            [1.8501838275522484, 45.669873020615476],
            [1.8699813984024516, 45.660071706005375],
            [1.8801477185687716, 45.6800373468778],
            [1.910111609585294, 45.6800373468778],
            [1.899945289418974, 45.700002987750224],
            [1.9502418207681371, 45.719968628622645],
            [1.9898369624685417, 45.719968628622645],
            [2.0000032826348617, 45.75009859575739],
            [2.040133493817705, 45.759899910367494],
            [2.0802637050005472, 45.75009859575739],
            [2.0802637050005472, 45.73013295488497],
            [2.1300251668672727, 45.73013295488497],
            [2.159989057883795, 45.719968628622645],
            [2.2001192690666374, 45.719968628622645],
            [2.1899529489003173, 45.700002987750224],
            [2.2300831600831605, 45.700002987750224],
            [2.2402494802494806, 45.6898386614879],
            [2.270213371266003, 45.6898386614879],
            [2.290010942116205, 45.669873020615476],
            [2.3199748331327283, 45.669873020615476],
            [2.3499387241492506, 45.6898386614879],
            [2.3499387241492506, 45.71016731401255],
            [2.409866506182296, 45.71016731401255],
            [2.4398303971988184, 45.700002987750224],
            [2.4901269285479817, 45.73993426949507],
            [2.520090819564504, 45.71016731401255],
            [2.530257139730824, 45.6898386614879],
            [2.509924499398184, 45.669873020615476],
            [2.530257139730824, 45.660071706005375],
            [2.520090819564504, 45.640106065132954],
            [2.4799606083816617, 45.640106065132954],
            [2.4799606083816617, 45.60997609799821],
            [2.4601630375314585, 45.590010457125786],
            [2.520090819564504, 45.55007917538094],
            [2.509924499398184, 45.51994920824619],
            [2.509924499398184, 45.48001792650135],
            [2.4901269285479817, 45.42012100388408],
            [2.530257139730824, 45.38999103674933],
            [2.520090819564504, 45.379826710487],
            [2.4398303971988184, 45.379826710487],
            [2.4398303971988184, 45.38999103674933],
            [2.390068935332094, 45.40995667762175],
            [2.3499387241492506, 45.40995667762175],
            [2.369736294999453, 45.38999103674933],
            [2.3601050443155707, 45.379826710487],
            [2.3601050443155707, 45.33989542874216],
            [2.3199748331327283, 45.31992978786973],
            [2.290010942116205, 45.29016283238721],
            [2.270213371266003, 45.29016283238721],
            [2.260047051099683, 45.26983417986256],
            [2.2402494802494806, 45.26983417986256],
            [2.2402494802494806, 45.24986853899014],
            [2.2001192690666374, 45.229902898117714],
            [2.2001192690666374, 45.22010158350762],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 66,
        name: "Pyrénées-Orientales",
        REG: 76,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.1702002407265573, 42.44015835076188],
            [3.140236349710034, 42.42999402449955],
            [3.079773498194551, 42.42999402449955],
            [3.0498096071780294, 42.44995966537197],
            [3.0401783564941463, 42.4699253062444],
            [2.9700842542947816, 42.4699253062444],
            [2.94975161396214, 42.48008963250672],
            [2.9197877229456184, 42.4601239916343],
            [2.889823831929095, 42.4601239916343],
            [2.870026261078893, 42.4699253062444],
            [2.8400623700623706, 42.4601239916343],
            [2.8298960498960506, 42.44015835076188],
            [2.8100984790458474, 42.44015835076188],
            [2.7999321588795274, 42.41982969823722],
            [2.769968267863005, 42.41002838362713],
            [2.750170697012803, 42.42999402449955],
            [2.6699102746471173, 42.3998640573648],
            [2.6597439544807973, 42.37009710188228],
            [2.6800765948134373, 42.35013146100986],
            [2.6597439544807973, 42.33996713474753],
            [2.5901849217638695, 42.35993277561995],
            [2.560221030747347, 42.35013146100986],
            [2.5398883904147063, 42.33016582013744],
            [2.4799606083816617, 42.33996713474753],
            [2.4697942882153407, 42.35993277561995],
            [2.430199146514936, 42.3900627427547],
            [2.409866506182296, 42.3900627427547],
            [2.3397724039829306, 42.41002838362713],
            [2.3199748331327283, 42.42999402449955],
            [2.290010942116205, 42.41982969823722],
            [2.260047051099683, 42.44015835076188],
            [2.2001192690666374, 42.41982969823722],
            [2.159989057883795, 42.41982969823722],
            [2.1300251668672727, 42.41002838362713],
            [2.0898949556844295, 42.35993277561995],
            [1.9898369624685417, 42.35993277561995],
            [1.9700393916183394, 42.37989841649238],
            [1.9598730714520194, 42.41982969823722],
            [1.9400755006018162, 42.42999402449955],
            [1.9299091804354962, 42.44995966537197],
            [1.8897789692526539, 42.44995966537197],
            [1.8598150782361307, 42.4601239916343],
            [1.8400175073859284, 42.48008963250672],
            [1.810053616369406, 42.48989094711682],
            [1.7297931940037206, 42.48989094711682],
            [1.7201619433198383, 42.52002091425157],
            [1.7501258343363606, 42.559952195996416],
            [1.7902560455192038, 42.570116522258736],
            [1.8202199365357261, 42.57991783686884],
            [1.8699813984024516, 42.57991783686884],
            [1.8897789692526539, 42.59008216313116],
            [1.8897789692526539, 42.610047804003585],
            [1.9400755006018162, 42.610047804003585],
            [1.9502418207681371, 42.61984911861368],
            [1.9802057117846594, 42.61984911861368],
            [1.9898369624685417, 42.64997908574843],
            [2.019800853485064, 42.64997908574843],
            [2.0700973848342272, 42.669944726620855],
            [2.1102275960170696, 42.660143412010754],
            [2.170155378050115, 42.660143412010754],
            [2.1899529489003173, 42.660143412010754],
            [2.2402494802494806, 42.680109052883175],
            [2.260047051099683, 42.7000746937556],
            [2.290010942116205, 42.7000746937556],
            [2.3601050443155707, 42.729841649238125],
            [2.3397724039829306, 42.77013594263519],
            [2.3397724039829306, 42.799902898117715],
            [2.3199748331327283, 42.83003286525246],
            [2.369736294999453, 42.849998506124884],
            [2.400235255498414, 42.839834179862564],
            [2.4601630375314585, 42.839834179862564],
            [2.499758179231864, 42.849998506124884],
            [2.520090819564504, 42.839834179862564],
            [2.560221030747347, 42.849998506124884],
            [2.5698522814312295, 42.839834179862564],
            [2.5998161724477518, 42.839834179862564],
            [2.639946383630594, 42.83003286525246],
            [2.6699102746471173, 42.839834179862564],
            [2.6800765948134373, 42.83003286525246],
            [2.729838056680162, 42.83003286525246],
            [2.759801947696685, 42.86996414699731],
            [2.8100984790458474, 42.90009411413206],
            [2.870026261078893, 42.92005975500448],
            [2.880192581245213, 42.90009411413206],
            [2.9101564722617352, 42.90009411413206],
            [2.9197877229456184, 42.88012847325963],
            [2.9802505744611016, 42.86996414699731],
            [3.010214465477623, 42.849998506124884],
            [3.0401783564941463, 42.839834179862564],
            [3.0401783564941463, 42.7000746937556],
            [3.0401783564941463, 42.59988347774126],
            [3.0498096071780294, 42.59008216313116],
            [3.0498096071780294, 42.550150881386315],
            [3.100106138527191, 42.52002091425157],
            [3.130070029543714, 42.50985658798924],
            [3.130070029543714, 42.48008963250672],
            [3.1600339205602372, 42.4699253062444],
            [3.1702002407265573, 42.44015835076188],
          ],
          [
            [1.9598730714520194, 42.4699253062444],
            [1.9598730714520194, 42.44995966537197],
            [1.9898369624685417, 42.4601239916343],
            [1.9898369624685417, 42.48989094711682],
            [1.9598730714520194, 42.48008963250672],
            [1.9598730714520194, 42.4699253062444],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 53, name: "Mayenne", REG: 52, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.2398424335266442, 47.809826710487],
            [-1.2200448626764415, 47.81999103674933],
            [-1.2200448626764415, 47.85012100388408],
            [-1.1900809716599192, 47.8700866447565],
            [-1.2002472918262392, 47.890052285628926],
            [-1.1601170806433965, 47.92998356737377],
            [-1.1601170806433965, 47.960113534508515],
            [-1.1301531896268737, 47.96991484911862],
            [-1.1199868694605537, 47.98988048999104],
            [-1.090022978444031, 47.98988048999104],
            [-1.079856658277711, 47.980079175380936],
            [-1.0498927672611886, 47.980079175380936],
            [-1.0199288762446654, 48.000044816253364],
            [-1.0300951964109855, 48.03017478338811],
            [-1.0300951964109855, 48.070106065132954],
            [-1.0498927672611886, 48.09007170600538],
            [-1.0600590874275087, 48.130002987750224],
            [-1.0600590874275087, 48.16013295488497],
            [-1.079856658277711, 48.1800985957574],
            [-1.0702254075938287, 48.20006423662982],
            [-1.100189298610351, 48.25015984463699],
            [-1.090022978444031, 48.29009112638184],
            [-1.0600590874275087, 48.31005676725426],
            [-1.0498927672611886, 48.33002240812668],
            [-1.0600590874275087, 48.33982372273678],
            [-1.0600590874275087, 48.380118016133856],
            [-1.079856658277711, 48.4200492978787],
            [-1.0702254075938287, 48.450179265013446],
            [-1.0702254075938287, 48.47994622049597],
            [-1.079856658277711, 48.490110546758295],
            [-1.0702254075938287, 48.510076187630716],
            [-1.0600590874275087, 48.51987750224082],
            [-1.0097625560783454, 48.490110546758295],
            [-0.9701674143779409, 48.490110546758295],
            [-0.9600010942116208, 48.510076187630716],
            [-0.9198708830287776, 48.510076187630716],
            [-0.9000733121785753, 48.490110546758295],
            [-0.8599431009957321, 48.49991186136839],
            [-0.8198128898128898, 48.47994622049597],
            [-0.8101816391290075, 48.450179265013446],
            [-0.7802177481124852, 48.450179265013446],
            [-0.7598851077798443, 48.44001493875112],
            [-0.719754896597002, 48.450179265013446],
            [-0.729921216763322, 48.470144905885874],
            [-0.6801597548965974, 48.470144905885874],
            [-0.6501958638800742, 48.450179265013446],
            [-0.589733012364591, 48.470144905885874],
            [-0.5501378706641864, 48.470144905885874],
            [-0.5100076594813441, 48.510076187630716],
            [-0.4902100886311409, 48.49991186136839],
            [-0.46987744829850087, 48.510076187630716],
            [-0.3901520954152531, 48.510076187630716],
            [-0.35002188423241076, 48.47994622049597],
            [-0.32005799321588757, 48.51987750224082],
            [-0.2697614618667252, 48.51987750224082],
            [-0.23979757085020204, 48.53984314311324],
            [-0.23979757085020204, 48.560171795637885],
            [-0.20020242914979747, 48.560171795637885],
            [-0.17986978881715743, 48.53984314311324],
            [-0.17023853813327516, 48.49991186136839],
            [-0.14990589780063424, 48.47994622049597],
            [-0.13973957763431422, 48.450179265013446],
            [-0.049847904584746416, 48.450179265013446],
            [-0.060014224751066436, 48.4298506124888],
            [-0.049847904584746416, 48.380118016133856],
            [-0.07981179560126961, 48.36995368987153],
            [-0.11994200678411193, 48.36995368987153],
            [-0.13973957763431422, 48.36015237526143],
            [-0.11994200678411193, 48.33982372273678],
            [-0.16007221796695514, 48.33982372273678],
            [-0.13973957763431422, 48.29009112638184],
            [-0.16007221796695514, 48.25996115924709],
            [-0.14990589780063424, 48.22002987750224],
            [-0.16007221796695514, 48.20006423662982],
            [-0.19003610898347745, 48.1800985957574],
            [-0.24996389101652294, 48.16013295488497],
            [-0.24996389101652294, 48.14016731401255],
            [-0.21999999999999975, 48.119838661487904],
            [-0.23979757085020204, 48.09007170600538],
            [-0.23016632016631977, 48.059941738870634],
            [-0.27992778203304525, 48.059941738870634],
            [-0.29009410219936527, 48.05014042426053],
            [-0.3302243133822085, 48.05014042426053],
            [-0.33985556406609074, 48.009846130863465],
            [-0.30989167304956755, 48.009846130863465],
            [-0.3002604223656853, 47.96991484911862],
            [-0.27992778203304525, 47.949949208246196],
            [-0.3002604223656853, 47.940147893636095],
            [-0.3302243133822085, 47.940147893636095],
            [-0.33985556406609074, 47.92998356737377],
            [-0.3901520954152531, 47.92998356737377],
            [-0.40994966626545537, 47.91001792650135],
            [-0.36981945508261305, 47.8798879593666],
            [-0.37998577524893307, 47.85992231849418],
            [-0.40994966626545537, 47.85992231849418],
            [-0.42974723711565854, 47.85012100388408],
            [-0.43991355728197856, 47.830155363011656],
            [-0.4201159864317763, 47.80002539587691],
            [-0.3901520954152531, 47.809826710487],
            [-0.37998577524893307, 47.76989542874216],
            [-0.37998577524893307, 47.76009411413206],
            [-0.35002188423241076, 47.70999850612489],
            [-0.3302243133822085, 47.72016283238722],
            [-0.29009410219936527, 47.72016283238722],
            [-0.23979757085020204, 47.69983417986256],
            [-0.20020242914979747, 47.72996414699731],
            [-0.17986978881715743, 47.70999850612489],
            [-0.21999999999999975, 47.69003286525247],
            [-0.21999999999999975, 47.67986853899014],
            [-0.19003610898347745, 47.65010158350762],
            [-0.17023853813327516, 47.63993725724529],
            [-0.10977568661779191, 47.63993725724529],
            [-0.10977568661779191, 47.65990289811772],
            [-0.07981179560126961, 47.65990289811772],
            [-0.019884013568224113, 47.63993725724529],
            [-0.00008644271802182857, 47.65010158350762],
            [0.010079877448298191, 47.61997161637287],
            [0.07000765948134369, 47.61017030176277],
            [0.14973301236459147, 47.58004033462802],
            [0.18023197286355153, 47.589841649238124],
            [0.2000295437137547, 47.61017030176277],
            [0.229993434730277, 47.61017030176277],
            [0.2000295437137547, 47.61017030176277],
            [0.18023197286355153, 47.589841649238124],
            [0.14973301236459147, 47.58004033462802],
            [0.07000765948134369, 47.61017030176277],
            [0.010079877448298191, 47.61997161637287],
            [-0.00008644271802182857, 47.65010158350762],
            [-0.019884013568224113, 47.63993725724529],
            [-0.07981179560126961, 47.65990289811772],
            [-0.10977568661779191, 47.65990289811772],
            [-0.10977568661779191, 47.63993725724529],
            [-0.17023853813327516, 47.63993725724529],
            [-0.19003610898347745, 47.65010158350762],
            [-0.21999999999999975, 47.67986853899014],
            [-0.21999999999999975, 47.69003286525247],
            [-0.17986978881715743, 47.70999850612489],
            [-0.20020242914979747, 47.72996414699731],
            [-0.23979757085020204, 47.69983417986256],
            [-0.29009410219936527, 47.72016283238722],
            [-0.3302243133822085, 47.72016283238722],
            [-0.35002188423241076, 47.70999850612489],
            [-0.37998577524893307, 47.76009411413206],
            [-0.37998577524893307, 47.76989542874216],
            [-0.40994966626545537, 47.78005975500449],
            [-0.4500798774482986, 47.76009411413206],
            [-0.4800437684648209, 47.78005975500449],
            [-0.5201739796476641, 47.78986106961458],
            [-0.5298052303315464, 47.74992978786973],
            [-0.5801017616807087, 47.76009411413206],
            [-0.6100656526972319, 47.74012847325964],
            [-0.750253857095962, 47.74012847325964],
            [-0.7802177481124852, 47.74992978786973],
            [-0.8101816391290075, 47.76989542874216],
            [-0.8401455301455298, 47.76989542874216],
            [-0.8599431009957321, 47.76009411413206],
            [-0.8899069920122553, 47.76009411413206],
            [-0.9000733121785753, 47.76989542874216],
            [-0.9600010942116208, 47.80002539587691],
            [-0.9797986650618231, 47.76009411413206],
            [-1.0097625560783454, 47.76989542874216],
            [-1.079856658277711, 47.76989542874216],
            [-1.100189298610351, 47.78005975500449],
            [-1.1799146514935988, 47.78005975500449],
            [-1.2002472918262392, 47.80002539587691],
            [-1.2398424335266442, 47.809826710487],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 64,
        name: "Pyrénées-Atlantiques",
        REG: 75,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-1.5202188423241054, 43.52991933074395],
            [-1.4800886311412627, 43.54008365700627],
            [-1.4597559908086226, 43.52011801613385],
            [-1.4201608491082176, 43.50015237526143],
            [-1.290138964875807, 43.50015237526143],
            [-1.2500087536929643, 43.52011801613385],
            [-1.1697483313272787, 43.54988497161637],
            [-1.1301531896268737, 43.50995368987152],
            [-1.0199288762446654, 43.50995368987152],
            [-0.9899649852281431, 43.50015237526143],
            [-0.9899649852281431, 43.52991933074395],
            [-0.9102396323448954, 43.54988497161637],
            [-0.870109421162053, 43.54988497161637],
            [-0.8599431009957321, 43.54008365700627],
            [-0.8198128898128898, 43.5600492978787],
            [-0.7898489987963675, 43.5600492978787],
            [-0.7700514279461643, 43.58001493875112],
            [-0.729921216763322, 43.5600492978787],
            [-0.6598271145639565, 43.5600492978787],
            [-0.5998993325309119, 43.54008365700627],
            [-0.5699354415143887, 43.5600492978787],
            [-0.5501378706641864, 43.54008365700627],
            [-0.5298052303315464, 43.5600492978787],
            [-0.4500798774482986, 43.59998057962354],
            [-0.42974723711565854, 43.58001493875112],
            [-0.4602461976146186, 43.5600492978787],
            [-0.43991355728197856, 43.54988497161637],
            [-0.40994966626545537, 43.56985061248879],
            [-0.35002188423241076, 43.5600492978787],
            [-0.33985556406609074, 43.54988497161637],
            [-0.29009410219936527, 43.56985061248879],
            [-0.26013021118284296, 43.59017926501345],
            [-0.23979757085020204, 43.58001493875112],
            [-0.17986978881715743, 43.59998057962354],
            [-0.14990589780063424, 43.59017926501345],
            [-0.11994200678411193, 43.59017926501345],
            [-0.10014443593390965, 43.58001493875112],
            [-0.07018054491738734, 43.54988497161637],
            [-0.060014224751066436, 43.52991933074395],
            [-0.04021665390086415, 43.52011801613385],
            [-0.049847904584746416, 43.50015237526143],
            [-0.030050333734544132, 43.47002240812668],
            [-0.07018054491738734, 43.459858081864354],
            [-0.060014224751066436, 43.45005676725425],
            [-0.07018054491738734, 43.43009112638183],
            [-0.04021665390086415, 43.41992680011951],
            [-0.019884013568224113, 43.43989244099193],
            [0.010079877448298191, 43.41992680011951],
            [-0.00008644271802182857, 43.399961159247084],
            [-0.00008644271802182857, 43.369831192112336],
            [0.029877448298501363, 43.349865551239915],
            [0.010079877448298191, 43.329899910367494],
            [-0.030050333734544132, 43.329899910367494],
            [-0.04021665390086415, 43.280167314012544],
            [-0.019884013568224113, 43.270002987750225],
            [-0.04021665390086415, 43.230071706005376],
            [-0.07018054491738734, 43.21990737974305],
            [-0.07018054491738734, 43.17997609799821],
            [-0.10977568661779191, 43.17997609799821],
            [-0.13010832695043195, 43.170174783388106],
            [-0.14990589780063424, 43.12988048999104],
            [-0.17986978881715743, 43.10991484911861],
            [-0.20020242914979747, 43.06998356737377],
            [-0.19003610898347745, 43.05001792650134],
            [-0.21999999999999975, 43.03005228562892],
            [-0.26013021118284296, 43.03985360023902],
            [-0.26013021118284296, 43.0100866447565],
            [-0.29009410219936527, 43.0100866447565],
            [-0.29009410219936527, 42.95999103674933],
            [-0.27992778203304525, 42.92986106961458],
            [-0.30989167304956755, 42.92005975500448],
            [-0.32005799321588757, 42.88012847325963],
            [-0.30989167304956755, 42.849998506124884],
            [-0.3302243133822085, 42.83003286525246],
            [-0.35002188423241076, 42.839834179862564],
            [-0.3601882043987308, 42.819868538990136],
            [-0.3901520954152531, 42.799902898117715],
            [-0.40994966626545537, 42.81006722438004],
            [-0.43991355728197856, 42.799902898117715],
            [-0.5100076594813441, 42.83003286525246],
            [-0.5298052303315464, 42.79010158350762],
            [-0.5699354415143887, 42.779937257245294],
            [-0.5699354415143887, 42.81006722438004],
            [-0.5998993325309119, 42.81006722438004],
            [-0.5998993325309119, 42.83003286525246],
            [-0.6598271145639565, 42.86016283238721],
            [-0.6801597548965974, 42.88012847325963],
            [-0.6999573257467997, 42.88012847325963],
            [-0.729921216763322, 42.90009411413206],
            [-0.729921216763322, 42.949826710487],
            [-0.750253857095962, 42.97015536301165],
            [-0.8101816391290075, 42.949826710487],
            [-0.8599431009957321, 42.949826710487],
            [-0.8797406718459353, 42.95999103674933],
            [-0.9102396323448954, 42.95999103674933],
            [-0.9198708830287776, 42.949826710487],
            [-0.9701674143779409, 42.95999103674933],
            [-1.0097625560783454, 42.99012100388407],
            [-1.0702254075938287, 42.99992231849417],
            [-1.1098205492942332, 43.01988795936659],
            [-1.139784440310756, 43.0100866447565],
            [-1.1697483313272787, 43.03985360023902],
            [-1.1799146514935988, 43.03005228562892],
            [-1.2098785425101215, 43.05001792650134],
            [-1.2601750738592843, 43.03985360023902],
            [-1.2698063245431666, 43.05981924111144],
            [-1.3099365357260093, 43.06998356737377],
            [-1.2997702155596893, 43.08994920824619],
            [-1.2698063245431666, 43.12007917538094],
            [-1.329734106576212, 43.10991484911861],
            [-1.350066746908852, 43.08994920824619],
            [-1.339900426742532, 43.08014789363609],
            [-1.339900426742532, 43.05001792650134],
            [-1.350066746908852, 43.03005228562892],
            [-1.3698643177590548, 43.03005228562892],
            [-1.4399584199584199, 43.05001792650134],
            [-1.4597559908086226, 43.05981924111144],
            [-1.4699223109749426, 43.08014789363609],
            [-1.4597559908086226, 43.100113534508516],
            [-1.4099945289418976, 43.14004481625336],
            [-1.3998282087755771, 43.17997609799821],
            [-1.3800306379253748, 43.190140424260534],
            [-1.3800306379253748, 43.2500373468778],
            [-1.3998282087755771, 43.270002987750225],
            [-1.4699223109749426, 43.270002987750225],
            [-1.5100525221577854, 43.289968628622645],
            [-1.5598139840245104, 43.289968628622645],
            [-1.5699803041908305, 43.2500373468778],
            [-1.6101105153736732, 43.2500373468778],
            [-1.629908086223876, 43.280167314012544],
            [-1.6197417660575555, 43.30013295488497],
            [-1.640074406390196, 43.309934269495066],
            [-1.700002188423241, 43.309934269495066],
            [-1.7299660794397638, 43.30013295488497],
            [-1.749763650289966, 43.340064236629814],
            [-1.7898938614728088, 43.349865551239915],
            [-1.7802626107889266, 43.369831192112336],
            [-1.749763650289966, 43.39015984463699],
            [-1.7299660794397638, 43.37999551837466],
            [-1.689835868256921, 43.399961159247084],
            [-1.6700382974067187, 43.399961159247084],
            [-1.5999441952073532, 43.43009112638183],
            [-1.5699803041908305, 43.479823722736775],
            [-1.5501827333406282, 43.4899880489991],
            [-1.5202188423241054, 43.52991933074395],
          ],
          [
            [-0.10977568661779191, 43.309934269495066],
            [-0.07018054491738734, 43.309934269495066],
            [-0.07018054491738734, 43.340064236629814],
            [-0.10977568661779191, 43.309934269495066],
          ],
          [
            [-0.10977568661779191, 43.309934269495066],
            [-0.13973957763431422, 43.270002987750225],
            [-0.11994200678411193, 43.2500373468778],
            [-0.07981179560126961, 43.2598386614879],
            [-0.08997811576758963, 43.30013295488497],
            [-0.10977568661779191, 43.309934269495066],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 25, name: "Doubs", REG: 27, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [5.940254951307584, 46.979982073498654],
            [5.879792099792101, 46.99994771437108],
            [5.879792099792101, 47.0101120406334],
            [5.830030637925375, 47.0101120406334],
            [5.8198643177590546, 47.039878996115924],
            [5.800066746908853, 47.039878996115924],
            [5.789900426742533, 47.0199133552435],
            [5.75993653572601, 47.0101120406334],
            [5.740138964875807, 47.03007768150583],
            [5.779734106576213, 47.05004332237825],
            [5.77010285589233, 47.0899746041231],
            [5.789900426742533, 47.10013893038542],
            [5.800066746908853, 47.12010457125784],
            [5.830030637925375, 47.14007021213027],
            [5.810233067075173, 47.14987152674037],
            [5.810233067075173, 47.16983716761279],
            [5.789900426742533, 47.16983716761279],
            [5.789900426742533, 47.19016582013744],
            [5.75993653572601, 47.19016582013744],
            [5.75993653572601, 47.21013146100986],
            [5.719806324543167, 47.21993277561996],
            [5.719806324543167, 47.23989841649238],
            [5.700008753692965, 47.27002838362713],
            [5.740138964875807, 47.25986405736481],
            [5.75993653572601, 47.27982969823723],
            [5.8198643177590546, 47.300158350761876],
            [5.849828208775578, 47.300158350761876],
            [5.859994528941898, 47.320123991634304],
            [5.900124740124741, 47.320123991634304],
            [5.930088631141262, 47.340089632506725],
            [5.960052522157786, 47.340089632506725],
            [5.979850093007989, 47.3299253062444],
            [6.000182733340629, 47.340089632506725],
            [6.01998030419083, 47.3299253062444],
            [6.049944195207353, 47.34989094711682],
            [6.079908086223877, 47.34989094711682],
            [6.079908086223877, 47.36985658798925],
            [6.12003829740672, 47.38982222886167],
            [6.169799759273444, 47.38982222886167],
            [6.190132399606084, 47.410150881386315],
            [6.209929970456288, 47.43011652225874],
            [6.260226501805449, 47.43011652225874],
            [6.260226501805449, 47.450082163131164],
            [6.280024072655652, 47.450082163131164],
            [6.299821643505855, 47.49001344487601],
            [6.320154283838495, 47.49001344487601],
            [6.329785534522377, 47.509979085748434],
            [6.39024838603786, 47.509979085748434],
            [6.399879636721743, 47.52014341201075],
            [6.450176168070905, 47.52014341201075],
            [6.469973738921108, 47.49001344487601],
            [6.499937629937631, 47.509979085748434],
            [6.550234161286794, 47.49001344487601],
            [6.580198052303316, 47.509979085748434],
            [6.580198052303316, 47.54010905288318],
            [6.610161943319839, 47.54010905288318],
            [6.62995951417004, 47.529944726620855],
            [6.6700897253528835, 47.5600746937556],
            [6.719851187219608, 47.54991036749328],
            [6.74018382755225, 47.5600746937556],
            [6.759981398402451, 47.54010905288318],
            [6.779778969252654, 47.54010905288318],
            [6.809742860269176, 47.5600746937556],
            [6.819909180435498, 47.54991036749328],
            [6.860039391618339, 47.54991036749328],
            [6.879836962468542, 47.5600746937556],
            [6.900169602801182, 47.54991036749328],
            [6.9301334938177055, 47.52014341201075],
            [6.9098008534850655, 47.49001344487601],
            [6.9301334938177055, 47.459883477741265],
            [6.939764744501587, 47.43011652225874],
            [6.939764744501587, 47.410150881386315],
            [6.9199671736513855, 47.410150881386315],
            [6.9098008534850655, 47.38982222886167],
            [6.879836962468542, 47.36985658798925],
            [6.900169602801182, 47.360055273379146],
            [7.00022759601707, 47.360055273379146],
            [7.030191487033593, 47.36985658798925],
            [7.049989057883795, 47.360055273379146],
            [7.049989057883795, 47.3299253062444],
            [7.030191487033593, 47.3299253062444],
            [7.020025166867273, 47.30995966537198],
            [6.970263705000547, 47.289994024499556],
            [6.939764744501587, 47.289994024499556],
            [6.949931064667907, 47.25006274275471],
            [6.9199671736513855, 47.21993277561996],
            [6.890003282634862, 47.21013146100986],
            [6.860039391618339, 47.18000149387511],
            [6.860039391618339, 47.16003585300269],
            [6.830075500601818, 47.14007021213027],
            [6.759981398402451, 47.12010457125784],
            [6.74018382755225, 47.10994024499552],
            [6.74018382755225, 47.0899746041231],
            [6.710219936535727, 47.0899746041231],
            [6.700053616369407, 47.07000896325067],
            [6.719851187219608, 47.05004332237825],
            [6.6802560455192035, 47.039878996115924],
            [6.610161943319839, 46.99014639976098],
            [6.580198052303316, 46.99014639976098],
            [6.559865411970676, 46.979982073498654],
            [6.469973738921108, 46.96001643262623],
            [6.440009847904585, 46.929886465491485],
            [6.459807418754788, 46.889955183746636],
            [6.459807418754788, 46.850023902001794],
            [6.429843527738265, 46.810092620256945],
            [6.459807418754788, 46.790126979384524],
            [6.440009847904585, 46.75999701224978],
            [6.399879636721743, 46.74983268598745],
            [6.39024838603786, 46.72986704511503],
            [6.3597494255389, 46.72006573050493],
            [6.299821643505855, 46.68993576337019],
            [6.280024072655652, 46.68993576337019],
            [6.260226501805449, 46.66997012249776],
            [6.209929970456288, 46.63984015536301],
            [6.179966079439764, 46.61007319988049],
            [6.160168508589561, 46.61007319988049],
            [6.109871977240398, 46.57994323274574],
            [6.139835868256921, 46.55997759187332],
            [6.13020461757304, 46.55017627726322],
            [6.049944195207353, 46.61007319988049],
            [6.079908086223877, 46.63984015536301],
            [6.100240726556517, 46.65000448162534],
            [6.0697417660575566, 46.68993576337019],
            [6.13020461757304, 46.72006573050493],
            [6.179966079439764, 46.740031371377356],
            [6.199763650289966, 46.7799626531222],
            [6.160168508589561, 46.799928293994626],
            [6.150002188423241, 46.819893934867046],
            [6.109871977240398, 46.83985957573947],
            [6.090074406390197, 46.83985957573947],
            [6.0697417660575566, 46.859825216611895],
            [6.049944195207353, 46.850023902001794],
            [6.01998030419083, 46.850023902001794],
            [6.00981398402451, 46.869989542874215],
            [6.00981398402451, 46.90011951000896],
            [5.979850093007989, 46.909920824619064],
            [6.000182733340629, 46.929886465491485],
            [5.970218842324106, 46.949852106363906],
            [5.979850093007989, 46.96001643262623],
            [5.970218842324106, 46.979982073498654],
            [5.940254951307584, 46.979982073498654],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 77,
        name: "Seine-et-Marne",
        REG: 11,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.400235255498414, 48.31985808186436],
            [2.400235255498414, 48.33002240812668],
            [2.420032826348616, 48.33982372273678],
            [2.430199146514936, 48.36015237526143],
            [2.4799606083816617, 48.380118016133856],
            [2.4901269285479817, 48.40008365700628],
            [2.5500547105810263, 48.40008365700628],
            [2.499758179231864, 48.450179265013446],
            [2.509924499398184, 48.45998057962355],
            [2.499758179231864, 48.47994622049597],
            [2.509924499398184, 48.490110546758295],
            [2.499758179231864, 48.51987750224082],
            [2.520090819564504, 48.569973110247986],
            [2.5398883904147063, 48.600103077382734],
            [2.5398883904147063, 48.629870032865256],
            [2.5698522814312295, 48.670164326262324],
            [2.5698522814312295, 48.69012996713475],
            [2.5698522814312295, 48.71009560800717],
            [2.5998161724477518, 48.75002688975202],
            [2.5901849217638695, 48.76999253062444],
            [2.5998161724477518, 48.80992381236929],
            [2.5901849217638695, 48.80992381236929],
            [2.499758179231864, 48.86001942037646],
            [2.4499967173651385, 48.86001942037646],
            [2.420032826348616, 48.84985509411413],
            [2.4499967173651385, 48.86001942037646],
            [2.499758179231864, 48.86001942037646],
            [2.5901849217638695, 48.80992381236929],
            [2.5998161724477518, 48.80992381236929],
            [2.5698522814312295, 48.84985509411413],
            [2.5698522814312295, 48.89014938751121],
            [2.5901849217638695, 48.8999507021213],
            [2.5901849217638695, 48.93008066925605],
            [2.5998161724477518, 48.93988198386615],
            [2.5698522814312295, 48.980176277263226],
            [2.5800186015975495, 49.00014191813565],
            [2.5500547105810263, 49.00994323274575],
            [2.5800186015975495, 49.04987451449059],
            [2.5698522814312295, 49.06003884075292],
            [2.5901849217638695, 49.08000448162534],
            [2.620148812780392, 49.090168807887665],
            [2.629780063464274, 49.110134448760085],
            [2.6800765948134373, 49.090168807887665],
            [2.6998741656636396, 49.06003884075292],
            [2.7202068059962796, 49.08000448162534],
            [2.740004376846483, 49.06003884075292],
            [2.759801947696685, 49.06003884075292],
            [2.7897658387132074, 49.08000448162534],
            [2.8100984790458474, 49.099970122497766],
            [2.859859940912573, 49.06984015536301],
            [2.889823831929095, 49.08000448162534],
            [2.9401203632782584, 49.08000448162534],
            [2.9700842542947816, 49.090168807887665],
            [3.0701422475106694, 49.090168807887665],
            [3.0599759273443494, 49.099970122497766],
            [3.0701422475106694, 49.11993576337019],
            [3.079773498194551, 49.110134448760085],
            [3.140236349710034, 49.110134448760085],
            [3.1702002407265573, 49.08000448162534],
            [3.1899978115767587, 49.04987451449059],
            [3.1702002407265573, 49.00994323274575],
            [3.2001641317430787, 49.00994323274575],
            [3.209795382426962, 48.98997759187332],
            [3.260091913776125, 48.95984762473857],
            [3.260091913776125, 48.93988198386615],
            [3.3098533756428496, 48.93988198386615],
            [3.3098533756428496, 48.91991634299373],
            [3.3301860159754897, 48.91011502838363],
            [3.3697811576758943, 48.93008066925605],
            [3.3799474778422143, 48.91011502838363],
            [3.3799474778422143, 48.86982073498656],
            [3.4200776890250575, 48.86982073498656],
            [3.469839150891782, 48.84985509411413],
            [3.490171791224424, 48.84985509411413],
            [3.490171791224424, 48.82008813863161],
            [3.4398752598752607, 48.80992381236929],
            [3.4398752598752607, 48.78015685688677],
            [3.4099113688587375, 48.78015685688677],
            [3.3997450486924174, 48.759828204362115],
            [3.4302440091913775, 48.759828204362115],
            [3.4398752598752607, 48.739862563489694],
            [3.469839150891782, 48.739862563489694],
            [3.469839150891782, 48.69012996713475],
            [3.4398752598752607, 48.660000000000004],
            [3.480005471058104, 48.64003435912758],
            [3.490171791224424, 48.64983567373768],
            [3.5201356822409453, 48.64003435912758],
            [3.5602658934237885, 48.620068718255155],
            [3.5099693620746253, 48.609904391992835],
            [3.5201356822409453, 48.58993875112041],
            [3.490171791224424, 48.58993875112041],
            [3.469839150891782, 48.569973110247986],
            [3.480005471058104, 48.550007469375565],
            [3.4500415800415807, 48.53004182850314],
            [3.4099113688587375, 48.53004182850314],
            [3.4302440091913775, 48.490110546758295],
            [3.3997450486924174, 48.490110546758295],
            [3.3799474778422143, 48.47994622049597],
            [3.390113798008536, 48.45998057962355],
            [3.4099113688587375, 48.450179265013446],
            [3.3997450486924174, 48.4298506124888],
            [3.4200776890250575, 48.40988497161638],
            [3.4099113688587375, 48.38991933074395],
            [3.3799474778422143, 48.40008365700628],
            [3.360149906992013, 48.380118016133856],
            [3.349983586825693, 48.36995368987153],
            [3.3098533756428496, 48.36995368987153],
            [3.2798894846263265, 48.380118016133856],
            [3.249925593609805, 48.36995368987153],
            [3.119903709377394, 48.36995368987153],
            [3.100106138527191, 48.36015237526143],
            [3.0498096071780294, 48.36015237526143],
            [3.0401783564941463, 48.33002240812668],
            [3.019845716161506, 48.31005676725426],
            [3.0401783564941463, 48.27012548550941],
            [3.010214465477623, 48.22002987750224],
            [2.9599179341284616, 48.189899910367494],
            [2.9299540431119384, 48.1800985957574],
            [2.9401203632782584, 48.16013295488497],
            [2.870026261078893, 48.16013295488497],
            [2.8502286902286906, 48.14016731401255],
            [2.7999321588795274, 48.130002987750224],
            [2.7999321588795274, 48.16993426949507],
            [2.780134588029325, 48.16993426949507],
            [2.750170697012803, 48.14996862862265],
            [2.7202068059962796, 48.14016731401255],
            [2.7100404858299596, 48.119838661487904],
            [2.6800765948134373, 48.130002987750224],
            [2.6597439544807973, 48.119838661487904],
            [2.639946383630594, 48.14016731401255],
            [2.5998161724477518, 48.130002987750224],
            [2.5698522814312295, 48.14016731401255],
            [2.5398883904147063, 48.14016731401255],
            [2.520090819564504, 48.130002987750224],
            [2.4398303971988184, 48.130002987750224],
            [2.4799606083816617, 48.16013295488497],
            [2.509924499398184, 48.16013295488497],
            [2.520090819564504, 48.189899910367494],
            [2.520090819564504, 48.22983119211234],
            [2.509924499398184, 48.23999551837467],
            [2.4799606083816617, 48.23999551837467],
            [2.4697942882153407, 48.25996115924709],
            [2.4398303971988184, 48.25015984463699],
            [2.420032826348616, 48.25996115924709],
            [2.420032826348616, 48.29989244099193],
            [2.400235255498414, 48.31985808186436],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 91, name: "Essonne", REG: 11, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.9898369624685417, 48.29009112638184],
            [1.9700393916183394, 48.33982372273678],
            [1.9802057117846594, 48.36015237526143],
            [1.9802057117846594, 48.40008365700628],
            [1.9598730714520194, 48.40008365700628],
            [1.9400755006018162, 48.4200492978787],
            [1.9400755006018162, 48.44001493875112],
            [1.9197428602691762, 48.45998057962355],
            [1.9299091804354962, 48.49991186136839],
            [1.9598730714520194, 48.53004182850314],
            [1.9299091804354962, 48.550007469375565],
            [1.9400755006018162, 48.560171795637885],
            [2.019800853485064, 48.560171795637885],
            [2.019800853485064, 48.58013743651031],
            [2.059931064667907, 48.620068718255155],
            [2.019800853485064, 48.64003435912758],
            [2.029967173651384, 48.679965640872425],
            [2.049764744501587, 48.69012996713475],
            [2.0802637050005472, 48.69012996713475],
            [2.1102275960170696, 48.71009560800717],
            [2.1000612758507495, 48.739862563489694],
            [2.1401914870335927, 48.739862563489694],
            [2.2001192690666374, 48.76999253062444],
            [2.2300831600831605, 48.76999253062444],
            [2.249880730933363, 48.759828204362115],
            [2.279844621949885, 48.759828204362115],
            [2.270213371266003, 48.739862563489694],
            [2.279844621949885, 48.73006124887959],
            [2.3199748331327283, 48.75002688975202],
            [2.3499387241492506, 48.739862563489694],
            [2.369736294999453, 48.719896922617274],
            [2.4398303971988184, 48.719896922617274],
            [2.4601630375314585, 48.73006124887959],
            [2.520090819564504, 48.73006124887959],
            [2.520090819564504, 48.71009560800717],
            [2.5500547105810263, 48.69012996713475],
            [2.5698522814312295, 48.69012996713475],
            [2.5698522814312295, 48.670164326262324],
            [2.5398883904147063, 48.629870032865256],
            [2.5398883904147063, 48.600103077382734],
            [2.520090819564504, 48.569973110247986],
            [2.499758179231864, 48.51987750224082],
            [2.509924499398184, 48.490110546758295],
            [2.499758179231864, 48.47994622049597],
            [2.509924499398184, 48.45998057962355],
            [2.499758179231864, 48.450179265013446],
            [2.5500547105810263, 48.40008365700628],
            [2.4901269285479817, 48.40008365700628],
            [2.4799606083816617, 48.380118016133856],
            [2.430199146514936, 48.36015237526143],
            [2.420032826348616, 48.33982372273678],
            [2.400235255498414, 48.33002240812668],
            [2.400235255498414, 48.31985808186436],
            [2.3601050443155707, 48.31005676725426],
            [2.3301411532990484, 48.33002240812668],
            [2.3098085129664083, 48.33002240812668],
            [2.300177262282526, 48.31005676725426],
            [2.249880730933363, 48.33002240812668],
            [2.2097505197505196, 48.33982372273678],
            [2.159989057883795, 48.29989244099193],
            [2.1102275960170696, 48.29989244099193],
            [2.0898949556844295, 48.29009112638184],
            [1.9898369624685417, 48.29009112638184],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 37,
        name: "Indre-et-Loire",
        REG: 24,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.8699365357260094, 46.74983268598745],
            [0.8399726447094871, 46.75999701224978],
            [0.829806324543167, 46.790126979384524],
            [0.8100087536929648, 46.790126979384524],
            [0.8100087536929648, 46.83005826112937],
            [0.7998424335266439, 46.850023902001794],
            [0.7698785425101216, 46.850023902001794],
            [0.699784440310756, 46.90011951000896],
            [0.7099507604770761, 46.94005079175381],
            [0.6901531896268738, 46.97018075888856],
            [0.6601892986103515, 46.99014639976098],
            [0.6200590874275083, 46.99014639976098],
            [0.6200590874275083, 47.0101120406334],
            [0.590095196410986, 47.0101120406334],
            [0.5697625560783459, 46.979982073498654],
            [0.600261516577306, 46.96001643262623],
            [0.49003720319509814, 46.96001643262623],
            [0.4397406718459349, 46.94005079175381],
            [0.3899792099792103, 46.94005079175381],
            [0.3600153189626871, 46.949852106363906],
            [0.3300514279461648, 46.929886465491485],
            [0.31025385709596254, 46.94005079175381],
            [0.3000875369296425, 46.96001643262623],
            [0.31025385709596254, 46.979982073498654],
            [0.3000875369296425, 47.0199133552435],
            [0.31025385709596254, 47.05004332237825],
            [0.2599573257467993, 47.05004332237825],
            [0.2599573257467993, 47.07000896325067],
            [0.24015975489659702, 47.07000896325067],
            [0.21019586388007472, 47.05004332237825],
            [0.18023197286355153, 47.07000896325067],
            [0.2000295437137547, 47.0899746041231],
            [0.18023197286355153, 47.12010457125784],
            [0.1598993325309115, 47.10013893038542],
            [0.12993544151438918, 47.12010457125784],
            [0.1101378706641869, 47.12990588586794],
            [0.0801739796476637, 47.12010457125784],
            [0.0801739796476637, 47.14987152674037],
            [0.0502100886311414, 47.16003585300269],
            [0.07000765948134369, 47.19016582013744],
            [0.0502100886311414, 47.19996713474754],
            [0.07000765948134369, 47.21993277561996],
            [0.0801739796476637, 47.25006274275471],
            [0.0801739796476637, 47.289994024499556],
            [0.11976912134806916, 47.3299253062444],
            [0.1401017616807092, 47.340089632506725],
            [0.14973301236459147, 47.360055273379146],
            [0.18023197286355153, 47.380020914251574],
            [0.1700656526972315, 47.399986555123995],
            [0.1898632235474338, 47.43011652225874],
            [0.18023197286355153, 47.450082163131164],
            [0.1898632235474338, 47.470047804003585],
            [0.21982711456395698, 47.50017777113833],
            [0.21982711456395698, 47.529944726620855],
            [0.2000295437137547, 47.54010905288318],
            [0.21019586388007472, 47.5698760083657],
            [0.229993434730277, 47.58004033462802],
            [0.229993434730277, 47.61017030176277],
            [0.2599573257467993, 47.61017030176277],
            [0.2797548965970016, 47.60000597550045],
            [0.3198851077798448, 47.60000597550045],
            [0.34021774811248484, 47.58004033462802],
            [0.3798128898128903, 47.5698760083657],
            [0.40014553014553034, 47.589841649238124],
            [0.3600153189626871, 47.61997161637287],
            [0.3798128898128903, 47.63993725724529],
            [0.40014553014553034, 47.63993725724529],
            [0.4199431009957326, 47.61997161637287],
            [0.4499069920122549, 47.61997161637287],
            [0.46007331217857583, 47.63993725724529],
            [0.5002035233614182, 47.63993725724529],
            [0.5301674143779405, 47.65010158350762],
            [0.5601313053944637, 47.67006722438004],
            [0.590095196410986, 47.67006722438004],
            [0.6098927672611882, 47.69003286525247],
            [0.6302254075938292, 47.70999850612489],
            [0.6698205492942337, 47.69983417986256],
            [0.7099507604770761, 47.67986853899014],
            [0.7399146514935993, 47.69983417986256],
            [0.7902111828427616, 47.67986853899014],
            [0.8597702155596894, 47.67986853899014],
            [0.8399726447094871, 47.65010158350762],
            [0.8597702155596894, 47.6301359426352],
            [0.8501389648758071, 47.61997161637287],
            [0.8597702155596894, 47.60000597550045],
            [0.8999004267425326, 47.60000597550045],
            [0.8999004267425326, 47.61997161637287],
            [0.9202330670751726, 47.6301359426352],
            [0.9699945289418972, 47.6301359426352],
            [0.9897920997921004, 47.61997161637287],
            [0.9801608491082181, 47.60000597550045],
            [1.0101247401247404, 47.60000597550045],
            [1.0299223109749427, 47.61017030176277],
            [1.059886201991465, 47.58004033462802],
            [1.080218842324106, 47.5698760083657],
            [1.0502549513075827, 47.54010905288318],
            [1.070052522157786, 47.52014341201075],
            [1.070052522157786, 47.50017777113833],
            [1.0898500930079882, 47.470047804003585],
            [1.1101827333406282, 47.470047804003585],
            [1.1299803041908305, 47.450082163131164],
            [1.1101827333406282, 47.43011652225874],
            [1.1198139840245105, 47.380020914251574],
            [1.1101827333406282, 47.36985658798925],
            [1.1198139840245105, 47.34989094711682],
            [1.1101827333406282, 47.3299253062444],
            [1.0898500930079882, 47.3299253062444],
            [1.1101827333406282, 47.300158350761876],
            [1.1599441952073537, 47.27002838362713],
            [1.2198719772403983, 47.289994024499556],
            [1.2600021884232415, 47.25986405736481],
            [1.2797997592734438, 47.25986405736481],
            [1.3199299704562861, 47.19016582013744],
            [1.330096290622607, 47.19016582013744],
            [1.3600601816391293, 47.14007021213027],
            [1.3600601816391293, 47.10994024499552],
            [1.3199299704562861, 47.10013893038542],
            [1.3199299704562861, 47.080173289513],
            [1.2899660794397638, 47.07000896325067],
            [1.2797997592734438, 47.039878996115924],
            [1.2300382974067183, 47.0101120406334],
            [1.210240726556516, 47.03007768150583],
            [1.1599441952073537, 47.039878996115924],
            [1.1198139840245105, 47.0199133552435],
            [1.1101827333406282, 47.03007768150583],
            [1.080218842324106, 47.0199133552435],
            [1.0502549513075827, 46.979982073498654],
            [1.059886201991465, 46.949852106363906],
            [1.0400886311412627, 46.949852106363906],
            [1.0299223109749427, 46.909920824619064],
            [1.0299223109749427, 46.88015386913654],
            [1.0101247401247404, 46.83985957573947],
            [1.0101247401247404, 46.810092620256945],
            [0.9897920997921004, 46.799928293994626],
            [1.0101247401247404, 46.75999701224978],
            [0.9801608491082181, 46.75999701224978],
            [0.9501969580916949, 46.740031371377356],
            [0.9298643177590549, 46.75999701224978],
            [0.8897341065762117, 46.75999701224978],
            [0.8699365357260094, 46.74983268598745],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: "2B",
        name: "Haute-Corse",
        REG: 94,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [8.57012145748988, 42.37989841649238],
            [8.6000853485064, 42.37989841649238],
            [8.61025166867272, 42.3900627427547],
            [8.6000853485064, 42.41002838362713],
            [8.61025166867272, 42.41982969823722],
            [8.660013130539447, 42.41982969823722],
            [8.670179450705767, 42.44015835076188],
            [8.649846810373127, 42.4699253062444],
            [8.660013130539447, 42.50985658798924],
            [8.709774592406173, 42.53998655512399],
            [8.709774592406173, 42.57991783686884],
            [8.730107232738813, 42.57991783686884],
            [8.760071123755335, 42.559952195996416],
            [8.790035014771856, 42.559952195996416],
            [8.819998905788381, 42.610047804003585],
            [8.869760367655104, 42.610047804003585],
            [8.879926687821424, 42.630013444876006],
            [8.909890578837949, 42.630013444876006],
            [8.93985446985447, 42.64017777113833],
            [8.95002079002079, 42.630013444876006],
            [8.979984681037312, 42.64017777113833],
            [9.020114892220157, 42.64017777113833],
            [9.060245103402998, 42.660143412010754],
            [9.06987635408688, 42.689910367493276],
            [9.099840245103405, 42.720040334628024],
            [9.159768027136447, 42.740005975500445],
            [9.259826020352335, 42.7098760083657],
            [9.28978991136886, 42.680109052883175],
            [9.319753802385382, 42.7000746937556],
            [9.350252762884342, 42.740005975500445],
            [9.340086442718022, 42.75997161637287],
            [9.340086442718022, 42.799902898117715],
            [9.319753802385382, 42.83003286525246],
            [9.340086442718022, 42.86016283238721],
            [9.329920122551702, 42.90009411413206],
            [9.359884013568227, 42.92005975500448],
            [9.350252762884342, 42.92986106961458],
            [9.350252762884342, 42.97015536301165],
            [9.340086442718022, 42.99992231849417],
            [9.359884013568227, 43.0100866447565],
            [9.41981179560127, 43.0100866447565],
            [9.459942006784114, 42.99012100388407],
            [9.449775686617794, 42.95999103674933],
            [9.470108326950434, 42.9400253958769],
            [9.470108326950434, 42.88992978786973],
            [9.479739577634316, 42.88012847325963],
            [9.479739577634316, 42.839834179862564],
            [9.489905897800636, 42.83003286525246],
            [9.489905897800636, 42.799902898117715],
            [9.470108326950434, 42.77013594263519],
            [9.470108326950434, 42.75017030176277],
            [9.449775686617794, 42.7098760083657],
            [9.449775686617794, 42.660143412010754],
            [9.459942006784114, 42.64017777113833],
            [9.519869788817157, 42.57991783686884],
            [9.530036108983477, 42.559952195996416],
            [9.530036108983477, 42.48008963250672],
            [9.540202429149797, 42.4699253062444],
            [9.540202429149797, 42.3900627427547],
            [9.530036108983477, 42.37989841649238],
            [9.540202429149797, 42.35993277561995],
            [9.540202429149797, 42.33016582013744],
            [9.560000000000002, 42.28007021213026],
            [9.560000000000002, 42.249940244995514],
            [9.549833679833682, 42.22017328951299],
            [9.560000000000002, 42.199844636988345],
            [9.549833679833682, 42.159913355243496],
            [9.560000000000002, 42.139947714371075],
            [9.549833679833682, 42.100016432626234],
            [9.500072217966956, 42.04992082461906],
            [9.459942006784114, 41.99982521661189],
            [9.44014443593391, 41.99002390200179],
            [9.410180544917388, 41.95989393486704],
            [9.41981179560127, 41.93012697938452],
            [9.400014224751068, 41.89999701224978],
            [9.400014224751068, 41.86006573050493],
            [9.380216653900867, 41.86986704511503],
            [9.340086442718022, 41.84010008963251],
            [9.269992340518659, 41.84010008963251],
            [9.229862129335814, 41.86006573050493],
            [9.250194769668454, 41.89999701224978],
            [9.220230878651932, 41.9101613385121],
            [9.229862129335814, 41.93012697938452],
            [9.220230878651932, 41.950092620256946],
            [9.229862129335814, 41.97005826112937],
            [9.220230878651932, 41.97985957573947],
            [9.220230878651932, 42.02995518374664],
            [9.159768027136447, 42.02995518374664],
            [9.129804136119926, 42.04992082461906],
            [9.129804136119926, 42.08985210636391],
            [9.110006565269725, 42.119982073498655],
            [9.0800426742532, 42.119982073498655],
            [9.06987635408688, 42.17007768150582],
            [9.050078783236678, 42.17007768150582],
            [9.050078783236678, 42.21000896325067],
            [9.020114892220157, 42.199844636988345],
            [8.990151001203632, 42.21000896325067],
            [8.969818360870992, 42.22997460412309],
            [8.95002079002079, 42.22997460412309],
            [8.920056899004269, 42.26010457125784],
            [8.900259328154064, 42.249940244995514],
            [8.879926687821424, 42.26990588586794],
            [8.890093007987744, 42.28007021213026],
            [8.860129116971223, 42.30003585300269],
            [8.860129116971223, 42.33016582013744],
            [8.819998905788381, 42.32000149387511],
            [8.790035014771856, 42.33016582013744],
            [8.770237443921655, 42.32000149387511],
            [8.760071123755335, 42.33996713474753],
            [8.719940912572493, 42.33996713474753],
            [8.709774592406173, 42.35013146100986],
            [8.679810701389648, 42.35013146100986],
            [8.640215559689246, 42.37009710188228],
            [8.6000853485064, 42.37009710188228],
            [8.57012145748988, 42.37989841649238],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 95, name: "Val-d'Oise", REG: 11, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.6099376299376305, 49.08000448162534],
            [1.6201039501039505, 49.099970122497766],
            [1.6500678411204728, 49.130100089632506],
            [1.669865411970675, 49.170031371377355],
            [1.680031732136995, 49.209962653122204],
            [1.6998293029871983, 49.229928293994625],
            [1.7099956231535183, 49.24009262025695],
            [1.7399595141700406, 49.220126979384524],
            [1.7201619433198383, 49.2001613385121],
            [1.7597570850202429, 49.170031371377355],
            [1.7800897253528838, 49.189997012249776],
            [1.799887296203086, 49.189997012249776],
            [1.8400175073859284, 49.170031371377355],
            [1.8699813984024516, 49.170031371377355],
            [1.8801477185687716, 49.15986704511503],
            [1.9299091804354962, 49.170031371377355],
            [1.9598730714520194, 49.170031371377355],
            [1.9700393916183394, 49.179832685987456],
            [2.0000032826348617, 49.179832685987456],
            [2.040133493817705, 49.189997012249776],
            [2.0802637050005472, 49.209962653122204],
            [2.1000612758507495, 49.189997012249776],
            [2.1300251668672727, 49.189997012249776],
            [2.159989057883795, 49.170031371377355],
            [2.2300831600831605, 49.170031371377355],
            [2.2199168399168405, 49.150065730504934],
            [2.260047051099683, 49.150065730504934],
            [2.290010942116205, 49.15986704511503],
            [2.300177262282526, 49.179832685987456],
            [2.3199748331327283, 49.179832685987456],
            [2.3601050443155707, 49.150065730504934],
            [2.4398303971988184, 49.150065730504934],
            [2.499758179231864, 49.11993576337019],
            [2.4901269285479817, 49.110134448760085],
            [2.530257139730824, 49.099970122497766],
            [2.560221030747347, 49.099970122497766],
            [2.5901849217638695, 49.08000448162534],
            [2.5698522814312295, 49.06003884075292],
            [2.5800186015975495, 49.04987451449059],
            [2.5500547105810263, 49.00994323274575],
            [2.530257139730824, 49.00014191813565],
            [2.499758179231864, 48.9700119510009],
            [2.4697942882153407, 48.95984762473857],
            [2.409866506182296, 48.95984762473857],
            [2.379902615165773, 48.9700119510009],
            [2.3397724039829306, 48.9700119510009],
            [2.3301411532990484, 48.95984762473857],
            [2.290010942116205, 48.95004631012848],
            [2.270213371266003, 48.95004631012848],
            [2.2001192690666374, 48.91011502838363],
            [2.2001192690666374, 48.93988198386615],
            [2.170155378050115, 48.980176277263226],
            [2.149822737717475, 48.98997759187332],
            [2.119858846700952, 48.98997759187332],
            [2.1300251668672727, 49.00994323274575],
            [2.059931064667907, 49.00994323274575],
            [2.049764744501587, 49.00014191813565],
            [2.019800853485064, 49.00014191813565],
            [1.9898369624685417, 49.02010755900807],
            [1.9400755006018162, 49.02010755900807],
            [1.910111609585294, 49.040073199880496],
            [1.8801477185687716, 49.02990887361817],
            [1.8501838275522484, 49.02990887361817],
            [1.8699813984024516, 49.06003884075292],
            [1.8400175073859284, 49.06003884075292],
            [1.8202199365357261, 49.08000448162534],
            [1.7902560455192038, 49.06003884075292],
            [1.7501258343363606, 49.06003884075292],
            [1.7201619433198383, 49.040073199880496],
            [1.669865411970675, 49.08000448162534],
            [1.6201039501039505, 49.06984015536301],
            [1.6099376299376305, 49.08000448162534],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 51, name: "Marne", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.670000000000001, 48.53984314311324],
            [4.640036108983478, 48.550007469375565],
            [4.569942006784113, 48.550007469375565],
            [4.52981179560127, 48.53004182850314],
            [4.460252762884342, 48.550007469375565],
            [4.420122551701499, 48.550007469375565],
            [4.350028449502134, 48.600103077382734],
            [4.330230878651931, 48.600103077382734],
            [4.309898238319291, 48.620068718255155],
            [4.320064558485611, 48.64003435912758],
            [4.320064558485611, 48.679965640872425],
            [4.330230878651931, 48.699931281744846],
            [4.309898238319291, 48.71009560800717],
            [4.249970456286246, 48.71009560800717],
            [4.230172885436043, 48.699931281744846],
            [4.200208994419522, 48.699931281744846],
            [4.17987635408688, 48.71009560800717],
            [4.130114892220155, 48.69012996713475],
            [4.089984681037312, 48.699931281744846],
            [4.070187110187111, 48.69012996713475],
            [4.060020790020791, 48.670164326262324],
            [4.040223219170588, 48.660000000000004],
            [4.000093007987744, 48.660000000000004],
            [3.9797603676551043, 48.64983567373768],
            [3.9797603676551043, 48.629870032865256],
            [3.959962796804903, 48.620068718255155],
            [3.949796476638583, 48.600103077382734],
            [3.9198325856220597, 48.609904391992835],
            [3.9000350147718565, 48.58013743651031],
            [3.859904803589015, 48.569973110247986],
            [3.859904803589015, 48.53984314311324],
            [3.829940912572492, 48.51987750224082],
            [3.7999770215559687, 48.53004182850314],
            [3.7598468103731273, 48.53004182850314],
            [3.729882919356604, 48.53984314311324],
            [3.710085348506401, 48.53004182850314],
            [3.689752708173761, 48.53984314311324],
            [3.6399912463070363, 48.53984314311324],
            [3.6298249261407163, 48.569973110247986],
            [3.599861035124193, 48.569973110247986],
            [3.5602658934237885, 48.609904391992835],
            [3.5602658934237885, 48.620068718255155],
            [3.5201356822409453, 48.64003435912758],
            [3.490171791224424, 48.64983567373768],
            [3.480005471058104, 48.64003435912758],
            [3.4398752598752607, 48.660000000000004],
            [3.469839150891782, 48.69012996713475],
            [3.469839150891782, 48.739862563489694],
            [3.4398752598752607, 48.739862563489694],
            [3.4302440091913775, 48.759828204362115],
            [3.3997450486924174, 48.759828204362115],
            [3.4099113688587375, 48.78015685688677],
            [3.4398752598752607, 48.78015685688677],
            [3.4398752598752607, 48.80992381236929],
            [3.490171791224424, 48.82008813863161],
            [3.490171791224424, 48.84985509411413],
            [3.5201356822409453, 48.91011502838363],
            [3.5500995732574685, 48.91991634299373],
            [3.5698971441076717, 48.93988198386615],
            [3.599861035124193, 48.95004631012848],
            [3.6399912463070363, 49.00014191813565],
            [3.6801214574898795, 49.02010755900807],
            [3.6597888171572377, 49.040073199880496],
            [3.620193675456833, 49.040073199880496],
            [3.5902297844403117, 49.02990887361817],
            [3.5902297844403117, 49.06003884075292],
            [3.6399912463070363, 49.08000448162534],
            [3.610027355290513, 49.11993576337019],
            [3.620193675456833, 49.150065730504934],
            [3.699919028340081, 49.150065730504934],
            [3.740049239522924, 49.15986704511503],
            [3.750215559689244, 49.179832685987456],
            [3.710085348506401, 49.179832685987456],
            [3.699919028340081, 49.209962653122204],
            [3.6699551373235595, 49.220126979384524],
            [3.6699551373235595, 49.24009262025695],
            [3.6399912463070363, 49.299989542874215],
            [3.6501575664733563, 49.31995518374664],
            [3.6699551373235595, 49.31995518374664],
            [3.740049239522924, 49.339920824619064],
            [3.7801794507057673, 49.359886465491485],
            [3.849738483422695, 49.359886465491485],
            [3.859904803589015, 49.39001643262623],
            [3.9198325856220597, 49.40998207349866],
            [3.959962796804903, 49.37985210636391],
            [3.9899266878214243, 49.37985210636391],
            [4.010259328154066, 49.359886465491485],
            [4.040223219170588, 49.359886465491485],
            [4.040223219170588, 49.40018075888856],
            [4.049854469854471, 49.40998207349866],
            [4.070187110187111, 49.40018075888856],
            [4.190042674253202, 49.40018075888856],
            [4.200208994419522, 49.37985210636391],
            [4.249970456286246, 49.37985210636391],
            [4.260136776452566, 49.359886465491485],
            [4.29010066746909, 49.35008515088139],
            [4.309898238319291, 49.33011951000897],
            [4.339862129335814, 49.31995518374664],
            [4.379992340518657, 49.31995518374664],
            [4.390158660684977, 49.299989542874215],
            [4.429753802385382, 49.280023902001794],
            [4.520180544917387, 49.280023902001794],
            [4.559775686617793, 49.299989542874215],
            [4.599905897800634, 49.289825216611895],
            [4.620238538133276, 49.24009262025695],
            [4.640036108983478, 49.229928293994625],
            [4.699963891016522, 49.249893934867046],
            [4.729927782033045, 49.249893934867046],
            [4.7400941021993654, 49.24009262025695],
            [4.859949666265456, 49.24009262025695],
            [4.879747237115658, 49.26005826112937],
            [4.949841339315024, 49.24009262025695],
            [4.970173979647664, 49.24009262025695],
            [4.9899715504978674, 49.209962653122204],
            [4.940210088631141, 49.189997012249776],
            [4.970173979647664, 49.130100089632506],
            [5.0001378706641875, 49.110134448760085],
            [5.0001378706641875, 49.06984015536301],
            [5.009769121348069, 49.06003884075292],
            [4.970173979647664, 49.02010755900807],
            [5.009769121348069, 49.02990887361817],
            [5.039733012364592, 49.02010755900807],
            [5.030101761680709, 49.00014191813565],
            [5.039733012364592, 48.9700119510009],
            [5.030101761680709, 48.95004631012848],
            [4.970173979647664, 48.93008066925605],
            [4.949841339315024, 48.93008066925605],
            [4.930043768464821, 48.91011502838363],
            [4.91024619761462, 48.86982073498656],
            [4.940210088631141, 48.84005377950403],
            [4.88991355728198, 48.82008813863161],
            [4.88991355728198, 48.80012249775919],
            [4.930043768464821, 48.78995817149686],
            [4.9899715504978674, 48.739862563489694],
            [5.009769121348069, 48.739862563489694],
            [5.009769121348069, 48.699931281744846],
            [4.9899715504978674, 48.679965640872425],
            [4.979805230331547, 48.69012996713475],
            [4.949841339315024, 48.69012996713475],
            [4.940210088631141, 48.679965640872425],
            [4.91024619761462, 48.69012996713475],
            [4.8701159864317765, 48.670164326262324],
            [4.780224313382209, 48.670164326262324],
            [4.770057993215889, 48.64983567373768],
            [4.840152095415253, 48.64983567373768],
            [4.849783346099136, 48.64003435912758],
            [4.849783346099136, 48.609904391992835],
            [4.829985775248933, 48.609904391992835],
            [4.770057993215889, 48.58993875112041],
            [4.78985556406609, 48.569973110247986],
            [4.780224313382209, 48.550007469375565],
            [4.78985556406609, 48.53004182850314],
            [4.719761461866725, 48.53984314311324],
            [4.670000000000001, 48.53984314311324],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 72, name: "Sarthe", REG: 52, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.229993434730277, 47.61017030176277],
            [0.2000295437137547, 47.61017030176277],
            [0.18023197286355153, 47.589841649238124],
            [0.14973301236459147, 47.58004033462802],
            [0.07000765948134369, 47.61017030176277],
            [0.010079877448298191, 47.61997161637287],
            [-0.00008644271802182857, 47.65010158350762],
            [-0.019884013568224113, 47.63993725724529],
            [-0.07981179560126961, 47.65990289811772],
            [-0.10977568661779191, 47.65990289811772],
            [-0.10977568661779191, 47.63993725724529],
            [-0.17023853813327516, 47.63993725724529],
            [-0.19003610898347745, 47.65010158350762],
            [-0.21999999999999975, 47.67986853899014],
            [-0.21999999999999975, 47.69003286525247],
            [-0.17986978881715743, 47.70999850612489],
            [-0.20020242914979747, 47.72996414699731],
            [-0.23979757085020204, 47.69983417986256],
            [-0.29009410219936527, 47.72016283238722],
            [-0.3302243133822085, 47.72016283238722],
            [-0.35002188423241076, 47.70999850612489],
            [-0.37998577524893307, 47.76009411413206],
            [-0.37998577524893307, 47.76989542874216],
            [-0.3901520954152531, 47.809826710487],
            [-0.4201159864317763, 47.80002539587691],
            [-0.43991355728197856, 47.830155363011656],
            [-0.42974723711565854, 47.85012100388408],
            [-0.40994966626545537, 47.85992231849418],
            [-0.37998577524893307, 47.85992231849418],
            [-0.36981945508261305, 47.8798879593666],
            [-0.40994966626545537, 47.91001792650135],
            [-0.3901520954152531, 47.92998356737377],
            [-0.33985556406609074, 47.92998356737377],
            [-0.3302243133822085, 47.940147893636095],
            [-0.3002604223656853, 47.940147893636095],
            [-0.27992778203304525, 47.949949208246196],
            [-0.3002604223656853, 47.96991484911862],
            [-0.30989167304956755, 48.009846130863465],
            [-0.33985556406609074, 48.009846130863465],
            [-0.3302243133822085, 48.05014042426053],
            [-0.29009410219936527, 48.05014042426053],
            [-0.27992778203304525, 48.059941738870634],
            [-0.23016632016631977, 48.059941738870634],
            [-0.23979757085020204, 48.09007170600538],
            [-0.21999999999999975, 48.119838661487904],
            [-0.24996389101652294, 48.14016731401255],
            [-0.24996389101652294, 48.16013295488497],
            [-0.19003610898347745, 48.1800985957574],
            [-0.16007221796695514, 48.20006423662982],
            [-0.14990589780063424, 48.22002987750224],
            [-0.16007221796695514, 48.25996115924709],
            [-0.13973957763431422, 48.29009112638184],
            [-0.16007221796695514, 48.33982372273678],
            [-0.11994200678411193, 48.33982372273678],
            [-0.13973957763431422, 48.36015237526143],
            [-0.11994200678411193, 48.36995368987153],
            [-0.07981179560126961, 48.36995368987153],
            [-0.049847904584746416, 48.380118016133856],
            [-0.019884013568224113, 48.38991933074395],
            [0.0202461976146191, 48.380118016133856],
            [0.0502100886311414, 48.38991933074395],
            [0.07000765948134369, 48.40988497161638],
            [0.09997155049786599, 48.40988497161638],
            [0.11976912134806916, 48.44001493875112],
            [0.1598993325309115, 48.44001493875112],
            [0.1700656526972315, 48.45998057962355],
            [0.21982711456395698, 48.470144905885874],
            [0.2497910055804793, 48.470144905885874],
            [0.2599573257467993, 48.47994622049597],
            [0.3000875369296425, 48.47994622049597],
            [0.3498489987963671, 48.45998057962355],
            [0.3798128898128903, 48.4298506124888],
            [0.37018163912900803, 48.38991933074395],
            [0.3899792099792103, 48.34998804899911],
            [0.3798128898128903, 48.33002240812668],
            [0.4199431009957326, 48.31985808186436],
            [0.4397406718459349, 48.29989244099193],
            [0.46007331217857583, 48.31005676725426],
            [0.5002035233614182, 48.29009112638184],
            [0.5098347740453004, 48.27012548550941],
            [0.5301674143779405, 48.27012548550941],
            [0.5499649852281436, 48.25015984463699],
            [0.5799288762446659, 48.23999551837467],
            [0.6398566582777114, 48.23999551837467],
            [0.6500229784440315, 48.25996115924709],
            [0.6799868694605538, 48.25015984463699],
            [0.720117080643397, 48.20006423662982],
            [0.7602472918262393, 48.1800985957574],
            [0.7998424335266439, 48.189899910367494],
            [0.829806324543167, 48.16993426949507],
            [0.8597702155596894, 48.16993426949507],
            [0.9100667469088526, 48.14996862862265],
            [0.9100667469088526, 48.14016731401255],
            [0.8501389648758071, 48.130002987750224],
            [0.8399726447094871, 48.099873020615476],
            [0.8501389648758071, 48.09007170600538],
            [0.8399726447094871, 48.070106065132954],
            [0.7902111828427616, 48.070106065132954],
            [0.7902111828427616, 48.05014042426053],
            [0.8100087536929648, 48.03017478338811],
            [0.8399726447094871, 48.03017478338811],
            [0.8201750738592848, 47.980079175380936],
            [0.8501389648758071, 47.949949208246196],
            [0.8501389648758071, 47.940147893636095],
            [0.8100087536929648, 47.92998356737377],
            [0.7902111828427616, 47.91001792650135],
            [0.7602472918262393, 47.89985360023902],
            [0.7602472918262393, 47.85992231849418],
            [0.7698785425101216, 47.830155363011656],
            [0.7500809716599193, 47.830155363011656],
            [0.7099507604770761, 47.78986106961458],
            [0.6500229784440315, 47.76009411413206],
            [0.6200590874275083, 47.74992978786973],
            [0.6098927672611882, 47.72996414699731],
            [0.5799288762446659, 47.70999850612489],
            [0.6098927672611882, 47.69003286525247],
            [0.590095196410986, 47.67006722438004],
            [0.5601313053944637, 47.67006722438004],
            [0.5301674143779405, 47.65010158350762],
            [0.5002035233614182, 47.63993725724529],
            [0.46007331217857583, 47.63993725724529],
            [0.4499069920122549, 47.61997161637287],
            [0.4199431009957326, 47.61997161637287],
            [0.40014553014553034, 47.63993725724529],
            [0.3798128898128903, 47.63993725724529],
            [0.3600153189626871, 47.61997161637287],
            [0.40014553014553034, 47.589841649238124],
            [0.3798128898128903, 47.5698760083657],
            [0.34021774811248484, 47.58004033462802],
            [0.3198851077798448, 47.60000597550045],
            [0.2797548965970016, 47.60000597550045],
            [0.2599573257467993, 47.61017030176277],
            [0.229993434730277, 47.61017030176277],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 75, name: "Paris", REG: 11, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.3301411532990484, 48.82008813863161],
            [2.300177262282526, 48.82988945324171],
            [2.260047051099683, 48.82988945324171],
            [2.249880730933363, 48.84985509411413],
            [2.2199168399168405, 48.84985509411413],
            [2.2300831600831605, 48.86982073498656],
            [2.249880730933363, 48.87998506124888],
            [2.279844621949885, 48.87998506124888],
            [2.3199748331327283, 48.8999507021213],
            [2.400235255498414, 48.8999507021213],
            [2.400235255498414, 48.87998506124888],
            [2.420032826348616, 48.84985509411413],
            [2.4697942882153407, 48.84005377950403],
            [2.4601630375314585, 48.82008813863161],
            [2.420032826348616, 48.82008813863161],
            [2.390068935332094, 48.82988945324171],
            [2.3601050443155707, 48.82008813863161],
            [2.3301411532990484, 48.82008813863161],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 18, name: "Cher", REG: 24, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.170155378050115, 46.41985509411413],
            [2.149822737717475, 46.46014938751121],
            [2.1899529489003173, 46.4699507021213],
            [2.2001192690666374, 46.48991634299372],
            [2.159989057883795, 46.55997759187332],
            [2.170155378050115, 46.57014191813565],
            [2.170155378050115, 46.59990887361817],
            [2.1899529489003173, 46.61987451449059],
            [2.1797866287339973, 46.65000448162534],
            [2.1401914870335927, 46.66997012249776],
            [2.159989057883795, 46.68993576337019],
            [2.1300251668672727, 46.70990140424261],
            [2.0898949556844295, 46.70990140424261],
            [2.0898949556844295, 46.72986704511503],
            [2.0700973848342272, 46.72986704511503],
            [2.0700973848342272, 46.74983268598745],
            [2.1102275960170696, 46.7799626531222],
            [2.0700973848342272, 46.810092620256945],
            [2.059931064667907, 46.83005826112937],
            [2.0898949556844295, 46.850023902001794],
            [2.1000612758507495, 46.869989542874215],
            [2.1401914870335927, 46.889955183746636],
            [2.149822737717475, 46.909920824619064],
            [2.1401914870335927, 46.92008515088139],
            [2.1102275960170696, 46.909920824619064],
            [2.0700973848342272, 46.929886465491485],
            [2.0700973848342272, 46.949852106363906],
            [2.0898949556844295, 46.97018075888856],
            [2.1000612758507495, 47.0101120406334],
            [2.029967173651384, 47.05004332237825],
            [2.059931064667907, 47.080173289513],
            [2.049764744501587, 47.10013893038542],
            [2.0000032826348617, 47.10013893038542],
            [2.0000032826348617, 47.12990588586794],
            [1.9502418207681371, 47.12010457125784],
            [1.9197428602691762, 47.10013893038542],
            [1.910111609585294, 47.10994024499552],
            [1.8801477185687716, 47.10013893038542],
            [1.8298511872196084, 47.12010457125784],
            [1.799887296203086, 47.12010457125784],
            [1.7800897253528838, 47.12990588586794],
            [1.810053616369406, 47.14987152674037],
            [1.810053616369406, 47.16983716761279],
            [1.8400175073859284, 47.18000149387511],
            [1.8400175073859284, 47.21993277561996],
            [1.8801477185687716, 47.21013146100986],
            [1.9197428602691762, 47.230097101882286],
            [1.899945289418974, 47.25006274275471],
            [1.9400755006018162, 47.289994024499556],
            [2.0000032826348617, 47.27002838362713],
            [2.029967173651384, 47.27002838362713],
            [2.0898949556844295, 47.289994024499556],
            [2.1300251668672727, 47.27982969823723],
            [2.159989057883795, 47.300158350761876],
            [2.149822737717475, 47.320123991634304],
            [2.1300251668672727, 47.320123991634304],
            [2.119858846700952, 47.36985658798925],
            [2.1000612758507495, 47.36985658798925],
            [2.1000612758507495, 47.38982222886167],
            [2.119858846700952, 47.410150881386315],
            [2.1401914870335927, 47.410150881386315],
            [2.1899529489003173, 47.43991783686884],
            [2.2001192690666374, 47.410150881386315],
            [2.2402494802494806, 47.410150881386315],
            [2.249880730933363, 47.43991783686884],
            [2.2402494802494806, 47.470047804003585],
            [2.249880730933363, 47.49001344487601],
            [2.2199168399168405, 47.50017777113833],
            [2.2001192690666374, 47.54991036749328],
            [2.1300251668672727, 47.54991036749328],
            [2.119858846700952, 47.58004033462802],
            [2.159989057883795, 47.60000597550045],
            [2.2402494802494806, 47.61997161637287],
            [2.290010942116205, 47.6301359426352],
            [2.3601050443155707, 47.589841649238124],
            [2.390068935332094, 47.589841649238124],
            [2.400235255498414, 47.60000597550045],
            [2.4499967173651385, 47.61017030176277],
            [2.4601630375314585, 47.589841649238124],
            [2.4901269285479817, 47.5698760083657],
            [2.5698522814312295, 47.5698760083657],
            [2.620148812780392, 47.54010905288318],
            [2.609982492614072, 47.529944726620855],
            [2.6597439544807973, 47.509979085748434],
            [2.6597439544807973, 47.49001344487601],
            [2.6902429149797573, 47.479849118613686],
            [2.729838056680162, 47.50017777113833],
            [2.7202068059962796, 47.52014341201075],
            [2.729838056680162, 47.54010905288318],
            [2.759801947696685, 47.52014341201075],
            [2.780134588029325, 47.52014341201075],
            [2.8100984790458474, 47.49001344487601],
            [2.8400623700623706, 47.509979085748434],
            [2.870026261078893, 47.52014341201075],
            [2.889823831929095, 47.509979085748434],
            [2.9299540431119384, 47.43011652225874],
            [2.889823831929095, 47.36985658798925],
            [2.870026261078893, 47.3299253062444],
            [2.880192581245213, 47.320123991634304],
            [2.9401203632782584, 47.289994024499556],
            [2.9802505744611016, 47.25986405736481],
            [2.9802505744611016, 47.230097101882286],
            [3.019845716161506, 47.16003585300269],
            [3.0300120363278262, 47.12990588586794],
            [3.0300120363278262, 47.0899746041231],
            [3.019845716161506, 47.05984463698835],
            [3.0599759273443494, 47.05004332237825],
            [3.0701422475106694, 47.03007768150583],
            [3.0701422475106694, 46.99994771437108],
            [3.0599759273443494, 46.979982073498654],
            [3.079773498194551, 46.949852106363906],
            [3.0599759273443494, 46.94005079175381],
            [3.0498096071780294, 46.909920824619064],
            [3.0701422475106694, 46.850023902001794],
            [3.0300120363278262, 46.790126979384524],
            [3.019845716161506, 46.799928293994626],
            [2.9299540431119384, 46.799928293994626],
            [2.880192581245213, 46.75999701224978],
            [2.8400623700623706, 46.740031371377356],
            [2.759801947696685, 46.72006573050493],
            [2.740004376846483, 46.72986704511503],
            [2.729838056680162, 46.74983268598745],
            [2.6998741656636396, 46.740031371377356],
            [2.6998741656636396, 46.72006573050493],
            [2.650112703796915, 46.68993576337019],
            [2.620148812780392, 46.68993576337019],
            [2.609982492614072, 46.66997012249776],
            [2.5698522814312295, 46.66016880788766],
            [2.5998161724477518, 46.63984015536301],
            [2.5800186015975495, 46.63003884075292],
            [2.5800186015975495, 46.61007319988049],
            [2.5998161724477518, 46.59990887361817],
            [2.609982492614072, 46.55017627726322],
            [2.5398883904147063, 46.52004631012847],
            [2.530257139730824, 46.52984762473857],
            [2.4697942882153407, 46.52984762473857],
            [2.4499967173651385, 46.52004631012847],
            [2.430199146514936, 46.52984762473857],
            [2.409866506182296, 46.52004631012847],
            [2.369736294999453, 46.52004631012847],
            [2.3301411532990484, 46.50008066925605],
            [2.279844621949885, 46.44998506124888],
            [2.279844621949885, 46.41985509411413],
            [2.249880730933363, 46.43001942037646],
            [2.2199168399168405, 46.41985509411413],
            [2.2001192690666374, 46.43001942037646],
            [2.170155378050115, 46.41985509411413],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 82,
        name: "Tarn-et-Garonne",
        REG: 76,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.2701685085895615, 43.78983567373768],
            [1.210240726556516, 43.76987003286525],
            [1.2198719772403983, 43.78983567373768],
            [1.179741766057556, 43.78983567373768],
            [1.179741766057556, 43.8],
            [1.1401466243571505, 43.819965640872425],
            [1.1198139840245105, 43.8],
            [1.080218842324106, 43.819965640872425],
            [1.059886201991465, 43.8],
            [0.9897920997921004, 43.8],
            [0.9801608491082181, 43.78983567373768],
            [0.9501969580916949, 43.78983567373768],
            [0.8999004267425326, 43.78983567373768],
            [0.9100667469088526, 43.819965640872425],
            [0.8999004267425326, 43.839931281744846],
            [0.9100667469088526, 43.850095608007166],
            [0.8897341065762117, 43.870061248879594],
            [0.8897341065762117, 43.909992530624436],
            [0.8597702155596894, 43.92015685688676],
            [0.8201750738592848, 43.92015685688676],
            [0.8100087536929648, 43.929958171496864],
            [0.7698785425101216, 43.92015685688676],
            [0.7602472918262393, 43.949923812369285],
            [0.7800448626764416, 43.949923812369285],
            [0.7902111828427616, 43.969889453241706],
            [0.829806324543167, 44.000019420376454],
            [0.8100087536929648, 44.01998506124888],
            [0.8201750738592848, 44.0301493875112],
            [0.8501389648758071, 44.0301493875112],
            [0.8399726447094871, 44.05011502838363],
            [0.8201750738592848, 44.05991634299372],
            [0.7998424335266439, 44.0399507021213],
            [0.7602472918262393, 44.0301493875112],
            [0.7602472918262393, 44.05011502838363],
            [0.7399146514935993, 44.07008066925605],
            [0.7500809716599193, 44.09984762473857],
            [0.8201750738592848, 44.14014191813564],
            [0.8597702155596894, 44.12997759187332],
            [0.8897341065762117, 44.14014191813564],
            [0.8897341065762117, 44.16990887361816],
            [0.8501389648758071, 44.16990887361816],
            [0.8597702155596894, 44.18987451449059],
            [0.8999004267425326, 44.18987451449059],
            [0.9298643177590549, 44.23016880788766],
            [0.9202330670751726, 44.23997012249776],
            [0.9501969580916949, 44.27990140424261],
            [0.8999004267425326, 44.29986704511503],
            [0.8699365357260094, 44.31983268598745],
            [0.8897341065762117, 44.3499626531222],
            [0.8897341065762117, 44.36992829399462],
            [0.9202330670751726, 44.380092620256946],
            [0.9501969580916949, 44.360126979384525],
            [0.9801608491082181, 44.360126979384525],
            [0.9999584199584204, 44.36992829399462],
            [1.0197559908086227, 44.360126979384525],
            [1.0502549513075827, 44.360126979384525],
            [1.059886201991465, 44.380092620256946],
            [1.1000164131743082, 44.38989393486705],
            [1.1299803041908305, 44.38989393486705],
            [1.1299803041908305, 44.36992829399462],
            [1.0898500930079882, 44.36992829399462],
            [1.1101827333406282, 44.3401613385121],
            [1.1101827333406282, 44.31983268598745],
            [1.1401466243571505, 44.31983268598745],
            [1.210240726556516, 44.27010008963251],
            [1.2300382974067183, 44.27990140424261],
            [1.2498358682569215, 44.27010008963251],
            [1.3001323996060838, 44.29986704511503],
            [1.3001323996060838, 44.25993576337018],
            [1.2797997592734438, 44.250134448760086],
            [1.3001323996060838, 44.23016880788766],
            [1.330096290622607, 44.23016880788766],
            [1.3600601816391293, 44.20003884075291],
            [1.3900240726556516, 44.23016880788766],
            [1.4301542838384949, 44.23997012249776],
            [1.4697494255388994, 44.27990140424261],
            [1.5098796367217417, 44.27010008963251],
            [1.5200459568880627, 44.250134448760086],
            [1.550009847904585, 44.23016880788766],
            [1.5901400590874273, 44.250134448760086],
            [1.5698074187547872, 44.27990140424261],
            [1.5698074187547872, 44.29986704511503],
            [1.6201039501039505, 44.29986704511503],
            [1.6201039501039505, 44.27990140424261],
            [1.6399015209541528, 44.27010008963251],
            [1.6602341612867928, 44.29006573050493],
            [1.7399595141700406, 44.32999701224978],
            [1.7699234051865629, 44.31003137137735],
            [1.7902560455192038, 44.32999701224978],
            [1.8298511872196084, 44.3401613385121],
            [1.8501838275522484, 44.32999701224978],
            [1.8801477185687716, 44.3401613385121],
            [1.8598150782361307, 44.31983268598745],
            [1.899945289418974, 44.27990140424261],
            [1.9700393916183394, 44.27990140424261],
            [1.9598730714520194, 44.25993576337018],
            [1.9400755006018162, 44.250134448760086],
            [1.910111609585294, 44.20984015536301],
            [1.910111609585294, 44.18987451449059],
            [1.9299091804354962, 44.18987451449059],
            [1.9700393916183394, 44.16990887361816],
            [1.9898369624685417, 44.14994323274574],
            [1.9700393916183394, 44.14014191813564],
            [1.9299091804354962, 44.16010755900807],
            [1.8897789692526539, 44.16010755900807],
            [1.910111609585294, 44.14014191813564],
            [1.8400175073859284, 44.14014191813564],
            [1.810053616369406, 44.12997759187332],
            [1.7800897253528838, 44.09984762473857],
            [1.7201619433198383, 44.12017627726322],
            [1.690198052303316, 44.11001195100089],
            [1.669865411970675, 44.12017627726322],
            [1.6500678411204728, 44.09984762473857],
            [1.669865411970675, 44.09004631012847],
            [1.6602341612867928, 44.07008066925605],
            [1.690198052303316, 44.05991634299372],
            [1.6998293029871983, 44.0399507021213],
            [1.690198052303316, 44.01998506124888],
            [1.6201039501039505, 43.969889453241706],
            [1.5901400590874273, 43.96008813863161],
            [1.5698074187547872, 43.969889453241706],
            [1.539843527738265, 43.949923812369285],
            [1.5698074187547872, 43.940122497759184],
            [1.560176168070905, 43.92015685688676],
            [1.5302122770543827, 43.92015685688676],
            [1.5002483860378595, 43.890026889752015],
            [1.4799157457052194, 43.909992530624436],
            [1.4499518546886971, 43.870061248879594],
            [1.4199879636721748, 43.870061248879594],
            [1.3702265018054494, 43.890026889752015],
            [1.340262610788927, 43.850095608007166],
            [1.3199299704562861, 43.85989692261727],
            [1.3001323996060838, 43.850095608007166],
            [1.309763650289966, 43.830129967134745],
            [1.3498938614728093, 43.839931281744846],
            [1.3600601816391293, 43.819965640872425],
            [1.309763650289966, 43.8],
            [1.2701685085895615, 43.8],
            [1.2701685085895615, 43.78983567373768],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 973, name: "Guyane", REG: "03", CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.9797986650618231, 41.86986704511503],
            [-1.0199288762446654, 41.80997012249776],
            [-1.0498927672611886, 41.79000448162533],
            [-1.0498927672611886, 41.77003884075291],
            [-1.1098205492942332, 41.66984762473857],
            [-1.100189298610351, 41.649881983866145],
            [-1.1499507604770765, 41.6099507021213],
            [-1.2002472918262392, 41.589985061248875],
            [-1.2098785425101215, 41.570019420376454],
            [-1.2398424335266442, 41.55985509411413],
            [-1.279972644709487, 41.570019420376454],
            [-1.339900426742532, 41.55985509411413],
            [-1.329734106576212, 41.579820734986555],
            [-1.3602330670751726, 41.6001493875112],
            [-1.3998282087755771, 41.570019420376454],
            [-1.4399584199584199, 41.579820734986555],
            [-1.4800886311412627, 41.579820734986555],
            [-1.4902549513075831, 41.6001493875112],
            [-1.5501827333406282, 41.570019420376454],
            [-1.5298500930079877, 41.55985509411413],
            [-1.5897778750410332, 41.55005377950403],
            [-1.5999441952073532, 41.530088138631605],
            [-1.7299660794397638, 41.55005377950403],
            [-1.7401323996060838, 41.570019420376454],
            [-1.7197997592734438, 41.6001493875112],
            [-1.689835868256921, 41.62011502838362],
            [-1.6700382974067187, 41.649881983866145],
            [-1.640074406390196, 41.71014191813564],
            [-1.650240726556516, 41.75987451449058],
            [-1.629908086223876, 41.79000448162533],
            [-1.6101105153736732, 41.80016880788766],
            [-1.5999441952073532, 41.86006573050493],
            [-1.640074406390196, 41.88983268598745],
            [-1.6802046175730387, 41.9101613385121],
            [-1.7197997592734438, 41.950092620256946],
            [-1.7299660794397638, 41.97005826112937],
            [-1.749763650289966, 41.97985957573947],
            [-1.749763650289966, 42.009989542874216],
            [-1.7700962906226065, 42.02995518374664],
            [-1.7700962906226065, 42.11018075888855],
            [-1.7898938614728088, 42.139947714371075],
            [-1.7802626107889266, 42.17007768150582],
            [-1.7299660794397638, 42.22997460412309],
            [-1.6598719772403983, 42.28007021213026],
            [-1.650240726556516, 42.309837167612784],
            [-1.629908086223876, 42.33996713474753],
            [-1.6101105153736732, 42.35013146100986],
            [-1.5699803041908305, 42.33016582013744],
            [-1.4699223109749426, 42.30003585300269],
            [-1.3201028558923298, 42.28007021213026],
            [-1.2997702155596893, 42.28007021213026],
            [-1.2500087536929643, 42.26010457125784],
            [-1.1697483313272787, 42.21000896325067],
            [-1.100189298610351, 42.179878996115924],
            [-1.0600590874275087, 42.179878996115924],
            [-1.0402615165773064, 42.159913355243496],
            [-0.9797986650618231, 42.130146399760974],
            [-0.9498347740452999, 42.069886465491486],
            [-0.9498347740452999, 42.130146399760974],
            [-0.9300372031950976, 42.130146399760974],
            [-0.8899069920122553, 42.08985210636391],
            [-0.8497767808294121, 42.009989542874216],
            [-0.8797406718459353, 41.97985957573947],
            [-0.8899069920122553, 41.95989393486704],
            [-0.9300372031950976, 41.93992829399462],
            [-0.9402035233614177, 41.9199626531222],
            [-0.9797986650618231, 41.86986704511503],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 33, name: "Gironde", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.13973957763431422, 44.23016880788766],
            [-0.17023853813327516, 44.23997012249776],
            [-0.19003610898347745, 44.27010008963251],
            [-0.23016632016631977, 44.25993576337018],
            [-0.21999999999999975, 44.20984015536301],
            [-0.26013021118284296, 44.20003884075291],
            [-0.2697614618667252, 44.18987451449059],
            [-0.30989167304956755, 44.20003884075291],
            [-0.3901520954152531, 44.20984015536301],
            [-0.39978334609913535, 44.23997012249776],
            [-0.37998577524893307, 44.29006573050493],
            [-0.42974723711565854, 44.29986704511503],
            [-0.42974723711565854, 44.31983268598745],
            [-0.5201739796476641, 44.3401613385121],
            [-0.5298052303315464, 44.360126979384525],
            [-0.5699354415143887, 44.380092620256946],
            [-0.6400295437137542, 44.40005826112937],
            [-0.6298632235474342, 44.40985957573947],
            [-0.6298632235474342, 44.439989542874216],
            [-0.6699934347302765, 44.45995518374664],
            [-0.6897910055804797, 44.439989542874216],
            [-0.729921216763322, 44.45015386913654],
            [-0.7700514279461643, 44.439989542874216],
            [-0.8101816391290075, 44.420023902001795],
            [-0.8401455301455298, 44.420023902001795],
            [-0.9102396323448954, 44.439989542874216],
            [-0.9498347740452999, 44.439989542874216],
            [-0.9701674143779409, 44.42982521661189],
            [-1.0300951964109855, 44.420023902001795],
            [-0.9899649852281431, 44.45995518374664],
            [-0.9797986650618231, 44.479920824619064],
            [-0.9899649852281431, 44.51005079175381],
            [-1.0300951964109855, 44.51005079175381],
            [-1.090022978444031, 44.53001643262623],
            [-1.1098205492942332, 44.499886465491485],
            [-1.2500087536929643, 44.47011951000896],
            [-1.2500087536929643, 44.51005079175381],
            [-1.2601750738592843, 44.54018075888855],
            [-1.230211182842762, 44.569947714371075],
            [-1.2098785425101215, 44.60007768150582],
            [-1.1900809716599192, 44.65997460412309],
            [-1.139784440310756, 44.65997460412309],
            [-1.1199868694605537, 44.64000896325067],
            [-1.079856658277711, 44.64000896325067],
            [-1.0702254075938287, 44.650173289513],
            [-1.0199288762446654, 44.650173289513],
            [-1.0097625560783454, 44.650173289513],
            [-1.0402615165773064, 44.69010457125784],
            [-1.1199868694605537, 44.75000149387511],
            [-1.1499507604770765, 44.76016582013744],
            [-1.2098785425101215, 44.71987152674036],
            [-1.2398424335266442, 44.67994024499552],
            [-1.2398424335266442, 44.62004332237825],
            [-1.2601750738592843, 44.62004332237825],
            [-1.2601750738592843, 44.65997460412309],
            [-1.230211182842762, 44.80989841649238],
            [-1.2098785425101215, 44.91989094711682],
            [-1.1900809716599192, 45.07017777113833],
            [-1.1900809716599192, 45.1300746937556],
            [-1.1697483313272787, 45.24986853899014],
            [-1.1601170806433965, 45.29016283238721],
            [-1.1601170806433965, 45.40995667762175],
            [-1.1499507604770765, 45.4400866447565],
            [-1.1601170806433965, 45.46985360023902],
            [-1.139784440310756, 45.510147893636095],
            [-1.100189298610351, 45.53991484911862],
            [-1.090022978444031, 45.55988048999104],
            [-1.0600590874275087, 45.57004481625336],
            [-1.0600590874275087, 45.55007917538094],
            [-1.0402615165773064, 45.55007917538094],
            [-1.0402615165773064, 45.530113534508516],
            [-1.0702254075938287, 45.51994920824619],
            [-1.0199288762446654, 45.48001792650135],
            [-0.9300372031950976, 45.4400866447565],
            [-0.9000733121785753, 45.40995667762175],
            [-0.8401455301455298, 45.379826710487],
            [-0.8000153189626875, 45.33989542874216],
            [-0.7598851077798443, 45.27999850612489],
            [-0.750253857095962, 45.229902898117714],
            [-0.6897910055804797, 45.24006722438004],
            [-0.6999573257467997, 45.29016283238721],
            [-0.719754896597002, 45.33009411413206],
            [-0.6501958638800742, 45.31992978786973],
            [-0.589733012364591, 45.31992978786973],
            [-0.5501378706641864, 45.29016283238721],
            [-0.4602461976146186, 45.29016283238721],
            [-0.42974723711565854, 45.27999850612489],
            [-0.40994966626545537, 45.24986853899014],
            [-0.40994966626545537, 45.22010158350762],
            [-0.4201159864317763, 45.20013594263519],
            [-0.37998577524893307, 45.159841649238125],
            [-0.33985556406609074, 45.170005975500445],
            [-0.30989167304956755, 45.150040334628024],
            [-0.27992778203304525, 45.139876008365704],
            [-0.26013021118284296, 45.11010905288318],
            [-0.21999999999999975, 45.11010905288318],
            [-0.19003610898347745, 45.090143412010754],
            [-0.13973957763431422, 45.090143412010754],
            [-0.10977568661779191, 45.119910367493276],
            [-0.08997811576758963, 45.119910367493276],
            [-0.07018054491738734, 45.099944726620855],
            [-0.04021665390086415, 45.099944726620855],
            [-0.00008644271802182857, 45.119910367493276],
            [0.029877448298501363, 45.119910367493276],
            [0.05984133931502367, 45.099944726620855],
            [0.07000765948134369, 45.07017777113833],
            [0.05984133931502367, 45.040047804003585],
            [0.04004376846482138, 45.040047804003585],
            [0.04004376846482138, 44.989952195996416],
            [0.010079877448298191, 44.980150881386315],
            [0.010079877448298191, 44.95002091425157],
            [0.029877448298501363, 44.910089632506725],
            [0.0202461976146191, 44.8901239916343],
            [-0.00008644271802182857, 44.87995966537198],
            [-0.010252762884341848, 44.85999402449955],
            [0.04004376846482138, 44.84002838362713],
            [0.04004376846482138, 44.8298640573648],
            [0.14973301236459147, 44.8298640573648],
            [0.1898632235474338, 44.82006274275471],
            [0.21982711456395698, 44.84002838362713],
            [0.24015975489659702, 44.870158350761876],
            [0.2797548965970016, 44.870158350761876],
            [0.3198851077798448, 44.84982969823723],
            [0.3000875369296425, 44.84002838362713],
            [0.2701236459131193, 44.80989841649238],
            [0.2701236459131193, 44.78013146100986],
            [0.3000875369296425, 44.76016582013744],
            [0.2497910055804793, 44.75000149387511],
            [0.21982711456395698, 44.76016582013744],
            [0.2000295437137547, 44.71987152674036],
            [0.18023197286355153, 44.75000149387511],
            [0.1401017616807092, 44.71007021213027],
            [0.1101378706641869, 44.71007021213027],
            [0.09997155049786599, 44.69990588586794],
            [0.12993544151438918, 44.67013893038542],
            [0.18023197286355153, 44.67013893038542],
            [0.1700656526972315, 44.629844636988345],
            [0.1401017616807092, 44.629844636988345],
            [0.11976912134806916, 44.5899133552435],
            [0.08980523033154597, 44.5801120406334],
            [0.07000765948134369, 44.549982073498654],
            [0.029877448298501363, 44.549982073498654],
            [0.0202461976146191, 44.53001643262623],
            [-0.019884013568224113, 44.499886465491485],
            [-0.00008644271802182857, 44.439989542874216],
            [-0.010252762884341848, 44.420023902001795],
            [0.0202461976146191, 44.38989393486705],
            [0.010079877448298191, 44.36992829399462],
            [-0.019884013568224113, 44.36992829399462],
            [-0.030050333734544132, 44.360126979384525],
            [-0.060014224751066436, 44.360126979384525],
            [-0.08997811576758963, 44.3401613385121],
            [-0.030050333734544132, 44.29986704511503],
            [-0.049847904584746416, 44.27010008963251],
            [-0.10014443593390965, 44.23016880788766],
            [-0.11994200678411193, 44.23997012249776],
            [-0.13973957763431422, 44.23016880788766],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 972,
        name: "Martinique",
        REG: "02",
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.350111609585294, 41.71014191813564],
            [-2.359742860269176, 41.66004631012847],
            [-2.399873071452019, 41.629916342993724],
            [-2.410039391618339, 41.6001493875112],
            [-2.4501696028011817, 41.6001493875112],
            [-2.4801334938177044, 41.629916342993724],
            [-2.459800853485064, 41.66004631012847],
            [-2.4699671736513844, 41.68001195100089],
            [-2.4298369624685416, 41.69997759187331],
            [-2.459800853485064, 41.71014191813564],
            [-2.4897647445015867, 41.68001195100089],
            [-2.5298949556844295, 41.69997759187331],
            [-2.5801914870335922, 41.69017627726322],
            [-2.6401192690666377, 41.69997759187331],
            [-2.64975051975052, 41.71994323274574],
            [-2.67008316008316, 41.69997759187331],
            [-2.710213371266003, 41.69997759187331],
            [-2.7300109421162055, 41.71014191813564],
            [-2.7701411532990483, 41.69017627726322],
            [-2.7701411532990483, 41.66984762473857],
            [-2.8001050443155706, 41.66984762473857],
            [-2.8300689353320934, 41.69017627726322],
            [-2.8300689353320934, 41.71994323274574],
            [-2.8498665061822956, 41.71994323274574],
            [-2.8498665061822956, 41.73990887361816],
            [-2.870199146514936, 41.75007319988049],
            [-2.8300689353320934, 41.80016880788766],
            [-2.8199026151657733, 41.80016880788766],
            [-2.7899387241492506, 41.82993576337018],
            [-2.759974833132728, 41.82013444876008],
            [-2.759974833132728, 41.80016880788766],
            [-2.719844621949885, 41.79000448162533],
            [-2.67008316008316, 41.82013444876008],
            [-2.719844621949885, 41.84010008963251],
            [-2.7401772622825256, 41.86006573050493],
            [-2.7401772622825256, 41.88983268598745],
            [-2.759974833132728, 41.88003137137735],
            [-2.8001050443155706, 41.88003137137735],
            [-2.8001050443155706, 41.88983268598745],
            [-2.860032826348616, 41.88003137137735],
            [-2.900163037531459, 41.9101613385121],
            [-2.949924499398184, 41.93012697938452],
            [-2.979888390414706, 41.950092620256946],
            [-3.009852281431229, 41.99002390200179],
            [-3.0499824926140717, 42.02995518374664],
            [-3.0499824926140717, 42.04992082461906],
            [-3.0301849217638694, 42.080050791753806],
            [-3.0398161724477517, 42.100016432626234],
            [-3.069780063464274, 42.119982073498655],
            [-3.120076594813437, 42.139947714371075],
            [-3.1398741656636395, 42.179878996115924],
            [-3.120076594813437, 42.249940244995514],
            [-3.0799463836305945, 42.26990588586794],
            [-3.0301849217638694, 42.28007021213026],
            [-3.009852281431229, 42.28987152674036],
            [-2.979888390414706, 42.28987152674036],
            [-2.919960608381661, 42.26990588586794],
            [-2.8798303971988184, 42.249940244995514],
            [-2.8199026151657733, 42.22997460412309],
            [-2.8001050443155706, 42.24013893038542],
            [-2.759974833132728, 42.21000896325067],
            [-2.749808512966408, 42.190043322378244],
            [-2.7300109421162055, 42.199844636988345],
            [-2.719844621949885, 42.179878996115924],
            [-2.65991683991684, 42.130146399760974],
            [-2.6401192690666377, 42.100016432626234],
            [-2.5898227377174745, 42.139947714371075],
            [-2.5700251668672722, 42.130146399760974],
            [-2.510097384834227, 42.17007768150582],
            [-2.4801334938177044, 42.159913355243496],
            [-2.4801334938177044, 42.139947714371075],
            [-2.510097384834227, 42.139947714371075],
            [-2.510097384834227, 42.100016432626234],
            [-2.55022759601707, 42.08985210636391],
            [-2.55022759601707, 42.11018075888855],
            [-2.599989057883795, 42.11018075888855],
            [-2.610155378050115, 42.100016432626234],
            [-2.5898227377174745, 42.060085150881385],
            [-2.55022759601707, 42.060085150881385],
            [-2.520263705000547, 42.040119510008964],
            [-2.5700251668672722, 42.020153869136536],
            [-2.5898227377174745, 41.99002390200179],
            [-2.5700251668672722, 41.97005826112937],
            [-2.55022759601707, 41.99002390200179],
            [-2.510097384834227, 41.99002390200179],
            [-2.520263705000547, 41.97005826112937],
            [-2.4999310646679067, 41.95989393486704],
            [-2.510097384834227, 41.93012697938452],
            [-2.4699671736513844, 41.9199626531222],
            [-2.4400032826348617, 41.88983268598745],
            [-2.4202057117846594, 41.88983268598745],
            [-2.3902418207681366, 41.82993576337018],
            [-2.359742860269176, 41.79000448162533],
            [-2.369909180435496, 41.77984015536301],
            [-2.359742860269176, 41.75007319988049],
            [-2.339945289418974, 41.73010755900806],
            [-2.350111609585294, 41.71014191813564],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 23, name: "Creuse", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [1.4199879636721748, 46.35015685688676],
            [1.4799157457052194, 46.39008813863161],
            [1.5098796367217417, 46.41985509411413],
            [1.5302122770543827, 46.43001942037646],
            [1.550009847904585, 46.39988945324171],
            [1.5901400590874273, 46.41005377950403],
            [1.6297352007878327, 46.39008813863161],
            [1.6602341612867928, 46.39988945324171],
            [1.680031732136995, 46.41985509411413],
            [1.7099956231535183, 46.39008813863161],
            [1.7501258343363606, 46.41005377950403],
            [1.7597570850202429, 46.43001942037646],
            [1.7501258343363606, 46.44998506124888],
            [1.799887296203086, 46.44998506124888],
            [1.8202199365357261, 46.43001942037646],
            [1.8801477185687716, 46.43001942037646],
            [1.8897789692526539, 46.439820734986554],
            [1.9197428602691762, 46.439820734986554],
            [1.9299091804354962, 46.43001942037646],
            [1.9802057117846594, 46.439820734986554],
            [1.9898369624685417, 46.43001942037646],
            [2.019800853485064, 46.43001942037646],
            [2.029967173651384, 46.41985509411413],
            [2.0700973848342272, 46.41985509411413],
            [2.1000612758507495, 46.41005377950403],
            [2.119858846700952, 46.41985509411413],
            [2.170155378050115, 46.41985509411413],
            [2.2001192690666374, 46.43001942037646],
            [2.2199168399168405, 46.41985509411413],
            [2.249880730933363, 46.43001942037646],
            [2.279844621949885, 46.41985509411413],
            [2.279844621949885, 46.39008813863161],
            [2.290010942116205, 46.379923812369285],
            [2.3301411532990484, 46.379923812369285],
            [2.3098085129664083, 46.359958171496864],
            [2.3098085129664083, 46.329828204362116],
            [2.3601050443155707, 46.320026889752015],
            [2.390068935332094, 46.329828204362116],
            [2.420032826348616, 46.309862563489695],
            [2.420032826348616, 46.289896922617274],
            [2.4697942882153407, 46.289896922617274],
            [2.4901269285479817, 46.249965640872425],
            [2.520090819564504, 46.240164326262324],
            [2.520090819564504, 46.199870032865256],
            [2.560221030747347, 46.170103077382734],
            [2.5698522814312295, 46.139973110247986],
            [2.5500547105810263, 46.12000746937556],
            [2.5500547105810263, 46.080076187630716],
            [2.5698522814312295, 46.04994622049597],
            [2.5998161724477518, 46.02998057962354],
            [2.5901849217638695, 45.9998506124888],
            [2.609982492614072, 45.97008365700628],
            [2.5698522814312295, 45.95991933074395],
            [2.5398883904147063, 45.9199880489991],
            [2.5500547105810263, 45.90982372273678],
            [2.509924499398184, 45.889858081864354],
            [2.4901269285479817, 45.86009112638183],
            [2.4697942882153407, 45.86989244099193],
            [2.4398303971988184, 45.86989244099193],
            [2.430199146514936, 45.82996115924709],
            [2.400235255498414, 45.84012548550941],
            [2.390068935332094, 45.82996115924709],
            [2.430199146514936, 45.79002987750224],
            [2.430199146514936, 45.77006423662982],
            [2.4901269285479817, 45.73993426949507],
            [2.4398303971988184, 45.700002987750224],
            [2.409866506182296, 45.71016731401255],
            [2.3499387241492506, 45.71016731401255],
            [2.3499387241492506, 45.6898386614879],
            [2.3199748331327283, 45.669873020615476],
            [2.290010942116205, 45.669873020615476],
            [2.270213371266003, 45.6898386614879],
            [2.2402494802494806, 45.6898386614879],
            [2.2300831600831605, 45.700002987750224],
            [2.1899529489003173, 45.700002987750224],
            [2.2001192690666374, 45.719968628622645],
            [2.159989057883795, 45.719968628622645],
            [2.1300251668672727, 45.73013295488497],
            [2.0802637050005472, 45.73013295488497],
            [2.0802637050005472, 45.75009859575739],
            [2.040133493817705, 45.759899910367494],
            [2.0000032826348617, 45.75009859575739],
            [1.9898369624685417, 45.719968628622645],
            [1.9502418207681371, 45.719968628622645],
            [1.899945289418974, 45.700002987750224],
            [1.8801477185687716, 45.73013295488497],
            [1.899945289418974, 45.759899910367494],
            [1.8598150782361307, 45.80999551837466],
            [1.8202199365357261, 45.80999551837466],
            [1.799887296203086, 45.82996115924709],
            [1.7800897253528838, 45.82996115924709],
            [1.7699234051865629, 45.86989244099193],
            [1.7297931940037206, 45.84012548550941],
            [1.669865411970675, 45.84012548550941],
            [1.5997713097713095, 45.86009112638183],
            [1.6099376299376305, 45.86989244099193],
            [1.5997713097713095, 45.889858081864354],
            [1.6399015209541528, 45.889858081864354],
            [1.6297352007878327, 45.9199880489991],
            [1.5799737389211073, 45.93015237526143],
            [1.550009847904585, 45.9199880489991],
            [1.5302122770543827, 45.93015237526143],
            [1.539843527738265, 45.95011801613385],
            [1.5698074187547872, 45.95991933074395],
            [1.5698074187547872, 45.9998506124888],
            [1.539843527738265, 45.9998506124888],
            [1.5302122770543827, 46.01001493875112],
            [1.550009847904585, 46.04014490588587],
            [1.5302122770543827, 46.060110546758295],
            [1.539843527738265, 46.080076187630716],
            [1.5098796367217417, 46.08987750224081],
            [1.4900820658715395, 46.10984314311324],
            [1.5002483860378595, 46.139973110247986],
            [1.4697494255388994, 46.150137436510306],
            [1.4601181748550172, 46.17990439199283],
            [1.409821643505854, 46.17990439199283],
            [1.3798577524893316, 46.21983567373768],
            [1.4001903928219717, 46.240164326262324],
            [1.4397855345223771, 46.320026889752015],
            [1.4499518546886971, 46.329828204362116],
            [1.4199879636721748, 46.35015685688676],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 24, name: "Dordogne", REG: 75, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-0.04021665390086415, 45.099944726620855],
            [-0.030050333734544132, 45.1300746937556],
            [-0.04021665390086415, 45.139876008365704],
            [-0.00008644271802182857, 45.150040334628024],
            [-0.019884013568224113, 45.170005975500445],
            [-0.00008644271802182857, 45.18997161637287],
            [0.04004376846482138, 45.20993725724529],
            [0.05984133931502367, 45.229902898117714],
            [0.0801739796476637, 45.22010158350762],
            [0.09997155049786599, 45.229902898117714],
            [0.1101378706641869, 45.20993725724529],
            [0.14973301236459147, 45.20993725724529],
            [0.18023197286355153, 45.26003286525246],
            [0.2000295437137547, 45.26003286525246],
            [0.21982711456395698, 45.29016283238721],
            [0.2497910055804793, 45.29016283238721],
            [0.2701236459131193, 45.29996414699731],
            [0.2497910055804793, 45.35986106961458],
            [0.2497910055804793, 45.379826710487],
            [0.2797548965970016, 45.42992231849418],
            [0.3000875369296425, 45.42992231849418],
            [0.3000875369296425, 45.4498879593666],
            [0.4097767808294126, 45.48981924111144],
            [0.4499069920122549, 45.510147893636095],
            [0.47023963234489585, 45.53991484911862],
            [0.5002035233614182, 45.55007917538094],
            [0.5200010942116204, 45.590010457125786],
            [0.5002035233614182, 45.62014042426053],
            [0.5301674143779405, 45.640106065132954],
            [0.5601313053944637, 45.62994173887063],
            [0.5697625560783459, 45.649907379743055],
            [0.6302254075938292, 45.71016731401255],
            [0.6500229784440315, 45.6898386614879],
            [0.7399146514935993, 45.6898386614879],
            [0.7602472918262393, 45.669873020615476],
            [0.7800448626764416, 45.669873020615476],
            [0.7500809716599193, 45.62014042426053],
            [0.7800448626764416, 45.590010457125786],
            [0.7998424335266439, 45.60017478338811],
            [0.8100087536929648, 45.57984613086346],
            [0.8399726447094871, 45.57984613086346],
            [0.8699365357260094, 45.62014042426053],
            [0.8999004267425326, 45.60997609799821],
            [1.0197559908086227, 45.60997609799821],
            [1.0400886311412627, 45.590010457125786],
            [1.0299223109749427, 45.57984613086346],
            [1.080218842324106, 45.530113534508516],
            [1.1299803041908305, 45.53991484911862],
            [1.1497778750410328, 45.51994920824619],
            [1.1198139840245105, 45.48981924111144],
            [1.1401466243571505, 45.46985360023902],
            [1.1599441952073537, 45.48001792650135],
            [1.179741766057556, 45.46005228562892],
            [1.2300382974067183, 45.46005228562892],
            [1.2300382974067183, 45.4400866447565],
            [1.2498358682569215, 45.4400866447565],
            [1.2701685085895615, 45.4400866447565],
            [1.2600021884232415, 45.40015536301165],
            [1.2701685085895615, 45.38999103674933],
            [1.3001323996060838, 45.38999103674933],
            [1.3199299704562861, 45.379826710487],
            [1.3199299704562861, 45.35986106961458],
            [1.3001323996060838, 45.35986106961458],
            [1.2600021884232415, 45.31992978786973],
            [1.2402046175730392, 45.31992978786973],
            [1.2402046175730392, 45.29016283238721],
            [1.2300382974067183, 45.26983417986256],
            [1.2797997592734438, 45.24006722438004],
            [1.2300382974067183, 45.22010158350762],
            [1.2300382974067183, 45.20013594263519],
            [1.2701685085895615, 45.20013594263519],
            [1.2899660794397638, 45.18997161637287],
            [1.2797997592734438, 45.170005975500445],
            [1.2600021884232415, 45.159841649238125],
            [1.2899660794397638, 45.139876008365704],
            [1.3798577524893316, 45.139876008365704],
            [1.4001903928219717, 45.1300746937556],
            [1.409821643505854, 45.11010905288318],
            [1.3798577524893316, 45.11010905288318],
            [1.409821643505854, 45.07017777113833],
            [1.409821643505854, 45.049849118613686],
            [1.4499518546886971, 45.020082163131164],
            [1.409821643505854, 45.00991783686884],
            [1.409821643505854, 44.969986555123995],
            [1.4397855345223771, 44.93985658798924],
            [1.4397855345223771, 44.91989094711682],
            [1.4199879636721748, 44.91989094711682],
            [1.4199879636721748, 44.8999253062444],
            [1.4397855345223771, 44.8901239916343],
            [1.4397855345223771, 44.870158350761876],
            [1.409821643505854, 44.870158350761876],
            [1.4001903928219717, 44.84982969823723],
            [1.3600601816391293, 44.84002838362713],
            [1.3600601816391293, 44.80989841649238],
            [1.330096290622607, 44.80989841649238],
            [1.3001323996060838, 44.80009710188228],
            [1.3001323996060838, 44.78013146100986],
            [1.3199299704562861, 44.76016582013744],
            [1.3199299704562861, 44.73983716761279],
            [1.3001323996060838, 44.73983716761279],
            [1.2899660794397638, 44.71007021213027],
            [1.2701685085895615, 44.71987152674036],
            [1.2198719772403983, 44.69010457125784],
            [1.2198719772403983, 44.67994024499552],
            [1.1701105153736737, 44.67994024499552],
            [1.1497778750410328, 44.67013893038542],
            [1.1497778750410328, 44.629844636988345],
            [1.1299803041908305, 44.62004332237825],
            [1.1000164131743082, 44.5899133552435],
            [1.080218842324106, 44.5801120406334],
            [1.070052522157786, 44.60007768150582],
            [1.0502549513075827, 44.60007768150582],
            [0.9801608491082181, 44.64000896325067],
            [0.9298643177590549, 44.64000896325067],
            [0.9100667469088526, 44.62004332237825],
            [0.8699365357260094, 44.60007768150582],
            [0.8399726447094871, 44.609878996115924],
            [0.8201750738592848, 44.629844636988345],
            [0.8399726447094871, 44.64000896325067],
            [0.8399726447094871, 44.67013893038542],
            [0.8201750738592848, 44.69990588586794],
            [0.7902111828427616, 44.69990588586794],
            [0.7800448626764416, 44.67994024499552],
            [0.6601892986103515, 44.67994024499552],
            [0.6500229784440315, 44.69990588586794],
            [0.590095196410986, 44.69990588586794],
            [0.5697625560783459, 44.67013893038542],
            [0.47023963234489585, 44.67013893038542],
            [0.4199431009957326, 44.650173289513],
            [0.3798128898128903, 44.650173289513],
            [0.3498489987963671, 44.65997460412309],
            [0.3600153189626871, 44.69010457125784],
            [0.34021774811248484, 44.69990588586794],
            [0.3498489987963671, 44.71987152674036],
            [0.34021774811248484, 44.73983716761279],
            [0.3000875369296425, 44.76016582013744],
            [0.2701236459131193, 44.78013146100986],
            [0.2701236459131193, 44.80989841649238],
            [0.3000875369296425, 44.84002838362713],
            [0.3198851077798448, 44.84982969823723],
            [0.2797548965970016, 44.870158350761876],
            [0.24015975489659702, 44.870158350761876],
            [0.21982711456395698, 44.84002838362713],
            [0.1898632235474338, 44.82006274275471],
            [0.14973301236459147, 44.8298640573648],
            [0.04004376846482138, 44.8298640573648],
            [0.04004376846482138, 44.84002838362713],
            [-0.010252762884341848, 44.85999402449955],
            [-0.00008644271802182857, 44.87995966537198],
            [0.0202461976146191, 44.8901239916343],
            [0.029877448298501363, 44.910089632506725],
            [0.010079877448298191, 44.95002091425157],
            [0.010079877448298191, 44.980150881386315],
            [0.04004376846482138, 44.989952195996416],
            [0.04004376846482138, 45.040047804003585],
            [0.05984133931502367, 45.040047804003585],
            [0.07000765948134369, 45.07017777113833],
            [0.05984133931502367, 45.099944726620855],
            [0.029877448298501363, 45.119910367493276],
            [-0.00008644271802182857, 45.119910367493276],
            [-0.04021665390086415, 45.099944726620855],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 71,
        name: "Saône-et-Loire",
        REG: 27,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.780224313382209, 46.17990439199283],
            [4.7502604223656855, 46.170103077382734],
            [4.719761461866725, 46.17990439199283],
            [4.719761461866725, 46.240164326262324],
            [4.689797570850202, 46.249965640872425],
            [4.680166320166321, 46.269931281744846],
            [4.710130211182844, 46.269931281744846],
            [4.689797570850202, 46.300061248879594],
            [4.640036108983478, 46.300061248879594],
            [4.620238538133276, 46.28009560800717],
            [4.620238538133276, 46.260129967134745],
            [4.569942006784113, 46.28009560800717],
            [4.55014443593391, 46.269931281744846],
            [4.499847904584747, 46.269931281744846],
            [4.460252762884342, 46.300061248879594],
            [4.409956231535179, 46.300061248879594],
            [4.390158660684977, 46.249965640872425],
            [4.390158660684977, 46.21983567373768],
            [4.320064558485611, 46.170103077382734],
            [4.29010066746909, 46.170103077382734],
            [4.27993434730277, 46.15993875112041],
            [4.249970456286246, 46.15993875112041],
            [4.260136776452566, 46.17990439199283],
            [4.249970456286246, 46.190068718255155],
            [4.17987635408688, 46.190068718255155],
            [4.17987635408688, 46.170103077382734],
            [4.130114892220155, 46.17990439199283],
            [4.100151001203634, 46.199870032865256],
            [4.060020790020791, 46.190068718255155],
            [4.030056899004268, 46.170103077382734],
            [3.9899266878214243, 46.170103077382734],
            [3.970129116971223, 46.199870032865256],
            [3.9401652259546998, 46.210034359127576],
            [3.9198325856220597, 46.199870032865256],
            [3.8898686946055365, 46.210034359127576],
            [3.9102013349381766, 46.240164326262324],
            [3.9000350147718565, 46.28009560800717],
            [3.9000350147718565, 46.289896922617274],
            [3.949796476638583, 46.300061248879594],
            [3.949796476638583, 46.320026889752015],
            [3.9797603676551043, 46.320026889752015],
            [3.9899266878214243, 46.329828204362116],
            [3.9899266878214243, 46.37012249775919],
            [3.9797603676551043, 46.39008813863161],
            [4.000093007987744, 46.43001942037646],
            [4.000093007987744, 46.46014938751121],
            [3.959962796804903, 46.48991634299372],
            [3.9299989057883797, 46.48991634299372],
            [3.9198325856220597, 46.50008066925605],
            [3.8898686946055365, 46.48011502838363],
            [3.859904803589015, 46.50008066925605],
            [3.859904803589015, 46.52004631012847],
            [3.840107232738812, 46.52984762473857],
            [3.8101433417222887, 46.52004631012847],
            [3.7700131305394473, 46.5400119510009],
            [3.740049239522924, 46.5400119510009],
            [3.740049239522924, 46.57994323274574],
            [3.720251668672721, 46.61007319988049],
            [3.720251668672721, 46.63003884075292],
            [3.699919028340081, 46.66016880788766],
            [3.6699551373235595, 46.680134448760086],
            [3.6399912463070363, 46.70990140424261],
            [3.620193675456833, 46.740031371377356],
            [3.6298249261407163, 46.74983268598745],
            [3.6399912463070363, 46.740031371377356],
            [3.689752708173761, 46.740031371377356],
            [3.699919028340081, 46.74983268598745],
            [3.740049239522924, 46.74983268598745],
            [3.7801794507057673, 46.740031371377356],
            [3.7898107013896487, 46.70010008963251],
            [3.829940912572492, 46.70010008963251],
            [3.870071123755335, 46.72986704511503],
            [3.9000350147718565, 46.72986704511503],
            [3.949796476638583, 46.74983268598745],
            [3.959962796804903, 46.770161338512104],
            [4.040223219170588, 46.790126979384524],
            [4.060020790020791, 46.7799626531222],
            [4.060020790020791, 46.819893934867046],
            [4.049854469854471, 46.83985957573947],
            [4.100151001203634, 46.869989542874215],
            [4.070187110187111, 46.889955183746636],
            [4.040223219170588, 46.90011951000896],
            [4.040223219170588, 46.929886465491485],
            [4.049854469854471, 46.96001643262623],
            [4.040223219170588, 46.979982073498654],
            [4.010259328154066, 46.97018075888856],
            [4.000093007987744, 46.99014639976098],
            [4.040223219170588, 46.99994771437108],
            [4.060020790020791, 47.0199133552435],
            [4.070187110187111, 47.05984463698835],
            [4.040223219170588, 47.080173289513],
            [4.049854469854471, 47.0899746041231],
            [4.049854469854471, 47.12010457125784],
            [4.119948572053835, 47.12010457125784],
            [4.1499124630703585, 47.10994024499552],
            [4.170245103402999, 47.12010457125784],
            [4.190042674253202, 47.12990588586794],
            [4.190042674253202, 47.14987152674037],
            [4.209840245103403, 47.16003585300269],
            [4.260136776452566, 47.10994024499552],
            [4.30026698763541, 47.10994024499552],
            [4.309898238319291, 47.10013893038542],
            [4.350028449502134, 47.10013893038542],
            [4.339862129335814, 47.07000896325067],
            [4.360194769668454, 47.05984463698835],
            [4.369826020352337, 47.080173289513],
            [4.420122551701499, 47.080173289513],
            [4.399789911368859, 47.05984463698835],
            [4.429753802385382, 47.039878996115924],
            [4.460252762884342, 47.039878996115924],
            [4.469884013568225, 47.03007768150583],
            [4.499847904584747, 47.03007768150583],
            [4.510014224751067, 47.0101120406334],
            [4.559775686617793, 47.0101120406334],
            [4.569942006784113, 46.97018075888856],
            [4.589739577634314, 46.97018075888856],
            [4.599905897800634, 46.949852106363906],
            [4.620238538133276, 46.94005079175381],
            [4.650202429149798, 46.94005079175381],
            [4.680166320166321, 46.929886465491485],
            [4.670000000000001, 46.909920824619064],
            [4.689797570850202, 46.90011951000896],
            [4.719761461866725, 46.92008515088139],
            [4.780224313382209, 46.92008515088139],
            [4.819819455082613, 46.94005079175381],
            [4.8701159864317765, 46.949852106363906],
            [4.91024619761462, 46.97018075888856],
            [4.949841339315024, 46.96001643262623],
            [5.0001378706641875, 46.96001643262623],
            [5.030101761680709, 46.979982073498654],
            [5.060065652697232, 46.979982073498654],
            [5.070231972863552, 46.96001643262623],
            [5.100195863880075, 46.949852106363906],
            [5.109827114563957, 46.96001643262623],
            [5.16012364591312, 46.96001643262623],
            [5.190087536929643, 46.97018075888856],
            [5.2200514279461645, 46.99014639976098],
            [5.260181639129008, 46.979982073498654],
            [5.260181639129008, 46.929886465491485],
            [5.279979209979211, 46.94005079175381],
            [5.309943100995732, 46.94005079175381],
            [5.309943100995732, 46.909920824619064],
            [5.369870883028779, 46.88015386913654],
            [5.3998347740453, 46.889955183746636],
            [5.3998347740453, 46.869989542874215],
            [5.420167414377942, 46.859825216611895],
            [5.4597625560783465, 46.859825216611895],
            [5.4597625560783465, 46.83005826112937],
            [5.380037203195099, 46.83005826112937],
            [5.3297406718459355, 46.810092620256945],
            [5.3399069920122555, 46.790126979384524],
            [5.3602396323448955, 46.790126979384524],
            [5.390203523361419, 46.770161338512104],
            [5.3602396323448955, 46.72986704511503],
            [5.390203523361419, 46.72986704511503],
            [5.410001094211622, 46.70010008963251],
            [5.3998347740453, 46.68993576337019],
            [5.420167414377942, 46.66997012249776],
            [5.420167414377942, 46.65000448162534],
            [5.439964985228143, 46.63984015536301],
            [5.410001094211622, 46.61007319988049],
            [5.410001094211622, 46.57994323274574],
            [5.3602396323448955, 46.57994323274574],
            [5.3602396323448955, 46.52004631012847],
            [5.420167414377942, 46.50008066925605],
            [5.410001094211622, 46.4699507021213],
            [5.380037203195099, 46.46014938751121],
            [5.320109421162054, 46.46014938751121],
            [5.309943100995732, 46.44998506124888],
            [5.260181639129008, 46.44998506124888],
            [5.2200514279461645, 46.4699507021213],
            [5.200253857095963, 46.50988198386615],
            [5.16012364591312, 46.50008066925605],
            [5.13979100558048, 46.50988198386615],
            [5.109827114563957, 46.48991634299372],
            [5.100195863880075, 46.50008066925605],
            [5.049899332530912, 46.48011502838363],
            [5.009769121348069, 46.50008066925605],
            [5.009769121348069, 46.50988198386615],
            [4.979805230331547, 46.52004631012847],
            [4.970173979647664, 46.50988198386615],
            [4.930043768464821, 46.50988198386615],
            [4.91024619761462, 46.48011502838363],
            [4.91024619761462, 46.46014938751121],
            [4.88991355728198, 46.44998506124888],
            [4.88991355728198, 46.39988945324171],
            [4.859949666265456, 46.37012249775919],
            [4.849783346099136, 46.329828204362116],
            [4.829985775248933, 46.300061248879594],
            [4.810188204398732, 46.240164326262324],
            [4.780224313382209, 46.17990439199283],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 67, name: "Bas-Rhin", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [7.090119269066638, 48.510076187630716],
            [7.120083160083161, 48.510076187630716],
            [7.079952948900318, 48.51987750224082],
            [7.079952948900318, 48.510076187630716],
            [7.079952948900318, 48.51987750224082],
            [7.079952948900318, 48.53984314311324],
            [7.090119269066638, 48.53004182850314],
            [7.120083160083161, 48.53984314311324],
            [7.1398807309333625, 48.53004182850314],
            [7.169844621949886, 48.53004182850314],
            [7.190177262282526, 48.550007469375565],
            [7.220141153299049, 48.550007469375565],
            [7.2597362949994535, 48.58993875112041],
            [7.2800689353320935, 48.620068718255155],
            [7.2699026151657735, 48.629870032865256],
            [7.299866506182297, 48.660000000000004],
            [7.2699026151657735, 48.660000000000004],
            [7.23993872414925, 48.69012996713475],
            [7.2597362949994535, 48.699931281744846],
            [7.290235255498414, 48.73006124887959],
            [7.290235255498414, 48.75002688975202],
            [7.310032826348617, 48.76999253062444],
            [7.290235255498414, 48.78995817149686],
            [7.250105044315572, 48.80992381236929],
            [7.22977240398293, 48.82988945324171],
            [7.190177262282526, 48.82988945324171],
            [7.169844621949886, 48.84005377950403],
            [7.1398807309333625, 48.84005377950403],
            [7.130249480249481, 48.82008813863161],
            [7.090119269066638, 48.78995817149686],
            [7.049989057883795, 48.80992381236929],
            [7.049989057883795, 48.84985509411413],
            [7.060155378050115, 48.86001942037646],
            [6.99006127585075, 48.89014938751121],
            [6.960097384834227, 48.89014938751121],
            [6.960097384834227, 48.91991634299373],
            [6.97989495568443, 48.93008066925605],
            [6.99006127585075, 48.95984762473857],
            [7.030191487033593, 48.95984762473857],
            [7.049989057883795, 49.00014191813565],
            [7.049989057883795, 49.02990887361817],
            [7.099750519750521, 49.06003884075292],
            [7.120083160083161, 49.040073199880496],
            [7.130249480249481, 49.00994323274575],
            [7.169844621949886, 49.00994323274575],
            [7.209974833132729, 48.980176277263226],
            [7.23993872414925, 48.98997759187332],
            [7.310032826348617, 48.95984762473857],
            [7.310032826348617, 48.95004631012848],
            [7.3897581792318645, 48.95004631012848],
            [7.3999244993981845, 48.95984762473857],
            [7.429888390414708, 48.95984762473857],
            [7.450221030747348, 48.9700119510009],
            [7.480184921763869, 48.95984762473857],
            [7.510148812780392, 48.93988198386615],
            [7.549743954480797, 48.93988198386615],
            [7.580242914979757, 48.95984762473857],
            [7.58987416566364, 48.98997759187332],
            [7.630004376846483, 49.02990887361817],
            [7.640170697012803, 49.04987451449059],
            [7.770192581245214, 49.04987451449059],
            [7.800156472261736, 49.06003884075292],
            [7.870250574461102, 49.02990887361817],
            [7.879881825144984, 49.04987451449059],
            [7.920012036327827, 49.040073199880496],
            [7.939809607178028, 49.06003884075292],
            [7.979939818360871, 49.02990887361817],
            [7.999737389211075, 49.02990887361817],
            [8.09016413174308, 48.98997759187332],
            [8.120128022759602, 48.980176277263226],
            [8.22018601597549, 48.980176277263226],
            [8.229817266659374, 48.95984762473857],
            [8.19985337564285, 48.95984762473857],
            [8.169889484626328, 48.91991634299373],
            [8.139925593609806, 48.8999507021213],
            [8.109961702593282, 48.82988945324171],
            [8.09016413174308, 48.80012249775919],
            [8.060200240726559, 48.78995817149686],
            [8.030236349710034, 48.78995817149686],
            [8.020070029543714, 48.759828204362115],
            [7.969773498194551, 48.759828204362115],
            [7.969773498194551, 48.73006124887959],
            [7.900214465477624, 48.670164326262324],
            [7.84991793412846, 48.64983567373768],
            [7.83975161396214, 48.629870032865256],
            [7.800156472261736, 48.58993875112041],
            [7.809787722945619, 48.560171795637885],
            [7.800156472261736, 48.510076187630716],
            [7.770192581245214, 48.490110546758295],
            [7.770192581245214, 48.45998057962355],
            [7.730062370062371, 48.40008365700628],
            [7.730062370062371, 48.380118016133856],
            [7.749859940912573, 48.33002240812668],
            [7.689932158879528, 48.29989244099193],
            [7.670134588029325, 48.22002987750224],
            [7.640170697012803, 48.20006423662982],
            [7.630004376846483, 48.1800985957574],
            [7.60004048582996, 48.16013295488497],
            [7.60004048582996, 48.14016731401255],
            [7.580242914979757, 48.119838661487904],
            [7.5197800634642755, 48.130002987750224],
            [7.5197800634642755, 48.14996862862265],
            [7.470018601597549, 48.16013295488497],
            [7.470018601597549, 48.20006423662982],
            [7.440054710581028, 48.22002987750224],
            [7.4100908195645045, 48.22002987750224],
            [7.3999244993981845, 48.22983119211234],
            [7.35016303753146, 48.25015984463699],
            [7.310032826348617, 48.25015984463699],
            [7.329830397198818, 48.27012548550941],
            [7.299866506182297, 48.27992680011951],
            [7.2800689353320935, 48.29989244099193],
            [7.250105044315572, 48.29989244099193],
            [7.199808512966409, 48.31005676725426],
            [7.180010942116206, 48.33002240812668],
            [7.120083160083161, 48.33002240812668],
            [7.079952948900318, 48.34998804899911],
            [7.109916839916841, 48.380118016133856],
            [7.099750519750521, 48.38991933074395],
            [7.099750519750521, 48.450179265013446],
            [7.120083160083161, 48.47994622049597],
            [7.090119269066638, 48.490110546758295],
            [7.090119269066638, 48.510076187630716],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 94, name: "Val-de-Marne", REG: 11, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.3199748331327283, 48.75002688975202],
            [2.3199748331327283, 48.80992381236929],
            [2.3301411532990484, 48.82008813863161],
            [2.3601050443155707, 48.82008813863161],
            [2.390068935332094, 48.82988945324171],
            [2.420032826348616, 48.82008813863161],
            [2.4601630375314585, 48.82008813863161],
            [2.4697942882153407, 48.84005377950403],
            [2.420032826348616, 48.84985509411413],
            [2.4499967173651385, 48.86001942037646],
            [2.499758179231864, 48.86001942037646],
            [2.5901849217638695, 48.80992381236929],
            [2.5998161724477518, 48.80992381236929],
            [2.5901849217638695, 48.76999253062444],
            [2.5998161724477518, 48.75002688975202],
            [2.5698522814312295, 48.71009560800717],
            [2.5698522814312295, 48.69012996713475],
            [2.5500547105810263, 48.69012996713475],
            [2.520090819564504, 48.71009560800717],
            [2.520090819564504, 48.73006124887959],
            [2.4601630375314585, 48.73006124887959],
            [2.4398303971988184, 48.719896922617274],
            [2.369736294999453, 48.719896922617274],
            [2.3499387241492506, 48.739862563489694],
            [2.3199748331327283, 48.75002688975202],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 74, name: "Haute-Savoie", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [6.100240726556517, 45.73993426949507],
            [6.060110515373673, 45.75009859575739],
            [6.039777875041033, 45.73993426949507],
            [5.970218842324106, 45.77006423662982],
            [5.979850093007989, 45.799831192112336],
            [5.960052522157786, 45.80999551837466],
            [5.900124740124741, 45.80999551837466],
            [5.900124740124741, 45.82996115924709],
            [5.870160849108218, 45.84012548550941],
            [5.879792099792101, 45.86009112638183],
            [5.859994528941898, 45.93015237526143],
            [5.830030637925375, 45.93995368987153],
            [5.830030637925375, 45.97008365700628],
            [5.810233067075173, 45.9900492978787],
            [5.810233067075173, 46.080076187630716],
            [5.8198643177590546, 46.10004182850314],
            [5.859994528941898, 46.08987750224081],
            [5.889958419958421, 46.08987750224081],
            [5.889958419958421, 46.12000746937556],
            [5.919922310974942, 46.130171795637885],
            [5.960052522157786, 46.130171795637885],
            [5.979850093007989, 46.139973110247986],
            [6.049944195207353, 46.139973110247986],
            [6.049944195207353, 46.150137436510306],
            [6.100240726556517, 46.150137436510306],
            [6.13020461757304, 46.139973110247986],
            [6.179966079439764, 46.15993875112041],
            [6.190132399606084, 46.17990439199283],
            [6.250060181639129, 46.210034359127576],
            [6.290190392821972, 46.21983567373768],
            [6.309987963672175, 46.240164326262324],
            [6.309987963672175, 46.260129967134745],
            [6.260226501805449, 46.249965640872425],
            [6.239893861472809, 46.28009560800717],
            [6.239893861472809, 46.300061248879594],
            [6.269857752489332, 46.33999253062444],
            [6.299821643505855, 46.37012249775919],
            [6.350118174855017, 46.37012249775919],
            [6.3597494255389, 46.35015685688676],
            [6.39024838603786, 46.33999253062444],
            [6.410045956888063, 46.359958171496864],
            [6.440009847904585, 46.359958171496864],
            [6.510103950103951, 46.39988945324171],
            [6.5400678411204725, 46.39008813863161],
            [6.570031732136996, 46.39988945324171],
            [6.61979319400372, 46.39988945324171],
            [6.640125834336362, 46.41005377950403],
            [6.719851187219608, 46.41005377950403],
            [6.7899452894189745, 46.39008813863161],
            [6.8001116095852945, 46.379923812369285],
            [6.770147718568771, 46.359958171496864],
            [6.770147718568771, 46.35015685688676],
            [6.8001116095852945, 46.320026889752015],
            [6.860039391618339, 46.28009560800717],
            [6.849873071452019, 46.260129967134745],
            [6.819909180435498, 46.230000000000004],
            [6.809742860269176, 46.17990439199283],
            [6.7899452894189745, 46.150137436510306],
            [6.809742860269176, 46.130171795637885],
            [6.849873071452019, 46.130171795637885],
            [6.900169602801182, 46.12000746937556],
            [6.890003282634862, 46.10984314311324],
            [6.890003282634862, 46.080076187630716],
            [6.870205711784659, 46.04994622049597],
            [6.890003282634862, 46.04014490588587],
            [6.9199671736513855, 46.060110546758295],
            [6.939764744501587, 46.060110546758295],
            [6.960097384834227, 46.02998057962354],
            [7.009858846700953, 45.9998506124888],
            [7.020025166867273, 45.97988497161637],
            [7.009858846700953, 45.97008365700628],
            [7.039822737717475, 45.95011801613385],
            [7.039822737717475, 45.9199880489991],
            [7.00022759601707, 45.889858081864354],
            [7.00022759601707, 45.86989244099193],
            [6.949931064667907, 45.86009112638183],
            [6.939764744501587, 45.84992680011951],
            [6.900169602801182, 45.84012548550941],
            [6.879836962468542, 45.84992680011951],
            [6.849873071452019, 45.84012548550941],
            [6.819909180435498, 45.84012548550941],
            [6.8001116095852945, 45.82015984463699],
            [6.809742860269176, 45.799831192112336],
            [6.8001116095852945, 45.779865551239915],
            [6.759981398402451, 45.77006423662982],
            [6.710219936535727, 45.719968628622645],
            [6.689887296203087, 45.73013295488497],
            [6.689887296203087, 45.77006423662982],
            [6.6599234051865634, 45.79002987750224],
            [6.6599234051865634, 45.799831192112336],
            [6.580198052303316, 45.799831192112336],
            [6.580198052303316, 45.82015984463699],
            [6.550234161286794, 45.82996115924709],
            [6.5400678411204725, 45.86009112638183],
            [6.570031732136996, 45.86009112638183],
            [6.559865411970676, 45.889858081864354],
            [6.510103950103951, 45.90982372273678],
            [6.499937629937631, 45.889858081864354],
            [6.469973738921108, 45.88005676725426],
            [6.450176168070905, 45.84012548550941],
            [6.420212277054383, 45.799831192112336],
            [6.39024838603786, 45.779865551239915],
            [6.3597494255389, 45.77006423662982],
            [6.36991574570522, 45.75009859575739],
            [6.350118174855017, 45.73993426949507],
            [6.350118174855017, 45.719968628622645],
            [6.329785534522377, 45.6898386614879],
            [6.280024072655652, 45.6800373468778],
            [6.230262610788928, 45.700002987750224],
            [6.190132399606084, 45.700002987750224],
            [6.169799759273444, 45.759899910367494],
            [6.100240726556517, 45.759899910367494],
            [6.100240726556517, 45.73993426949507],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: "02", name: "Aisne", REG: 32, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.490171791224424, 48.84985509411413],
            [3.469839150891782, 48.84985509411413],
            [3.4200776890250575, 48.86982073498656],
            [3.3799474778422143, 48.86982073498656],
            [3.3799474778422143, 48.91011502838363],
            [3.3697811576758943, 48.93008066925605],
            [3.3301860159754897, 48.91011502838363],
            [3.3098533756428496, 48.91991634299373],
            [3.3098533756428496, 48.93988198386615],
            [3.260091913776125, 48.93988198386615],
            [3.260091913776125, 48.95984762473857],
            [3.209795382426962, 48.98997759187332],
            [3.2001641317430787, 49.00994323274575],
            [3.1702002407265573, 49.00994323274575],
            [3.1899978115767587, 49.04987451449059],
            [3.1702002407265573, 49.08000448162534],
            [3.140236349710034, 49.110134448760085],
            [3.079773498194551, 49.110134448760085],
            [3.0701422475106694, 49.11993576337019],
            [3.089939818360871, 49.11993576337019],
            [3.140236349710034, 49.150065730504934],
            [3.089939818360871, 49.189997012249776],
            [3.0300120363278262, 49.209962653122204],
            [3.019845716161506, 49.220126979384524],
            [3.000048145311303, 49.209962653122204],
            [3.000048145311303, 49.189997012249776],
            [2.9700842542947816, 49.189997012249776],
            [2.9599179341284616, 49.229928293994625],
            [3.000048145311303, 49.24009262025695],
            [3.019845716161506, 49.220126979384524],
            [3.0300120363278262, 49.24009262025695],
            [3.0300120363278262, 49.289825216611895],
            [2.989881825144983, 49.289825216611895],
            [2.9802505744611016, 49.31015386913654],
            [2.9599179341284616, 49.31995518374664],
            [3.010214465477623, 49.339920824619064],
            [3.0300120363278262, 49.33011951000897],
            [3.0701422475106694, 49.35008515088139],
            [3.089939818360871, 49.37985210636391],
            [3.100106138527191, 49.44011204063341],
            [3.130070029543714, 49.42994771437108],
            [3.1600339205602372, 49.4499133552435],
            [3.109737389211074, 49.46987899611592],
            [3.119903709377394, 49.48984463698835],
            [3.100106138527191, 49.510173289513],
            [3.130070029543714, 49.53013893038542],
            [3.130070029543714, 49.57007021213027],
            [3.140236349710034, 49.57987152674037],
            [3.100106138527191, 49.62016582013744],
            [3.130070029543714, 49.70002838362713],
            [3.119903709377394, 49.70982969823723],
            [3.089939818360871, 49.7599253062444],
            [3.0701422475106694, 49.770089632506725],
            [3.089939818360871, 49.79005527337915],
            [3.0599759273443494, 49.829986555123995],
            [3.079773498194551, 49.849952195996416],
            [3.079773498194551, 49.869917836868844],
            [3.119903709377394, 49.88008216313116],
            [3.119903709377394, 49.92001344487601],
            [3.1600339205602372, 49.95014341201076],
            [3.1702002407265573, 49.97010905288318],
            [3.1600339205602372, 49.9900746937556],
            [3.1702002407265573, 50.01004033462803],
            [3.230128022759602, 50.03000597550045],
            [3.270258233942445, 50.03000597550045],
            [3.2798894846263265, 50.01984164923813],
            [3.339817266659373, 50.01984164923813],
            [3.349983586825693, 50.04017030176278],
            [3.4302440091913775, 50.01984164923813],
            [3.490171791224424, 50.01984164923813],
            [3.5399332530911485, 50.04997161637287],
            [3.5800634642739917, 50.04997161637287],
            [3.610027355290513, 50.03000597550045],
            [3.6501575664733563, 50.04017030176278],
            [3.6699551373235595, 50.0601359426352],
            [3.720251668672721, 50.0699372572453],
            [3.750215559689244, 50.04997161637287],
            [3.7999770215559687, 50.04997161637287],
            [3.819774592406172, 50.04017030176278],
            [3.840107232738812, 50.04997161637287],
            [3.870071123755335, 50.04017030176278],
            [3.8898686946055365, 50.01984164923813],
            [3.9198325856220597, 50.03000597550045],
            [3.949796476638583, 50.03000597550045],
            [3.9797603676551043, 50.04017030176278],
            [4.000093007987744, 50.03000597550045],
            [3.9797603676551043, 49.9998760083657],
            [4.010259328154066, 49.9998760083657],
            [4.030056899004268, 49.97991036749328],
            [4.060020790020791, 49.9900746937556],
            [4.100151001203634, 49.97010905288318],
            [4.1397461429040385, 49.97991036749328],
            [4.170245103402999, 49.97991036749328],
            [4.230172885436043, 49.95994472662086],
            [4.220006565269723, 49.909849118613685],
            [4.260136776452566, 49.90004780400359],
            [4.249970456286246, 49.86011652225874],
            [4.230172885436043, 49.849952195996416],
            [4.209840245103403, 49.810020914251574],
            [4.220006565269723, 49.79005527337915],
            [4.209840245103403, 49.770089632506725],
            [4.239804136119926, 49.770089632506725],
            [4.230172885436043, 49.73015835076188],
            [4.190042674253202, 49.719994024499556],
            [4.17987635408688, 49.70002838362713],
            [4.1397461429040385, 49.68986405736481],
            [4.119948572053835, 49.660097101882286],
            [4.119948572053835, 49.62996713474754],
            [4.070187110187111, 49.640131461009865],
            [4.030056899004268, 49.62016582013744],
            [4.060020790020791, 49.59983716761279],
            [4.060020790020791, 49.55010457125785],
            [4.079818360870992, 49.53994024499552],
            [4.079818360870992, 49.5199746041231],
            [4.040223219170588, 49.510173289513],
            [4.040223219170588, 49.46987899611592],
            [4.049854469854471, 49.4499133552435],
            [4.040223219170588, 49.42014639976098],
            [4.049854469854471, 49.40998207349866],
            [4.040223219170588, 49.40018075888856],
            [4.040223219170588, 49.359886465491485],
            [4.010259328154066, 49.359886465491485],
            [3.9899266878214243, 49.37985210636391],
            [3.959962796804903, 49.37985210636391],
            [3.9198325856220597, 49.40998207349866],
            [3.859904803589015, 49.39001643262623],
            [3.849738483422695, 49.359886465491485],
            [3.7801794507057673, 49.359886465491485],
            [3.740049239522924, 49.339920824619064],
            [3.6699551373235595, 49.31995518374664],
            [3.6501575664733563, 49.31995518374664],
            [3.6399912463070363, 49.299989542874215],
            [3.6699551373235595, 49.24009262025695],
            [3.6699551373235595, 49.220126979384524],
            [3.699919028340081, 49.209962653122204],
            [3.710085348506401, 49.179832685987456],
            [3.750215559689244, 49.179832685987456],
            [3.740049239522924, 49.15986704511503],
            [3.699919028340081, 49.150065730504934],
            [3.620193675456833, 49.150065730504934],
            [3.610027355290513, 49.11993576337019],
            [3.6399912463070363, 49.08000448162534],
            [3.5902297844403117, 49.06003884075292],
            [3.5902297844403117, 49.02990887361817],
            [3.620193675456833, 49.040073199880496],
            [3.6597888171572377, 49.040073199880496],
            [3.6801214574898795, 49.02010755900807],
            [3.6399912463070363, 49.00014191813565],
            [3.599861035124193, 48.95004631012848],
            [3.5698971441076717, 48.93988198386615],
            [3.5500995732574685, 48.91991634299373],
            [3.5201356822409453, 48.91011502838363],
            [3.490171791224424, 48.84985509411413],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: "07", name: "Ardèche", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [4.000093007987744, 44.45995518374664],
            [3.9899266878214243, 44.47011951000896],
            [3.9899266878214243, 44.499886465491485],
            [3.949796476638583, 44.569947714371075],
            [3.9198325856220597, 44.569947714371075],
            [3.9102013349381766, 44.609878996115924],
            [3.8898686946055365, 44.62004332237825],
            [3.9000350147718565, 44.64000896325067],
            [3.870071123755335, 44.67994024499552],
            [3.880237443921655, 44.69990588586794],
            [3.859904803589015, 44.71987152674036],
            [3.859904803589015, 44.73983716761279],
            [3.870071123755335, 44.76016582013744],
            [3.8898686946055365, 44.75000149387511],
            [3.9401652259546998, 44.80009710188228],
            [3.9401652259546998, 44.82006274275471],
            [3.959962796804903, 44.8298640573648],
            [3.9797603676551043, 44.80989841649238],
            [4.010259328154066, 44.8298640573648],
            [4.030056899004268, 44.8298640573648],
            [4.030056899004268, 44.870158350761876],
            [4.089984681037312, 44.870158350761876],
            [4.119948572053835, 44.87995966537198],
            [4.160078783236679, 44.870158350761876],
            [4.17987635408688, 44.8901239916343],
            [4.200208994419522, 44.930055273379146],
            [4.220006565269723, 44.930055273379146],
            [4.220006565269723, 44.95982222886167],
            [4.230172885436043, 44.969986555123995],
            [4.260136776452566, 44.95982222886167],
            [4.27993434730277, 44.969986555123995],
            [4.309898238319291, 44.969986555123995],
            [4.309898238319291, 44.989952195996416],
            [4.29010066746909, 45.000116522258736],
            [4.30026698763541, 45.020082163131164],
            [4.320064558485611, 45.02988347774126],
            [4.360194769668454, 45.02988347774126],
            [4.379992340518657, 45.049849118613686],
            [4.350028449502134, 45.07017777113833],
            [4.360194769668454, 45.099944726620855],
            [4.399789911368859, 45.11010905288318],
            [4.369826020352337, 45.1300746937556],
            [4.379992340518657, 45.139876008365704],
            [4.439920122551702, 45.139876008365704],
            [4.480050333734545, 45.20013594263519],
            [4.480050333734545, 45.24006722438004],
            [4.510014224751067, 45.229902898117714],
            [4.559775686617793, 45.24986853899014],
            [4.580108326950433, 45.24006722438004],
            [4.610072217966954, 45.24986853899014],
            [4.589739577634314, 45.26983417986256],
            [4.599905897800634, 45.29016283238721],
            [4.620238538133276, 45.29016283238721],
            [4.620238538133276, 45.31012847325964],
            [4.640036108983478, 45.33009411413206],
            [4.680166320166321, 45.35005975500448],
            [4.719761461866725, 45.35005975500448],
            [4.759891673049569, 45.37002539587691],
            [4.770057993215889, 45.35005975500448],
            [4.759891673049569, 45.31992978786973],
            [4.800021884232412, 45.29996414699731],
            [4.810188204398732, 45.29016283238721],
            [4.810188204398732, 45.26003286525246],
            [4.800021884232412, 45.229902898117714],
            [4.810188204398732, 45.20013594263519],
            [4.810188204398732, 45.170005975500445],
            [4.829985775248933, 45.150040334628024],
            [4.800021884232412, 45.1300746937556],
            [4.810188204398732, 45.11010905288318],
            [4.829985775248933, 45.099944726620855],
            [4.829985775248933, 45.07017777113833],
            [4.849783346099136, 45.060013444876006],
            [4.840152095415253, 45.040047804003585],
            [4.840152095415253, 45.000116522258736],
            [4.879747237115658, 44.93985658798924],
            [4.8701159864317765, 44.910089632506725],
            [4.849783346099136, 44.8999253062444],
            [4.859949666265456, 44.870158350761876],
            [4.819819455082613, 44.84002838362713],
            [4.819819455082613, 44.82006274275471],
            [4.800021884232412, 44.80989841649238],
            [4.800021884232412, 44.78993277561996],
            [4.759891673049569, 44.76996713474753],
            [4.759891673049569, 44.71987152674036],
            [4.780224313382209, 44.67994024499552],
            [4.780224313382209, 44.650173289513],
            [4.7502604223656855, 44.62004332237825],
            [4.7400941021993654, 44.60007768150582],
            [4.710130211182844, 44.5801120406334],
            [4.689797570850202, 44.549982073498654],
            [4.710130211182844, 44.53001643262623],
            [4.689797570850202, 44.519852106363906],
            [4.689797570850202, 44.490085150881384],
            [4.699963891016522, 44.479920824619064],
            [4.699963891016522, 44.45015386913654],
            [4.670000000000001, 44.42982521661189],
            [4.650202429149798, 44.36992829399462],
            [4.650202429149798, 44.32999701224978],
            [4.650202429149798, 44.27010008963251],
            [4.599905897800634, 44.29006573050493],
            [4.559775686617793, 44.29986704511503],
            [4.55014443593391, 44.31983268598745],
            [4.52981179560127, 44.31983268598745],
            [4.510014224751067, 44.3401613385121],
            [4.460252762884342, 44.3401613385121],
            [4.450086442718022, 44.32999701224978],
            [4.450086442718022, 44.29986704511503],
            [4.429753802385382, 44.29006573050493],
            [4.390158660684977, 44.29006573050493],
            [4.399789911368859, 44.32999701224978],
            [4.390158660684977, 44.3499626531222],
            [4.369826020352337, 44.3401613385121],
            [4.330230878651931, 44.3401613385121],
            [4.320064558485611, 44.31983268598745],
            [4.30026698763541, 44.31003137137735],
            [4.27993434730277, 44.27010008963251],
            [4.260136776452566, 44.25993576337018],
            [4.220006565269723, 44.29006573050493],
            [4.190042674253202, 44.29986704511503],
            [4.17987635408688, 44.31983268598745],
            [4.1397461429040385, 44.31003137137735],
            [4.119948572053835, 44.32999701224978],
            [4.070187110187111, 44.32999701224978],
            [4.049854469854471, 44.31983268598745],
            [4.049854469854471, 44.380092620256946],
            [4.070187110187111, 44.40985957573947],
            [4.049854469854471, 44.40985957573947],
            [4.040223219170588, 44.45015386913654],
            [4.000093007987744, 44.45995518374664],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 83, name: "Var", REG: 93, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [6.199763650289966, 42.97995667762175],
              [6.199763650289966, 42.99992231849417],
              [6.230262610788928, 43.0100866447565],
              [6.250060181639129, 42.99992231849417],
              [6.199763650289966, 42.97995667762175],
            ],
          ],
          [
            [
              [6.469973738921108, 43.01988795936659],
              [6.440009847904585, 42.99992231849417],
              [6.429843527738265, 43.0100866447565],
              [6.459807418754788, 43.03005228562892],
              [6.469973738921108, 43.05001792650134],
              [6.489771309771311, 43.03985360023902],
              [6.469973738921108, 43.01988795936659],
            ],
          ],
          [
            [
              [5.900124740124741, 43.08014789363609],
              [5.940254951307584, 43.08994920824619],
              [5.940254951307584, 43.06998356737377],
              [5.900124740124741, 43.06998356737377],
              [5.900124740124741, 43.08014789363609],
              [5.870160849108218, 43.06998356737377],
              [5.859994528941898, 43.05001792650134],
              [5.830030637925375, 43.05001792650134],
              [5.789900426742533, 43.06998356737377],
              [5.810233067075173, 43.08994920824619],
              [5.789900426742533, 43.10991484911861],
              [5.719806324543167, 43.14984613086346],
              [5.680211182842762, 43.160010457125786],
              [5.670044862676442, 43.17997609799821],
              [5.680211182842762, 43.190140424260534],
              [5.680211182842762, 43.23987302061548],
              [5.740138964875807, 43.2598386614879],
              [5.75993653572601, 43.280167314012544],
              [5.729972644709487, 43.32009859575739],
              [5.689842433526645, 43.309934269495066],
              [5.680211182842762, 43.32009859575739],
              [5.700008753692965, 43.349865551239915],
              [5.689842433526645, 43.369831192112336],
              [5.700008753692965, 43.41012548550941],
              [5.74977021555969, 43.399961159247084],
              [5.779734106576213, 43.41012548550941],
              [5.74977021555969, 43.43009112638183],
              [5.729972644709487, 43.47002240812668],
              [5.700008753692965, 43.479823722736775],
              [5.719806324543167, 43.54008365700627],
              [5.710175073859285, 43.5600492978787],
              [5.670044862676442, 43.5600492978787],
              [5.659878542510122, 43.58001493875112],
              [5.689842433526645, 43.58001493875112],
              [5.680211182842762, 43.61014490588587],
              [5.700008753692965, 43.63991186136839],
              [5.719806324543167, 43.65007618763072],
              [5.77010285589233, 43.65987750224081],
              [5.800066746908853, 43.65987750224081],
              [5.800066746908853, 43.67984314311323],
              [5.779734106576213, 43.720137436510306],
              [5.74977021555969, 43.720137436510306],
              [5.75993653572601, 43.72993875112041],
              [5.779734106576213, 43.760068718255155],
              [5.830030637925375, 43.74990439199283],
              [5.849828208775578, 43.720137436510306],
              [5.889958419958421, 43.72993875112041],
              [5.919922310974942, 43.760068718255155],
              [5.940254951307584, 43.74990439199283],
              [5.940254951307584, 43.72993875112041],
              [5.970218842324106, 43.720137436510306],
              [6.01998030419083, 43.67004182850314],
              [6.039777875041033, 43.67984314311323],
              [6.049944195207353, 43.700171795637885],
              [6.0697417660575566, 43.700171795637885],
              [6.100240726556517, 43.72993875112041],
              [6.109871977240398, 43.74990439199283],
              [6.139835868256921, 43.74010307738273],
              [6.169799759273444, 43.74990439199283],
              [6.179966079439764, 43.76987003286525],
              [6.209929970456288, 43.8],
              [6.260226501805449, 43.8],
              [6.260226501805449, 43.780034359127576],
              [6.350118174855017, 43.74010307738273],
              [6.38008206587154, 43.74010307738273],
              [6.410045956888063, 43.760068718255155],
              [6.420212277054383, 43.78983567373768],
              [6.489771309771311, 43.78983567373768],
              [6.519735200787832, 43.810164326262324],
              [6.5400678411204725, 43.8],
              [6.550234161286794, 43.780034359127576],
              [6.589829302987199, 43.810164326262324],
              [6.640125834336362, 43.78983567373768],
              [6.640125834336362, 43.76987003286525],
              [6.6599234051865634, 43.74990439199283],
              [6.689887296203087, 43.760068718255155],
              [6.710219936535727, 43.74010307738273],
              [6.749815078236131, 43.74010307738273],
              [6.770147718568771, 43.720137436510306],
              [6.770147718568771, 43.69000746937556],
              [6.759981398402451, 43.67004182850314],
              [6.779778969252654, 43.65987750224081],
              [6.7899452894189745, 43.63991186136839],
              [6.840241820768138, 43.61014490588587],
              [6.890003282634862, 43.61014490588587],
              [6.9098008534850655, 43.59998057962354],
              [6.900169602801182, 43.58001493875112],
              [6.9098008534850655, 43.56985061248879],
              [6.879836962468542, 43.52991933074395],
              [6.900169602801182, 43.52011801613385],
              [6.900169602801182, 43.50015237526143],
              [6.9301334938177055, 43.479823722736775],
              [6.9199671736513855, 43.45005676725425],
              [6.890003282634862, 43.43009112638183],
              [6.860039391618339, 43.43009112638183],
              [6.849873071452019, 43.41012548550941],
              [6.830075500601818, 43.41992680011951],
              [6.7899452894189745, 43.41012548550941],
              [6.759981398402451, 43.41992680011951],
              [6.74018382755225, 43.41012548550941],
              [6.710219936535727, 43.369831192112336],
              [6.710219936535727, 43.349865551239915],
              [6.6802560455192035, 43.340064236629814],
              [6.6700897253528835, 43.309934269495066],
              [6.62995951417004, 43.309934269495066],
              [6.589829302987199, 43.280167314012544],
              [6.589829302987199, 43.2598386614879],
              [6.61979319400372, 43.270002987750225],
              [6.700053616369407, 43.270002987750225],
              [6.6802560455192035, 43.23987302061548],
              [6.6599234051865634, 43.23987302061548],
              [6.6599234051865634, 43.21990737974305],
              [6.6802560455192035, 43.19994173887063],
              [6.640125834336362, 43.190140424260534],
              [6.640125834336362, 43.170174783388106],
              [6.61979319400372, 43.160010457125786],
              [6.599995623153519, 43.17997609799821],
              [6.559865411970676, 43.190140424260534],
              [6.5400678411204725, 43.170174783388106],
              [6.489771309771311, 43.14984613086346],
              [6.469973738921108, 43.160010457125786],
              [6.39024838603786, 43.14004481625336],
              [6.36991574570522, 43.14004481625336],
              [6.3597494255389, 43.12007917538094],
              [6.36991574570522, 43.08994920824619],
              [6.329785534522377, 43.08994920824619],
              [6.309987963672175, 43.10991484911861],
              [6.269857752489332, 43.12007917538094],
              [6.239893861472809, 43.10991484911861],
              [6.179966079439764, 43.10991484911861],
              [6.150002188423241, 43.08014789363609],
              [6.150002188423241, 43.03985360023902],
              [6.13020461757304, 43.05001792650134],
              [6.13020461757304, 43.08014789363609],
              [6.079908086223877, 43.08994920824619],
              [6.049944195207353, 43.08014789363609],
              [6.01998030419083, 43.08014789363609],
              [6.01998030419083, 43.100113534508516],
              [5.990016413174309, 43.100113534508516],
              [5.979850093007989, 43.10991484911861],
              [5.930088631141262, 43.100113534508516],
              [5.889958419958421, 43.12007917538094],
              [5.900124740124741, 43.08014789363609],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 45, name: "Loiret", REG: 24, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.2402494802494806, 47.61997161637287],
            [2.2402494802494806, 47.63993725724529],
            [2.2097505197505196, 47.67986853899014],
            [2.170155378050115, 47.67006722438004],
            [2.1300251668672727, 47.67986853899014],
            [2.0700973848342272, 47.67986853899014],
            [2.059931064667907, 47.67006722438004],
            [2.0101696028011817, 47.67986853899014],
            [1.9598730714520194, 47.65990289811772],
            [1.9400755006018162, 47.65990289811772],
            [1.9400755006018162, 47.67986853899014],
            [1.910111609585294, 47.67006722438004],
            [1.8897789692526539, 47.67986853899014],
            [1.8598150782361307, 47.67986853899014],
            [1.8501838275522484, 47.65990289811772],
            [1.810053616369406, 47.65010158350762],
            [1.7800897253528838, 47.65010158350762],
            [1.7399595141700406, 47.65990289811772],
            [1.7099956231535183, 47.72016283238722],
            [1.690198052303316, 47.74012847325964],
            [1.6297352007878327, 47.76009411413206],
            [1.6201039501039505, 47.74012847325964],
            [1.5997713097713095, 47.74012847325964],
            [1.550009847904585, 47.76989542874216],
            [1.5698074187547872, 47.80002539587691],
            [1.5302122770543827, 47.830155363011656],
            [1.550009847904585, 47.83995667762175],
            [1.5901400590874273, 47.8798879593666],
            [1.5799737389211073, 47.89985360023902],
            [1.5302122770543827, 47.92998356737377],
            [1.5302122770543827, 47.940147893636095],
            [1.560176168070905, 47.960113534508515],
            [1.560176168070905, 47.98988048999104],
            [1.5200459568880627, 47.980079175380936],
            [1.5200459568880627, 48.009846130863465],
            [1.5098796367217417, 48.03017478338811],
            [1.550009847904585, 48.039976097998206],
            [1.5901400590874273, 48.03017478338811],
            [1.6201039501039505, 48.05014042426053],
            [1.6297352007878327, 48.070106065132954],
            [1.7699234051865629, 48.070106065132954],
            [1.799887296203086, 48.09007170600538],
            [1.8298511872196084, 48.079907379743055],
            [1.8801477185687716, 48.099873020615476],
            [1.899945289418974, 48.130002987750224],
            [1.899945289418974, 48.14996862862265],
            [1.9197428602691762, 48.16993426949507],
            [1.9700393916183394, 48.16993426949507],
            [1.9502418207681371, 48.189899910367494],
            [1.9700393916183394, 48.25015984463699],
            [1.9898369624685417, 48.27012548550941],
            [1.9898369624685417, 48.29009112638184],
            [2.0898949556844295, 48.29009112638184],
            [2.1102275960170696, 48.29989244099193],
            [2.159989057883795, 48.29989244099193],
            [2.2097505197505196, 48.33982372273678],
            [2.249880730933363, 48.33002240812668],
            [2.300177262282526, 48.31005676725426],
            [2.3098085129664083, 48.33002240812668],
            [2.3301411532990484, 48.33002240812668],
            [2.3601050443155707, 48.31005676725426],
            [2.400235255498414, 48.31985808186436],
            [2.420032826348616, 48.29989244099193],
            [2.420032826348616, 48.25996115924709],
            [2.4398303971988184, 48.25015984463699],
            [2.4697942882153407, 48.25996115924709],
            [2.4799606083816617, 48.23999551837467],
            [2.509924499398184, 48.23999551837467],
            [2.520090819564504, 48.22983119211234],
            [2.520090819564504, 48.189899910367494],
            [2.509924499398184, 48.16013295488497],
            [2.4799606083816617, 48.16013295488497],
            [2.4398303971988184, 48.130002987750224],
            [2.520090819564504, 48.130002987750224],
            [2.5398883904147063, 48.14016731401255],
            [2.5698522814312295, 48.14016731401255],
            [2.5998161724477518, 48.130002987750224],
            [2.639946383630594, 48.14016731401255],
            [2.6597439544807973, 48.119838661487904],
            [2.6800765948134373, 48.130002987750224],
            [2.7100404858299596, 48.119838661487904],
            [2.7202068059962796, 48.14016731401255],
            [2.750170697012803, 48.14996862862265],
            [2.780134588029325, 48.16993426949507],
            [2.7999321588795274, 48.16993426949507],
            [2.7999321588795274, 48.130002987750224],
            [2.8502286902286906, 48.14016731401255],
            [2.870026261078893, 48.16013295488497],
            [2.9401203632782584, 48.16013295488497],
            [2.9599179341284616, 48.14996862862265],
            [2.989881825144983, 48.14996862862265],
            [3.019845716161506, 48.14016731401255],
            [3.0401783564941463, 48.119838661487904],
            [3.0401783564941463, 48.09007170600538],
            [3.0599759273443494, 48.059941738870634],
            [3.089939818360871, 48.05014042426053],
            [3.119903709377394, 48.03017478338811],
            [3.119903709377394, 47.98988048999104],
            [3.130070029543714, 47.96991484911862],
            [3.109737389211074, 47.960113534508515],
            [3.079773498194551, 47.92998356737377],
            [3.010214465477623, 47.89985360023902],
            [3.010214465477623, 47.8798879593666],
            [3.0300120363278262, 47.83995667762175],
            [3.010214465477623, 47.830155363011656],
            [3.0300120363278262, 47.80002539587691],
            [3.019845716161506, 47.78986106961458],
            [2.989881825144983, 47.78986106961458],
            [2.9802505744611016, 47.78005975500449],
            [2.9299540431119384, 47.76009411413206],
            [2.8502286902286906, 47.76009411413206],
            [2.859859940912573, 47.74992978786973],
            [2.8502286902286906, 47.72996414699731],
            [2.880192581245213, 47.72016283238722],
            [2.889823831929095, 47.69983417986256],
            [2.9197877229456184, 47.67986853899014],
            [2.9299540431119384, 47.65990289811772],
            [2.94975161396214, 47.65010158350762],
            [2.9299540431119384, 47.6301359426352],
            [2.9401203632782584, 47.60000597550045],
            [2.9599179341284616, 47.589841649238124],
            [2.9599179341284616, 47.5698760083657],
            [2.9802505744611016, 47.5698760083657],
            [2.9599179341284616, 47.5600746937556],
            [2.9101564722617352, 47.5698760083657],
            [2.899990152095415, 47.54991036749328],
            [2.859859940912573, 47.54991036749328],
            [2.8502286902286906, 47.54010905288318],
            [2.870026261078893, 47.52014341201075],
            [2.8400623700623706, 47.509979085748434],
            [2.8100984790458474, 47.49001344487601],
            [2.780134588029325, 47.52014341201075],
            [2.759801947696685, 47.52014341201075],
            [2.729838056680162, 47.54010905288318],
            [2.7202068059962796, 47.52014341201075],
            [2.729838056680162, 47.50017777113833],
            [2.6902429149797573, 47.479849118613686],
            [2.6597439544807973, 47.49001344487601],
            [2.6597439544807973, 47.509979085748434],
            [2.609982492614072, 47.529944726620855],
            [2.620148812780392, 47.54010905288318],
            [2.5698522814312295, 47.5698760083657],
            [2.4901269285479817, 47.5698760083657],
            [2.4601630375314585, 47.589841649238124],
            [2.4499967173651385, 47.61017030176277],
            [2.400235255498414, 47.60000597550045],
            [2.390068935332094, 47.589841649238124],
            [2.3601050443155707, 47.589841649238124],
            [2.290010942116205, 47.6301359426352],
            [2.2402494802494806, 47.61997161637287],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 84, name: "Vaucluse", REG: 93, CAT: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [4.9899715504978674, 44.29006573050493],
              [4.979805230331547, 44.29986704511503],
              [4.919877448298501, 44.31003137137735],
              [4.88991355728198, 44.29986704511503],
              [4.879747237115658, 44.32999701224978],
              [4.88991355728198, 44.36992829399462],
              [4.91024619761462, 44.36992829399462],
              [4.91024619761462, 44.40005826112937],
              [4.919877448298501, 44.40985957573947],
              [4.949841339315024, 44.40985957573947],
              [4.970173979647664, 44.42982521661189],
              [5.009769121348069, 44.40985957573947],
              [5.019935441514389, 44.38989393486705],
              [5.049899332530912, 44.380092620256946],
              [5.049899332530912, 44.360126979384525],
              [5.030101761680709, 44.360126979384525],
              [5.019935441514389, 44.3401613385121],
              [4.9899715504978674, 44.31003137137735],
              [4.9899715504978674, 44.29006573050493],
            ],
          ],
          [
            [
              [5.75993653572601, 43.72993875112041],
              [5.74977021555969, 43.720137436510306],
              [5.740138964875807, 43.720137436510306],
              [5.710175073859285, 43.69000746937556],
              [5.659878542510122, 43.69000746937556],
              [5.640080971659919, 43.67004182850314],
              [5.6101170806433975, 43.65987750224081],
              [5.529856658277711, 43.65987750224081],
              [5.410001094211622, 43.69000746937556],
              [5.3399069920122555, 43.720137436510306],
              [5.320109421162054, 43.74010307738273],
              [5.260181639129008, 43.74010307738273],
              [5.239848998796368, 43.74990439199283],
              [5.190087536929643, 43.74010307738273],
              [5.13979100558048, 43.74990439199283],
              [5.049899332530912, 43.78983567373768],
              [5.030101761680709, 43.830129967134745],
              [5.0001378706641875, 43.839931281744846],
              [4.970173979647664, 43.870061248879594],
              [4.9000798774483, 43.890026889752015],
              [4.849783346099136, 43.909992530624436],
              [4.810188204398732, 43.909992530624436],
              [4.770057993215889, 43.92015685688676],
              [4.7400941021993654, 43.92015685688676],
              [4.810188204398732, 43.96008813863161],
              [4.810188204398732, 43.989855094114134],
              [4.840152095415253, 43.989855094114134],
              [4.840152095415253, 44.009820734986555],
              [4.78985556406609, 44.05991634299372],
              [4.78985556406609, 44.07008066925605],
              [4.759891673049569, 44.079881983866144],
              [4.729927782033045, 44.079881983866144],
              [4.710130211182844, 44.11001195100089],
              [4.719761461866725, 44.14014191813564],
              [4.719761461866725, 44.18987451449059],
              [4.710130211182844, 44.20984015536301],
              [4.680166320166321, 44.23016880788766],
              [4.650202429149798, 44.25993576337018],
              [4.650202429149798, 44.27010008963251],
              [4.650202429149798, 44.32999701224978],
              [4.680166320166321, 44.31983268598745],
              [4.710130211182844, 44.31983268598745],
              [4.719761461866725, 44.32999701224978],
              [4.759891673049569, 44.32999701224978],
              [4.800021884232412, 44.31003137137735],
              [4.800021884232412, 44.27010008963251],
              [4.810188204398732, 44.25993576337018],
              [4.810188204398732, 44.23016880788766],
              [4.829985775248933, 44.23016880788766],
              [4.879747237115658, 44.25993576337018],
              [4.930043768464821, 44.25993576337018],
              [4.940210088631141, 44.27010008963251],
              [4.9899715504978674, 44.29006573050493],
              [5.019935441514389, 44.29006573050493],
              [5.060065652697232, 44.31003137137735],
              [5.079863223547435, 44.27990140424261],
              [5.109827114563957, 44.27990140424261],
              [5.169754896597003, 44.31003137137735],
              [5.169754896597003, 44.29006573050493],
              [5.1499573257468, 44.23997012249776],
              [5.179921216763323, 44.22000448162534],
              [5.2098851077798445, 44.20984015536301],
              [5.239848998796368, 44.20984015536301],
              [5.239848998796368, 44.23016880788766],
              [5.260181639129008, 44.23016880788766],
              [5.299776780829412, 44.20984015536301],
              [5.3399069920122555, 44.20003884075291],
              [5.380037203195099, 44.20984015536301],
              [5.390203523361419, 44.18007319988049],
              [5.380037203195099, 44.16010755900807],
              [5.3998347740453, 44.14994323274574],
              [5.439964985228143, 44.14994323274574],
              [5.450131305394463, 44.12017627726322],
              [5.49989276726119, 44.12017627726322],
              [5.49989276726119, 44.05991634299372],
              [5.540022978444031, 44.07008066925605],
              [5.540022978444031, 44.01998506124888],
              [5.51005908742751, 43.969889453241706],
              [5.51005908742751, 43.949923812369285],
              [5.540022978444031, 43.940122497759184],
              [5.569986869460554, 43.940122497759184],
              [5.580153189626874, 43.92015685688676],
              [5.6101170806433975, 43.92015685688676],
              [5.569986869460554, 43.85989692261727],
              [5.550189298610351, 43.850095608007166],
              [5.540022978444031, 43.819965640872425],
              [5.569986869460554, 43.830129967134745],
              [5.650247291826239, 43.830129967134745],
              [5.689842433526645, 43.780034359127576],
              [5.710175073859285, 43.780034359127576],
              [5.719806324543167, 43.760068718255155],
              [5.75993653572601, 43.72993875112041],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 48, name: "Lozère", REG: 76, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [2.9802505744611016, 44.64000896325067],
            [2.9802505744611016, 44.650173289513],
            [3.0300120363278262, 44.71987152674036],
            [3.0300120363278262, 44.75000149387511],
            [3.0498096071780294, 44.78013146100986],
            [3.0599759273443494, 44.82006274275471],
            [3.079773498194551, 44.82006274275471],
            [3.100106138527191, 44.84002838362713],
            [3.089939818360871, 44.85999402449955],
            [3.100106138527191, 44.87995966537198],
            [3.140236349710034, 44.8999253062444],
            [3.1798314914104386, 44.85999402449955],
            [3.230128022759602, 44.87995966537198],
            [3.230128022759602, 44.910089632506725],
            [3.249925593609805, 44.91989094711682],
            [3.260091913776125, 44.93985658798924],
            [3.2900558047926465, 44.930055273379146],
            [3.360149906992013, 44.969986555123995],
            [3.4200776890250575, 44.930055273379146],
            [3.4099113688587375, 44.91989094711682],
            [3.4398752598752607, 44.87995966537198],
            [3.4398752598752607, 44.84982969823723],
            [3.480005471058104, 44.80989841649238],
            [3.5399332530911485, 44.8298640573648],
            [3.5902297844403117, 44.8298640573648],
            [3.599861035124193, 44.85999402449955],
            [3.6399912463070363, 44.87995966537198],
            [3.6699551373235595, 44.85999402449955],
            [3.6699551373235595, 44.8298640573648],
            [3.699919028340081, 44.84002838362713],
            [3.720251668672721, 44.8298640573648],
            [3.740049239522924, 44.84002838362713],
            [3.7598468103731273, 44.80009710188228],
            [3.7999770215559687, 44.78993277561996],
            [3.8101433417222887, 44.76996713474753],
            [3.840107232738812, 44.76996713474753],
            [3.840107232738812, 44.75000149387511],
            [3.859904803589015, 44.73983716761279],
            [3.859904803589015, 44.71987152674036],
            [3.880237443921655, 44.69990588586794],
            [3.870071123755335, 44.67994024499552],
            [3.9000350147718565, 44.64000896325067],
            [3.8898686946055365, 44.62004332237825],
            [3.9102013349381766, 44.609878996115924],
            [3.9198325856220597, 44.569947714371075],
            [3.949796476638583, 44.569947714371075],
            [3.9899266878214243, 44.499886465491485],
            [3.9899266878214243, 44.47011951000896],
            [4.000093007987744, 44.45995518374664],
            [3.970129116971223, 44.42982521661189],
            [3.949796476638583, 44.40005826112937],
            [3.9198325856220597, 44.40985957573947],
            [3.8898686946055365, 44.38989393486705],
            [3.949796476638583, 44.32999701224978],
            [3.9198325856220597, 44.31003137137735],
            [3.949796476638583, 44.27010008963251],
            [3.949796476638583, 44.22000448162534],
            [3.9401652259546998, 44.18987451449059],
            [3.959962796804903, 44.18987451449059],
            [3.970129116971223, 44.16010755900807],
            [3.9299989057883797, 44.18007319988049],
            [3.9299989057883797, 44.16010755900807],
            [3.8898686946055365, 44.14994323274574],
            [3.870071123755335, 44.12997759187332],
            [3.829940912572492, 44.14014191813564],
            [3.7999770215559687, 44.12997759187332],
            [3.7598468103731273, 44.14994323274574],
            [3.6699551373235595, 44.18007319988049],
            [3.6399912463070363, 44.18007319988049],
            [3.6298249261407163, 44.16010755900807],
            [3.6399912463070363, 44.14014191813564],
            [3.6298249261407163, 44.12017627726322],
            [3.5698971441076717, 44.12017627726322],
            [3.5399332530911485, 44.11001195100089],
            [3.5099693620746253, 44.12997759187332],
            [3.480005471058104, 44.12017627726322],
            [3.4398752598752607, 44.12997759187332],
            [3.4302440091913775, 44.14994323274574],
            [3.3697811576758943, 44.16990887361816],
            [3.360149906992013, 44.20003884075291],
            [3.260091913776125, 44.20003884075291],
            [3.239759273443485, 44.18987451449059],
            [3.219961702593282, 44.20003884075291],
            [3.230128022759602, 44.23016880788766],
            [3.1899978115767587, 44.250134448760086],
            [3.1600339205602372, 44.250134448760086],
            [3.119903709377394, 44.25993576337018],
            [3.130070029543714, 44.29006573050493],
            [3.149867600393917, 44.31003137137735],
            [3.149867600393917, 44.32999701224978],
            [3.130070029543714, 44.3401613385121],
            [3.119903709377394, 44.360126979384525],
            [3.119903709377394, 44.38989393486705],
            [3.140236349710034, 44.38989393486705],
            [3.140236349710034, 44.45995518374664],
            [3.0701422475106694, 44.499886465491485],
            [3.079773498194551, 44.519852106363906],
            [3.0701422475106694, 44.53001643262623],
            [3.079773498194551, 44.569947714371075],
            [3.0300120363278262, 44.60007768150582],
            [2.9802505744611016, 44.64000896325067],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 43, name: "Haute-Loire", REG: 84, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.859904803589015, 44.73983716761279],
            [3.840107232738812, 44.75000149387511],
            [3.840107232738812, 44.76996713474753],
            [3.8101433417222887, 44.76996713474753],
            [3.7999770215559687, 44.78993277561996],
            [3.7598468103731273, 44.80009710188228],
            [3.740049239522924, 44.84002838362713],
            [3.720251668672721, 44.8298640573648],
            [3.699919028340081, 44.84002838362713],
            [3.6699551373235595, 44.8298640573648],
            [3.6699551373235595, 44.85999402449955],
            [3.6399912463070363, 44.87995966537198],
            [3.599861035124193, 44.85999402449955],
            [3.5902297844403117, 44.8298640573648],
            [3.5399332530911485, 44.8298640573648],
            [3.480005471058104, 44.80989841649238],
            [3.4398752598752607, 44.84982969823723],
            [3.4398752598752607, 44.87995966537198],
            [3.4099113688587375, 44.91989094711682],
            [3.4200776890250575, 44.930055273379146],
            [3.360149906992013, 44.969986555123995],
            [3.349983586825693, 45.000116522258736],
            [3.3098533756428496, 45.020082163131164],
            [3.3002221249589683, 45.060013444876006],
            [3.3098533756428496, 45.090143412010754],
            [3.349983586825693, 45.099944726620855],
            [3.3098533756428496, 45.119910367493276],
            [3.2900558047926465, 45.119910367493276],
            [3.260091913776125, 45.170005975500445],
            [3.270258233942445, 45.20993725724529],
            [3.239759273443485, 45.22010158350762],
            [3.219961702593282, 45.24986853899014],
            [3.230128022759602, 45.26983417986256],
            [3.219961702593282, 45.27999850612489],
            [3.1702002407265573, 45.27999850612489],
            [3.1600339205602372, 45.29016283238721],
            [3.130070029543714, 45.29016283238721],
            [3.109737389211074, 45.29996414699731],
            [3.100106138527191, 45.31992978786973],
            [3.109737389211074, 45.33009411413206],
            [3.100106138527191, 45.35005975500448],
            [3.1798314914104386, 45.35005975500448],
            [3.1798314914104386, 45.35986106961458],
            [3.239759273443485, 45.38999103674933],
            [3.2900558047926465, 45.40015536301165],
            [3.3098533756428496, 45.42012100388408],
            [3.360149906992013, 45.42012100388408],
            [3.3799474778422143, 45.40015536301165],
            [3.4602079002079007, 45.40015536301165],
            [3.4602079002079007, 45.40995667762175],
            [3.4998030419083053, 45.42992231849418],
            [3.5201356822409453, 45.40015536301165],
            [3.5698971441076717, 45.40015536301165],
            [3.5902297844403117, 45.35986106961458],
            [3.620193675456833, 45.33989542874216],
            [3.6597888171572377, 45.35986106961458],
            [3.6801214574898795, 45.379826710487],
            [3.699919028340081, 45.35986106961458],
            [3.729882919356604, 45.35986106961458],
            [3.740049239522924, 45.35005975500448],
            [3.7801794507057673, 45.35005975500448],
            [3.7898107013896487, 45.379826710487],
            [3.8101433417222887, 45.38999103674933],
            [3.840107232738812, 45.379826710487],
            [3.849738483422695, 45.35986106961458],
            [3.9000350147718565, 45.35986106961458],
            [3.9198325856220597, 45.35005975500448],
            [3.9401652259546998, 45.37002539587691],
            [3.9797603676551043, 45.379826710487],
            [4.000093007987744, 45.35986106961458],
            [4.010259328154066, 45.33009411413206],
            [4.030056899004268, 45.35005975500448],
            [4.079818360870992, 45.33989542874216],
            [4.079818360870992, 45.35986106961458],
            [4.109782251887515, 45.35986106961458],
            [4.160078783236679, 45.38999103674933],
            [4.200208994419522, 45.379826710487],
            [4.239804136119926, 45.38999103674933],
            [4.269768027136448, 45.35986106961458],
            [4.309898238319291, 45.35986106961458],
            [4.339862129335814, 45.37002539587691],
            [4.360194769668454, 45.33989542874216],
            [4.330230878651931, 45.31992978786973],
            [4.350028449502134, 45.29996414699731],
            [4.350028449502134, 45.27999850612489],
            [4.369826020352337, 45.26003286525246],
            [4.390158660684977, 45.26003286525246],
            [4.420122551701499, 45.27999850612489],
            [4.480050333734545, 45.24006722438004],
            [4.480050333734545, 45.20013594263519],
            [4.439920122551702, 45.139876008365704],
            [4.379992340518657, 45.139876008365704],
            [4.369826020352337, 45.1300746937556],
            [4.399789911368859, 45.11010905288318],
            [4.360194769668454, 45.099944726620855],
            [4.350028449502134, 45.07017777113833],
            [4.379992340518657, 45.049849118613686],
            [4.360194769668454, 45.02988347774126],
            [4.320064558485611, 45.02988347774126],
            [4.30026698763541, 45.020082163131164],
            [4.29010066746909, 45.000116522258736],
            [4.309898238319291, 44.989952195996416],
            [4.309898238319291, 44.969986555123995],
            [4.27993434730277, 44.969986555123995],
            [4.260136776452566, 44.95982222886167],
            [4.230172885436043, 44.969986555123995],
            [4.220006565269723, 44.95982222886167],
            [4.220006565269723, 44.930055273379146],
            [4.200208994419522, 44.930055273379146],
            [4.17987635408688, 44.8901239916343],
            [4.160078783236679, 44.870158350761876],
            [4.119948572053835, 44.87995966537198],
            [4.089984681037312, 44.870158350761876],
            [4.030056899004268, 44.870158350761876],
            [4.030056899004268, 44.8298640573648],
            [4.010259328154066, 44.8298640573648],
            [3.9797603676551043, 44.80989841649238],
            [3.959962796804903, 44.8298640573648],
            [3.9401652259546998, 44.82006274275471],
            [3.9401652259546998, 44.80009710188228],
            [3.8898686946055365, 44.75000149387511],
            [3.870071123755335, 44.76016582013744],
            [3.859904803589015, 44.73983716761279],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: {
        CODE: 44,
        name: "Loire-Atlantique",
        REG: 52,
        CAT: 0,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-2.459800853485064, 47.450082163131164],
            [-2.4400032826348617, 47.470047804003585],
            [-2.410039391618339, 47.459883477741265],
            [-2.320147718568771, 47.459883477741265],
            [-2.299815078236131, 47.50017777113833],
            [-2.299815078236131, 47.52014341201075],
            [-2.2398872962030856, 47.49001344487601],
            [-2.2200897253528833, 47.509979085748434],
            [-2.1901258343363605, 47.509979085748434],
            [-2.1901258343363605, 47.49001344487601],
            [-2.1697931940037205, 47.49001344487601],
            [-2.1499956231535178, 47.52014341201075],
            [-2.1002341612867927, 47.529944726620855],
            [-2.1002341612867927, 47.60000597550045],
            [-2.0799015209541527, 47.61997161637287],
            [-2.1002341612867927, 47.6301359426352],
            [-2.0799015209541527, 47.65010158350762],
            [-2.04993762993763, 47.65010158350762],
            [-2.03977130977131, 47.67006722438004],
            [-2.009807418754787, 47.67006722438004],
            [-1.9702122770543822, 47.69003286525247],
            [-1.9402483860378599, 47.69003286525247],
            [-1.8797855345223766, 47.69983417986256],
            [-1.8599879636721743, 47.70999850612489],
            [-1.8198577524893316, 47.70999850612489],
            [-1.7898938614728088, 47.69983417986256],
            [-1.749763650289966, 47.70999850612489],
            [-1.7299660794397638, 47.69983417986256],
            [-1.7101685085895615, 47.70999850612489],
            [-1.6598719772403983, 47.70999850612489],
            [-1.640074406390196, 47.72016283238722],
            [-1.629908086223876, 47.76009411413206],
            [-1.6101105153736732, 47.76009411413206],
            [-1.5897778750410332, 47.78005975500449],
            [-1.5298500930079877, 47.78005975500449],
            [-1.5100525221577854, 47.80002539587691],
            [-1.4800886311412627, 47.80002539587691],
            [-1.4699223109749426, 47.809826710487],
            [-1.4800886311412627, 47.830155363011656],
            [-1.3901969580916949, 47.830155363011656],
            [-1.3602330670751726, 47.80002539587691],
            [-1.339900426742532, 47.78986106961458],
            [-1.2500087536929643, 47.78005975500449],
            [-1.2398424335266442, 47.76009411413206],
            [-1.2500087536929643, 47.72996414699731],
            [-1.2002472918262392, 47.70999850612489],
            [-1.1697483313272787, 47.69003286525247],
            [-1.1799146514935988, 47.67006722438004],
            [-1.1601170806433965, 47.65990289811772],
            [-1.1601170806433965, 47.63993725724529],
            [-1.139784440310756, 47.61997161637287],
            [-1.100189298610351, 47.61997161637287],
            [-1.079856658277711, 47.61017030176277],
            [-1.0300951964109855, 47.60000597550045],
            [-1.0097625560783454, 47.589841649238124],
            [-1.0402615165773064, 47.54991036749328],
            [-1.0402615165773064, 47.509979085748434],
            [-1.0097625560783454, 47.49001344487601],
            [-0.9701674143779409, 47.49001344487601],
            [-0.9701674143779409, 47.470047804003585],
            [-0.9498347740452999, 47.450082163131164],
            [-0.9498347740452999, 47.38982222886167],
            [-0.9797986650618231, 47.36985658798925],
            [-1.139784440310756, 47.36985658798925],
            [-1.1799146514935988, 47.34989094711682],
            [-1.230211182842762, 47.34989094711682],
            [-1.279972644709487, 47.340089632506725],
            [-1.339900426742532, 47.320123991634304],
            [-1.350066746908852, 47.300158350761876],
            [-1.290138964875807, 47.300158350761876],
            [-1.279972644709487, 47.27002838362713],
            [-1.230211182842762, 47.23989841649238],
            [-1.2002472918262392, 47.25006274275471],
            [-1.1799146514935988, 47.23989841649238],
            [-1.1900809716599192, 47.21993277561996],
            [-1.1601170806433965, 47.19016582013744],
            [-1.1697483313272787, 47.16983716761279],
            [-1.230211182842762, 47.12990588586794],
            [-1.230211182842762, 47.10013893038542],
            [-1.1697483313272787, 47.0899746041231],
            [-1.1499507604770765, 47.07000896325067],
            [-1.1199868694605537, 47.05984463698835],
            [-1.1199868694605537, 47.039878996115924],
            [-1.1499507604770765, 47.03007768150583],
            [-1.2002472918262392, 47.039878996115924],
            [-1.2698063245431666, 47.080173289513],
            [-1.290138964875807, 47.080173289513],
            [-1.2997702155596893, 47.03007768150583],
            [-1.3602330670751726, 47.039878996115924],
            [-1.3800306379253748, 47.03007768150583],
            [-1.3602330670751726, 46.99994771437108],
            [-1.3800306379253748, 46.99014639976098],
            [-1.3698643177590548, 46.949852106363906],
            [-1.4699223109749426, 46.929886465491485],
            [-1.4597559908086226, 46.96001643262623],
            [-1.4800886311412627, 46.979982073498654],
            [-1.4699223109749426, 46.99014639976098],
            [-1.4699223109749426, 47.03007768150583],
            [-1.4998862019914654, 47.039878996115924],
            [-1.5501827333406282, 47.0101120406334],
            [-1.5400164131743082, 46.99994771437108],
            [-1.5501827333406282, 46.979982073498654],
            [-1.5202188423241054, 46.94005079175381],
            [-1.5501827333406282, 46.929886465491485],
            [-1.4998862019914654, 46.889955183746636],
            [-1.4998862019914654, 46.88015386913654],
            [-1.5501827333406282, 46.859825216611895],
            [-1.580146624357151, 46.869989542874215],
            [-1.6101105153736732, 46.869989542874215],
            [-1.689835868256921, 46.889955183746636],
            [-1.7197997592734438, 46.88015386913654],
            [-1.7401323996060838, 46.90011951000896],
            [-1.749763650289966, 46.929886465491485],
            [-1.8300240726556516, 46.929886465491485],
            [-1.8300240726556516, 46.949852106363906],
            [-1.8701542838384944, 46.949852106363906],
            [-1.9097494255388994, 46.97018075888856],
            [-1.9199157457052194, 46.99014639976098],
            [-1.9402483860378599, 46.99014639976098],
            [-1.9798435277382644, 47.03007768150583],
            [-2.000176168070905, 47.05984463698835],
            [-2.0301400590874277, 47.07000896325067],
            [-2.04993762993763, 47.0899746041231],
            [-2.109865411970675, 47.10994024499552],
            [-2.1601619433198382, 47.10994024499552],
            [-2.1799595141700405, 47.12010457125784],
            [-2.2099234051865633, 47.12010457125784],
            [-2.2398872962030856, 47.12990588586794],
            [-2.2302560455192033, 47.14987152674037],
            [-2.199757085020243, 47.16003585300269],
            [-2.1697931940037205, 47.16003585300269],
            [-2.1601619433198382, 47.19016582013744],
            [-2.1697931940037205, 47.23989841649238],
            [-2.1697931940037205, 47.27002838362713],
            [-2.1301980523033155, 47.27002838362713],
            [-2.06010395010395, 47.27982969823723],
            [-2.0301400590874277, 47.289994024499556],
            [-2.009807418754787, 47.30995966537198],
            [-2.1002341612867927, 47.30995966537198],
            [-2.1697931940037205, 47.289994024499556],
            [-2.199757085020243, 47.27002838362713],
            [-2.2302560455192033, 47.25986405736481],
            [-2.290183827552249, 47.230097101882286],
            [-2.299815078236131, 47.23989841649238],
            [-2.339945289418974, 47.25006274275471],
            [-2.350111609585294, 47.27002838362713],
            [-2.410039391618339, 47.27982969823723],
            [-2.4202057117846594, 47.25986405736481],
            [-2.4501696028011817, 47.25986405736481],
            [-2.459800853485064, 47.27002838362713],
            [-2.55022759601707, 47.289994024499556],
            [-2.5400612758507495, 47.300158350761876],
            [-2.510097384834227, 47.300158350761876],
            [-2.4999310646679067, 47.320123991634304],
            [-2.5298949556844295, 47.380020914251574],
            [-2.4699671736513844, 47.419952195996416],
            [-2.459800853485064, 47.410150881386315],
            [-2.4298369624685416, 47.410150881386315],
            [-2.459800853485064, 47.450082163131164],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 41, name: "Loir-et-Cher", REG: 24, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [0.6098927672611882, 47.69003286525247],
            [0.5799288762446659, 47.70999850612489],
            [0.6098927672611882, 47.72996414699731],
            [0.6200590874275083, 47.74992978786973],
            [0.6500229784440315, 47.76009411413206],
            [0.7099507604770761, 47.78986106961458],
            [0.7500809716599193, 47.830155363011656],
            [0.7698785425101216, 47.830155363011656],
            [0.7602472918262393, 47.85992231849418],
            [0.7602472918262393, 47.89985360023902],
            [0.7902111828427616, 47.91001792650135],
            [0.8100087536929648, 47.92998356737377],
            [0.8501389648758071, 47.940147893636095],
            [0.8501389648758071, 47.949949208246196],
            [0.8201750738592848, 47.980079175380936],
            [0.8399726447094871, 48.03017478338811],
            [0.8100087536929648, 48.03017478338811],
            [0.7902111828427616, 48.05014042426053],
            [0.7902111828427616, 48.070106065132954],
            [0.8399726447094871, 48.070106065132954],
            [0.8501389648758071, 48.09007170600538],
            [0.8399726447094871, 48.099873020615476],
            [0.8699365357260094, 48.1100373468778],
            [0.9100667469088526, 48.099873020615476],
            [0.9298643177590549, 48.1100373468778],
            [0.9598282087755772, 48.099873020615476],
            [0.9999584199584204, 48.130002987750224],
            [1.0400886311412627, 48.119838661487904],
            [0.9897920997921004, 48.099873020615476],
            [1.0197559908086227, 48.09007170600538],
            [1.059886201991465, 48.09007170600538],
            [1.070052522157786, 48.079907379743055],
            [1.1101827333406282, 48.079907379743055],
            [1.1101827333406282, 48.059941738870634],
            [1.1299803041908305, 48.03017478338811],
            [1.1599441952073537, 48.020010457125785],
            [1.189908086223876, 48.000044816253364],
            [1.189908086223876, 47.96991484911862],
            [1.2198719772403983, 47.980079175380936],
            [1.2498358682569215, 47.980079175380936],
            [1.2701685085895615, 47.960113534508515],
            [1.3001323996060838, 47.96991484911862],
            [1.309763650289966, 47.949949208246196],
            [1.340262610788927, 47.960113534508515],
            [1.3702265018054494, 47.949949208246196],
            [1.3900240726556516, 47.980079175380936],
            [1.409821643505854, 47.96991484911862],
            [1.4397855345223771, 47.980079175380936],
            [1.4301542838384949, 48.000044816253364],
            [1.4397855345223771, 48.009846130863465],
            [1.4601181748550172, 48.009846130863465],
            [1.4900820658715395, 47.98988048999104],
            [1.5200459568880627, 47.980079175380936],
            [1.560176168070905, 47.98988048999104],
            [1.560176168070905, 47.960113534508515],
            [1.5302122770543827, 47.940147893636095],
            [1.5302122770543827, 47.92998356737377],
            [1.5799737389211073, 47.89985360023902],
            [1.5901400590874273, 47.8798879593666],
            [1.550009847904585, 47.83995667762175],
            [1.5302122770543827, 47.830155363011656],
            [1.5698074187547872, 47.80002539587691],
            [1.550009847904585, 47.76989542874216],
            [1.5997713097713095, 47.74012847325964],
            [1.6201039501039505, 47.74012847325964],
            [1.6297352007878327, 47.76009411413206],
            [1.690198052303316, 47.74012847325964],
            [1.7099956231535183, 47.72016283238722],
            [1.7399595141700406, 47.65990289811772],
            [1.7800897253528838, 47.65010158350762],
            [1.810053616369406, 47.65010158350762],
            [1.8501838275522484, 47.65990289811772],
            [1.8598150782361307, 47.67986853899014],
            [1.8897789692526539, 47.67986853899014],
            [1.910111609585294, 47.67006722438004],
            [1.9400755006018162, 47.67986853899014],
            [1.9400755006018162, 47.65990289811772],
            [1.9598730714520194, 47.65990289811772],
            [2.0101696028011817, 47.67986853899014],
            [2.059931064667907, 47.67006722438004],
            [2.0700973848342272, 47.67986853899014],
            [2.1300251668672727, 47.67986853899014],
            [2.170155378050115, 47.67006722438004],
            [2.2097505197505196, 47.67986853899014],
            [2.2402494802494806, 47.63993725724529],
            [2.2402494802494806, 47.61997161637287],
            [2.159989057883795, 47.60000597550045],
            [2.119858846700952, 47.58004033462802],
            [2.1300251668672727, 47.54991036749328],
            [2.2001192690666374, 47.54991036749328],
            [2.2199168399168405, 47.50017777113833],
            [2.249880730933363, 47.49001344487601],
            [2.2402494802494806, 47.470047804003585],
            [2.249880730933363, 47.43991783686884],
            [2.2402494802494806, 47.410150881386315],
            [2.2001192690666374, 47.410150881386315],
            [2.1899529489003173, 47.43991783686884],
            [2.1401914870335927, 47.410150881386315],
            [2.119858846700952, 47.410150881386315],
            [2.1000612758507495, 47.38982222886167],
            [2.1000612758507495, 47.36985658798925],
            [2.119858846700952, 47.36985658798925],
            [2.1300251668672727, 47.320123991634304],
            [2.149822737717475, 47.320123991634304],
            [2.159989057883795, 47.300158350761876],
            [2.1300251668672727, 47.27982969823723],
            [2.0898949556844295, 47.289994024499556],
            [2.029967173651384, 47.27002838362713],
            [2.0000032826348617, 47.27002838362713],
            [1.9400755006018162, 47.289994024499556],
            [1.899945289418974, 47.25006274275471],
            [1.9197428602691762, 47.230097101882286],
            [1.8801477185687716, 47.21013146100986],
            [1.8400175073859284, 47.21993277561996],
            [1.810053616369406, 47.230097101882286],
            [1.7800897253528838, 47.230097101882286],
            [1.7501258343363606, 47.25006274275471],
            [1.7201619433198383, 47.27982969823723],
            [1.6998293029871983, 47.25986405736481],
            [1.6500678411204728, 47.25986405736481],
            [1.6201039501039505, 47.27002838362713],
            [1.5901400590874273, 47.25986405736481],
            [1.5200459568880627, 47.25986405736481],
            [1.5302122770543827, 47.25006274275471],
            [1.5200459568880627, 47.230097101882286],
            [1.4799157457052194, 47.23989841649238],
            [1.4499518546886971, 47.23989841649238],
            [1.3498938614728093, 47.19016582013744],
            [1.330096290622607, 47.19016582013744],
            [1.3199299704562861, 47.19016582013744],
            [1.2797997592734438, 47.25986405736481],
            [1.2600021884232415, 47.25986405736481],
            [1.2198719772403983, 47.289994024499556],
            [1.1599441952073537, 47.27002838362713],
            [1.1101827333406282, 47.300158350761876],
            [1.0898500930079882, 47.3299253062444],
            [1.1101827333406282, 47.3299253062444],
            [1.1198139840245105, 47.34989094711682],
            [1.1101827333406282, 47.36985658798925],
            [1.1198139840245105, 47.380020914251574],
            [1.1101827333406282, 47.43011652225874],
            [1.1299803041908305, 47.450082163131164],
            [1.1101827333406282, 47.470047804003585],
            [1.0898500930079882, 47.470047804003585],
            [1.070052522157786, 47.50017777113833],
            [1.070052522157786, 47.52014341201075],
            [1.0502549513075827, 47.54010905288318],
            [1.080218842324106, 47.5698760083657],
            [1.059886201991465, 47.58004033462802],
            [1.0299223109749427, 47.61017030176277],
            [1.0101247401247404, 47.60000597550045],
            [0.9801608491082181, 47.60000597550045],
            [0.9897920997921004, 47.61997161637287],
            [0.9699945289418972, 47.6301359426352],
            [0.9202330670751726, 47.6301359426352],
            [0.8999004267425326, 47.61997161637287],
            [0.8999004267425326, 47.60000597550045],
            [0.8597702155596894, 47.60000597550045],
            [0.8501389648758071, 47.61997161637287],
            [0.8597702155596894, 47.6301359426352],
            [0.8399726447094871, 47.65010158350762],
            [0.8597702155596894, 47.67986853899014],
            [0.7902111828427616, 47.67986853899014],
            [0.7399146514935993, 47.69983417986256],
            [0.7099507604770761, 47.67986853899014],
            [0.6698205492942337, 47.69983417986256],
            [0.6302254075938292, 47.70999850612489],
            [0.6098927672611882, 47.69003286525247],
          ],
        ],
      },
    },
    {
      type: "Feature",
      id: 0,
      properties: { CODE: 10, name: "Aube", REG: 44, CAT: 0 },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [3.4099113688587375, 48.38991933074395],
            [3.4200776890250575, 48.40988497161638],
            [3.3997450486924174, 48.4298506124888],
            [3.4099113688587375, 48.450179265013446],
            [3.390113798008536, 48.45998057962355],
            [3.3799474778422143, 48.47994622049597],
            [3.3997450486924174, 48.490110546758295],
            [3.4302440091913775, 48.490110546758295],
            [3.4099113688587375, 48.53004182850314],
            [3.4500415800415807, 48.53004182850314],
            [3.480005471058104, 48.550007469375565],
            [3.469839150891782, 48.569973110247986],
            [3.490171791224424, 48.58993875112041],
            [3.5201356822409453, 48.58993875112041],
            [3.5099693620746253, 48.609904391992835],
            [3.5602658934237885, 48.620068718255155],
            [3.5602658934237885, 48.609904391992835],
            [3.599861035124193, 48.569973110247986],
            [3.6298249261407163, 48.569973110247986],
            [3.6399912463070363, 48.53984314311324],
            [3.689752708173761, 48.53984314311324],
            [3.710085348506401, 48.53004182850314],
            [3.729882919356604, 48.53984314311324],
            [3.7598468103731273, 48.53004182850314],
            [3.7999770215559687, 48.53004182850314],
            [3.829940912572492, 48.51987750224082],
            [3.859904803589015, 48.53984314311324],
            [3.859904803589015, 48.569973110247986],
            [3.9000350147718565, 48.58013743651031],
            [3.9198325856220597, 48.609904391992835],
            [3.949796476638583, 48.600103077382734],
            [3.959962796804903, 48.620068718255155],
            [3.9797603676551043, 48.629870032865256],
            [3.9797603676551043, 48.64983567373768],
            [4.000093007987744, 48.660000000000004],
            [4.040223219170588, 48.660000000000004],
            [4.060020790020791, 48.670164326262324],
            [4.070187110187111, 48.69012996713475],
            [4.089984681037312, 48.699931281744846],
            [4.130114892220155, 48.69012996713475],
            [4.17987635408688, 48.71009560800717],
            [4.200208994419522, 48.699931281744846],
            [4.230172885436043, 48.699931281744846],
            [4.249970456286246, 48.71009560800717],
            [4.309898238319291, 48.71009560800717],
            [4.330230878651931, 48.699931281744846],
            [4.320064558485611, 48.679965640872425],
            [4.320064558485611, 48.64003435912758],
            [4.309898238319291, 48.620068718255155],
            [4.330230878651931, 48.600103077382734],
            [4.350028449502134, 48.600103077382734],
            [4.420122551701499, 48.550007469375565],
            [4.460252762884342, 48.550007469375565],
            [4.52981179560127, 48.53004182850314],
            [4.569942006784113, 48.550007469375565],
            [4.640036108983478, 48.550007469375565],
            [4.670000000000001, 48.53984314311324],
            [4.670000000000001, 48.53004182850314],
            [4.680166320166321, 48.51987750224082],
            [4.659833679833681, 48.49991186136839],
            [4.640036108983478, 48.45998057962355],
            [4.689797570850202, 48.4298506124888],
            [4.680166320166321, 48.4200492978787],
            [4.699963891016522, 48.38991933074395],
            [4.759891673049569, 48.38991933074395],
            [4.7502604223656855, 48.36995368987153],
            [4.819819455082613, 48.34998804899911],
            [4.829985775248933, 48.33982372273678],
            [4.810188204398732, 48.31985808186436],
            [4.849783346099136, 48.29989244099193],
            [4.840152095415253, 48.27992680011951],
            [4.859949666265456, 48.27012548550941],
            [4.840152095415253, 48.25015984463699],
            [4.859949666265456, 48.209865551239915],
            [4.859949666265456, 48.189899910367494],
            [4.840152095415253, 48.16993426949507],
            [4.829985775248933, 48.1100373468778],
            [4.810188204398732, 48.099873020615476],
            [4.759891673049569, 48.119838661487904],
            [4.729927782033045, 48.119838661487904],
            [4.689797570850202, 48.09007170600538],
            [4.689797570850202, 48.070106065132954],
            [4.710130211182844, 48.05014042426053],
            [4.699963891016522, 48.020010457125785],
            [4.620238538133276, 48.020010457125785],
            [4.580108326950433, 48.03017478338811],
            [4.55014443593391, 48.009846130863465],
            [4.53997811576759, 47.98988048999104],
            [4.559775686617793, 47.96991484911862],
            [4.499847904584747, 47.96991484911862],
            [4.450086442718022, 47.960113534508515],
            [4.420122551701499, 47.96991484911862],
            [4.350028449502134, 47.960113534508515],
            [4.309898238319291, 47.960113534508515],
            [4.29010066746909, 47.92998356737377],
            [4.269768027136448, 47.91981924111145],
            [4.220006565269723, 47.949949208246196],
            [4.230172885436043, 47.96991484911862],
            [4.200208994419522, 47.96991484911862],
            [4.209840245103403, 47.949949208246196],
            [4.190042674253202, 47.940147893636095],
            [4.170245103402999, 47.960113534508515],
            [4.119948572053835, 47.92998356737377],
            [4.060020790020791, 47.949949208246196],
            [4.049854469854471, 47.92998356737377],
            [3.9899266878214243, 47.92998356737377],
            [3.959962796804903, 47.940147893636095],
            [3.949796476638583, 47.92998356737377],
            [3.8898686946055365, 47.92998356737377],
            [3.9102013349381766, 47.960113534508515],
            [3.9000350147718565, 48.000044816253364],
            [3.880237443921655, 47.980079175380936],
            [3.849738483422695, 47.980079175380936],
            [3.840107232738812, 48.000044816253364],
            [3.870071123755335, 48.020010457125785],
            [3.849738483422695, 48.03017478338811],
            [3.829940912572492, 48.059941738870634],
            [3.7999770215559687, 48.09007170600538],
            [3.7999770215559687, 48.1100373468778],
            [3.7700131305394473, 48.130002987750224],
            [3.740049239522924, 48.130002987750224],
            [3.750215559689244, 48.16993426949507],
            [3.710085348506401, 48.16993426949507],
            [3.720251668672721, 48.14996862862265],
            [3.689752708173761, 48.14996862862265],
            [3.6597888171572377, 48.16013295488497],
            [3.620193675456833, 48.189899910367494],
            [3.5902297844403117, 48.1800985957574],
            [3.5800634642739917, 48.189899910367494],
            [3.610027355290513, 48.209865551239915],
            [3.620193675456833, 48.22983119211234],
            [3.599861035124193, 48.23999551837467],
            [3.620193675456833, 48.27012548550941],
            [3.5800634642739917, 48.27992680011951],
            [3.5902297844403117, 48.29989244099193],
            [3.5602658934237885, 48.31005676725426],
            [3.5500995732574685, 48.33002240812668],
            [3.5297669329248285, 48.33982372273678],
            [3.4998030419083053, 48.36995368987153],
            [3.4500415800415807, 48.36995368987153],
            [3.4302440091913775, 48.36015237526143],
            [3.4099113688587375, 48.38991933074395],
          ],
        ],
      },
    },
  ],
};

export default franceData;
